webpackJsonp([0],{

/***/ "+5C9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[(!_vm.hasPacket)?_c('check-fnwallet'):_vm._e(),_vm._v(" "),(_vm.hasPacket)?_c('futurocoins-from-mining'):_vm._e(),_vm._v(" "),_c('settings'),_vm._v(" "),_c('verification'),_vm._v(" "),_c('security')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+6sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['updateValue', 'sending', 'showErrors', 'isVerified'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    computed: {
        defaultValue: function defaultValue() {
            return this.$store.getters.user.phoneNumber;
        }
    },
    watch: {
        defaultValue: function defaultValue() {
            this.fieldValue = this.defaultValue;
        },
        fieldValue: function fieldValue() {
            this.updateValue('phoneNumber', this.fieldValue);
        }
    },
    mounted: function mounted() {
        this.fieldValue = this.defaultValue;
        this.updateValue('phoneNumber', this.fieldValue);
    }
});

/***/ }),

/***/ "+8Je":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[(!_vm.hasPacket)?_c('check-fnwallet'):_vm._e(),_vm._v(" "),(_vm.hasPacket)?_c('futurocoins-from-mining'):_vm._e(),_vm._v(" "),_c('calculator')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+AmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payout_vue__ = __webpack_require__("S/wW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc367b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payout_vue__ = __webpack_require__("0kVb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc367b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("50Yw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Qm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__("SW55");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710c78f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__("LG9l");
function injectStyle (ssrContext) {
  __webpack_require__("uQVa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-710c78f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710c78f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+RE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    data: function data() {
        return {
            payoutsOpen: false
        };
    },

    computed: {
        payouts: function payouts() {
            return this.$store.getters.futurocoinWithdraw.length > 0 ? this.$store.getters.futurocoinWithdraw : [];
        }
    },
    methods: {
        toggleList: function toggleList() {
            this.payoutsOpen = !this.payoutsOpen;
        }
    }
});

/***/ }),

/***/ "+Ur2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');

var RoyalBonuses = function () {
    function RoyalBonuses() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RoyalBonuses);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RoyalBonuses, [{
        key: 'fetchData',
        value: function fetchData() {
            if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.checkAuth) {
                __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.user.royalBonuses).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setRoyalBonuses', response.body);
                });
            }
        }
    }]);

    return RoyalBonuses;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('royalBonuses', RoyalBonuses);

/***/ }),

/***/ "+nep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);








__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api'),
    datetime = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('datetime'),
    status = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('status');

var state = {
    transferHistory: {},

    transferHistoryLoader: true,

    transferHistorySettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: [],
        type: []
    }
};

var getters = {
    transferHistory: function transferHistory(state) {
        return state.transferHistory;
    },

    transferHistoryLoader: function transferHistoryLoader(state) {
        return state.transferHistoryLoader;
    },

    transferHistorySettings: function transferHistorySettings(state) {
        return state.transferHistorySettings;
    }
};

var mutations = {
    /**
     * Set transfer history in store
     * @param state
     * @param data
     */
    setTransferHistory: function setTransferHistory(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'transferHistory', data.results);
        } else {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'transferHistory', []);
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'numberOfPages', data.number_of_pages);
    },


    /**
     * Clear filter in transfer history
     * @param state
     */
    transferHistoryClearFilter: function transferHistoryClearFilter(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'type', '');
    },
    transferHistoryLoaderOn: function transferHistoryLoaderOn(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'transferHistoryLoader', true);
    },
    transferHistoryLoaderOff: function transferHistoryLoaderOff(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'transferHistoryLoader', false);
    }
};

var actions = {

    /**
     * Get transfer history data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadTransferHistory: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (data) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                commit('transferHistoryLoaderOn');
                                var settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(data);

                                if (settings.params.sort) {
                                    var sort = [];
                                    for (var field in data.params.sort) {
                                        sort.push(data.params.sort[field]);
                                    }
                                    settings.params.sort = sort;
                                }
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.transfer.history(settings.params)).then(function (response) {
                                    commit('setTransferHistory', response.data);
                                    commit('transferHistoryLoaderOff');
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    commit('transferHistoryLoaderOff');
                                    reject();
                                });
                            }));

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadTransferHistory(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return loadTransferHistory;
    }(),


    /**
     * Set sorting in transfer history
     * @param field
     * @returns {Promise}
     */
    transferHistorySetSort: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, field) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                var sort = state.transferHistorySettings.sort,
                                    isSet = false;

                                for (var sortId in sort) {
                                    if (!isSet && sort[sortId].field === field) {
                                        isSet = sortId;
                                    }
                                }

                                if (!isSet) {
                                    sort.push({
                                        field: field,
                                        order: 'asc'
                                    });
                                } else {
                                    sort[isSet].order = sort[isSet].order === 'desc' ? 'asc' : 'desc';
                                }

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'sort', sort);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function transferHistorySetSort(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return transferHistorySetSort;
    }(),


    /**
     * Set filter in transfer history
     * @param type
     * @returns {Promise}
     */
    transferHistorySetFilter: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, type) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'type', type);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function transferHistorySetFilter(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return transferHistorySetFilter;
    }(),


    /**
     * Set max number of items in transfer history
     * @param getters
     * @param data
     * @returns {Promise}
     */
    transferHistorySetItems: function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

                            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function transferHistorySetItems(_x7, _x8) {
            return _ref8.apply(this, arguments);
        }

        return transferHistorySetItems;
    }(),


    /**
     * Set page in transfer history
     * @param getters
     * @param data
     * @returns {Promise}
     */
    transferHistorySetPage: function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

                            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'currentPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function transferHistorySetPage(_x9, _x10) {
            return _ref10.apply(this, arguments);
        }

        return transferHistorySetPage;
    }(),


    /**
     * Set date in transfer history
     * @param date
     * @returns {Promise}
     */
    transferHistorySetDate: function () {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref11, date) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref11);

                            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                var dates = date.split(' to ');

                                if (dates[1]) {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'fromDate', datetime.localToUtc(dates[0]));
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'toDate', datetime.localToUtc(dates[1]));
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'fromDate', datetime.localToUtc(dates[0]));
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.transferHistorySettings, 'toDate', false);
                                }

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function transferHistorySetDate(_x11, _x12) {
            return _ref12.apply(this, arguments);
        }

        return transferHistorySetDate;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "+unR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploaded-files-component"},[_c('p',{staticStyle:{"margin-bottom":"11px"}},[_vm._v("If you want to withdraw your money you must verify your account. "),(_vm.files.length <= 0)?_c('span',[_vm._v("Please send us scan of your ID with your living address\n        or ID and bill to confirm your living address. You have uploaded no files.")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('b-row',{key:index,staticClass:"one-file"},[_c('div',{staticClass:"file-row"},[_c('b-col',{attrs:{"lg":"3"}},[_c('p',[_vm._v("Upload files:")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(_vm.datetime.utcToLocal(file.created_at)))])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"file-row"},[_c('b-col',{attrs:{"lg":"3"}},[_c('p',[_vm._v("Status:")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',{class:{ 'status-success': file.status === 'accepted',
                             'status-decline': file.status === 'declined',
                             'status-new'    : file.status === 'new',}},[_vm._v(_vm._s(file.status))])])],1),_vm._v(" "),_c('br'),_vm._v(" "),(file.reason)?_c('div',{staticClass:"file-row"},[_c('b-col',{attrs:{"lg":"3"}},[_c('p',[_vm._v("Reason:")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',{class:{ 'status-decline': file.status === 'declined' }},[_vm._v(_vm._s(file.reason))])])],1):_vm._e()])}),_vm._v(" "),(_vm.files.length <= 0 && !_vm.loader)?_c('p',{staticStyle:{"color":"red"}},[_vm._v("You have not uploaded any file yet.")]):_vm._e(),_vm._v(" "),(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('image-modal',{attrs:{"source":_vm.src}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+wPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[(!_vm.hasPacket)?_c('check-fnwallet'):_vm._e(),_vm._v(" "),(_vm.hasPacket)?_c('futurocoins-from-mining'):_vm._e(),_vm._v(" "),_c('form',{staticClass:"wallet-otp",attrs:{"id":"wallet_otp"},on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',{staticClass:"wallet-preferences-inner"},[_c('b-col',{attrs:{"lg":"12"}},[_c('h3',{staticClass:"section-main-title settings-header instruction-header"},[_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v("\n                        How to configure One Time Password security?\n                    ")]),_vm._v(" "),_c('span',{staticClass:"fr desktop-only"},[_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v("Instructions/Manual: ")]),_vm._v(" "),_c('ul',{staticClass:"otp-instruction-lang"},_vm._l((_vm.instructions),function(link,lang){return _c('li',{staticStyle:{"margin-left":"6px"}},[_c('a',{attrs:{"href":link,"target":"_blank"}},[_vm._v(_vm._s(lang))])])}),0)])]),_vm._v(" "),_c('h3',{staticClass:"section-main-title mobile-only instruction-header no-border",staticStyle:{"margin-bottom":"30px"}},[_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v("Instructions/Manual: ")]),_vm._v(" "),_c('ul',{staticClass:"otp-instruction-lang"},_vm._l((_vm.instructions),function(link,lang){return _c('li',{staticStyle:{"margin-left":"6px"}},[_c('a',{attrs:{"href":link,"target":"_blank"}},[_vm._v(_vm._s(lang))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"instruction"},[_c('div',{staticClass:"instruction-item"},[_c('div',{staticClass:"instruction-item--number currency-color"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"instruction-item--content"},[_c('p',[_vm._v("Install Google Authenticator on your smartphone."),_c('br',{staticClass:"desktop-only"}),_vm._v("You will easily find in Google Play/App Store and it is free to install and use.")]),_vm._v(" "),_c('ul',{staticClass:"stores"},[_c('li',[_c('a',{attrs:{"href":"https://itunes.apple.com/us/app/google-authenticator/id388497605","target":"_blank"}},[_c('div',{staticClass:"store-icon app-store"}),_vm._v(" App store\n                                    ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2","target":"_blank"}},[_c('div',{staticClass:"store-icon google-play"}),_vm._v(" Google play\n                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"instruction-item"},[_c('div',{staticClass:"instruction-item--number currency-color"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"instruction-item--content"},[_c('p',[_vm._v("Choose your smartphone, scan the bar code or type"),_c('br',{staticClass:"desktop-only"}),_vm._v("your name and key within your Google Authenticator app.")]),_vm._v(" "),_c('div',{staticClass:"scan-code"},[_c('div',{staticClass:"qrcode"},[_c('p',[_vm._v("Scan your code")]),_vm._v(" "),_c('qrcode-vue',{attrs:{"value":_vm.qrcode}})],1),_vm._v(" "),_c('div',{staticClass:"copy"},[_c('p',[_vm._v("OR just type your name and key")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Account name:")]),_vm._v(" "+_vm._s(_vm.accountName)+"_"+_vm._s(_vm.username)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Account key: ")]),_vm._v(" "+_vm._s(_vm.accountKey)+"\n                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"instruction-item"},[_c('div',{staticClass:"instruction-item--number currency-color"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"instruction-item--content"},[_c('p',[_vm._v("Check if your code from"),_c('br',{staticClass:"desktop-only"}),_vm._v("Google Authenticator app is valid.")])])])]),_vm._v(" "),_c('h3',{staticClass:"section-main-title no-border instruction-header checker-title"},[_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v("If the code is correct, the configuration will be completed and you never see this site again.")])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-check"},[_c('div',{staticClass:"outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"otp_checker","name":"code","type":"text","data-vv-rules":"required","disabled":_vm.progress},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token=$event.target.value}}}),_vm._v(" "),(!_vm.progress)?_c('button',{staticClass:"button--primary"},[_vm._v("Check")]):_vm._e(),_vm._v(" "),(_vm.progress)?_c('button',{staticClass:"button--primary button--progress",attrs:{"type":"button"}},[_vm._v("Check")]):_vm._e()]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code')),expression:"errors.has('code')"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('code')))])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/1KA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var state = {
    exchangeRate: {}
};

var getters = {
    exchangeRate: function exchangeRate(state) {
        return state.exchangeRate;
    }
};

var mutations = {
    /**
     * Set exchange rate in store
     * @param state
     * @param data
     */
    setExchangeRate: function setExchangeRate(state, data) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'exchangeRate', data);
    }
};

var actions = {
    /**
     * Load exchange rate from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadExchangeRate: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var commit = _ref.commit;
            var data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            data = {
                                usd: {
                                    label: 'USD',
                                    value: 2345
                                },
                                pln: {
                                    label: 'PLN',
                                    value: 412
                                },
                                eur: {
                                    label: 'EURO',
                                    value: 734
                                },
                                cny: {
                                    label: 'CNY',
                                    value: 361
                                }
                            };

                            commit('setExchangeRate', data);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadExchangeRate(_x) {
            return _ref2.apply(this, arguments);
        }

        return loadExchangeRate;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "/45B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6359492_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderOptionsSignout_vue__ = __webpack_require__("9O5B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6359492_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderOptionsSignout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/5OG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ComingSoon_vue__ = __webpack_require__("SM57");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ComingSoon: __WEBPACK_IMPORTED_MODULE_0__common_ComingSoon_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */] }
});

/***/ }),

/***/ "/6pU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"autocomplete":"off"}},[_vm._m(0),_vm._v(" "),(_vm.method === 'banktransfer')?_c('p',[_vm._v("Due to legal regulations you can’t withdraw more than FND 15,000 every 10 days.")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Maximum amount of a single withdrawal is FND 10,000.")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"24px"}}),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('amount',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"percent":_vm.amountParams[_vm.method].percent,"minimum":_vm.amountParams[_vm.method].minimum,"amount-error":_vm.amountError,"max-amount-error":_vm.maxAmountError,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(parseFloat(_vm.account.amount) < _vm.amountParams[_vm.method].minimum && _vm.showErrors),expression:"parseFloat(account.amount) < amountParams[method].minimum && showErrors"}],staticClass:"field-error--description"},[_vm._v("Minimum payout amount is FND "+_vm._s(_vm.amountParams[_vm.method].minimum))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.available < _vm.account.amount && _vm.showErrors && !_vm.amountParams[_vm.method].percent),expression:"available < account.amount && showErrors && !amountParams[method].percent"}],staticClass:"field-error--description"},[_vm._v("\n        You do not have enough money to withdraw that amount and pay fee. If you want to use this payout gateway you can withdraw FND "+_vm._s(_vm.available)+"\n    ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.maxAmountError),expression:"maxAmountError"}],staticClass:"field-error--description"},[_vm._v("You cannot withdraw more than FND 10,000 once.")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.available < _vm.account.amount && _vm.showErrors && _vm.amountParams[_vm.method].percent),expression:"available < account.amount && showErrors && amountParams[method].percent"}],staticClass:"field-error--description"},[_vm._v("\n        You do not have enough money to withdraw that amount and pay fee.\n    ")]),_vm._v(" "),_c('p',[_vm._v("+ fee: FND "+_vm._s(_vm.feeValue.toFixed(2)))]),_vm._v(" "),_c('div',{staticStyle:{"margin":"24px"}}),_vm._v(" "),(_vm.method === 'banktransfer')?_c('bank-transfer',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),(_vm.method === 'bitcoin')?_c('bitcoin',{attrs:{"countries":_vm.countries,"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),(_vm.method === 'neteller')?_c('neteller',{attrs:{"countries":_vm.countries,"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),(_vm.method === 'payza')?_c('payza',{attrs:{"countries":_vm.countries,"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),(_vm.method === 'perfectmoney')?_c('perfect-money',{attrs:{"countries":_vm.countries,"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),(_vm.method === 'stp')?_c('stp',{attrs:{"countries":_vm.countries,"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),(_vm.method === 'advcash')?_c('advcash',{attrs:{"countries":_vm.countries,"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner payout-option-inner--actions"},[_c('b-col',{attrs:{"lg":"6"}},[_c('button',{staticClass:"button--primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.validate()}}},[_vm._v("Payout")])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"color--red"},[_vm._v("Attention!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/96R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_StartPacketContent_vue__ = __webpack_require__("Ge/K");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], StartPacketContent: __WEBPACK_IMPORTED_MODULE_1__content_StartPacketContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "/9WW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style2"},[_c('thead',[_c('tr',{staticClass:"business-qualifications-header-table"},_vm._l((_vm.tableHeaders),function(header,headerId){return _c('th',{key:headerId},[_c('p',[_vm._v(_vm._s(header))])])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableRows),function(row){return _c('tr',{staticClass:"row-items"},[_c('td',[_vm._v("\n                        "+_vm._s(row.date)+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v("\n                        $"+_vm._s(_vm.money.format(row.value, 'fnd'))+"\n                    ")]),_vm._v(" "),_c('td',[(_vm.IsGenerateButtonVisible(row.invoice_generated_id))?_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.IsInvoiceGenerating(row.id) },attrs:{"disabled":!_vm.isVerified()},on:{"click":function($event){return _vm.GenerateInvoice(row.id)}}},[_vm._v("Generate")]):_vm._e(),_vm._v(" "),(!_vm.IsGenerateButtonVisible(row.invoice_generated_id))?_c('a',{staticClass:"button--primary",attrs:{"href":_vm.GetDownloadLink(row.invoice_generated_id)}},[_vm._v("Download")]):_vm._e()])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Kr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeam_vue__ = __webpack_require__("2pqR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b99ffbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeam_vue__ = __webpack_require__("v78y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b99ffbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/O9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("y76o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d154dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("bnKk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d154dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/TF9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YjR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/zxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

__webpack_require__("H/Zg");
__webpack_require__("zD7H");

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api');

var Account = function () {
    function Account() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Account);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Account, [{
        key: 'save',

        /**
         * Save new user's account
         * @returns {Promise}
         */
        value: function save(data) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.post(api.auth.registration, data).then(function () {
                    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('modals', {
                        modal: 'alert',
                        data: {
                            visible: true,
                            message: 'Registration complete. You can now log in.',
                            reload: false
                        }
                    });
                    resolve();
                }, function (error) {
                    switch (error.status) {
                        default:
                            _this.errorMessage(error);
                            break;
                    }
                    reject();
                });
            });
        }

        /**
         * Display error message
         * @param error
         */

    }, {
        key: 'errorMessage',
        value: function errorMessage(error) {
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('modals', {
                modal: 'alert',
                data: {
                    visible: true,
                    message: error.data.message[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.data.message)[0]],
                    reload: false
                }
            });
        }
    }]);

    return Account;
}();

__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.service('account', Account);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "03uI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__options_HeaderOptionsSignout_vue__ = __webpack_require__("/45B");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { HeaderOptionsSignout: __WEBPACK_IMPORTED_MODULE_0__options_HeaderOptionsSignout_vue__["a" /* default */] }
});

/***/ }),

/***/ "0AIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketUpdate_vue__ = __webpack_require__("s/3Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f931c30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketUpdate_vue__ = __webpack_require__("FRPg");
function injectStyle (ssrContext) {
  __webpack_require__("DEop")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f931c30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f931c30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Dow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_perfectmoney_component"}},[_c('p',[_vm._v("Perfect Money")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('perfect-money-account-number',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0EFW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0QUt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Stp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_PayoutHistoryContent_vue__ = __webpack_require__("Zbdh");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], PayoutHistoryContent: __WEBPACK_IMPORTED_MODULE_1__content_PayoutHistoryContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "0W7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('city', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "0d1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__("dDoS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['filters'],
    computed: {
        open: function open() {
            return this.$store.getters.commissionsFilter;
        }
    },
    methods: {
        hideFilter: function hideFilter() {
            if (this.open) {
                this.$store.commit('commissionsFilterOff');
            }
        },


        /**
         * Set filter
         * @param event
         * @param value
         */
        setFilter: function setFilter(event, value) {
            var checked = event.target.checked;

            if (checked) {
                this.$store.commit('commissionsAddFilter', value);
            } else {
                this.$store.commit('commissionsRemoveFilter', value);
            }
            this.getData();
        },


        /**
         * Get data
         */
        getData: function getData() {
            var settings = this.$store.getters.commissionsSettings;

            this.$store.dispatch('loadCommissions', {
                params: settings
            });
        }
    },
    mounted: function mounted() {
        var defaultFilter = this.$store.getters.commissionsSettings.filter;

        for (var filter in defaultFilter) {
            document.querySelector('#filter_' + defaultFilter[filter]).checked = true;
        }
    },

    directives: {
        ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
    }
});

/***/ }),

/***/ "0kVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('div',{staticClass:"modal-component",attrs:{"id":"modal_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.hideModal()}}}),_vm._v(" "),_c('div',{staticClass:"modal-inner"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[(_vm.security == 'GOOGLE_AUTHENTICATOR')?_c('p',{staticClass:"p1"},[_vm._v("Put here code from google\n                                authenticator"),_c('br'),_vm._v(" and confirm your transaction:")]):_vm._e(),_vm._v(" "),(_vm.security == 'EMAIL')?_c('p',{staticClass:"p1"},[_vm._v("Check your email address, put here code from\n                                message"),_c('br'),_vm._v(" and confirm your transaction.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-form-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","name":"code","data-vv-rules":"required"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code') && _vm.showErrors),expression:"errors.has('code') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('code')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.validCode),expression:"!validCode"}],staticClass:"field-error--description"},[_vm._v("Invalid code, please try\n                                    again.")])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"button--cancel",on:{"click":function($event){_vm.progress ? '' : _vm.hideModal()}}},[_vm._v("Cancel\n                                ")]),_vm._v(" "),_c('button',{staticClass:"button--action button--confirm",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Confirm\n                                ")])])])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0vf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'news',"title":'News'}}),_vm._v(" "),_c('news-content')],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0xrw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bitcoin_BitcoinAccountNumber_vue__ = __webpack_require__("MjI1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], BitcoinAccountNumber: __WEBPACK_IMPORTED_MODULE_1__bitcoin_BitcoinAccountNumber_vue__["a" /* default */] }
});

/***/ }),

/***/ "1180":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.showErrorPage)?_c('layout'):_vm._e(),_vm._v(" "),(_vm.code == 404 && _vm.showErrorPage)?_c('error-404'):_vm._e(),_vm._v(" "),(_vm.code == 500 && _vm.showErrorPage)?_c('error-500'):_vm._e(),_vm._v(" "),(_vm.code == 503 && _vm.showErrorPage)?_c('error-503'):_vm._e(),_vm._v(" "),[_c('footer',[_c('cookie-law',{attrs:{"theme":"dark-lime"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n                    This website uses cookies to ensure you get the best experience on our website.\n                    More details "),_c('a',{attrs:{"href":"https://futuro.network/terms","target":"_blank"}},[_vm._v("HERE")]),_vm._v(".\n                ")])])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "17Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoModal_vue__ = __webpack_require__("seo/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501a5251_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoModal_vue__ = __webpack_require__("Oe1L");
function injectStyle (ssrContext) {
  __webpack_require__("40rL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-501a5251"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501a5251_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1BnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__item_SectionMenuItem_vue__ = __webpack_require__("pXg3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { SectionMenuItem: __WEBPACK_IMPORTED_MODULE_0__item_SectionMenuItem_vue__["a" /* default */] },
    props: ['active', 'title'],
    data: function data() {
        return {
            menu: {
                dashboard: {
                    name: 'Dashboard',
                    path: 'Dashboard',
                    noPacketPath: 'StartPacket',
                    noPacket: true
                },
                withdraw: {
                    name: 'Withdraw',
                    path: 'Withdraw',
                    noPacketPath: 'Withdraw',
                    noPacket: true
                },
                futurocoin: {
                    name: 'Futurocoin',
                    path: 'Futurocoin',
                    noPacket: true
                },
                myStartPacket: {
                    name: 'My start package',
                    path: 'MyStartPacket',
                    parentClickable: true,
                    lv2: {
                        invoices: {
                            name: 'Invoices',
                            path: 'Invoices',
                            external: false
                        }
                    }
                },
                business: {
                    name: 'Business',
                    path: 'Business',
                    lv2: {
                        qualifications: {
                            name: 'Qualifications',
                            path: 'BusinessQualifications',
                            external: false
                        },
                        commissions: {
                            name: 'Commissions',
                            path: 'BusinessCommissions',
                            external: false
                        },
                        codes: {
                            name: 'Vouchers',
                            path: 'Codes',
                            external: false
                        }
                    }
                },
                myTeam: {
                    name: 'My team',
                    path: 'MyTeam'
                },
                payout: {
                    name: 'Payout',
                    path: 'Payout'
                },
                sponsorSystem: {
                    name: 'Sponsor system',
                    path: 'SponsorSystem'
                },
                news: {
                    name: 'News',
                    path: 'News'
                },
                topQualified: {
                    name: 'Top Qualified',
                    path: 'TopQualified'
                },
                profile: {
                    name: 'Profile',
                    path: 'Profile',
                    mobileOnly: true,
                    noPacket: true
                },
                terms: {
                    name: 'Terms of Use',
                    path: 'Terms',
                    noPacket: true,
                    parentClickable: false,
                    lv2: {
                        terms: {
                            name: 'Terms ans Conditions',
                            path: '/static/media/terms-and-conditions.pdf',
                            external: true
                        },
                        commissions: {
                            name: 'Privacy Policy',
                            path: '/static/media/privacy-policy.pdf',
                            external: true
                        }
                    }
                },
                logout: {
                    name: 'Logout',
                    path: 'Logout',
                    mobileOnly: true,
                    noPacket: true
                }
            }
        };
    },

    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "1P/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        informations: function informations() {
            return {
                1: {
                    label: 'My start package',
                    value: 'FND ' + this.$store.getters.user.position,
                    position: 'block-1'
                },
                2: {
                    label: 'My Direct bonus',
                    value: this.$store.getters.user.directBonusPosition + '%',
                    position: 'block-1'
                }
            };
        }
    }
});

/***/ }),

/***/ "1cql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Phone_vue__ = __webpack_require__("+6sf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb505dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Phone_vue__ = __webpack_require__("qwGm");
function injectStyle (ssrContext) {
  __webpack_require__("1pDW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cb505dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Phone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb505dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Phone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1pDW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1rPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlebar_HeaderCookieMessage_vue__ = __webpack_require__("KjUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlebar_HeaderAlertBottom_vue__ = __webpack_require__("4j9y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlebar_HeaderLogo_vue__ = __webpack_require__("I2RA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlebar_HeaderOptions_vue__ = __webpack_require__("QWlQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlebar_HeaderUser_vue__ = __webpack_require__("MHyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__section_menu_MainMenuHamburger_vue__ = __webpack_require__("znVX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: { HeaderAlertBottom: __WEBPACK_IMPORTED_MODULE_1__middlebar_HeaderAlertBottom_vue__["a" /* default */], HeaderLogo: __WEBPACK_IMPORTED_MODULE_2__middlebar_HeaderLogo_vue__["a" /* default */], HeaderCookieMessage: __WEBPACK_IMPORTED_MODULE_0__middlebar_HeaderCookieMessage_vue__["a" /* default */], HeaderOptions: __WEBPACK_IMPORTED_MODULE_3__middlebar_HeaderOptions_vue__["a" /* default */], HeaderUser: __WEBPACK_IMPORTED_MODULE_4__middlebar_HeaderUser_vue__["a" /* default */], MainMenuHamburger: __WEBPACK_IMPORTED_MODULE_5__section_menu_MainMenuHamburger_vue__["a" /* default */] },
    computed: {
        termsAccepted: function termsAccepted() {
            return this.$store.getters.user['terms_of_use_accepted'];
        }
    }
});

/***/ }),

/***/ "1yF1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commissions_CommissionsTotal_vue__ = __webpack_require__("G23/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commissions_CommissionsStats_vue__ = __webpack_require__("Pc0f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commissions_CommissionsTable_vue__ = __webpack_require__("9Z1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['popup', 'totalIncomes'],
    components: { CommissionsTotal: __WEBPACK_IMPORTED_MODULE_0__commissions_CommissionsTotal_vue__["a" /* default */], CommissionsStats: __WEBPACK_IMPORTED_MODULE_1__commissions_CommissionsStats_vue__["a" /* default */], CommissionsTable: __WEBPACK_IMPORTED_MODULE_2__commissions_CommissionsTable_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_3__dashboard_FuturocoinsFromMining_vue__["a" /* default */] },
    mounted: function mounted() {
        this.totalIncomes.fetchData();
    }
});

/***/ }),

/***/ "21ZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has(_vm.fieldKey) && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":'user_data_' + _vm.fieldKey}},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":'user_data_' + _vm.fieldKey,"name":_vm.fieldKey,"type":"text","data-vv-rules":"required|max:255","data-vv-as":_vm.label,"disabled":_vm.sending || _vm.isVerified},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.fieldKey) && _vm.showErrors),expression:"errors.has(fieldKey) && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first(_vm.fieldKey)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "22Uw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('bic_swift') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_bic_swift"}},[_vm._v("\n            BIC/SWIFT\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_bic_swift","name":"bic_swift","type":"text","data-vv-rules":"required|max:255","data-vv-as":"BIC/SWIFT","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bic_swift') && _vm.showErrors ),expression:"errors.has('bic_swift') && showErrors "}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('bic_swift')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "25FX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinRoyalTransfer_vue__ = __webpack_require__("3IYN");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98d3651c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinRoyalTransfer_vue__ = __webpack_require__("92sC");
function injectStyle (ssrContext) {
  __webpack_require__("2JnO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98d3651c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinRoyalTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98d3651c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinRoyalTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "2CVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer"},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"fullscreen-box--content"},[_c('transition',{attrs:{"name":"fadeInUp"}},[(_vm.view == 1)?_c('remind-password-form',{attrs:{"view":_vm.view}}):_vm._e()],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2G/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinHistoryContent_vue__ = __webpack_require__("vxE9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81598ecc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinHistoryContent_vue__ = __webpack_require__("v37A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinHistoryContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81598ecc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinHistoryContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2JJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    countries: []
};

var getters = {
    countries: function countries(state) {
        return state.countries;
    }
};

var mutations = {
    setCountries: function setCountries(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'countries', data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "2JnO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2K5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    computed: {
        panel: function panel() {

            var unilevelTeam = this.$store.getters.user.unilevelTeam;

            return {
                startPacket: {
                    label: 'My start<br>package',
                    value: 'FND ' + this.money.packageFormat(this.$store.getters.user.position, 'fnd'),
                    path: 'MyStartPacket'
                },
                careerLevel: {
                    label: 'My career<br>level',
                    value: this.$store.getters.user.careerLevel,
                    path: 'BusinessQualifications'
                },
                matchingBonus: {
                    label: 'My matching<br>bonus',
                    value: this.$store.getters.user.matchingBonus + '%',
                    path: 'BusinessQualifications'
                },
                unilevel: {
                    label: 'My Unilevel<br>Team',
                    value: unilevelTeam + '<br>' + (unilevelTeam === 1 ? 'Member' : 'Members'),
                    path: 'MyTeam'
                },
                sponsor: {
                    label: 'Futuro Sponsor<br>System',
                    value: 'COMING<BR>SOON!',
                    path: 'SponsorSystem'
                },
                matrixes: {
                    label: 'The amount transferred to FutureNet Products Packs FND 1000',
                    value: 'FND ' + this.money.format(this.$store.getters.user.future_net_upgrade_account_balance, 'fnd'),
                    info: true,
                    path: 'FNProductPacks',
                    small: true
                }
            };
        }
    }
});

/***/ }),

/***/ "2W2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2h5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__topbar_HeaderExchange_vue__ = __webpack_require__("yzjp");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { HeaderExchange: __WEBPACK_IMPORTED_MODULE_0__topbar_HeaderExchange_vue__["a" /* default */] }
});

/***/ }),

/***/ "2jf0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'myStartPacket',"title":'My start<br>package'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('start-packet-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2m+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        reload: function reload() {
            window.location.reload();
        }
    }
});

/***/ }),

/***/ "2pqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_MyTeamContent_vue__ = __webpack_require__("AWN8");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], MyTeamContent: __WEBPACK_IMPORTED_MODULE_1__content_MyTeamContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "2rtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-component",attrs:{"id":"layout_component"}},[(!_vm.$route.meta.hideHeader && _vm.auth)?_c('header',{staticClass:"layout-header"},[_c('layout-header')],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"layout-section"},[_c('router-view',{attrs:{"auth":_vm.auth}})],1),_vm._v(" "),_c('alert'),_vm._v(" "),_c('buy-packet'),_vm._v(" "),_c('withdraw-coins-modal'),_vm._v(" "),(_vm.auth)?_c('autologout-component'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2zo0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "37qr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'money', 'popup'],
    data: function data() {
        return {
            date: '',
            loader: false,
            items: 25
        };
    },

    computed: {
        payouts: function payouts() {
            return this.$store.getters.payouts;
        },
        currentPage: function currentPage() {
            return this.$store.getters.payoutsSettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.payoutsSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.payoutsSettings.numberOfPages;
        }
    },
    methods: {
        /**
         * Change sort
         */
        changeSort: function changeSort(field) {
            var _this = this;

            this.$store.dispatch('payoutsSetSort', field).then(function () {
                _this.getData();
            });
        },

        /**
         * Set default settings
         */
        clearSettings: function clearSettings() {
            var _this2 = this;

            this.$store.dispatch('payoutsSettingsClear').then(function () {
                _this2.getData();
                _this2.items = 25;
            });
        },


        /**
         * Get data with transactions
         */
        getData: function getData() {
            var _this3 = this;

            this.loader = true;

            var settings = this.$store.getters.payoutsSettings;

            this.$store.dispatch('loadPayouts', {
                params: settings
            }).then(function () {
                _this3.loader = false;
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this4 = this;

            this.items = items;
            this.$store.dispatch('payoutsSetItems', items).then(function () {
                _this4.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this5 = this;

            this.$store.dispatch('payoutsSetPage', page).then(function () {
                _this5.getData();
            });
        },


        /**
         * Send confirmation email
         */
        sendConfirmationEmail: function sendConfirmationEmail(id) {
            var _this6 = this;

            this.$http.post(this.api.payout.email, {
                id: id
            }).then(function () {
                _this6.popup.show('Confirmation link was sent on your e-mail address.');
            }, function (error) {
                _this6.popup.show(error.body.errors[0].message);
            });
        },


        /**
         * Cancel payout
         */
        cancelPayout: function cancelPayout(id) {
            var _this7 = this;

            this.$http.post(this.api.payout.cancel, {
                id: id
            }).then(function () {
                _this7.$router.push({ 'name': 'Payout' });
                _this7.popup.show('Payout was cancelled.');
            }, function (error) {
                _this7.popup.show(error.body.errors[0].message);
            });
        }
    },
    watch: {
        /**
         * Get data with transactions if date in calendar was changed
         */
        date: function date() {
            var _this8 = this;

            this.$store.dispatch('payoutsSetDate', this.date).then(function () {
                _this8.getData();
            });
        }
    },
    beforeMount: function beforeMount() {
        var _this9 = this;

        var settings = this.$store.getters.payoutsSettings;

        this.$store.dispatch('loadPayouts', {
            params: settings
        }).then(function () {
            _this9.items = settings.maxPerPage;
        });
    }
});

/***/ }),

/***/ "3IYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    data: function data() {
        return {
            amount: 0,
            progress: false,
            showErrors: false
        };
    },

    computed: {
        available: function available() {
            return this.money.format(this.$store.getters.ftoAccounts.allowToWithdrawFromRoyal, 'fto');
        },
        confirm: function confirm() {
            return this.$store.getters.modals.withdrawCoins.accept;
        },
        type: function type() {
            return this.$store.getters.modals.withdrawCoins.type;
        }
    },
    methods: {
        withdrawAll: function withdrawAll() {
            this.amount = this.available;
        },
        validate: function validate(e) {
            var _this = this;

            if (!this.progress) {
                this.showErrors = false;
                this.$validator.validateAll().then(function () {
                    if (!_this.errors.any() && Number(_this.available) > 0 && Number(_this.amount) <= Number(_this.available)) {
                        _this.$store.commit('modals', {
                            modal: 'withdrawCoins',
                            data: {
                                visible: true,
                                coins: _this.amount,
                                type: 'royal',
                                accept: false
                            }
                        });
                    } else {
                        _this.showErrors = true;
                    }
                });
            }
        }
    }
});

/***/ }),

/***/ "3Qsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankTransfer_vue__ = __webpack_require__("kOpC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2220b52b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankTransfer_vue__ = __webpack_require__("sYzt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2220b52b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Zlc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    computed: {
        defaultValue: function defaultValue() {
            return this.$store.getters.user.email;
        }
    },
    watch: {
        defaultValue: function defaultValue() {
            this.fieldValue = this.defaultValue;
        }
    },
    mounted: function mounted() {
        this.fieldValue = this.defaultValue;
    }
});

/***/ }),

/***/ "3cPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[(!_vm.hasPacket)?_c('check-fnwallet'):_vm._e(),_vm._v(" "),(_vm.hasPacket)?_c('futurocoins-from-mining'):_vm._e(),_vm._v(" "),_c('form',{attrs:{"autocomplete":"off"}},[_c('b-row',{staticClass:"profile-edit-data-header",attrs:{"id":"profile_edit_data_header"}},[_c('b-col',{attrs:{"lg":"12"}},[_c('h3',[_vm._v("Profile - edit data")])]),_vm._v(" "),_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'first name',"field-key":'first_name',"property":'firstName',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'last name',"field-key":'last_name',"property":'lastName',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('b-col',{staticClass:"empty",attrs:{"lg":"4"}}),_vm._v(" "),_c('email'),_vm._v(" "),_c('phone',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('b-col',{staticClass:"empty",attrs:{"lg":"4"}}),_vm._v(" "),_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'street',"field-key":'street',"property":'street',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'city',"field-key":'city',"property":'city',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('b-col',{staticClass:"empty",attrs:{"lg":"4"}}),_vm._v(" "),_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'zip code',"field-key":'zip',"property":'postalCode',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('autocomplete-component',{attrs:{"default-value":_vm.defaultValues.country,"disabled":_vm.progress || _vm.isVerified,"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.updateValue}})],1),_vm._v(" "),_c('b-col',{staticClass:"empty",attrs:{"lg":"4"}}),_vm._v(" "),_c('birthdate',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('gender',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"update-value":_vm.updateValue,"change-event":_vm.toggleCompanyFields,"is-verified":_vm.isVerified}}),_vm._v(" "),_c('b-col',{staticClass:"empty",attrs:{"lg":"4"}}),_vm._v(" "),(_vm.showCompanyFields)?_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'company name',"field-key":'company_name',"property":'companyName',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}):_vm._e(),_vm._v(" "),(_vm.showCompanyFields)?_c('textfield',{attrs:{"sending":_vm.progress,"show-errors":_vm.showErrors,"label":'company registration number',"field-key":'company_registration_number',"property":'companyRegistrationNumber',"update-value":_vm.updateValue,"is-verified":_vm.isVerified}}):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"row-buttons"},[_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('router-link',{staticClass:"button--cancel-red",attrs:{"to":{ name: 'Profile' }}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.isVerified)?_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress },attrs:{"type":"button"},on:{"click":function($event){!_vm.progress ? _vm.validate() : false}}},[_vm._v("Save data")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3eU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-user-component",attrs:{"id":"header_user_component"}},[_c('div',{staticClass:"header-profile-inner"},[_c('router-link',{attrs:{"to":{ path: '/profile' }}},[_c('div',{staticClass:"header-profile-fullname"},[_vm._v("\n                "+_vm._s(_vm.fullname)+"\n            ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "40rL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "49/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamTreeLevel_vue__ = __webpack_require__("joDf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef9e694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamTreeLevel_vue__ = __webpack_require__("fhvM");
function injectStyle (ssrContext) {
  __webpack_require__("J1J0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamTreeLevel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef9e694_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamTreeLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4EqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_DashboardFirstTimeContent_vue__ = __webpack_require__("wUzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_InfoModal__ = __webpack_require__("17Xg");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'status', 'user'],
    props: ['auth', 'mobile, user'],
    components: { InfoModal: __WEBPACK_IMPORTED_MODULE_2__modals_InfoModal__["a" /* default */], MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], DashboardFirstTimeContent: __WEBPACK_IMPORTED_MODULE_1__content_DashboardFirstTimeContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        if (!this.$store.getters.checkAuth) {
            this.$http.get(this.api.auth.user).then(function (response) {
                _this.user.fetchData(response.data).then(function () {
                    if (_this.$store.getters.user.position != 0) {
                        _this.$router.push({ name: 'Dashboard' });
                    }
                });
            }, function (error) {
                switch (error.status) {
                    case 401:
                        _this.$store.commit('setRedirect', { name: 'Send' });
                        break;
                    default:
                        _this.status['status' + error.status](next);
                        break;
                }
            });
        } else {
            if (this.$store.getters.user.position != 0) {
                this.$router.push({ name: 'Dashboard' });
            }
        }
    }
});

/***/ }),

/***/ "4M7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "4j9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdcd11c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderAlertBottom_vue__ = __webpack_require__("vrhb");
function injectStyle (ssrContext) {
  __webpack_require__("j9I8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bdcd11c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdcd11c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderAlertBottom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "50Yw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5EBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutHistory_vue__ = __webpack_require__("0Stp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c45396_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutHistory_vue__ = __webpack_require__("QkmV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c45396_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5K2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');

var Statistics = function () {
    function Statistics() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Statistics);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Statistics, [{
        key: 'fetchData',
        value: function fetchData() {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.reports.statistics).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setStatistics', response.body);
            });
        }
    }]);

    return Statistics;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('statistics', Statistics);

/***/ }),

/***/ "5YtG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5a7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BusinessQualificationsTurnoverTooSmall_vue__ = __webpack_require__("RRqH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    components: { BusinessQualificationsTurnoverTooSmall: __WEBPACK_IMPORTED_MODULE_0__BusinessQualificationsTurnoverTooSmall_vue__["a" /* default */] },
    computed: {
        option: function option() {
            return this.$store.getters.qualifications.option;
        },
        informations: function informations() {
            return {
                0: {
                    label: 'My career level <br class="desktop-only">(from the previous month)',
                    value: this.$store.getters.user.previousCareerLevel
                },
                1: {
                    label: 'My career level <br class="desktop-only">(worked out this month)',
                    value: this.$store.getters.user.currentMonthCareerLevel
                },
                2: {
                    label: 'My monthly turnover <br class="desktop-only"><br class="desktop-only">',
                    value: 'FND ' + this.money.format(this.$store.getters.statistics.turnoverMonthly, 'fnd')
                },
                3: {
                    label: 'Career sponsor Bonus',
                    value: this.$store.getters.user.directBonusCareerLevel + '%'
                },
                4: {
                    label: 'Matching Bonus',
                    value: this.$store.getters.user.matchingBonus + '%'
                },
                5: {
                    label: 'Car Bonus',
                    value: 'FND ' + this.money.format(this.$store.getters.user.lastCarBonus, 'fnd'),
                    notice: '* paid monthly'
                },
                6: {
                    label: 'Business Bonus',
                    value: 'FND ' + this.money.format(this.$store.getters.user.lastBusinessBonus, 'fnd'),
                    notice: '* paid monthly'
                }
            };
        }
    },
    data: function data() {
        return {
            update: {
                label: 'If you want to go to the next position you must make an update in your Start Packet',
                value: 'Make an update',
                url: 'StartPacket'
            }
        };
    }
});

/***/ }),

/***/ "5iRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item form-input",class:{ 'form-item--error': _vm.errors.has(_vm.name) && _vm.showErrors }},[((_vm.type ? _vm.type : 'text')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],ref:_vm.name,attrs:{"placeholder":_vm.label,"name":_vm.name,"id":'register_form_' + _vm.name,"data-vv-rules":_vm.rules,"data-vv-as":_vm.label,"disabled":_vm.progress || _vm.disabled,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}):((_vm.type ? _vm.type : 'text')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],ref:_vm.name,attrs:{"placeholder":_vm.label,"name":_vm.name,"id":'register_form_' + _vm.name,"data-vv-rules":_vm.rules,"data-vv-as":_vm.label,"disabled":_vm.progress || _vm.disabled,"type":"radio"},domProps:{"checked":_vm._q(_vm.value,null)},on:{"change":function($event){_vm.value=null}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],ref:_vm.name,attrs:{"placeholder":_vm.label,"name":_vm.name,"id":'register_form_' + _vm.name,"data-vv-rules":_vm.rules,"data-vv-as":_vm.label,"disabled":_vm.progress || _vm.disabled,"type":_vm.type ? _vm.type : 'text'},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.name) && _vm.showErrors),expression:"errors.has(name) && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first(_vm.name)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5k63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);








__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api'),
    status = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('status');

var state = {
    fnproductPacks: [],

    fnproductPacksSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: []
    }
};

var getters = {
    fnproductPacks: function fnproductPacks(state) {
        return state.fnproductPacks;
    },

    fnproductPacksSettings: function fnproductPacksSettings(state) {
        return state.fnproductPacksSettings;
    }
};

var mutations = {
    /**
     * Set daily mining in store
     * @param state
     * @param data
     */
    setFnproductPacks: function setFnproductPacks(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'fnproductPacks', data.results);
        } else {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'fnproductPacks', []);
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.fnproductPacksSettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.fnproductPacksSettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.fnproductPacksSettings, 'numberOfPages', data.number_of_pages);
    }
};

var actions = {
    /**
     * Get daily mining data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadFnproductPacks: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                var settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(data);

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.transferToFN.history(settings.params)).then(function (response) {
                                    commit('setFnproductPacks', response.data);
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    reject();
                                });
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadFnproductPacks(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return loadFnproductPacks;
    }(),


    /**
     * Set max number of items in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    fnproductPacksSetItems: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.fnproductPacksSettings, 'maxPerPage', data);
                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function fnproductPacksSetItems(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return fnproductPacksSetItems;
    }(),


    /**
     * Set page in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    fnproductPacksSetPage: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.fnproductPacksSettings, 'currentPage', data);
                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function fnproductPacksSetPage(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return fnproductPacksSetPage;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "5kAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"bottombar-component",attrs:{"id":"bottombar_component"}},[_c('b-col',{attrs:{"lg":"3"}}),_vm._v(" "),_c('b-col',{staticClass:"header-stats",attrs:{"cols":"12","lg":"9","id":"header_stats"}},[_c('header-stats')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5nD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be6aa7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesHeader_vue__ = __webpack_require__("Ed/3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be6aa7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5qFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{attrs:{"id":"header_alert_component"}},[_c('div',{staticClass:"header-alert--inside"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"12px"}},[_c('button',{staticClass:"button--cancel-white",on:{"click":function($event){return _vm.confirm()}}},[_vm._v("OK")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "65uj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_bitcoin_component"}},[_c('p',[_vm._v("Bitcoin")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('bitcoin-account-number',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "673Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Aa5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6B5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"stats-item-component"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.value + ' FTO')}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6L2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    statistics: {
        incomeDaily: 0,
        incomeWeekly: 0,
        incomeMonthly: 0,
        turnoverDaily: 0,
        turnoverWeekly: 0,
        turnoverMonthly: 0
    }
};

var getters = {
    statistics: function statistics(state) {
        return state.statistics;
    }
};

var mutations = {
    setStatistics: function setStatistics(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'statistics', {
            incomeDaily: data.income_daily,
            incomeWeekly: data.income_weekly,
            incomeMonthly: data.income_monthly,
            turnoverDaily: data.turnover_daily,
            turnoverWeekly: data.turnover_weekly,
            turnoverMonthly: data.turnover_monthly
        });
    }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "6PyL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_InvoicesContent_vue__ = __webpack_require__("TAYD");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], InvoicesContent: __WEBPACK_IMPORTED_MODULE_1__content_InvoicesContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "6vbn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money', 'statistics'],
    computed: {
        stats: function stats() {
            return {
                1: {
                    label: 'My income today',
                    label_mobile: 'Today',
                    value: this.money.format(this.$store.getters.statistics.incomeDaily, 'fnd')
                },

                2: {
                    label: 'My weekly income',
                    label_mobile: 'Week',
                    value: this.money.format(this.$store.getters.statistics.incomeWeekly, 'fnd')
                },
                3: {
                    label: 'My monthly income',
                    label_mobile: 'Monthly',
                    value: this.money.format(this.$store.getters.statistics.incomeMonthly, 'fnd')
                },
                4: {
                    label: 'My turnover today',
                    label_mobile: 'Today',
                    value: this.money.format(this.$store.getters.statistics.turnoverDaily, 'fnd')
                },
                5: {
                    label: 'Weekly turnover',
                    label_mobile: 'Week',
                    value: this.money.format(this.$store.getters.statistics.turnoverWeekly, 'fnd')
                },

                6: {
                    label: 'My monthly turnover',
                    label_mobile: 'Monthly',
                    value: this.money.format(this.$store.getters.statistics.turnoverMonthly, 'fnd')
                }
            };
        }
    },
    mounted: function mounted() {
        this.statistics.fetchData();
    }
});

/***/ }),

/***/ "7/Py":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "79ri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_WalletName_vue__ = __webpack_require__("HzLc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Description_vue__ = __webpack_require__("M1PE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], WalletName: __WEBPACK_IMPORTED_MODULE_1__common_WalletName_vue__["a" /* default */], Description: __WEBPACK_IMPORTED_MODULE_2__common_Description_vue__["a" /* default */] }
});

/***/ }),

/***/ "7D7A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7M2v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"futurocoin-table-component",attrs:{"id":"royal-bonuses_table_component"}},[_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("Bonuses")]),_vm._v(" "),_c('div',{staticClass:"futurocoin-table-outer table-responsive"},[_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.royalBonusesList),function(amount,bonus){return (amount > 0)?_c('tr',{key:_vm.index},[_c('td',[_c('p',[_vm._v(_vm._s(bonus.replace('_', ' ')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.money.format(amount, 'fto'))+" FTO")])])]):_vm._e()}),0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('p',[_vm._v("Bonus")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Amount")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Q6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('zip', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "7alQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Verification_vue__ = __webpack_require__("U2Rs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7419f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Verification_vue__ = __webpack_require__("zdo5");
function injectStyle (ssrContext) {
  __webpack_require__("mVWM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f7419f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Verification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7419f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Verification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7j/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"futurocoin-withdraw-component",attrs:{"id":"futurocoin_withdraw_component","no-gutters":""}},[_c('b-col',{staticClass:"futurocoin-withdraw-info",attrs:{"lg":"4","md":"4","cols":"12"}},[_c('p',{staticClass:"color--gray"},[_vm._v(_vm._s(_vm.withdraw.date)+" you can withdraw "+_vm._s(_vm.withdraw.percent)+"%\n            of your FuturoCoins")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7nsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a);

__webpack_require__("H/Zg");
__webpack_require__("C/dE");
__webpack_require__("ye8Q");

var api = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('api'),
    popup = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('popup'),
    user = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('user');

var Packet = function () {
    function Packet() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Packet);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Packet, [{
        key: 'create',

        /**
         * Create recipient
         * @param value
         */
        value: function create(value) {
            this.value = value;
        }

        /**
         * Buy packet
         */

    }, {
        key: 'buy',
        value: function buy(method, code, upgrade) {
            var _this = this;

            var params = {};

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (method === 'futurenetAccount') {
                    params = {
                        package: _this.value
                    };

                    if (upgrade) {
                        params['upgradePackageId'] = upgrade;
                    }

                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.package.buy, params).then(function (response) {
                        user.reloadData(response.data).then(function () {
                            popup.show('The package has been bought correctly.');
                            __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'Dashboard' });
                            resolve();
                        });
                    }, function (error) {
                        reject(error);
                    });
                } else if (method === 'transferMoney') {
                    params = {
                        product: _this.value
                    };

                    if (upgrade) {
                        params['upgradePackageId'] = upgrade;
                    }
                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.futurepay.buy, params).then(function (response) {
                        window.open(response.data.data.url, '_self');
                        resolve();
                    }, function (error) {
                        reject(error);
                    });
                } else if (method === 'code') {
                    params = {
                        package: _this.value,
                        code: code
                    };

                    if (upgrade) {
                        params['upgradePackageId'] = upgrade;
                    }

                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.futurepay.buyWithCode, params).then(function (response) {
                        user.reloadData(response.data).then(function () {
                            popup.show('The package has been bought correctly.');
                            __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'Dashboard' });
                            resolve();
                        });
                    }, function (error) {
                        reject(error);
                    });
                } else if (method === 'bitcoin') {
                    params = {
                        product: _this.value
                    };

                    if (upgrade) {
                        params['upgradePackageId'] = upgrade;
                    }

                    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.microWallet.buyPackage, params).then(function (response) {
                        user.reloadData(response.data).then(function () {
                            popup.show('The package has been bought correctly.');
                            __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'Dashboard' });
                            resolve();
                        });
                    }, function (error) {
                        reject(error);
                    });
                }
            });
        }
    }]);

    return Packet;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('packet', Packet);

/***/ }),

/***/ "7o89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("Uf2K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69123098_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("pvNk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69123098_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7vMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"security tr",attrs:{"id":"security"}},[_c('h3',[_vm._v("Security")]),_vm._v(" "),_c('h4',[_vm._v("Two-factor authentication method")]),_vm._v(" "),_c('div',{attrs:{"id":"security_settings"}},[_c('param-component',{attrs:{"input-label":'For login',"list":_vm.loginOptions,"param-key":'two_step_login',"param-label":'Two step login',"param-name":'twoStepLogin',"param-settings-name":'TWO_STEP_LOGIN_VERIFICATION'}}),_vm._v(" "),_c('param-component',{attrs:{"input-label":'For payouts',"list":_vm.payoutsOptions,"param-key":'payouts',"param-label":'Payouts',"param-name":'payouts',"param-settings-name":'TWO_STEP_PAYOUT_VERIFICATION'}})],1),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"30px"}},[_c('router-link',{staticStyle:{"color":"red"},attrs:{"to":{'name': 'TermsUpdate'}}},[_vm._v("Show the selected consents and statements "),_c('i',{staticClass:"mdi mdi-chevron-right"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7w2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Neteller_vue__ = __webpack_require__("HVqT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60149026_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Neteller_vue__ = __webpack_require__("k5sS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Neteller_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60149026_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Neteller_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "83Un":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinWithdraw_vue__ = __webpack_require__("WRaB");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b69eccc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinWithdraw_vue__ = __webpack_require__("7j/f");
function injectStyle (ssrContext) {
  __webpack_require__("iwU3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b69eccc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinWithdraw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b69eccc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinWithdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "840f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer",style:({ overflow: _vm.view == 2 ? 'hidden' : 'auto' })},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"fullscreen-box--content",class:{'center': _vm.view != 0 && _vm.view != 6}},[_c('transition',{attrs:{"name":"fadeInUp"}},[_c('login-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 0),expression:"view == 0"}],attrs:{"view":_vm.view,"save-captcha":_vm.saveCaptcha}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fadeInUp"}},[(_vm.view == 1)?_c('token-form',{attrs:{"view":_vm.view,"captcha-value":_vm.captchaValue}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fadeInUp"}},[(_vm.view == 3)?_c('forgot-password',{attrs:{"view":_vm.view}}):_vm._e()],1)],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8VDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Textfield_vue__ = __webpack_require__("bzZn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c4f5bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textfield_vue__ = __webpack_require__("21ZQ");
function injectStyle (ssrContext) {
  __webpack_require__("2zo0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7c4f5bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Textfield_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c4f5bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textfield_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8cK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start-packet-list-component",attrs:{"id":"start_packet_list_component"}},[_c('p',{staticStyle:{"margin-bottom":"11px"}},[_vm._v("Congratulations! Below your mining packages:")]),_vm._v(" "),_c('div',{staticClass:"codes-list-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.packages),function(single,index){return _c('tr',{key:index},[_c('td',[_c('p',[_vm._v("FND "+_vm._s(single.position))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v("FND "+_vm._s(_vm.money.format(single.value, 'fnd')))])]),_vm._v(" "),_c('td',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.datetime.utcToLocal(single.date)))])])]),_vm._v(" "),_c('td',[((!single.was_upgraded && !single.is_expired) || !single.is_expired)?_c('p',[_vm._v("working")]):_c('p',[_vm._v("not working")])]),_vm._v(" "),_c('td',[(_vm.countDays(single.date).days > 0 && !single.is_expired && !single.was_upgraded)?_c('p',[_vm._v(_vm._s(_vm.countDays(single.date).days + ' ' + _vm.countDays(single.date).word))]):_vm._e(),_vm._v(" "),(_vm.countDays(single.date).days < 1 && !single.is_expired && !single.was_upgraded)?_c('p',[_vm._v("expired (time is over)")]):_vm._e(),_vm._v(" "),(single.was_upgraded || (single.was_upgraded && single.is_expired))?_c('p',[_vm._v("upgraded")]):_vm._e()]),_vm._v(" "),_c('td',[(!single.is_expired && _vm.countDays(single.date).days >= 0 && parseInt(single.position) < 25000 && !single.was_upgraded)?_c('button',{staticClass:"button--primary",on:{"click":function($event){return _vm.buyPacket(single.position, single.id)}}},[_vm._v("Upgrade")]):_vm._e()])])}),0)]),_vm._v(" "),(_vm.packages.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No results.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('p',[_vm._v("Value")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Amount paid")])]),_vm._v(" "),_c('th',[_c('p',[_c('strong',[_vm._v("Date of purchase")])])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Status")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Time to make an upgrade")])]),_vm._v(" "),_c('th',[_c('p')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8feS":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("H/Zg");
__webpack_require__("/zxG");
__webpack_require__("haes");
__webpack_require__("iN9T");
__webpack_require__("W9ib");
__webpack_require__("Vg51");
__webpack_require__("P1AA");
__webpack_require__("8mae");
__webpack_require__("vV8N");
__webpack_require__("RCno");
__webpack_require__("xxgd");
__webpack_require__("7nsf");
__webpack_require__("wa+Y");
__webpack_require__("C/dE");
__webpack_require__("dSZ5");
__webpack_require__("+Ur2");
__webpack_require__("HE03");
__webpack_require__("zD7H");
__webpack_require__("5K2O");
__webpack_require__("FjY8");
__webpack_require__("B8Z6");
__webpack_require__("J+4p");
__webpack_require__("ye8Q");
__webpack_require__("K20k");

/***/ }),

/***/ "8fwS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8hLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['ranking', 'selected', 'setRanking'],
    data: function data() {
        return {
            openList: false,
            hoverList: false
        };
    }
});

/***/ }),

/***/ "8mae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');

var FtoAccounts = function () {
    function FtoAccounts() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FtoAccounts);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FtoAccounts, [{
        key: 'fetchData',
        value: function fetchData() {
            if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.checkAuth) {
                __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.user.ftoAccounts).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setFtoAccounts', response.body.data);
                });
            }
        }
    }]);

    return FtoAccounts;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('ftoAccounts', FtoAccounts);

/***/ }),

/***/ "8o3D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("r0SI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06116069_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("jgsZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06116069_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8zyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['invoice', 'money', 'monthlyStatement'],
    data: function data() {
        return {
            loader: true,
            tableHeaders: {
                date: 'Date',
                value: 'Value',
                invoice: 'Invoice'
            }
        };
    },

    computed: {
        tableRows: function tableRows() {
            return this.$store.getters.monthlyStatement;
        }
    },
    methods: {
        downloadLink: function downloadLink(period) {
            return this.monthlyStatement.getDownloadLink(period);
        }
    },
    created: function created() {
        var _this = this;

        this.monthlyStatement.fetchData().then(function () {
            _this.loader = false;
        });
    }
});

/***/ }),

/***/ "92sC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',{staticClass:"futurocoin-transfer-component",attrs:{"id":"futurocoin_transfer_component"}},[_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('div',{staticClass:"form-item form-item-amount"},[_c('div',{staticClass:"transfer-value",class:{ 'field-error': (_vm.errors.has('withdraw_royal') || _vm.available < 0) && _vm.showErrors }},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],attrs:{"type":"text","name":"withdraw_royal","data-vv-rules":"required|money|greaterThanZero","data-vv-as":"amount","disabled":_vm.progress},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"currency"},[_vm._v("FTO")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('withdraw_royal') && _vm.showErrors),expression:"errors.has('withdraw_royal') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('withdraw_royal')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.available < _vm.amount && _vm.showErrors),expression:"available < amount && showErrors"}],staticClass:"field-error--description"},[_vm._v("Not enough founds")])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('div',{staticClass:"transfer-get-all"},[_c('p',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.withdrawAll()}}},[_vm._v("withdraw all available coins")])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress }},[_vm._v("Transfer to wallet")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "93WT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['code', 'money'],
    data: function data() {
        return {
            items: 25
        };
    },

    computed: {
        currentPage: function currentPage() {
            return this.$store.getters.listSettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.listSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.listSettings.numberOfPages;
        },
        loader: function loader() {
            return this.$store.getters.codes.isListLoading;
        },
        codes: function codes() {
            return this.$store.getters.codes.list;
        },
        settings: function settings() {
            return this.$store.getters.listSettings;
        }
    },
    methods: {
        /**
         * Get data with transactions
         */
        getData: function getData() {
            this.code.fetchList(this.settings);
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this = this;

            this.items = items;
            this.$store.dispatch('listSetItems', items).then(function () {
                _this.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this2 = this;

            this.$store.dispatch('listSetPage', page).then(function () {
                _this2.getData();
                window.scrollTo(0, 0);
            });
        },


        /**
         * Get row number
         */
        rowNumber: function rowNumber(index) {
            return (this.currentPage - 1) * this.maxPerPage + index + 1;
        },


        /**
         * Code status
         * @param code
         */
        codeStatus: function codeStatus(code) {
            return code.status.replace(/_/g, ' ');
        },


        /**
         * Cancel code
         * @param code
         */
        cancelCode: function cancelCode(code) {
            this.code.cancelCode(code);
            this.setPage(1);
            this.getData();
        }
    },
    mounted: function mounted() {
        this.getData();
    }
});

/***/ }),

/***/ "99wC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoices_InvoicesHeader_vue__ = __webpack_require__("5nD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invoices_InvoicesTable_vue__ = __webpack_require__("Mocx");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['invoice'],
    mounted: function mounted() {
        this.invoice.fetchPackageList();
    },

    components: { FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__["a" /* default */], InvoicesHeader: __WEBPACK_IMPORTED_MODULE_1__invoices_InvoicesHeader_vue__["a" /* default */], InvoicesTable: __WEBPACK_IMPORTED_MODULE_2__invoices_InvoicesTable_vue__["a" /* default */] }
});

/***/ }),

/***/ "9AEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinTable_vue__ = __webpack_require__("H8fS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c5aefc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinTable_vue__ = __webpack_require__("X/bZ");
function injectStyle (ssrContext) {
  __webpack_require__("673Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c5aefc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c5aefc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9DQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-team-tree"},[_c('b-row',{staticClass:"my-team-tree__search"},[_c('b-col',{attrs:{"col":"","lg":"4","cols":"12"}},[_c('dropdown-component',{attrs:{"autocomplete":true,"searchUrl":_vm.api.user.tree.search,"onElementClick":_vm.loadTree}})],1)],1),_vm._v(" "),_vm._l((_vm.tree),function(level,levelIndex){return _c('div',{staticClass:"my-team-tree__level"},[_c('my-team-tree-level',{attrs:{"levelIndex":levelIndex,"items":level}})],1)}),_vm._v(" "),_c('div',{staticClass:"my-team-tree__buttons"},[_c('a',{staticClass:"button--primary",attrs:{"disabled":!_vm.areButtonsAvailable},on:{"click":function($event){return _vm.backToPreviousLevel()}}},[_vm._v("Back to previous level")]),_vm._v(" "),_c('a',{staticClass:"button--primary",attrs:{"disabled":!_vm.areButtonsAvailable},on:{"click":function($event){return _vm.treeReset()}}},[_vm._v("Tree reset")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9F0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPanel_vue__ = __webpack_require__("2K5F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1510f26e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPanel_vue__ = __webpack_require__("uc3K");
function injectStyle (ssrContext) {
  __webpack_require__("kD/R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1510f26e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1510f26e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Hxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("M+H2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399a9bba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("0vf/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399a9bba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9L9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('birth_date') && _vm.showErrors }},[_c('label',{staticClass:"form-label"},[_vm._v("\n            Birth date\n        ")]),_vm._v(" "),_c('div',{staticClass:"date--outer"},[(!_vm.isVerified)?_c('datepicker',{attrs:{"disabled":_vm.sending,"options":{ mode: 'single', maxDate: 'today', defaultDate: _vm.fieldValue }},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","id":"user_data_birth_date","name":"birth_date","data-vv-as":"birth date","data-vv-rules":"required","readonly":true,"disabled":_vm.sending || _vm.isVerified},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('birth_date') && _vm.showErrors),expression:"errors.has('birth_date') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('birth_date')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Nmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('coming-soon')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9O5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header_options_signout_component"}},[_c('div',{staticClass:"header-options-inner header-options-signout-inner"},[_c('div',{staticClass:"header-options-icon header-options-icon-color--gray"},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":{ name: 'Logout' }}},[_c('span',{staticClass:"mdi mdi-power",attrs:{"title":"Logout"}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9TqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingPlanContent_vue__ = __webpack_require__("fNFs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7960df50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingPlanContent_vue__ = __webpack_require__("xk9m");
function injectStyle (ssrContext) {
  __webpack_require__("fW/9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7960df50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingPlanContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7960df50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingPlanContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Vq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatementTable_vue__ = __webpack_require__("8zyc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0885a66b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatementTable_vue__ = __webpack_require__("iiO/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatementTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0885a66b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatementTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Z1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsTable_vue__ = __webpack_require__("auol");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56ce32ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsTable_vue__ = __webpack_require__("S+rs");
function injectStyle (ssrContext) {
  __webpack_require__("AWOr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56ce32ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9dc0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9iuO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api'),
    datetime = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('datetime'),
    status = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('status');

var state = {
    dailyMining: {},

    dailyMiningSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: []
    },

    futurocoinWithdraw: {}
};

var getters = {
    dailyMining: function dailyMining(state) {
        return state.dailyMining;
    },

    dailyMiningSettings: function dailyMiningSettings(state) {
        return state.dailyMiningSettings;
    },

    futurocoin: function futurocoin(state) {
        return state.futurocoin;
    },

    futurocoinWithdraw: function futurocoinWithdraw(state) {
        return state.futurocoinWithdraw;
    }
};

var mutations = {
    /**
     * Set daily mining in store
     * @param state
     * @param data
     */
    setDailyMining: function setDailyMining(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'dailyMining', data.results);
        } else {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'dailyMining', []);
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'numberOfPages', data.number_of_pages);
    },


    /**
     * Set futurocoin withdraw in store
     * @param state
     * @param data
     */
    setFuturocoinWithdraw: function setFuturocoinWithdraw(state, data) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'futurocoinWithdraw', data);
    }
};

var actions = {

    /**
     * Get daily mining data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadDailyMining: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (data) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                var settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(data);
                                if (settings.params.sort) {
                                    var sort = [];
                                    for (var field in data.params.sort) {
                                        sort.push(data.params.sort[field]);
                                    }
                                    settings.params.sort = sort;
                                }
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.mining.history(settings.params)).then(function (response) {
                                    commit('setDailyMining', response.data);
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    reject();
                                });
                            }));

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadDailyMining(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return loadDailyMining;
    }(),


    /**
     * Set sorting in daily mining
     * @param field
     * @returns {Promise}
     */
    dailyMiningSetSort: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, field) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                var sort = state.dailyMiningSettings.sort,
                                    isSet = false;

                                for (var sortId in sort) {
                                    if (!isSet && sort[sortId].field === field) {
                                        isSet = sortId;
                                    }
                                }

                                if (!isSet) {
                                    sort.push({
                                        field: field,
                                        order: 'ASC'
                                    });
                                } else {
                                    sort[isSet].order = sort[isSet].order === 'DESC' ? 'ASC' : 'DESC';
                                }

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'sort', sort);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function dailyMiningSetSort(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return dailyMiningSetSort;
    }(),


    /**
     * Set max number of items in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    dailyMiningSetItems: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function dailyMiningSetItems(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return dailyMiningSetItems;
    }(),


    /**
     * Set page in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    dailyMiningSetPage: function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

                            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'currentPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function dailyMiningSetPage(_x7, _x8) {
            return _ref8.apply(this, arguments);
        }

        return dailyMiningSetPage;
    }(),


    /**
     * Set date in daily mining
     * @param date
     * @returns {Promise}
     */
    dailyMiningSetDate: function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9, date) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

                            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                var dates = date.split(' to ');

                                if (dates[1]) {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'fromDate', datetime.localToUtc(dates[0]));
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'toDate', datetime.localToUtc(dates[1]));
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'fromDate', datetime.localToUtc(dates[0]));
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.dailyMiningSettings, 'toDate', datetime.localToUtc(__WEBPACK_IMPORTED_MODULE_7_moment___default()().format()));
                                }

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function dailyMiningSetDate(_x9, _x10) {
            return _ref10.apply(this, arguments);
        }

        return dailyMiningSetDate;
    }(),


    /**
     * Get futurocoin withdraw from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadFuturocoinWithdraw: function () {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref11) {
            var commit = _ref11.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.user.withdraw).then(function (response) {
                                commit('setFuturocoinWithdraw', response.data.data);
                            }, function (error) {
                                status['status' + error.status]();
                            });

                        case 1:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function loadFuturocoinWithdraw(_x11) {
            return _ref12.apply(this, arguments);
        }

        return loadFuturocoinWithdraw;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "A7YB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A8e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Iban_vue__ = __webpack_require__("kOKg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2d27764_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Iban_vue__ = __webpack_require__("Y996");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Iban_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2d27764_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Iban_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ABJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AIAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('zip') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_zip"}},[_vm._v("\n            Postcode\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_zip","name":"zip","type":"text","data-vv-rules":"required|max:12","data-vv-as":"zip","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('zip') && _vm.showErrors),expression:"errors.has('zip') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('zip')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AJVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketHeader_vue__ = __webpack_require__("1P/q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982e4ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketHeader_vue__ = __webpack_require__("VxMS");
function injectStyle (ssrContext) {
  __webpack_require__("zsLI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982e4ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AMCO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketFooter_vue__ = __webpack_require__("FhA1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780bbb1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketFooter_vue__ = __webpack_require__("nfiH");
function injectStyle (ssrContext) {
  __webpack_require__("qkms")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-780bbb1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780bbb1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AMl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyPacket_vue__ = __webpack_require__("yeq5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8a1ee2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyPacket_vue__ = __webpack_require__("VECj");
function injectStyle (ssrContext) {
  __webpack_require__("EJ5R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a8a1ee2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyPacket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8a1ee2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyPacket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "APq4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "APta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopQualified_vue__ = __webpack_require__("cscL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce4616a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopQualified_vue__ = __webpack_require__("OHKy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopQualified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce4616a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopQualified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AWN8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamContent_vue__ = __webpack_require__("MAU2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_297ae16e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamContent_vue__ = __webpack_require__("vCI5");
function injectStyle (ssrContext) {
  __webpack_require__("bh5i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_297ae16e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AWOr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AYnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-area"},[_c('div',{staticClass:"pagination--items desktop-only"},[_c('div',{staticClass:"form-item form-item-select"},[_c('label',{staticClass:"form-label",attrs:{"for":"pagination_items"}},[_vm._v("Items per page")]),_vm._v(" "),_c('div',{staticClass:"select-outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.items),expression:"items"}],attrs:{"type":"text","id":"pagination_items","name":"items","readonly":true,"disabled":_vm.loader},domProps:{"value":(_vm.items)},on:{"click":function($event){_vm.openList = true},"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.items=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList && !_vm.loader),expression:"openList && !loader"}]},_vm._l((_vm.paginationOptions),function(items,index){return _c('li',{on:{"click":function($event){_vm.setItems(index), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v(_vm._s(items))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"pagination--page"},[_c('ul',[(_vm.currentPage > 1)?_c('li',{on:{"click":function($event){_vm.setPage(1); _vm.goToTop()}}},[_c('i',{staticClass:"mdi mdi-chevron-double-left"})]):_vm._e(),_vm._v(" "),(_vm.currentPage > 1)?_c('li',{on:{"click":function($event){_vm.setPage(_vm.currentPage - 1); _vm.goToTop()}}},[_c('i',{staticClass:"mdi mdi-chevron-left"})]):_vm._e(),_vm._v(" "),(_vm.currentPage > 1)?_c('li',{on:{"click":function($event){_vm.setPage(_vm.currentPage - 1); _vm.goToTop()}}},[_vm._v("\n                "+_vm._s(_vm.currentPage - 1)+"\n            ")]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"active",staticStyle:{"cursor":"default"}},[_vm._v("\n                "+_vm._s(_vm.currentPage)+"\n            ")]),_vm._v(" "),(_vm.currentPage < _vm.numberOfPages)?_c('li',{on:{"click":function($event){_vm.setPage(_vm.currentPage + 1); _vm.goToTop()}}},[_vm._v("\n                "+_vm._s(_vm.currentPage +  1)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.currentPage !== _vm.numberOfPages)?_c('li',{on:{"click":function($event){_vm.setPage(_vm.currentPage + 1); _vm.goToTop()}}},[_c('i',{staticClass:"mdi mdi-chevron-right"})]):_vm._e(),_vm._v(" "),(_vm.currentPage !== _vm.numberOfPages)?_c('li',{on:{"click":function($event){_vm.setPage(_vm.numberOfPages); _vm.goToTop()}}},[_c('i',{staticClass:"mdi mdi-chevron-double-right"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AsgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__("jW2I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29333214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__("kdA6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29333214_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B+h8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7000fb88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__ = __webpack_require__("rcsJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7000fb88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B8Z6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');

var TotalIncomes = function () {
    function TotalIncomes() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TotalIncomes);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TotalIncomes, [{
        key: 'fetchData',
        value: function fetchData() {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.bonus.totalIncomes).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setTotalIncomes', response.data);
            });
        }
    }]);

    return TotalIncomes;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('totalIncomes', TotalIncomes);

/***/ }),

/***/ "BIxo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ftn_popup.73f9ec8.png";

/***/ }),

/***/ "BRrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('advcash_login') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_advcash_login"}},[_vm._v("\n            AdvCash login\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_advcash_login","name":"advcash_login","type":"text","data-vv-rules":"required|max:255","data-vv-as":"AdvCash login","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('advcash_login') && _vm.showErrors),expression:"errors.has('advcash_login') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('advcash_login')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BXpv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['updateValue', 'sending', 'showErrors', 'changeEvent', 'isVerified'],
    data: function data() {
        return {
            genderCode: '',
            genders: {
                male: 'Personal',
                company: 'Company'
            },
            openList: false,
            hoverList: false,
            selected: ''
        };
    },

    computed: {
        defaultValue: function defaultValue() {
            return this.$store.getters.user.gender;
        },
        isCompany: function isCompany() {
            return this.$store.getters.user.isCompany;
        }
    },
    watch: {
        defaultValue: function defaultValue() {
            this.genderCode = this.defaultValue;
        },
        genderCode: function genderCode() {
            this.updateValue('gender', this.genderCode);
        }
    },
    methods: {
        setItem: function setItem(code, value) {
            this.selected = value;
            this.genderCode = code;
            this.changeEvent(code);
        }
    },
    mounted: function mounted() {
        var defaultValue = this.defaultValue;

        if (this.isCompany) {
            defaultValue = 'company';
            this.changeEvent(defaultValue);
        }

        this.selected = this.genders[defaultValue];
        this.genderCode = defaultValue;
        this.updateValue('gender', this.genderCode);
    }
});

/***/ }),

/***/ "BZrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);








__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api'),
    status = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('status');

var state = {
    payouts: [],

    payoutsSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: []
    }
};

var getters = {
    payouts: function payouts(state) {
        return state.payouts;
    },

    payoutsSettings: function payoutsSettings(state) {
        return state.payoutsSettings;
    }
};

var mutations = {
    /**
     * Set daily mining in store
     * @param state
     * @param data
     */
    setPayouts: function setPayouts(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'payouts', data.results);
        } else {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'payouts', []);
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'numberOfPages', data.number_of_pages);
    }
};

var actions = {

    /**
     * Get daily mining data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadPayouts: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                var settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(data);
                                if (settings.params.sort) {
                                    var sort = [];
                                    for (var field in data.params.sort) {
                                        sort.push(data.params.sort[field]);
                                    }
                                    settings.params.sort = sort;
                                }
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.payout.list(settings.params)).then(function (response) {
                                    commit('setPayouts', response.data);
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    reject();
                                });
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadPayouts(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return loadPayouts;
    }(),


    /**
     * Set sorting in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    payoutsSetSort: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, field) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                var sort = state.payoutsSettings.sort,
                                    isSet = false;

                                for (var sortId in sort) {
                                    if (!isSet && sort[sortId].field === field) {
                                        isSet = sortId;
                                    }
                                }

                                if (!isSet) {
                                    sort.push({
                                        field: field,
                                        order: 'ASC'
                                    });
                                } else {
                                    sort[isSet].order = sort[isSet].order === 'DESC' ? 'ASC' : 'DESC';
                                }

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'sort', sort);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function payoutsSetSort(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return payoutsSetSort;
    }(),


    /**
     * Set max number of items in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    payoutsSetItems: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function payoutsSetItems(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return payoutsSetItems;
    }(),


    /**
     * Set page in daily mining
     * @param getters
     * @param data
     * @returns {Promise}
     */
    payoutsSetPage: function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

                            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'currentPage', data);
                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function payoutsSetPage(_x7, _x8) {
            return _ref8.apply(this, arguments);
        }

        return payoutsSetPage;
    }(),


    /**
     * Set date in daily mining
     * @param date
     * @returns {Promise}
     */
    payoutsSetDate: function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9, date) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

                            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                var dates = date.split(' to ');

                                if (dates[1]) {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'fromDate', dates[0]);
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'toDate', dates[1]);
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'fromDate', dates[0]);
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.payoutsSettings, 'toDate', false);
                                }

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function payoutsSetDate(_x9, _x10) {
            return _ref10.apply(this, arguments);
        }

        return payoutsSetDate;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "BbNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    error: {
        status: false,
        code: 0,
        redirect: false
    }
};

var getters = {
    error: function error(state) {
        return state.error;
    }
};

var mutations = {
    setError: function setError(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'error', {
            status: data.status,
            code: data.code,
            redirect: data.redirect
        });
    }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "Bdim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'myStartPacket',"title":'Invoices'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('invoices-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BkPh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BmrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvcashLogin_vue__ = __webpack_require__("DNWh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_868bb448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvcashLogin_vue__ = __webpack_require__("BRrt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvcashLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_868bb448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvcashLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bob9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_component_vue__ = __webpack_require__("o84U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7557e683_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_component_vue__ = __webpack_require__("XDUq");
function injectStyle (ssrContext) {
  __webpack_require__("YPtq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7557e683"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7557e683_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C/dE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a);

var Popup = function () {
    function Popup() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Popup);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Popup, [{
        key: 'show',

        /**
         * Show popup
         * @param message
         * @param button
         * @param reload
         */
        value: function show(message, button, reload) {
            if (!button && !reload) {
                button = 'OK';
                reload = false;
            }

            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('modals', {
                modal: 'alert',
                data: {
                    visible: true,
                    message: message,
                    button: button,
                    reload: reload
                }
            });
        }

        /**
         * Hide popup
         */

    }, {
        key: 'hide',
        value: function hide() {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('modals', {
                modal: 'alert',
                data: {
                    visible: false,
                    message: '',
                    reload: false
                }
            });
        }
    }]);

    return Popup;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('popup', Popup);

/***/ }),

/***/ "CAMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawForm_vue__ = __webpack_require__("zpNn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d10fc61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawForm_vue__ = __webpack_require__("zNih");
function injectStyle (ssrContext) {
  __webpack_require__("tPa8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d10fc61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d10fc61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CAkf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CRx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'business',"title":'Monthly Statement'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('monthly-statement-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CZFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"7"}},[_c('p',[_vm._v("Please fill out all fields to upload ID and verify your account.")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'ProfileEditData' }}},[_vm._v("Edit data")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CZa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"3"}},[_c('p',[_vm._v(_vm._s(_vm.inputLabel))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('div',{staticClass:"form-item form-item-text"},[_c('div',{staticClass:"select-outer"},[_c('input',{attrs:{"type":"hidden","name":'security_' + _vm.paramKey,"value":"this.settingId"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.label),expression:"label"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","id":_vm.paramKey,"name":_vm.paramKey,"data-vv-rules":"required","readonly":true},domProps:{"value":(_vm.label)},on:{"click":function($event){_vm.openList = true},"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.label=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList),expression:"openList"}]},_vm._l((_vm.list),function(value,index){return _c('li',{on:{"click":function($event){_vm.onChange(value, index), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v(_vm._s(value))])}),0)])])]),_vm._v(" "),(_vm.confirmation.visibility)?_c('save-settings',{attrs:{"action-error":_vm.fail,"action-success":_vm.setSelected,"action-success-params":_vm.confirmation.params,"confirmation-type":_vm.settingValue,"message":'Are you sure you want to change the settings?',"settings":_vm.confirmation.settings}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CjjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    dependencies: ['money'],
    props: ['amountError', 'maxAmountError', 'minimum', 'percent', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: 0
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('amount', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "CmBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    modals: {
        alert: {
            visible: false,
            message: '',
            reload: false
        },
        buyPacket: {
            visible: false,
            packet: 0,
            select: false,
            current: false,
            upgrade: false
        },
        confirmation: {
            actionError: false,
            actionSuccess: false,
            confirmationType: false,
            settings: false,
            visible: false
        },
        image: {
            visible: false
        },
        payout: {
            visible: false,
            params: {}
        },
        withdrawCoins: {
            visible: false,
            coins: 0,
            type: 'mining', // mining | royal
            accept: false
        }
    }
};

var getters = {
    modals: function modals(state) {
        return state.modals;
    }
};

var mutations = {
    modals: function modals(state, params) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.modals, params.modal, params.data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "DCDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderStats_vue__ = __webpack_require__("6vbn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f087e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderStats_vue__ = __webpack_require__("gVFZ");
function injectStyle (ssrContext) {
  __webpack_require__("iQo2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f087e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DEop":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DI36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coindeal_vue__ = __webpack_require__("WCWf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d9cc0a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coindeal_vue__ = __webpack_require__("aLI+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coindeal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d9cc0a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coindeal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DNWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "DRWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"error-500-content-component"},[_c('b-col',{attrs:{"lg":"12"}},[_c('h1',{staticClass:"error-title"},[_vm._v("Repairs are in progress")]),_vm._v(" "),_c('p',[_vm._v("This website is currently down for maintance. Soon we will be back and working again. Thanks for your patience.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dco8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountNumber_vue__ = __webpack_require__("aMkS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79dca68c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountNumber_vue__ = __webpack_require__("UdFg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79dca68c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DgVu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemindPassword_vue__ = __webpack_require__("Lfcz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7736cc9b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemindPassword_vue__ = __webpack_require__("2CVM");
function injectStyle (ssrContext) {
  __webpack_require__("U/Yn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7736cc9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemindPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7736cc9b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemindPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DmGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        username: function username() {
            return this.$store.getters.user.login;
        },
        email: function email() {
            return this.$store.getters.user.email;
        },
        street: function street() {
            return this.$store.getters.user.street ? this.$store.getters.user.street : '-';
        },
        zip: function zip() {
            return this.$store.getters.user.zip ? this.$store.getters.user.zip : '';
        },
        city: function city() {
            return this.$store.getters.user.city ? this.$store.getters.user.city : '';
        },
        phoneNumber: function phoneNumber() {
            return this.$store.getters.user.phoneNumber ? this.$store.getters.user.phoneNumber : '';
        },
        reflink: function reflink() {
            return 'futuro.network/register/' + (this.$store.getters.user.login ? this.$store.getters.user.login : '');
        },
        isVerified: function isVerified() {
            return this.$store.getters.user.isVerified;
        }
    }
});

/***/ }),

/***/ "DriP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dx+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        amount: function amount() {
            return this.$store.getters.qualifications.amount;
        }
    }
});

/***/ }),

/***/ "DzgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    path: [],
    tree: [],
    loading: false
};

var getters = {
    getTree: function getTree(state) {
        return state.tree;
    },
    getTreePath: function getTreePath(state) {
        return state.path;
    },
    getTreeLoading: function getTreeLoading(state) {
        return state.loading;
    }
};

var mutations = {
    InsertLevel: function InsertLevel(state, params) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.tree, params.levelIndex + 1, params.level);
        return state;
    },
    SetPath: function SetPath(state, params) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.path, params.levelIndex + 1, { login: params.login, index: params.index });
        return state;
    },
    BackToLevel: function BackToLevel(state, params) {
        state.tree.splice(params.levelIndex, state.tree.length - params.levelIndex);
        state.path.splice(params.levelIndex, state.tree.length - params.levelIndex + 1);
        return state;
    },
    BackToLevelWithoutPath: function BackToLevelWithoutPath(state, params) {
        state.tree.splice(params.levelIndex, state.tree.length - params.levelIndex);
        state.path.splice(params.levelIndex, state.tree.length - params.levelIndex + 2);
        return state;
    },
    ShowTreeLoader: function ShowTreeLoader(state, params) {
        state.loading = params.loading;
        return state;
    },
    ClearTree: function ClearTree(state) {
        state.tree = [];
        state.path = [];
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "E/nY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('invoices-header'),_vm._v(" "),_c('invoices-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E9CY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketList_vue__ = __webpack_require__("sXdc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d32ba0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketList_vue__ = __webpack_require__("8cK5");
function injectStyle (ssrContext) {
  __webpack_require__("yAWa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d32ba0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d32ba0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ECUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"header-payout",attrs:{"lg":"4"}},[(_vm.hasPacket)?_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'Payout' }}},[_vm._v("Payout")]):_c('button',{staticClass:"button--primary",attrs:{"disabled":true,"type":'button'}},[_vm._v("\n        Payout\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EJ5R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EOn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'marketingPlan',"title":'Marketing Plan'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('marketing-plan-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EQRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_withdraw_WithdrawForm_vue__ = __webpack_require__("CAMx");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], WithdrawForm: __WEBPACK_IMPORTED_MODULE_1__content_withdraw_WithdrawForm_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "EYD+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        }
    }
});

/***/ }),

/***/ "EYcN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EaRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e4f59e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditData_vue__ = __webpack_require__("CZFb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e4f59e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ed/3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticStyle:{"margin-bottom":"35px"}},[_vm._v("Invoices")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EiG4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenForm_vue__ = __webpack_require__("jG/H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c2ef48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenForm_vue__ = __webpack_require__("hv3x");
function injectStyle (ssrContext) {
  __webpack_require__("i2Wu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77c2ef48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c2ef48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EjMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eac402a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckFnwallet_vue__ = __webpack_require__("LpQ+");
function injectStyle (ssrContext) {
  __webpack_require__("FCyp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eac402a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckFnwallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EtWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_DashboardPanel_vue__ = __webpack_require__("9F0r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { DashboardPanel: __WEBPACK_IMPORTED_MODULE_0__dashboard_DashboardPanel_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */] }
});

/***/ }),

/***/ "Eyos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__ = __webpack_require__("T2l1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b12767cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__ = __webpack_require__("MVyc");
function injectStyle (ssrContext) {
  __webpack_require__("cdbE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b12767cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b12767cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F+Aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    terms: [],
    acceptedTerms: []
};

var getters = {
    terms: function terms(state) {
        return state.terms;
    },
    acceptedTerms: function acceptedTerms(state) {
        return state.acceptedTerms;
    }
};

var mutations = {
    setTerms: function setTerms(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'terms', data);
    },
    setAcceptedTerms: function setAcceptedTerms(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'acceptedTerms', data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "F2uS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"futurocoin-payout-component",attrs:{"id":"futurocoin_payout_component"}},[_c('div',{staticClass:"payout-header",on:{"click":function($event){return _vm.toggleList()}}},[_c('p',[_vm._v("\n            Show payout schedule\n            ")]),(!_vm.payoutsOpen)?_c('div',{staticClass:"triangle triangle--bottom"}):_vm._e(),_vm._v(" "),(_vm.payoutsOpen)?_c('div',{staticClass:"triangle triangle--top"}):_vm._e(),_vm._v(" "),_c('p')]),_vm._v(" "),(_vm.payouts.length > 0)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.payoutsOpen),expression:"payoutsOpen"}],staticClass:"payout-list"},_vm._l((_vm.payouts),function(item,index){return _c('li',{key:index},[_c('p',[_c('span',{staticClass:"payout-list--date"},[_vm._v("to "+_vm._s(item.date))]),_vm._v(" "),_c('span',{staticClass:"payout-list--spacer"},[_vm._v("up to")]),_vm._v(" "),_c('span',{staticClass:"payout-list--label"},[_vm._v(_vm._s(_vm.money.format(item.to_withdraw.amount, 'fto'))+" "+_vm._s(item.to_withdraw.currency)+" - "+_vm._s(item.percent)+"% of yours FuturoCoins")])])])}),0):_vm._e(),_vm._v(" "),(_vm.payouts.length == 0)?_c('div',{staticClass:"data-loader__block"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F4E9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F5my":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('div',{staticClass:"modal-component",attrs:{"id":"modal_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.hideModal()}}}),_vm._v(" "),_c('div',{staticClass:"modal-inner"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('p',{staticClass:"p2"},[_vm._v("You want to withdraw"),_c('br',{staticClass:"desktop-only"}),_vm._v(" "+_vm._s(_vm.coins)+" coins")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button--action button--confirm",attrs:{"type":"button"},on:{"click":function($event){return _vm.accept()}}},[_vm._v("\n                                    Transfer to wallet")])])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw-warning"},[_c('i',{staticClass:"mdi mdi-alert-outline"}),_vm._v(" "),_c('i',[_vm._v("*Before you will transfer your FTOs "),_c('br'),_vm._v("the first time, please log to your FNWallet")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F9hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"business-qualifications-header",attrs:{"id":"business_qualifications_header"}},[(_vm.option === 'make_update')?_c('b-col',{staticClass:"business-qualifications-header-update",attrs:{"cols":"12","lg":"6","order-lg":"2","order":"0","id":"business_qualifications_header_update"}},[_c('router-link',{staticClass:"business-qualifications-header-update-element",attrs:{"to":{ name: _vm.update.url }}},[_c('p',{staticClass:"business-qualifications-header-update-label"},[_vm._v(_vm._s(_vm.update.label))]),_vm._v(" "),_c('p',{staticClass:"business-qualifications-header-update-value",staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.update.value))])])],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"12","order-lg":"3"}},[_c('router-link',{attrs:{"to":{ name: 'MarketingPlan' }}},[_c('div',{staticClass:"business-qualifications-header__additional-link"},[_vm._v("\n                Go to the FuturoNetwork marketing plan"),_c('br'),_vm._v("\n                and check exactly how to achieve the next career levels\n            ")])])],1),_vm._v(" "),_vm._l((_vm.informations),function(information,index){return _c('b-col',{key:index,staticClass:"business-qualifications-header-info",attrs:{"cols":"6","lg":"3","id":"business_qualifications_header_info","order":index}},[_c('div',{staticClass:"business-qualifications-header-info-element"},[_c('p',{staticClass:"business-qualifications-header-info-label",domProps:{"innerHTML":_vm._s(information.label)}}),_vm._v(" "),_c('p',{staticClass:"business-qualifications-header-info-value",class:{ 'notice-available': information.notice },domProps:{"innerHTML":_vm._s(information.value)}}),_vm._v(" "),_c('p',{staticClass:"business-qualifications-header-info-notice"},[_vm._v(_vm._s(information.notice))])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FCyp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FHNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"topbar-component",attrs:{"id":"topbar_component"}},[_c('b-col',{staticClass:"header-exchange desktop-only",attrs:{"id":"header_exchange","lg":"6"}},[_c('header-exchange')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FNEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    computed: {
        totalIncome: function totalIncome() {
            return 'FND ' + this.money.format(this.$store.getters.totalIncomes.total_income.amount, 'fnd');
        }
    }
});

/***/ }),

/***/ "FRPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"id":"start-packet-update"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('p',{staticStyle:{"margin-bottom":"30px"}},[_vm._v("You can buy additional package to increase your mining stake.")])]),_vm._v(" "),_vm._l((_vm.packets),function(packet,index){return (index > 0)?_c('b-col',{key:index,attrs:{"lg":packet.size.lg,"cols":packet.size.sm}},[_c('div',{staticClass:"start-packet-update",class:{ 'content-center' : packet.size.lg === 12 },on:{"click":function($event){!_vm.loader && !packet.disable ? _vm.buyPacket(index) : ''}}},[_c('div',{staticClass:"start-packet-update--gradient"}),_vm._v(" "),_c('div',{staticClass:"start-packet-update-value"},[_c('span',{staticClass:"start-packet-update-value--sign"},[_vm._v(_vm._s(packet.sign))]),_vm._v(_vm._s(packet.label)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"start-packet-update-buy",class:{ 'disabled': packet.disable}},[_vm._v("Buy")]),_vm._v(" "),_c('div',{staticClass:"start-packet-update-stars"},_vm._l((7),function(star,starId){return _c('i',{key:starId,staticClass:"mdi mdi-star",class:{ 'active' : packet.stars >= star }})}),0),_vm._v(" "),_c('div',{staticClass:"start-packet-update-power"},[_vm._v("\n                    Power: "+_vm._s(packet.power)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"start-packet-update-digger",class:'start-packet-update-digger-background-' + index})])]):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FUxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FNProductPacksContent_vue__ = __webpack_require__("OHii");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16aa9778_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FNProductPacksContent_vue__ = __webpack_require__("gRVi");
function injectStyle (ssrContext) {
  __webpack_require__("sUmG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16aa9778"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FNProductPacksContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16aa9778_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FNProductPacksContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FYx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_City_vue__ = __webpack_require__("0W7+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c38b7e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_City_vue__ = __webpack_require__("h8yr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_City_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c38b7e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_City_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FbZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountCurrency_vue__ = __webpack_require__("xnSO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b529def2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountCurrency_vue__ = __webpack_require__("iR4Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountCurrency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b529def2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountCurrency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FhA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['careerLevel'],
    data: function data() {
        return {
            defaultText: 'Do you need more information?<br>\n' + '             Check out FuturoNetwork Marketing Plan'
        };
    },

    props: ['customText'],
    beforeMount: function beforeMount() {
        this.careerLevel.fetchData();
    },

    computed: {
        text: function text() {
            return this.customText ? this.customText : this.defaultText;
        }
    }
});

/***/ }),

/***/ "FigV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings_UserData_vue__ = __webpack_require__("hGOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_UserPassword_vue__ = __webpack_require__("OUcc");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { UserData: __WEBPACK_IMPORTED_MODULE_0__settings_UserData_vue__["a" /* default */], UserPassword: __WEBPACK_IMPORTED_MODULE_1__settings_UserPassword_vue__["a" /* default */] }
});

/***/ }),

/***/ "FjY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_inject__);






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('api');

var Terms = function () {
    function Terms() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Terms);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Terms, [{
        key: 'fetchData',
        value: function fetchData() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.terms.fetchData).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setTerms', response.body);
                    resolve();
                }, function () {
                    reject();
                });
            });
        }
    }, {
        key: 'setAccepted',
        value: function setAccepted() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.terms.accepted).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setAcceptedTerms', response.body);
                    resolve();
                }, function () {
                    reject();
                });
            });
        }
    }, {
        key: 'sign',
        value: function sign(data) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.terms.sign, { signatures: data }).then(function () {
                    resolve();
                }, function () {
                    reject();
                });
            });
        }
    }]);

    return Terms;
}();

__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.service('terms', Terms);

/***/ }),

/***/ "FlRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_878c4e0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorLogo_vue__ = __webpack_require__("LFQx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_878c4e0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FsOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_ProfileEditDataContent_vue__ = __webpack_require__("cOqq");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], ProfileEditDataContent: __WEBPACK_IMPORTED_MODULE_1__content_ProfileEditDataContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "Ftvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ae9416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404Content_vue__ = __webpack_require__("yeQl");
function injectStyle (ssrContext) {
  __webpack_require__("6Aa5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14ae9416"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ae9416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G23/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsTotal_vue__ = __webpack_require__("FNEN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112c85ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsTotal_vue__ = __webpack_require__("ySIp");
function injectStyle (ssrContext) {
  __webpack_require__("oO/w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsTotal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112c85ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsTotal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GBzi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GKAJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayzaEmail_vue__ = __webpack_require__("4M7Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_912a6f9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayzaEmail_vue__ = __webpack_require__("hzzb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayzaEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_912a6f9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayzaEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GR5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinMiningTransfer_vue__ = __webpack_require__("R1xg");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471f37a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinMiningTransfer_vue__ = __webpack_require__("NGZC");
function injectStyle (ssrContext) {
  __webpack_require__("CAkf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-471f37a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinMiningTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471f37a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinMiningTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "GSDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamTree_vue__ = __webpack_require__("kQS9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e3bb88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamTree_vue__ = __webpack_require__("9DQB");
function injectStyle (ssrContext) {
  __webpack_require__("zevV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e3bb88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GVad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['datetime', 'money', 'packet'],
    data: function data() {
        return {
            loader: false,
            items: 25
        };
    },

    computed: {
        rows: function rows() {
            return this.$store.getters.fnproductPacks;
        },
        currentPage: function currentPage() {
            return this.$store.getters.fnproductPacksSettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.fnproductPacksSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.fnproductPacksSettings.numberOfPages;
        }
    },
    methods: {
        /**
         * Get data with transactions
         */
        getData: function getData() {
            var _this = this;

            this.loader = true;

            var settings = this.$store.getters.fnproductPacksSettings;

            this.$store.dispatch('loadFnproductPacks', {
                params: settings
            }).then(function () {
                _this.loader = false;
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this2 = this;

            this.items = items;
            this.$store.dispatch('fnproductPacksSetItems', items).then(function () {
                _this2.getData();
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this3 = this;

            this.$store.dispatch('fnproductPacksSetPage', page).then(function () {
                _this3.getData();
            });
        }
    },
    beforeMount: function beforeMount() {
        var _this4 = this;

        var settings = this.$store.getters.fnproductPacksSettings;

        this.$store.dispatch('loadFnproductPacks', {
            params: settings
        }).then(function () {
            _this4.items = settings.maxPerPage;
        });
    }
});

/***/ }),

/***/ "Gaby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SponsorSystem_vue__ = __webpack_require__("gp3m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2fe528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SponsorSystem_vue__ = __webpack_require__("TAjg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SponsorSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2fe528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SponsorSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gah6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_OtpContent_vue__ = __webpack_require__("y3zd");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], OtpContent: __WEBPACK_IMPORTED_MODULE_1__content_OtpContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "Gdt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"12","cols":"12","order-lg":"2","order":"0"}},[_c('b-col',{staticStyle:{"padding":"0"},attrs:{"lg":"6"}},[_c('div',{staticClass:"commissions-total-label"},[_c('p',[_vm._v("Missing amount of turnover"),_c('br',{staticClass:"desktop-only"}),_vm._v(" to maintain the level:")])]),_vm._v(" "),_c('div',{staticClass:"commissions-total-value"},[_c('p',[_vm._v(_vm._s(_vm.amount)+"$")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ge/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketContent_vue__ = __webpack_require__("cGzM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9265eea6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketContent_vue__ = __webpack_require__("m+H1");
function injectStyle (ssrContext) {
  __webpack_require__("VteA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9265eea6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9265eea6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ggpo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Type_vue__ = __webpack_require__("mqfC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['datetime', 'money'],
    components: { Type: __WEBPACK_IMPORTED_MODULE_0__Type_vue__["a" /* default */] },
    data: function data() {
        return {
            date: '',
            items: 25
        };
    },

    computed: {
        transferHistory: function transferHistory() {
            return this.$store.getters.transferHistory;
        },
        currentPage: function currentPage() {
            return this.$store.getters.transferHistorySettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.transferHistorySettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.transferHistorySettings.numberOfPages;
        },
        loader: function loader() {
            return this.$store.getters.transferHistoryLoader;
        }
    },
    methods: {
        /**
         * Change sort
         */
        changeSort: function changeSort(field) {
            var _this = this;

            this.$store.dispatch('transferHistorySetSort', field).then(function () {
                _this.getData();
            });
        },

        /**
         * Set default settings
         */
        clearSettings: function clearSettings() {
            var _this2 = this;

            this.$store.dispatch('transferHistorySettingsClear').then(function () {
                _this2.getData();
                _this2.items = 25;
            });
        },


        /**
         * Get data with transactions
         */
        getData: function getData() {
            var _this3 = this;

            this.loader = true;

            var settings = this.$store.getters.transferHistorySettings;

            this.$store.dispatch('loadTransferHistory', {
                params: settings
            }).then(function () {
                _this3.loader = false;
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this4 = this;

            this.items = items;
            this.$store.dispatch('transferHistorySetItems', items).then(function () {
                _this4.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this5 = this;

            this.$store.dispatch('transferHistorySetPage', page).then(function () {
                _this5.getData();
                window.scrollTo(0, 0);
            });
        },


        /**
         * Get type name by key
         */
        getTypeName: function getTypeName(type) {
            var types = {
                royal_bonus: 'Royal bonus',
                mining: 'Mining'
            };

            return types[type];
        }
    },
    watch: {
        /**
         * Get data with transfers if date in calendar was changed
         */
        date: function date() {
            var _this6 = this;

            this.$store.dispatch('transferHistorySetDate', this.date).then(function () {
                _this6.getData();
            });
        }
    },
    beforeMount: function beforeMount() {
        var _this7 = this;

        var settings = this.$store.getters.transferHistorySettings;

        this.$store.dispatch('loadTransferHistory', {
            params: settings
        }).then(function () {
            _this7.items = settings.maxPerPage;
        });
    }
});

/***/ }),

/***/ "H/Zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_inject__);


__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.constant('api', {
    auth: {
        location: {
            banned: 'auth/location/banned'
        },
        login: 'auth/login',
        logout: 'auth/logout',
        registration: 'auth/registration',
        user: 'user'
    },
    bonus: {
        bonus: function bonus(params) {
            var url = 'bonus' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (var field in params.sort) {
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },
        history: function history(params) {
            var url = 'bonus/history' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.user) {
                url += '&user=' + params.user;
            }
            if (params.sort && params.sort.length > 0) {
                for (var field in params.sort) {
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            if (params.filter && params.filter.length > 0) {
                for (var _field in params.filter) {
                    url += '&types[' + _field + ']=' + params.filter[_field];
                }
            }
            return url;
        },
        summary: function summary(params) {
            var url = 'bonus/summary' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (var field in params.sort) {
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },

        totalIncomes: 'bonus/total-incomes'
    },
    careerLevel: {
        next: 'career-level/next-level'
    },
    codes: {
        list: function list(params) {
            var url = 'code/user/list';

            if (params && params.currentPage) {
                url += '?currentPage=' + params.currentPage;
            }
            if (params && params.maxPerPage) {
                url += '&maxPerPage=' + params.maxPerPage;
            }

            return url;
        },

        confirm: 'code/confirm-user',
        cancel: 'code/cancel-user',
        create: 'code/create'
    },
    commissions: {
        list: 'commissions/list',
        download: function download(period) {
            return 'commissions/monthly/' + period;
        }
    },
    countries: {
        list: 'dictionaries/country'
    },
    currency: function currency(sourceCryptoCurrency, destinationCurrency) {
        return 'currencies/rate/' + sourceCryptoCurrency + '/' + destinationCurrency;
    },

    futurepay: {
        buyWithCode: 'package/buy/code',
        buy: 'futurepay/buy-package',
        callback: 'futurepay/buy-package/callback'
    },
    history: 'users/login/history',
    invoice: {
        list: 'invoice/list',
        generate: function generate(packageId) {
            return 'invoice/create/' + packageId;
        },
        download: function download(invoiceId) {
            return 'invoice/pdf/' + invoiceId;
        }
    },
    marketing: {
        plans: 'marketing/plans'
    },
    microWallet: {
        buyPackage: 'micro-wallet/buy-package'
    },
    mining: {
        history: function history(params) {
            var url = 'mining/history' + '?currentPage=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (var field in params.sort) {
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },
        ftoPerPowerPoint: function ftoPerPowerPoint() {
            return 'mining/fto-per-power-point';
        }
    },
    notifications: {
        get: function get(currentPage, maxPerPage) {
            return 'notifications?currentPage=' + currentPage + '&maxPerPage=' + maxPerPage;
        },

        archive: 'notifications/archive',
        read: 'notifications/read'
    },
    package: {
        bought: 'package/bought-packages',
        boughtList: function boughtList(params) {
            var url = 'package/bought-packages-list';

            if (params) {
                if (params.currentPage) {
                    url += '?currentPage=' + params.currentPage;
                }
                if (params.maxPerPage) {
                    url += '&maxPerPage=' + params.maxPerPage;
                }
                if (params.fromDate) {
                    url += '&fromDate=' + params.fromDate;
                }
                if (params.toDate) {
                    url += '&toDate=' + params.toDate;
                }
                if (params.sort && params.sort.length > 0) {
                    for (var field in params.sort) {
                        url += '&sort[' + field + '][field]=' + params.sort[field].field;
                        url += '&sort[' + field + '][order]=' + params.sort[field].order;
                    }
                }
            } else {
                url += '?sort[0][field]=date&sort[0][order]=asc';
            }

            return url;
        },

        buy: 'package/buy'
    },
    payout: {
        list: function list(params) {
            var url = 'payout/list';
            if (params.currentPage) {
                url += '?currentPage=' + params.currentPage;
            }
            if (params.maxPerPage) {
                url += '&maxPerPage=' + params.maxPerPage;
            }
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&fromDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (var field in params.sort) {
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },

        cancel: 'payout/cancel-by-user',
        confirmByUser: 'payout/confirm-by-user',
        email: 'payout/send-confirm-email',
        request: 'payout/request',
        verify: function verify(id) {
            return 'payout/verifiy/' + id;
        }
    },
    ranking: {
        list: function list(params) {
            var url = 'user/top-qualified/list';

            if (params.currentPage) {
                url += '?currentPage=' + params.currentPage;
            }
            if (params.maxPerPage) {
                url += '&maxPerPage=' + params.maxPerPage;
            }
            if (params.careerLevel) {
                url += '&careerLevel=' + params.careerLevel;
            }

            return url;
        }
    },
    report: {
        income: function income(fromDate, toDate, type) {
            return 'report/income/' + fromDate + '/' + toDate + '/' + type;
        },
        turnover: function turnover(fromDate, toDate, type) {
            return 'report/turnover/' + fromDate + '/' + toDate + '/' + type;
        }
    },
    reports: {
        statistics: 'report/statistics'
    },
    terms: {
        fetchData: 'terms-of-use/list-regulations',
        accepted: 'terms-of-use/list-acceptances',
        sign: 'terms-of-use/sign'
    },
    token: {
        confirm: 'credentials/confirm',
        generate: function generate(userSettingName) {
            return 'credentials/generate/token/' + userSettingName;
        }
    },
    transfer: {
        miningTransfer: 'transfer/transfer-fto-mining',
        royalTransfer: 'transfer/transfer-fto-royal',
        history: function history(params) {
            var url = 'transfer/history' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.type) {
                url += '&type=' + params.type;
            }
            if (params.sort && params.sort.length > 0) {
                for (var field in params.sort) {
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        }
    },
    transferToFN: {
        history: function history(params) {
            return 'transfer-to-futurenet/history' + '?currentPage=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
        }
    },
    translation: function translation(languageCode, domain) {
        return 'translation/' + languageCode + '/' + domain;
    },

    user: {
        verification: {
            get: 'user/verification',
            request: 'user/verification/request'
        },
        changePassword: 'user/change-password',
        deactivate: function deactivate(emailOrLogin) {
            return 'user/' + emailOrLogin + '/deactivate';
        },

        ftoAccounts: 'user/fto-accounts',
        password: {
            change: 'user/change-password',
            remind: 'user/remind-password',
            new: 'user/new-password'

        },
        royalBonuses: 'bonus/royal-bonuses',
        settings: {
            change: 'user/change-settings',
            get: 'user/settings',
            google: 'user/google/authenticator/settings'
        },
        tree: {
            frontliners: function frontliners(emailOrLogin) {
                return 'user/tree/' + emailOrLogin + '/frontliners';
            },
            pathFor: function pathFor(emailOrLogin) {
                return 'user/tree/' + emailOrLogin + '/path';
            },
            search: function search(query) {
                return 'user/tree/search/' + query;
            }
        },
        update: 'user/update-profile-data',
        withdraw: 'user/withdraw-royal-schedule'
    },
    withdraw: {
        send: 'withdraw',
        getLast: 'withdraw/active',
        getAll: 'withdraw'
    }
});

/***/ }),

/***/ "H8fS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['datetime', 'money'],
    data: function data() {
        return {
            date: '',
            loader: false,
            items: 25
        };
    },

    computed: {
        dailyMining: function dailyMining() {
            return this.$store.getters.dailyMining;
        },
        currentPage: function currentPage() {
            return this.$store.getters.dailyMiningSettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.dailyMiningSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.dailyMiningSettings.numberOfPages;
        }
    },
    methods: {
        /**
         * Change sort
         */
        changeSort: function changeSort(field) {
            var _this = this;

            this.$store.dispatch('dailyMiningSetSort', field).then(function () {
                _this.getData();
            });
        },

        /**
         * Set default settings
         */
        clearSettings: function clearSettings() {
            var _this2 = this;

            this.$store.dispatch('dailyMiningSettingsClear').then(function () {
                _this2.getData();
                _this2.items = 25;
            });
        },


        /**
         * Get data with transactions
         */
        getData: function getData() {
            var _this3 = this;

            this.loader = true;

            var settings = this.$store.getters.dailyMiningSettings;

            this.$store.dispatch('loadDailyMining', {
                params: settings
            }).then(function () {
                _this3.loader = false;
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this4 = this;

            this.items = items;
            this.$store.dispatch('dailyMiningSetItems', items).then(function () {
                _this4.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this5 = this;

            this.$store.dispatch('dailyMiningSetPage', page).then(function () {
                _this5.getData();
            });
        }
    },
    watch: {
        /**
         * Get data with transactions if date in calendar was changed
         */
        date: function date() {
            var _this6 = this;

            this.$store.dispatch('dailyMiningSetDate', this.date).then(function () {
                _this6.getData();
            });
        }
    },
    beforeMount: function beforeMount() {
        var _this7 = this;

        var settings = this.$store.getters.dailyMiningSettings;

        this.$store.dispatch('loadDailyMining', {
            params: settings
        }).then(function () {
            _this7.items = settings.maxPerPage;
        });
    }
});

/***/ }),

/***/ "HE03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a);

__webpack_require__("H/Zg");
__webpack_require__("C/dE");
__webpack_require__("zD7H");
__webpack_require__("ye8Q");

var api = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('api'),
    popup = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('popup'),
    status = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('status'),
    user = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('user');

var Settings = function () {
    function Settings() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Settings);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Settings, [{
        key: 'create',

        /**
         * Create temporary settings
         */
        value: function create() {
            this.temporary = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.temporarySettings;
        }

        /**
         * Save settings
         */

    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var settings = [];
                for (var setting in _this.temporary) {
                    settings.push(_this.temporary[setting]);
                }
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.user.settings.change, {
                    userSettings: settings
                }).then(function (response) {
                    user.reloadData(response.data).then(function () {
                        popup.show('Data has been saved successfully!');
                        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'Profile' });
                        resolve();
                    });
                }, function (error) {
                    switch (error.status) {
                        case 422:
                            if (error.data.errors[0].message.toLowerCase().indexOf('google authenticator') > -1) {
                                popup.hide();
                                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('showOtpPage');
                                __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'Otp' });
                            } else {
                                popup.show(error.data.errors[0].message);
                            }
                            break;
                        default:
                            if (status['status' + error.status]) {
                                status['status' + error.status]();
                            } else {
                                popup.show(error.data.errors[0].message);
                            }
                            break;
                    }
                    reject();
                });
            });
        }
    }]);

    return Settings;
}();

__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.service('settings', Settings);

/***/ }),

/***/ "HTni":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("0EFW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HVqT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__neteller_NetellerEmail_vue__ = __webpack_require__("mOA0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], NetellerEmail: __WEBPACK_IMPORTED_MODULE_1__neteller_NetellerEmail_vue__["a" /* default */] }
});

/***/ }),

/***/ "HjPz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HtOP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('coming-soon')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HxXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        fullname: function fullname() {
            return this.$store.getters.userFullName;
        }
    }
});

/***/ }),

/***/ "HzLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletName_vue__ = __webpack_require__("YfyH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cbcaaaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletName_vue__ = __webpack_require__("aF0x");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WalletName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cbcaaaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WalletName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I2RA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderLogo_vue__ = __webpack_require__("EYD+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa4aa0e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderLogo_vue__ = __webpack_require__("wakk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa4aa0e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IB35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'popup', 'status'],
    data: function data() {
        return {
            progress: false,
            currentPassword: '',
            newPassword: '',
            repeatPassword: '',
            showErrors: false
        };
    },

    methods: {
        clearData: function clearData() {
            this.currentPassword = '';
            this.newPassword = '';
            this.repeatPassword = '';
        },
        validate: function validate() {
            var _this = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.submit();
                } else {
                    _this.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;

            this.$http.post(this.api.user.password.change, {
                oldPassword: this.currentPassword,
                newPassword: this.newPassword,
                newPasswordConfirmed: this.repeatPassword
            }).then(function () {
                _this2.popup.show('Password was changed successfully!', 'OK', false);
                _this2.clearData();
                _this2.progress = false;
            }, function (error) {
                switch (error.status) {
                    case 422:
                        _this2.popup.show(error.data.errors[0].message, 'OK', false);
                        break;
                    default:
                        if (_this2.status['status' + error.status]) {
                            _this2.status['status' + error.status]();
                        } else {
                            _this2.popup.show(error.data.errors[0].message, 'OK', false);
                        }
                }
                _this2.progress = false;
            });
        }
    },
    beforeMount: function beforeMount() {
        this.clearData();
    }
});

/***/ }),

/***/ "IIjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['packet'],
    data: function data() {
        return {
            loader: false,
            packets: {
                100: {
                    label: '100',
                    sign: '$',
                    stars: 1,
                    power: 1,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                250: {
                    label: '250',
                    sign: '$',
                    stars: 2,
                    power: 3,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                500: {
                    label: '500',
                    sign: '$',
                    stars: 3,
                    power: 7,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                1000: {
                    label: '1 000',
                    sign: '$',
                    stars: 4,
                    power: 15,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                5000: {
                    label: '5 000',
                    sign: '$',
                    stars: 5,
                    power: 80,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                10000: {
                    label: '10 000',
                    sign: '$',
                    stars: 6,
                    power: 180,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                25000: {
                    label: '25 000',
                    sign: '$',
                    stars: 7,
                    power: 500,
                    size: {
                        lg: 12,
                        sm: 12
                    },
                    disable: true
                }
            }
        };
    },

    methods: {
        buyPacket: function buyPacket(index) {
            this.packet.create(index);
            this.$store.commit('modals', {
                modal: 'buyPacket',
                data: {
                    visible: true,
                    message: 'Are you sure you want to buy this package?',
                    packet: this.packet
                }
            });
        }
    }
});

/***/ }),

/***/ "IJ0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('bic', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "IJRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-tabs-mobile mobile-only"},[_c('div',{staticClass:"form-item form-item-select"},[_c('div',{staticClass:"select-outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ranking[_vm.selected].name),expression:"ranking[selected].name"}],attrs:{"type":"text","name":"careerLevel","readonly":true},domProps:{"value":(_vm.ranking[_vm.selected].name)},on:{"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ranking[_vm.selected], "name", $event.target.value)}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList && !_vm.sending && !_vm.isVerified),expression:"openList && !sending && !isVerified"}]},_vm._l((_vm.ranking),function(value,index){return _c('li',{key:index,on:{"click":function($event){_vm.setRanking(value.code), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v(_vm._s(value.name))])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IK0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodesContent_vue__ = __webpack_require__("W+gU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9725c1fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodesContent_vue__ = __webpack_require__("tED9");
function injectStyle (ssrContext) {
  __webpack_require__("HjPz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9725c1fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodesContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9725c1fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodesContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IT6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_PayoutContent_vue__ = __webpack_require__("s/y0");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], PayoutContent: __WEBPACK_IMPORTED_MODULE_1__content_PayoutContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_authentication__ = __webpack_require__("nO8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_boughtPackets__ = __webpack_require__("JMHq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_code__ = __webpack_require__("xIdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_commissions__ = __webpack_require__("ZFAl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_countries__ = __webpack_require__("2JJ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_error__ = __webpack_require__("BbNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_exchange__ = __webpack_require__("/1KA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_fnproductPacks__ = __webpack_require__("5k63");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_ftoAccounts__ = __webpack_require__("KiG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_futurocoin__ = __webpack_require__("9iuO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_invoices__ = __webpack_require__("Voz4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_mlm__ = __webpack_require__("sx+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_modals__ = __webpack_require__("CmBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_monthlyStatement__ = __webpack_require__("Ry6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_payouts__ = __webpack_require__("BZrJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_royalBonuses__ = __webpack_require__("uAHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_settings__ = __webpack_require__("THyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_statistics__ = __webpack_require__("6L2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_ranking__ = __webpack_require__("toql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_terms__ = __webpack_require__("F+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_totalIncomes__ = __webpack_require__("sdOz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_transferHistory__ = __webpack_require__("+nep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_tree__ = __webpack_require__("DzgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_user__ = __webpack_require__("bREw");




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        authentication: __WEBPACK_IMPORTED_MODULE_2__modules_authentication__["a" /* default */],
        boughtPackets: __WEBPACK_IMPORTED_MODULE_3__modules_boughtPackets__["a" /* default */],
        code: __WEBPACK_IMPORTED_MODULE_4__modules_code__["a" /* default */],
        commissions: __WEBPACK_IMPORTED_MODULE_5__modules_commissions__["a" /* default */],
        countries: __WEBPACK_IMPORTED_MODULE_6__modules_countries__["a" /* default */],
        error: __WEBPACK_IMPORTED_MODULE_7__modules_error__["a" /* default */],
        exchange: __WEBPACK_IMPORTED_MODULE_8__modules_exchange__["a" /* default */],
        fnproductPacks: __WEBPACK_IMPORTED_MODULE_9__modules_fnproductPacks__["a" /* default */],
        ftoAccounts: __WEBPACK_IMPORTED_MODULE_10__modules_ftoAccounts__["a" /* default */],
        futurocoin: __WEBPACK_IMPORTED_MODULE_11__modules_futurocoin__["a" /* default */],
        invoices: __WEBPACK_IMPORTED_MODULE_12__modules_invoices__["a" /* default */],
        mlm: __WEBPACK_IMPORTED_MODULE_13__modules_mlm__["a" /* default */],
        modals: __WEBPACK_IMPORTED_MODULE_14__modules_modals__["a" /* default */],
        monthlyStatement: __WEBPACK_IMPORTED_MODULE_15__modules_monthlyStatement__["a" /* default */],
        payouts: __WEBPACK_IMPORTED_MODULE_16__modules_payouts__["a" /* default */],
        royalBonuses: __WEBPACK_IMPORTED_MODULE_17__modules_royalBonuses__["a" /* default */],
        settings: __WEBPACK_IMPORTED_MODULE_18__modules_settings__["a" /* default */],
        statistics: __WEBPACK_IMPORTED_MODULE_19__modules_statistics__["a" /* default */],
        ranking: __WEBPACK_IMPORTED_MODULE_20__modules_ranking__["a" /* default */],
        terms: __WEBPACK_IMPORTED_MODULE_21__modules_terms__["a" /* default */],
        totalIncomes: __WEBPACK_IMPORTED_MODULE_22__modules_totalIncomes__["a" /* default */],
        transferHistory: __WEBPACK_IMPORTED_MODULE_23__modules_transferHistory__["a" /* default */],
        tree: __WEBPACK_IMPORTED_MODULE_24__modules_tree__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_25__modules_user__["a" /* default */]
    }
}));

/***/ }),

/***/ "IgLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__("XEc+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9f8d72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__("NLRW");
function injectStyle (ssrContext) {
  __webpack_require__("nP4U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a9f8d72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9f8d72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Iozf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ivhk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinPayout_vue__ = __webpack_require__("+RE9");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cdeba03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinPayout_vue__ = __webpack_require__("F2uS");
function injectStyle (ssrContext) {
  __webpack_require__("f1H9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinPayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cdeba03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinPayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "J+4p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api'),
    money = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('money'),
    popup = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('popup');

var Transfer = function () {
    function Transfer() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Transfer);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Transfer, [{
        key: 'process',
        value: function process(type, amount) {
            switch (type) {
                case 'mining':
                    return this.miningTransfer(amount);
                case 'royal':
                    return this.royalTransfer(amount);
            }
        }
    }, {
        key: 'royalTransfer',
        value: function royalTransfer(amount) {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(api.transfer.royalTransfer, { amount: money.unformat(amount, 'fto') }).then(function () {
                popup.show('Transfer completed successfully.', 'OK', true);
            }, function (error) {
                popup.show(error.data.errors[0].message, 'OK', true);
            });
        }
    }, {
        key: 'miningTransfer',
        value: function miningTransfer(amount) {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(api.transfer.miningTransfer, { amount: money.unformat(amount, 'fto') }).then(function () {
                popup.show('Transfer completed successfully.', 'OK', true);
            }, function (error) {
                popup.show(error.data.errors[0].message, 'OK', true);
            });
        }
    }]);

    return Transfer;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('transfer', Transfer);

/***/ }),

/***/ "J1J0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J6yw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'withdraw',"title":'Withdraw Request'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('withdraw-form'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J8c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['code', 'money', 'user'],
    data: function data() {
        return {
            codeValue: 0,
            showErrors: true
        };
    },

    computed: {
        available: function available() {
            return this.money.format(this.$store.getters.user.moneyBalance, 'fnd');
        },
        progress: function progress() {
            return this.$store.getters.codes.isCreateLoading;
        }
    },
    methods: {
        validate: function validate() {
            var _this = this;

            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.code.createCode(_this.money.unformat(_this.codeValue, 'fnd'));
                } else {
                    _this.showErrors = true;
                }
            });
        }
    }
});

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("k0Yb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("vkIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JMHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api'),
    datetime = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('datetime'),
    status = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('status');

var state = {
    boughtPackets: [],

    boughtPacketsSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: []
    }
};

var getters = {
    boughtPackets: function boughtPackets(state) {
        return state.boughtPackets;
    },

    boughtPacketsSettings: function boughtPacketsSettings(state) {
        return state.boughtPacketsSettings;
    }
};

var mutations = {
    /**
     * Set bought packets in store
     * @param state
     * @param data
     */
    setBoughtPackets: function setBoughtPackets(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'boughtPackets', data.results);
        } else {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'boughtPackets', []);
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'numberOfPages', data.number_of_pages);
    }
};

var actions = {

    /**
     * Get bought packets data from api
     * @param commit
     * @param data
     * @returns {Promise<any>}
     */
    loadBoughtPackets: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (data) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                var settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(data);
                                if (settings.params.sort) {
                                    var sort = [];
                                    for (var field in data.params.sort) {
                                        sort.push(data.params.sort[field]);
                                    }
                                    settings.params.sort = sort;
                                }
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.package.boughtList(settings.params)).then(function (response) {
                                    commit('setBoughtPackets', response.data);
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    reject();
                                });
                            }));

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadBoughtPackets(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return loadBoughtPackets;
    }(),


    /**
     * Set sorting in bought packets
     * @param field
     * @returns {Promise}
     */
    boughtPacketsSetSort: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, field) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                var sort = state.boughtPacketsSettings.sort,
                                    isSet = false;

                                for (var sortId in sort) {
                                    if (!isSet && sort[sortId].field === field) {
                                        isSet = sortId;
                                    }
                                }

                                if (!isSet) {
                                    sort.push({
                                        field: field,
                                        order: 'ASC'
                                    });
                                } else {
                                    sort[isSet].order = sort[isSet].order === 'DESC' ? 'ASC' : 'DESC';
                                }

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'sort', sort);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function boughtPacketsSetSort(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return boughtPacketsSetSort;
    }(),


    /**
     * Set max number of items in bought packets
     * @param getters
     * @param data
     * @returns {Promise}
     */
    boughtPacketsSetItems: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function boughtPacketsSetItems(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return boughtPacketsSetItems;
    }(),


    /**
     * Set page in bought packets
     * @param getters
     * @param data
     * @returns {Promise}
     */
    boughtPacketsSetPage: function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

                            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'currentPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function boughtPacketsSetPage(_x7, _x8) {
            return _ref8.apply(this, arguments);
        }

        return boughtPacketsSetPage;
    }(),


    /**
     * Set date in bought packets
     * @param date
     * @returns {Promise}
     */
    boughtPacketsSetDate: function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9, date) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

                            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                var dates = date.split(' to ');

                                if (dates[1]) {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'fromDate', datetime.localToUtc(dates[0]));
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'toDate', datetime.localToUtc(dates[1]));
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'fromDate', datetime.localToUtc(dates[0]));
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.boughtPacketsSettings, 'toDate', datetime.localToUtc(__WEBPACK_IMPORTED_MODULE_7_moment___default()().format()));
                                }

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function boughtPacketsSetDate(_x9, _x10) {
            return _ref10.apply(this, arguments);
        }

        return boughtPacketsSetDate;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "JTuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    computed: {
        amount: function amount() {
            return 'FND ' + this.money.format(this.$store.getters.user.future_net_upgrade_account_balance, 'fnd');
        }
    }
});

/***/ }),

/***/ "JfmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'mb80' : _vm.HasUnilevelBonusFromFrontliners() }},[_c('h3',{staticStyle:{"margin-bottom":"35px"}},[_vm._v("My Unilevel Bonus")]),_vm._v(" "),_c('div',{staticClass:"table-outer start-packet-table"},[_c('table',{staticClass:"table-style2"},[_c('thead',[_c('tr',{staticClass:"start-packet-table"},_vm._l((_vm.GetTableHeader()),function(header,headerId){return _c('th',{key:headerId,class:{ 'active': headerId === _vm.startPacket }},[_c('p',{class:{ 'small-header-font' : _vm.HasUnilevelBonusFromFrontliners() },domProps:{"innerHTML":_vm._s(header)}})])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.GetTableRows()),function(row,rowId){return _c('tr',{key:rowId},_vm._l((row),function(cell,cellId){return _c('td',{key:cellId,class:{ 'active': cellId === _vm.startPacket }},[_c('p',[_vm._v(_vm._s(cell))])])}),0)}),0),_vm._v(" "),(!_vm.HasUnilevelBonusFromFrontliners())?_c('tr',{staticClass:"buy-items"},_vm._l((_vm.packets),function(packet,packetId){return _c('td',{key:packetId},[((packetId > parseInt(_vm.startPacket) && _vm.startPacket !== '25000') && packetId > 0)?_c('a',{staticClass:"buy-button disabled",on:{"click":function($event){!_vm.loader ? _vm.buyPacket(packetId) : ''}}},[_vm._v("Buy")]):_vm._e(),_vm._v(" "),(packet.progress)?_c('a',{staticClass:"buy-button button--progress"},[_vm._v("buy")]):_vm._e()])}),0):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K20k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");







var api = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('api'),
    popup = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('popup'),
    status = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('status');

var Verification = function () {
    function Verification() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Verification);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Verification, [{
        key: 'create',
        value: function create(params) {
            this.data = params;
        }
    }, {
        key: 'loadVerificationFiles',
        value: function loadVerificationFiles() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.user.verification.get).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setVerificationFiles', response.data.data.results);
                    resolve();
                }, function (error) {
                    if (status['status' + error.status]) {
                        status['status' + error.status]();
                    } else {
                        popup.show(error.data.errors[0].message);
                    }
                    reject();
                });
            });
        }
    }, {
        key: 'sendFiles',
        value: function sendFiles(filesList) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(api.user.verification.request, {
                    files: filesList
                }).then(function () {
                    popup.show('Upload success.');
                    resolve();
                }, function (error) {
                    if (status['status' + error.status]) {
                        status['status' + error.status]();
                    } else {
                        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('modals', {
                            modal: 'alert',
                            data: {
                                visible: true,
                                reload: false,
                                message: error.data.errors[0].message
                            }
                        });
                    }
                    reject();
                });
            });
        }
    }]);

    return Verification;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('verification', Verification);

/***/ }),

/***/ "K90U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturoNetworkPassword_vue__ = __webpack_require__("bICo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86636cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturoNetworkPassword_vue__ = __webpack_require__("ojr2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturoNetworkPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86636cb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturoNetworkPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KGCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"7"}},[_c('p',[_vm._v("Only JPG, PNG and PDF accepted. Max file size is 1 MB.")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[(_vm.filesList.length <= 0)?_c('div',{staticClass:"upload-file-container"},[_c('input',{attrs:{"type":"file","name":"upload_files","multiple":""},on:{"change":_vm.uploadFiles}}),_vm._v(" "),_c('button',{staticClass:"button--primary",attrs:{"type":"button"}},[_vm._v("Upload files")])]):_vm._e(),_vm._v(" "),(_vm.filesList.length > 0)?_c('div',{staticClass:"upload-file-container"},[_c('button',{staticClass:"button--primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeFiles()}}},[_vm._v("Remove files")])]):_vm._e()])],1),_vm._v(" "),_vm._l((_vm.filesList),function(value,index){return _c('b-row',{key:index,staticClass:"uploaded-file"},[_c('b-col',{staticClass:"uploaded-file-container",attrs:{"lg":"7"}},[_c('p',[_vm._v(_vm._s(value.name ? value.name : ''))]),_vm._v(" "),_c('img',{attrs:{"src":value.url ? value.url : '',"alt":""}})])],1)}),_vm._v(" "),(_vm.filesList.length > 0)?_c('b-row',{staticStyle:{"margin-top":"30px"}},[_c('b-col',{attrs:{"lg":"7"}}),_vm._v(" "),_c('b-col',{staticClass:"uploaded-file-action",attrs:{"lg":"3"}},[(!_vm.progress)?_c('button',{staticClass:"button--primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmFiles()}}},[_vm._v("Confirm")]):_vm._e(),_vm._v(" "),(_vm.progress)?_c('button',{staticClass:"button--primary button--progress",attrs:{"type":"button"}},[_vm._v("Confirm")]):_vm._e()])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KY3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'payout',"title":'Payout'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('payout-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kh+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileContent_vue__ = __webpack_require__("naA2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7c3d2dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileContent_vue__ = __webpack_require__("+5C9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7c3d2dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KiG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    ftoAccounts: {
        miningAccount: null,
        miningOriginalAccount: null,
        royalBonusAccount: null,
        allowToWithdrawFromRoyal: null
    }
};

var getters = {
    ftoAccounts: function ftoAccounts(state) {
        return state.ftoAccounts;
    }
};

var mutations = {
    setFtoAccounts: function setFtoAccounts(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'ftoAccounts', {
            miningAccount: data.mining_account.amount,
            miningOriginalAccount: data.mining_original_account.amount,
            royalBonusAccount: data.royal_bonus_account.amount,
            royalBonusOriginalAccount: data.royal_bonus_original_account.amount,
            allowToWithdrawFromRoyal: data.allow_to_withdraw_from_royal.amount
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "KjUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderCookieMessage_vue__ = __webpack_require__("rbvw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fed724_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderCookieMessage_vue__ = __webpack_require__("5qFj");
function injectStyle (ssrContext) {
  __webpack_require__("zqx8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60fed724"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderCookieMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fed724_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderCookieMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KjWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        }
    }
});

/***/ }),

/***/ "Kmko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"commissions-stats-component",attrs:{"id":"commissions_stats_component"}},_vm._l((_vm.stats),function(stat,index){return _c('b-col',{key:index,attrs:{"lg":"3","cols":"6"}},[_c('stats-item',{attrs:{"label":stat.label,"value":stat.value}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kwgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEditData_vue__ = __webpack_require__("FsOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62efd7ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEditData_vue__ = __webpack_require__("UTr6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEditData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62efd7ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEditData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kyvz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer"},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"fullscreen-box--content"},[_c('div',{staticClass:"box-component",attrs:{"id":"box_component"}},[_c('div',{staticClass:"box-component-inner"},[(_vm.userFromUe && !_vm.termsAccepted)?_c('div',[_c('p',[_vm._v("Dear user,")]),_vm._v(" "),_c('p',[_vm._v("We regret to inform You that Your account has been blocked. In\n                                    order to regain access\n                                    to Your account it is required that You accept two GDPR agreements (first two check\n                                    boxes). Lack of acceptance will result in irreversible termination of that account.\n                                    We ask that You make sure that Your agreement is saved on all platforms.")])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"register-form",attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._l((_vm.termsList),function(term,index){return _c('div',{key:index,staticStyle:{"margin-bottom":"20px"}},[_c('checkbox',{attrs:{"label":'term',"message":term.content,"name":term.key,"progress":_vm.progress,"rules":false,"show-errors":_vm.showErrors,"update-value":_vm.updateValue,"checked":_vm.getValue(term.key),"add-class":term.required ? 'required dark' : 'dark'}})],1)}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button--primary password",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Confirm\n                                    ")]),_vm._v(" "),_c('br'),_vm._v("or"),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{'name': 'Dashboard'}}},[_vm._v("Cancel")])],1)],2)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KzCJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LFQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('img',{staticClass:"logo",staticStyle:{"margin":"50px 0"},attrs:{"src":__webpack_require__("APq4"),"alt":"FutureNetwork"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LG9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__outer"},[_c('div',{staticClass:"home-page__element"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"12"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("APq4"),"alt":"FuturoNetwork"}})])],1)],1),_vm._v(" "),(_vm.canRegister === 'CAN_REGISTER')?_c('div',{staticClass:"home-page__element home-page__element__dark"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"12"}},[(_vm.userData && _vm.userData.sponsor)?_c('h1',{staticClass:"title"},[_vm._v("\n                    Welcome to FuturoNetwork "),_c('br',{staticClass:"desktop-only"}),_vm._v("online business\n                ")]):_c('h1',{staticClass:"title"},[_vm._v("\n                    Thank you for your interest "),_c('br',{staticClass:"desktop-only"}),_vm._v("in FuturoNetwork™ platform\n                ")])])],1),_vm._v(" "),(_vm.userData && _vm.userData.sponsor)?_c('form',{staticClass:"full",on:{"submit":function($event){$event.preventDefault();return _vm.validate()}}},[_c('b-row',{staticClass:"register-form"},[_c('b-col',{attrs:{"lg":"6"}},[(_vm.userData.sponsor && _vm.userData.sponsor !== 'futurenet')?_c('textfield',{attrs:{"name":'your_sponsor_name',"label":'Sponsor',"progress":_vm.progress,"update-value":_vm.updateValue,"disabled":true,"default":'Sponsor: ' + _vm.userData.sponsor}}):_vm._e(),_vm._v(" "),_c('textfield',{attrs:{"name":'first_name',"label":'first name',"progress":_vm.progress,"rules":'required|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}}),_vm._v(" "),_c('textfield',{attrs:{"name":'last_name',"label":'last name',"progress":_vm.progress,"rules":'required|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}}),_vm._v(" "),_c('textfield',{attrs:{"name":'login',"label":'login',"progress":_vm.progress,"rules":'required|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}}),_vm._v(" "),_c('textfield',{attrs:{"name":'email',"label":'email address',"progress":_vm.progress,"rules":'required|email|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}}),_vm._v(" "),_c('textfield',{attrs:{"name":'email_confirmation',"label":'repeat email address',"progress":_vm.progress,"rules":'required|email|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-input",class:{ 'form-item--error': _vm.errors.has('password') && _vm.showErrors }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userData.password),expression:"userData.password"},{name:"validate",rawName:"v-validate"}],ref:"password",attrs:{"type":"password","placeholder":"Password","name":"password","id":"register_form_password","data-vv-rules":"required|min:8|max:255","data-vv-as":"password","disabled":_vm.progress},domProps:{"value":(_vm.userData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userData, "password", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password') && _vm.showErrors),expression:"errors.has('password') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-input",class:{ 'form-item--error': _vm.errors.has('repeat_password') && _vm.showErrors }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userData.password_confirmation),expression:"userData.password_confirmation"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"password","placeholder":"Repeat password","name":"repeat_password","id":"register_form_repeat_password","data-vv-rules":"required|confirmed:password|max:255","data-vv-as":"repeat password","disabled":_vm.progress},domProps:{"value":(_vm.userData.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userData, "password_confirmation", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('repeat_password') && _vm.showErrors),expression:"errors.has('repeat_password') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('repeat_password')))])]),_vm._v(" "),_c('div',{staticClass:"form-radios"},[_c('div',{staticClass:"radios"},[_c('div',{staticClass:"form-item form-radio",class:{ 'form-item--error': _vm.errors.has('gender') && _vm.showErrors }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userData.gender),expression:"userData.gender"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"radio","name":"gender","id":"account_type_personal","value":"male","data-vv-as":"account type","data-vv-rules":"required","disabled":_vm.progress},domProps:{"checked":_vm._q(_vm.userData.gender,"male")},on:{"change":function($event){return _vm.$set(_vm.userData, "gender", "male")}}}),_vm._v(" "),_c('label',{attrs:{"for":"account_type_personal"}},[_vm._v("Personal account")]),_vm._v(" "),_c('div',{staticClass:"check"})]),_vm._v(" "),_c('div',{staticClass:"form-item form-radio",class:{ 'form-item--error': _vm.errors.has('gender') && _vm.showErrors }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userData.gender),expression:"userData.gender"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"radio","name":"gender","id":"account_type_company","value":"company","data-vv-as":"account type","data-vv-rules":"required","disabled":_vm.progress},domProps:{"checked":_vm._q(_vm.userData.gender,"company")},on:{"change":function($event){return _vm.$set(_vm.userData, "gender", "company")}}}),_vm._v(" "),_c('label',{attrs:{"for":"account_type_company"}},[_vm._v("Company account")]),_vm._v(" "),_c('div',{staticClass:"check"})])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('gender') && _vm.showErrors),expression:"errors.has('gender') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('gender')))])]),_vm._v(" "),(_vm.userData.gender === 'company')?_c('textfield',{attrs:{"name":'company_name',"label":'company name',"progress":_vm.progress,"rules":'required|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}}):_vm._e(),_vm._v(" "),(_vm.userData.gender === 'company')?_c('textfield',{attrs:{"name":'company_registration_number',"label":'company registration number',"progress":_vm.progress,"rules":'required|max:255',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}}):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"register-form"},[_c('b-col',{attrs:{"cols":"12"}},[_vm._l((_vm.termsList),function(term,index){return _c('div',{key:index},[_c('checkbox',{attrs:{"message":term.content,"name":term.key,"label":'terms and conditions',"progress":_vm.progress,"rules":term.required ? 'required' : '',"show-errors":_vm.showErrors,"update-value":_vm.updateValue}})],1)}),_vm._v(" "),_c('div',{staticClass:"form-item form-recaptcha",class:{ 'form-item--error': _vm.errors.has('recaptcha') && _vm.showErrors }},[_c('vue-recaptcha',{staticClass:"g-recaptcha",attrs:{"sitekey":_vm.recaptcha.sitekey},on:{"verify":_vm.onVerify,"render":_vm.onRender}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('recaptcha') && _vm.showErrors),expression:"errors.has('recaptcha') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('recaptcha')))])],1)],2),_vm._v(" "),_c('b-col',{staticClass:"buttons",attrs:{"lg":"6"}},[_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Register")])])],1)],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"to-login tl",staticStyle:{"margin-top":"20px"}},[_vm._v("\n            Do you have an account?\n            "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.goToLogin()}}},[_vm._v("Log in FuturoNetwork")])])],1):_c('div',{staticClass:"home-page__element home-page__element__dark"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"12"}},[_c('h1',{staticClass:"title"},[_vm._v("\n                    In some countries registration for the service has been blocked for legal reasons. You can not register.\n                ")]),_vm._v(" "),_c('p',{staticClass:"to-login tl",staticStyle:{"margin-top":"20px"}},[_vm._v("\n                    Do you have an account?\n                    "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.goToLogin()}}},[_vm._v("Log in FuturoNetwork")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"home-page__element"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LN/0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            tableHeaders: {
                career: 'Career level',
                bronze: 'Bronze',
                silver: 'Silver',
                gold: 'Gold',
                diamond: 'Diamond',
                diamond_1: '1*Diamond',
                diamond_2: '2*Diamond',
                vip: 'Vip'
            },
            tableRows: {
                1: {
                    career: 'Level 1',
                    bronze: '2%',
                    silver: '2%',
                    gold: '3%',
                    diamond: '4%',
                    diamond_1: '4%',
                    diamond_2: '4%',
                    vip: '4%'
                },
                2: {
                    career: 'Level 2',
                    bronze: '2%',
                    silver: '2%',
                    gold: '3%',
                    diamond: '4%',
                    diamond_1: '4%',
                    diamond_2: '4%',
                    vip: '4%'
                },
                3: {
                    career: 'Level 3',
                    bronze: '2%',
                    silver: '2%',
                    gold: '3%',
                    diamond: '3%',
                    diamond_1: '4%',
                    diamond_2: '4%',
                    vip: '4%'
                },
                4: {
                    career: 'Level 4',
                    bronze: '1%',
                    silver: '2%',
                    gold: '3%',
                    diamond: '3%',
                    diamond_1: '4%',
                    diamond_2: '4%',
                    vip: '4%'
                },
                5: {
                    career: 'Level 5',
                    bronze: '1%',
                    silver: '2%',
                    gold: '2%',
                    diamond: '3%',
                    diamond_1: '3%',
                    diamond_2: '3%',
                    vip: '4%'
                },
                6: {
                    career: 'Level 6',
                    bronze: '1%',
                    silver: '2%',
                    gold: '2%',
                    diamond: '3%',
                    diamond_1: '3%',
                    diamond_2: '3%',
                    vip: '3%'
                },
                7: {
                    career: 'Level 7',
                    bronze: '1%',
                    silver: '2%',
                    gold: '2%',
                    diamond: '3%',
                    diamond_1: '3%',
                    diamond_2: '3%',
                    vip: '3%'
                },
                8: {
                    career: 'Level 8',
                    bronze: '',
                    silver: '',
                    gold: '2%',
                    diamond: '3%',
                    diamond_1: '3%',
                    diamond_2: '3%',
                    vip: '3%'
                },
                9: {
                    career: 'Level 9',
                    bronze: '',
                    silver: '',
                    gold: '',
                    diamond: '3%',
                    diamond_1: '3%',
                    diamond_2: '3%',
                    vip: '3%'
                },
                10: {
                    career: 'Level 10',
                    bronze: '',
                    silver: '',
                    gold: '',
                    diamond: '',
                    diamond_1: '',
                    diamond_2: '3%',
                    vip: '3%'
                }
            }
        };
    },

    computed: {
        careerLevel: function careerLevel() {
            return this.$store.getters.user.careerLevel;
        }
    }
});

/***/ }),

/***/ "Lfcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_RemindPasswordForm_vue__ = __webpack_require__("P3c6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { RemindPasswordForm: __WEBPACK_IMPORTED_MODULE_0__partials_RemindPasswordForm_vue__["a" /* default */] },
    computed: {
        view: function view() {
            return this.$store.getters.loginForm.view;
        }
    },
    methods: {
        changeView: function changeView(view) {
            var _this = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this.$store.commit('loginFormView', view);
            }, 600);
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store.commit('loginFormView', 2);
    },
    mounted: function mounted() {
        this.changeView(1);
    }
});

/***/ }),

/***/ "LkCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoyalBonusesTable_vue__ = __webpack_require__("mZoi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143f1f50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoyalBonusesTable_vue__ = __webpack_require__("7M2v");
function injectStyle (ssrContext) {
  __webpack_require__("ezXG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-143f1f50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoyalBonusesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143f1f50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoyalBonusesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ln/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__futurocoin_FuturocoinStats_vue__ = __webpack_require__("blku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__futurocoin_FuturocoinWithdraw_vue__ = __webpack_require__("83Un");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__futurocoin_FuturocoinPayout_vue__ = __webpack_require__("Ivhk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__futurocoin_FuturocoinMiningTransfer_vue__ = __webpack_require__("GR5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__futurocoin_FuturocoinRoyalTransfer_vue__ = __webpack_require__("25FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__futurocoin_FuturocoinTable_vue__ = __webpack_require__("9AEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__futurocoin_RoyalBonusesTable_vue__ = __webpack_require__("LkCD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['ftoAccounts', 'royalBonuses'],
    // FuturocoinWithdraw , FuturocoinPayout, FuturocoinMiningTransfer, FuturocoinRoyalTransfer
    components: { FuturocoinStats: __WEBPACK_IMPORTED_MODULE_0__futurocoin_FuturocoinStats_vue__["a" /* default */], FuturocoinTable: __WEBPACK_IMPORTED_MODULE_5__futurocoin_FuturocoinTable_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_6__dashboard_FuturocoinsFromMining_vue__["a" /* default */], RoyalBonusesTable: __WEBPACK_IMPORTED_MODULE_7__futurocoin_RoyalBonusesTable_vue__["a" /* default */] },
    computed: {
        mining: function mining() {
            return this.$store.getters.ftoAccounts.miningAccount;
        },
        royalPosition: function royalPosition() {
            return this.$store.getters.ftoAccounts.royalBonusAccount;
        }
    },
    created: function created() {
        this.$store.dispatch('loadDailyMining');
        this.$store.dispatch('loadFuturocoinWithdraw');
    }
});

/***/ }),

/***/ "LpQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"check-fnwallet-component",attrs:{"no-gutters":"","id":"check_fnwallet_component"}},[_c('b-col',{staticClass:"check-fnwallet-inner",attrs:{"lg":"8"}},[_c('a',{staticClass:"check-fnwallet-banner",attrs:{"href":"https://fnwallet.com","target":"_blank"}},[_vm._v("\n            Check out our FNWallet"),_c('br'),_vm._v("Keep, send and receive your coins.\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"check-fnwallet-logo-outer desktop-only",attrs:{"lg":"4","cols":"4"}},[_c('a',{staticClass:"check-fnwallet-logo",attrs:{"href":"https://fnwallet.com","target":"_blank"}},[_vm._v("\n            FNWallet\n        ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lq+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Topbar_vue__ = __webpack_require__("2h5M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4963047b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Topbar_vue__ = __webpack_require__("FHNH");
function injectStyle (ssrContext) {
  __webpack_require__("udQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4963047b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Topbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4963047b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Topbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M+H2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_NewsContent_vue__ = __webpack_require__("XvX4");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], NewsContent: __WEBPACK_IMPORTED_MODULE_1__content_NewsContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "M1PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__ = __webpack_require__("wpUA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9434fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__ = __webpack_require__("QzwW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9434fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c0b0f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1180");
function injectStyle (ssrContext) {
  __webpack_require__("GJot")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c0b0f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__my_team_MyTeamTotal_vue__ = __webpack_require__("QA3Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__my_team_MyTeamTree_vue__ = __webpack_require__("GSDo");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__["a" /* default */], MyTeamTotal: __WEBPACK_IMPORTED_MODULE_1__my_team_MyTeamTotal_vue__["a" /* default */], MyTeamTree: __WEBPACK_IMPORTED_MODULE_2__my_team_MyTeamTree_vue__["a" /* default */] }
});

/***/ }),

/***/ "MApT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['view'],
    dependencies: ['api', 'popup', 'status', 'user'],
    data: function data() {
        return {
            progress: false,
            newPassword: '',
            repeatPassword: '',
            showErrors: false
        };
    },

    methods: {
        changeView: function changeView(view) {
            var _this = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this.$store.commit('loginFormView', view);
            }, 600);
        },
        goToLogin: function goToLogin() {
            var _this2 = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this2.$router.push({ name: 'Login' });
            }, 600);
        },
        success: function success() {
            this.progress = false;
            this.popup.show('Your password was changed correctly. You can now log in');
        },
        validate: function validate() {
            var _this3 = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this3.errors.any()) {
                    _this3.submit();
                } else {
                    _this3.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this4 = this;

            var vm = this;
            vm.progress = true;

            vm.$http.post(this.api.user.password.new, {
                newPassword: vm.newPassword,
                newPasswordConfirmed: vm.repeatPassword,
                token: vm.$router.history.current.params.token
            }).then(function (response) {
                _this4.$router.push({ name: 'Login' });
                _this4.success(response.data);
            }, function (error) {
                setTimeout(function () {
                    vm.progress = false;
                    if (vm.status['status' + error.status]) {
                        vm.status['status' + error.status]();
                    } else {
                        vm.popup.show(error.data.errors[0].message);
                    }
                }, 600);
            });
        }
    }
});

/***/ }),

/***/ "MEVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_LayoutHeader_vue__ = __webpack_require__("yW/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_section_modals_Alert_vue__ = __webpack_require__("/O9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_section_modals_BuyPacket_vue__ = __webpack_require__("AMl5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_section_modals_WithdrawCoinsModal_vue__ = __webpack_require__("XaBC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//Modals




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Alert: __WEBPACK_IMPORTED_MODULE_1__partials_section_modals_Alert_vue__["a" /* default */], BuyPacket: __WEBPACK_IMPORTED_MODULE_2__partials_section_modals_BuyPacket_vue__["a" /* default */], LayoutHeader: __WEBPACK_IMPORTED_MODULE_0__partials_LayoutHeader_vue__["a" /* default */], WithdrawCoinsModal: __WEBPACK_IMPORTED_MODULE_3__partials_section_modals_WithdrawCoinsModal_vue__["a" /* default */] },
    computed: {
        auth: function auth() {
            return this.$store.getters.checkAuth;
        }
    }
});

/***/ }),

/***/ "MHyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderUser_vue__ = __webpack_require__("HxXg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e397cdce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderUser_vue__ = __webpack_require__("3eU3");
function injectStyle (ssrContext) {
  __webpack_require__("EYcN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e397cdce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHzj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MQXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('h3',{staticStyle:{"margin-bottom":"-35px"}},[_vm._v("My Career Bonus")]),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style2"},[_c('thead',[_c('tr',{staticClass:"business-qualifications-header-table"},_vm._l((_vm.tableHeaders),function(header,headerId){return _c('th',{key:headerId,class:{'active':  String(headerId) === _vm.careerLevel }},[_c('p',[_vm._v(_vm._s(header))])])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableRows),function(row,rowId){return _c('tr',{key:rowId,staticClass:"row-items"},_vm._l((row),function(cell,cellId){return _c('td',{class:{'active':  String(cellId) === _vm.careerLevel }},[_c('p',[_vm._v(_vm._s(cell))])])}),0)}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MVyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer"},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"fullscreen-box--content"},[_c('b-container',{staticClass:"register-center"},[_c('error-logo'),_vm._v(" "),_c('error-404-content')],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MjI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BitcoinAccountNumber_vue__ = __webpack_require__("wVkC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5457ca59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BitcoinAccountNumber_vue__ = __webpack_require__("g81O");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BitcoinAccountNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5457ca59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BitcoinAccountNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mocx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicesTable_vue__ = __webpack_require__("f1MP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a26d35d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesTable_vue__ = __webpack_require__("/9WW");
function injectStyle (ssrContext) {
  __webpack_require__("Yft9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a26d35d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MyOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"error-500-redirect-component"},[_c('b-col',{attrs:{"lg":"12"}},[_c('a',{staticClass:"button--primary",on:{"click":function($event){return _vm.reload()}}},[_vm._v("Try again")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NGZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',{staticClass:"futurocoin-transfer-component",attrs:{"id":"futurocoin_transfer_component"}},[_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('div',{staticClass:"form-item form-item-amount"},[_c('div',{staticClass:"transfer-value",class:{ 'field-error': (_vm.errors.has('withdraw_mining') || _vm.available < _vm.amount) && _vm.showErrors }},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],attrs:{"type":"text","name":"withdraw_mining","data-vv-rules":"required|money|greaterThanZero","data-vv-as":"amount","disabled":_vm.progress},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"currency"},[_vm._v("FTO")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('withdraw_mining') && _vm.showErrors),expression:"errors.has('withdraw_mining') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('withdraw_mining')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.available < _vm.amount && _vm.showErrors),expression:"available < amount && showErrors"}],staticClass:"field-error--description"},[_vm._v("Not enough founds")])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('div',{staticClass:"transfer-get-all"},[_c('p',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.withdrawAll()}}},[_vm._v("withdraw all available coins")])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress }},[_vm._v("Transfer to wallet")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_clipboards__ = __webpack_require__("1f+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_blu__ = __webpack_require__("xfLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_blu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_blu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_blu_dist_css_vue_blu_min_css__ = __webpack_require__("/YjR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_blu_dist_css_vue_blu_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_blu_dist_css_vue_blu_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_resource_nprogress__ = __webpack_require__("E7W3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_resource_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_resource_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_nprogress_css__ = __webpack_require__("d8+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_css_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_tippy__ = __webpack_require__("ybWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue2_touch_events__ = __webpack_require__("ufW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_shared_autocomplete_Autocomplete_component_vue__ = __webpack_require__("lEZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_shared_autologout_Autologout_component_vue__ = __webpack_require__("QmFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_shared_dropdown_Dropdown_component_vue__ = __webpack_require__("Bob9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_shared_pagination_Pagination_component_vue__ = __webpack_require__("OcDk");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















window.NProgress = __WEBPACK_IMPORTED_MODULE_12_nprogress___default.a;

__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */], { inject: true });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_clipboards__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_blu___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_inject___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_resource_nprogress___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_tippy___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue2_touch_events___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_analytics___default.a, {
    id: 'UA‌-57624689-15',
    router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]
});

// Globals component section





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('autocomplete-component', __WEBPACK_IMPORTED_MODULE_19__components_shared_autocomplete_Autocomplete_component_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('autologout-component', __WEBPACK_IMPORTED_MODULE_20__components_shared_autologout_Autologout_component_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('dropdown-component', __WEBPACK_IMPORTED_MODULE_21__components_shared_dropdown_Dropdown_component_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('pagination-component', __WEBPACK_IMPORTED_MODULE_22__components_shared_pagination_Pagination_component_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.credentials = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.root = "https://api.futuro.network/api/v1/";

// Add authorization if available
if (true) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers['Authorization'] = "Basic ZGVtbzpkZW1vMTIz";
}

var api = __WEBPACK_IMPORTED_MODULE_10_vue_inject___default.a.get('api'),
    status = __WEBPACK_IMPORTED_MODULE_10_vue_inject___default.a.get('status'),
    user = __WEBPACK_IMPORTED_MODULE_10_vue_inject___default.a.get('user');

var validation = {
    currency: {
        getMessage: function getMessage() {
            return 'The amount should have no more than two decimal places.';
        },
        validate: function validate(value) {
            return (/^[0-9]+([,.][0-9]{1,2})?$/.test(value)
            );
        }
    },
    digit: {
        getMessage: function getMessage() {
            return 'Your password must have at least one digit.';
        },
        validate: function validate(value) {
            return (/^.*\d.*$/.test(value)
            );
        }
    },
    greaterThanZero: {
        getMessage: function getMessage() {
            return 'Value must be greater than zero.';
        },
        validate: function validate(value) {
            return value > 0;
        }
    },
    isOnList: {
        getMessage: function getMessage() {
            return 'The value provided is not on the list.';
        },
        validate: function validate(value, list) {
            var _value = value.toLowerCase();
            var isOnList = list[0].filter(function (obj) {
                var name = obj.name.toLowerCase();
                return name.indexOf(_value) === 0 && name === _value;
            });
            return isOnList.length === 1 && isOnList[0].name.toLowerCase() === _value;
        }
    },
    money: {
        getMessage: function getMessage() {
            return 'Unauthorized characters';
        },
        validate: function validate(value) {
            return (/^[0-9]+([,.][0-9]+)?$/.test(value)
            );
        }
    },
    phone: {
        getMessage: function getMessage() {
            return 'Unauthorized characters';
        },
        validate: function validate(value) {
            return (/^[0-9-+() ]+$/.test(value)
            );
        }
    },
    specialChar: {
        getMessage: function getMessage() {
            return 'Your password must have at least one special character.';
        },
        validate: function validate(value) {
            return (/^.*(?=.*[@#$%^&+=!*?()\\]).+.*$/.test(value)
            );
        }
    }
};
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('currency', validation.currency);
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('digit', validation.digit);
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('greaterThanZero', validation.greaterThanZero);
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('isOnList', validation.isOnList);
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('money', validation.money);
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('phone', validation.phone);
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */].Validator.extend('specialChar', validation.specialChar);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
    var auth = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.checkAuth,
        url = request.url;

    var notCheckAgreements = ['auth/logout', 'logout'];

    if (auth && url !== 'user/fto-accounts') {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].cookie.set('FTN_SESSION_TIME', 0);
    }

    next(function (response) {
        // Catch response status
        switch (response.status) {
            case 403:
                if (notCheckAgreements.indexOf(url) < 0) {
                    status['status' + response.status](next);
                }
                break;
            case 404:
            case 500:
                status['status' + response.status](next);
                break;
            case 503:
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setError', {
                    status: true,
                    code: 503,
                    redirect: true
                });
                next({ name: 'Dashboard' });
                break;
        }
    });
});

var checkAuth = function checkAuth(to, from, next) {
    if (to.matched.some(function (record) {
        return record.meta.Auth;
    })) {
        if (!__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.checkAuth) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(api.auth.user).then(function (response) {
                user.fetchData(response.data).then(function () {
                    if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.user.position == 0 && !to.matched.some(function (record) {
                        return record.meta.noPacket;
                    })) {
                        return next({ name: 'StartPacket' });
                    } else {
                        return next();
                    }
                });
            }, function (error) {
                status['status' + error.status](next);
            });
        } else {
            if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.user.position == 0 && !to.matched.some(function (record) {
                return record.meta.noPacket;
            })) {
                return next({ name: 'StartPacket' });
            } else {
                return next();
            }
        }
    }
    return next();
};

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('offMobileMenu');

    var isBanned = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.isBanned;

    if ((typeof isBanned === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(isBanned)) === 'object') {
        user.isBanned().then(function (obj) {
            if (obj) {
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('banned', obj.banned);
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('location', obj.location);
            }

            return checkAuth(to, from, next);
        });
    } else {
        return checkAuth(to, from, next);
    }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_18__App__["a" /* default */] }
});

/***/ }),

/***/ "NLRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-componet",attrs:{"id":"calculator_component"}},[_c('b-row',[_c('b-col',{staticClass:"calculator-header",attrs:{"lg":"8"}},[_c('h3',[_vm._v("Check how many FTOs will you have at this minute"),_c('br',{staticClass:"desktop-only"}),_vm._v(" if you buy chosen mining package: ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-select",class:{ 'field-error': _vm.errors.has('country') }},[_c('div',{staticClass:"select-outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"text","name":"calculator_package","readonly":true},domProps:{"value":(_vm.selected)},on:{"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList),expression:"openList"}]},_vm._l((_vm.packages),function(force,amount){return _c('li',{key:amount,on:{"click":function($event){_vm.setItem('FND ' + amount + ' - ' + force + ' FORCE FACTOR', force), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v("FND "+_vm._s(amount)+" - "+_vm._s(force)+" FORCE FACTOR")])}),0)])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('p',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("at this moment you will have (per minute): ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[(!_vm.progress)?_c('div',{staticClass:"form-item form-item-amount"},[_c('div',{staticClass:"transfer-value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ftoValue),expression:"ftoValue"}],attrs:{"name":"calculator_fto","type":"text","readonly":true},domProps:{"value":(_vm.ftoValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ftoValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"currency"},[_vm._v("FTO")])])]):_vm._e(),_vm._v(" "),(_vm.progress)?_c('div',{staticClass:"data-loader data-loader__block"}):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("Remember that the above calculations are valid in the current minute. The number of mined FuturoCoins is constantly changing. We can not guarantee that you will receive the FTO number listed above in that minute.")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NaOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("sonc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1905a88b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("840f");
function injectStyle (ssrContext) {
  __webpack_require__("ba/H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1905a88b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1905a88b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NpqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"user_password tr",attrs:{"cols":"12","lg":"6","id":"user_password"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',[_c('b-col',{attrs:{"cols":"","lg":"12"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('current_password') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"settings_current_password"}},[_vm._v("\n                        Current password\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentPassword),expression:"currentPassword"},{name:"validate",rawName:"v-validate"}],staticClass:"settings-current-password",attrs:{"id":"settings_current_password","name":"current_password","data-vv-rules":"required","data-vv-as":"current password","disabled":_vm.progress,"type":"password"},domProps:{"value":(_vm.currentPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentPassword=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('current_password') && _vm.showErrors),expression:"errors.has('current_password') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('current_password')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('new_password') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"settings_new_password"}},[_vm._v("\n                        New password\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"},{name:"validate",rawName:"v-validate"}],ref:"new_password",staticClass:"settings-new-password",attrs:{"id":"settings_new_password","name":"new_password","data-vv-rules":"required|min:8|max:255","data-vv-as":"new password","disabled":_vm.progress,"type":"password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('new_password') && _vm.showErrors),expression:"errors.has('new_password') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('new_password')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('repeat_password') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"settings_repeat_password"}},[_vm._v("\n                        Repeat password\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"},{name:"validate",rawName:"v-validate"}],staticClass:"settings-repeat-password",attrs:{"id":"settings_repeat_password","name":"repeat_password","data-vv-rules":"confirmed:new_password|required","data-vv-as":"repeat password","disabled":_vm.progress,"type":"password"},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('repeat_password') && _vm.showErrors),expression:"errors.has('repeat_password') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('repeat_password')))])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"7"}},[_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Save password")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O7iR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fnproducts-packs-component",attrs:{"id":"fnproducts_packs_component"}},[_c('div',{staticClass:"codes-list-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(single,index){return _c('tr',{key:index},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.datetime.utcToLocal(single.date)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(single.source.replace('-', ' ').toUpperCase()))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v("FND "+_vm._s(_vm.money.format(single.amount, 'fnd')))])])])}),0)]),_vm._v(" "),(_vm.rows.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No results.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('p',[_vm._v("Date")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Bonus")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Amount to FutureNet Product Packs")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OAkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('email') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"user_data_email"}},[_vm._v("\n            Email address\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],attrs:{"id":"user_data_email","name":"email","type":"text","disabled":true},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email') && _vm.showErrors),expression:"errors.has('email') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('email')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ODA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinHistory_vue__ = __webpack_require__("zhJP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f7ed23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinHistory_vue__ = __webpack_require__("fqG+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f7ed23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OET/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "OHKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'topQualified',"title":'Top Qualified'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('top-qualified-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OHii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fnproductpacks_Header_vue__ = __webpack_require__("c08f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fnproductpacks_Table_vue__ = __webpack_require__("jSJo");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['fnproductPacks'],
    mounted: function mounted() {
        this.fnproductPack.fetchData();
    },

    components: { FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__["a" /* default */], PacksHeader: __WEBPACK_IMPORTED_MODULE_1__fnproductpacks_Header_vue__["a" /* default */], PacksTable: __WEBPACK_IMPORTED_MODULE_2__fnproductpacks_Table_vue__["a" /* default */] }
});

/***/ }),

/***/ "OJ/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_ImageModal_vue__ = __webpack_require__("R94H");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ImageModal: __WEBPACK_IMPORTED_MODULE_0__modals_ImageModal_vue__["a" /* default */] },
    dependencies: ['datetime', 'verification'],
    data: function data() {
        return {
            loader: true,
            src: ''
        };
    },

    computed: {
        files: function files() {
            return this.$store.getters.verificationFiles;
        }
    },
    methods: {
        showImage: function showImage(source) {
            this.src = source;
            this.$store.commit('modals', {
                modal: 'image',
                data: {
                    visible: true
                }
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.verification.loadVerificationFiles().then(function () {
            _this.loader = false;
        });
    }
});

/***/ }),

/***/ "OL71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_bottombar_HeaderPayout_vue__ = __webpack_require__("ukEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_bottombar_HeaderButton_vue__ = __webpack_require__("km1m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { HeaderButton: __WEBPACK_IMPORTED_MODULE_1__header_bottombar_HeaderButton_vue__["a" /* default */], HeaderPayout: __WEBPACK_IMPORTED_MODULE_0__header_bottombar_HeaderPayout_vue__["a" /* default */] },
    dependencies: ['ftoAccounts', 'money'],
    props: ['hidePayout', 'buttonLabel', 'buttonLink', 'transferHistory'],
    data: function data() {
        return {
            reload: ''
        };
    },

    computed: {
        amount: function amount() {
            return this.money.format(this.$store.getters.ftoAccounts.miningAccount, 'fto');
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;
        _this.ftoAccounts.fetchData();
        this.reload = setInterval(_this.ftoAccounts.fetchData, 60000);
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.reload);
    }
});

/***/ }),

/***/ "OUcc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPassword_vue__ = __webpack_require__("IB35");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_343d26a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPassword_vue__ = __webpack_require__("NpqB");
function injectStyle (ssrContext) {
  __webpack_require__("2W2/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_343d26a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OcDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_component_vue__ = __webpack_require__("XOin");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e26b7e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_component_vue__ = __webpack_require__("AYnT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e26b7e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oe1L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayModal)?_c('div',{staticClass:"modal-component",attrs:{"id":"modal_info_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.hideModal()}}}),_vm._v(" "),_vm._m(0)])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-inner text-left"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("BIxo"),"alt":"FuturoNetwork"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P1AA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');

var FNProductPacks = function () {
    function FNProductPacks() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FNProductPacks);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FNProductPacks, [{
        key: 'fetchData',
        value: function fetchData() {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.transferToFN.history).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setFNProductPacks', response.body.results);
            });
        }
    }]);

    return FNProductPacks;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('fnproductPacks', FNProductPacks);

/***/ }),

/***/ "P3c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemindPasswordForm_vue__ = __webpack_require__("MApT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c7254f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemindPasswordForm_vue__ = __webpack_require__("w780");
function injectStyle (ssrContext) {
  __webpack_require__("hhj0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76c7254f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemindPasswordForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c7254f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemindPasswordForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P4mI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['label', 'name', 'progress', 'rules', 'showErrors', 'type', 'updateValue', 'disabled', 'default'],
    data: function data() {
        return {
            value: ''
        };
    },

    watch: {
        value: function value() {
            this.updateValue(this.name, this.value);
        }
    },
    beforeMount: function beforeMount() {
        if (this.default) {
            this.value = this.default;
        }
    }
});

/***/ }),

/***/ "P9Rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingPlan_vue__ = __webpack_require__("xwmE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3b46a32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingPlan_vue__ = __webpack_require__("EOn2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingPlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3b46a32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingPlan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commissions_vue__ = __webpack_require__("eeog");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310f3955_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commissions_vue__ = __webpack_require__("hB2s");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310f3955_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PLPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-item-component"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PQrG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"section-menu-item",class:{ active: _vm.active == _vm.index, open: _vm.submenu, 'mobile-only': _vm.mobileOnly }},[(_vm.hasPacket || _vm.noPacket)?_c('div',[(!_vm.lv2 || _vm.item.parentClickable)?_c('router-link',{class:{ active: _vm.active == _vm.index },attrs:{"to":{ name: _vm.item.path }},on:{"click":function($event){return _vm.toggleSubmenu(_vm.item.parentClickable)}}},[_vm._v(_vm._s(_vm.item.name))]):_vm._e(),_vm._v(" "),(_vm.lv2 && !_vm.item.parentClickable)?_c('span',{class:{ active: _vm.active == _vm.index, open: _vm.submenu },on:{"click":function($event){return _vm.toggleSubmenu(true)}}},[_vm._v(_vm._s(_vm.item.name))]):_vm._e(),_vm._v(" "),(_vm.lv2 && _vm.submenu)?_c('ul',_vm._l((_vm.lv2),function(item,index){return _c('li',{key:index,staticClass:"section-menu-item section-menu-item--lv2"},[(!item.external)?_c('router-link',{attrs:{"to":{ name: item.path }}},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.external)?_c('a',{attrs:{"target":"_blank","href":item.path}},[_vm._v(_vm._s(item.name))]):_vm._e()],1)}),0):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.hasPacket && !_vm.noPacket)?_c('div',{staticClass:"item-disabled"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pc0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsStats_vue__ = __webpack_require__("VaUM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037e511c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsStats_vue__ = __webpack_require__("Kmko");
function injectStyle (ssrContext) {
  __webpack_require__("c+CG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037e511c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PgJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'dashboard',"title":'Dashboard'}}),_vm._v(" "),_c('info-modal'),_vm._v(" "),(!_vm.mobileMenu)?_c('dashboard-first-time-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pgnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['ranking', 'selected', 'setRanking'],
    methods: {
        getCoinPath: function getCoinPath(code) {
            return 'static/img/coins/' + code + '.png';
        }
    }
});

/***/ }),

/***/ "PuPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    props: ['ranking', 'selected'],
    data: function data() {
        return {
            date: '',
            loader: false,
            items: 25
        };
    },

    computed: {
        list: function list() {
            return this.$store.getters.ranking;
        },
        currentPage: function currentPage() {
            return this.$store.getters.rankingSettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.rankingSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.rankingSettings.numberOfPages;
        }
    },
    methods: {
        /**
         * Get data
         */
        getData: function getData() {
            var _this = this;

            this.loader = true;

            this.$store.commit('rankingSetCareerLevel', this.selected);

            this.$store.dispatch('loadRanking').then(function () {
                _this.loader = false;
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this2 = this;

            this.items = items;
            this.$store.dispatch('rankingSetItems', items).then(function () {
                _this2.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this3 = this;

            this.$store.dispatch('rankingSetPage', page).then(function () {
                _this3.getData();
            });
        },


        /**
         * Get row number
         */
        rowNumber: function rowNumber(index) {
            return (this.currentPage - 1) * this.maxPerPage + index + 1;
        }
    },
    beforeMount: function beforeMount() {
        this.getData();
    },

    watch: {
        selected: function selected() {
            this.setPage(1);
        }
    }
});

/***/ }),

/***/ "QA3Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamTotal_vue__ = __webpack_require__("nylp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129912ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamTotal_vue__ = __webpack_require__("fyYQ");
function injectStyle (ssrContext) {
  __webpack_require__("pfAh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTeamTotal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129912ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTeamTotal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QP14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"error-500-content-component"},[_c('b-col',{attrs:{"lg":"12"}},[_c('h1',{staticClass:"error-title"},[_vm._v("Internal server error")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QRUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"layout-header-component",attrs:{"fluid":"","id":"layout_header_component"}},[_c('middlebar'),_vm._v(" "),(!_vm.menuOpen)?_c('bottombar'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QWlQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderOptions_vue__ = __webpack_require__("03uI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8caf78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderOptions_vue__ = __webpack_require__("R4Tz");
function injectStyle (ssrContext) {
  __webpack_require__("ywea")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8caf78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QZCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            openList: false,
            hoverList: false,
            filterValue: 'NOT_CONFIGURED',
            selectedValue: '--',
            types: {
                NOT_CONFIGURED: '--',
                mining: 'From mining',
                royal_bonus: 'From Royal position'
            }
        };
    },

    methods: {
        setItem: function setItem(filterValue, label) {
            this.selectedValue = label;
            this.filterValue = filterValue;
        }
    },
    watch: {
        filterValue: function filterValue() {
            var _this = this;

            if (this.filterValue !== 'NOT_CONFIGURED') {
                this.$store.dispatch('transferHistorySetFilter', this.filterValue).then(function () {
                    _this.$store.dispatch('loadTransferHistory', {
                        params: _this.$store.getters.transferHistorySettings
                    });
                });
            } else {
                this.$store.commit('transferHistoryClearFilter');
            }
        }
    },
    beforeMount: function beforeMount() {
        var filter = this.$store.getters.transferHistorySettings.filter.filter(function (obj) {
            return obj.value === 'type';
        });

        if (filter.length > 0) {
            this.filterValue = filter[0].value;
            this.selectedValue = this.types[filter[0].value];
        } else {
            this.filterValue = 'NOT_CONFIGURED';
            this.selectedValue = this.types['NOT_CONFIGURED'];
        }
    }
});

/***/ }),

/***/ "Qk7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gender_vue__ = __webpack_require__("BXpv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e78e760_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gender_vue__ = __webpack_require__("kmNx");
function injectStyle (ssrContext) {
  __webpack_require__("7D7A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e78e760"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gender_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e78e760_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gender_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QkmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'payout',"title":'Payout'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('payout-history-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QmFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autologout_component_vue__ = __webpack_require__("RvBU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf83661_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autologout_component_vue__ = __webpack_require__("vOJp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autologout_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf83661_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autologout_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QzwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('description') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_description"}},[_vm._v("\n            Description\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_description","name":"description","type":"text","data-vv-rules":"required|max:255","data-vv-as":"description","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('description') && _vm.showErrors),expression:"errors.has('description') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('description')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R1xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    data: function data() {
        return {
            amount: 0,
            progress: false,
            showErrors: false
        };
    },

    computed: {
        available: function available() {
            return this.money.format(this.$store.getters.ftoAccounts.miningAccount, 'fto');
        },
        confirm: function confirm() {
            return this.$store.getters.modals.withdrawCoins.accept;
        },
        type: function type() {
            return this.$store.getters.modals.withdrawCoins.type;
        }
    },
    methods: {
        withdrawAll: function withdrawAll() {
            this.amount = this.available;
        },
        validate: function validate(e) {
            var _this = this;

            if (!this.progress) {
                this.showErrors = false;
                this.$validator.validateAll().then(function () {
                    if (!_this.errors.any() && Number(_this.available) > 0 && Number(_this.amount) <= Number(_this.available)) {
                        _this.$store.commit('modals', {
                            modal: 'withdrawCoins',
                            data: {
                                visible: true,
                                coins: _this.amount,
                                type: 'mining',
                                accept: false
                            }
                        });
                    } else {
                        _this.showErrors = true;
                    }
                });
            }
        }
    }
});

/***/ }),

/***/ "R4Tz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-options-component",attrs:{"id":"header_options_component"}},[_c('div',{staticClass:"header-options-inner"},[_c('ul',{staticClass:"header-options-list"},[_c('li',[_c('header-options-signout')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R94H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageModal_vue__ = __webpack_require__("poai");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf51687_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageModal_vue__ = __webpack_require__("WMJB");
function injectStyle (ssrContext) {
  __webpack_require__("cXYZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cf51687"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf51687_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RCno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);





var Money = function () {
    function Money() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Money);

        this.decimals = {
            fto: 8,
            fnd: 2
        };
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Money, [{
        key: 'isInteger',
        value: function isInteger(amount) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(amount) || !isNaN(parseInt(amount));
        }

        /**
         * Format money
         * @param amount
         * @param currency
         * @returns {string}
         */

    }, {
        key: 'format',
        value: function format(amount, currency) {
            return this.isInteger(amount) ? (parseInt(amount) / Math.pow(10, this.decimals[currency])).toFixed(this.decimals[currency]) : '-';
        }

        /**
         * Format money
         * @param amount
         * @param currency
         * @returns {*}
         */

    }, {
        key: 'unformat',
        value: function unformat(amount, currency) {
            return !isNaN(amount) ? parseInt(parseFloat(amount) * Math.pow(10, this.decimals[currency])) : '-';
        }

        /**
         * Typical values are passed as a cents equivalent but packages are defined as a dollars
         * Convert dollars to cents then parse
         * @param packet
         * @param currency
         */

    }, {
        key: 'packageFormat',
        value: function packageFormat(packet, currency) {
            return this.format(packet * 100, currency);
        }
    }]);

    return Money;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('money', Money);

/***/ }),

/***/ "REuH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RRqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsTurnoverTooSmall_vue__ = __webpack_require__("Dx+i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460331e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsTurnoverTooSmall_vue__ = __webpack_require__("Gdt5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsTurnoverTooSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460331e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsTurnoverTooSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rfz/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RjHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopQualifiedContent_vue__ = __webpack_require__("SI3A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01783d80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopQualifiedContent_vue__ = __webpack_require__("ZVS3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopQualifiedContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01783d80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopQualifiedContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RoPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"error-404-list-component"},[_c('b-col',{attrs:{"lg":"6","offset-lg":"6","cols":"12"}},[_c('ul',{staticClass:"menu-list"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}})],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}})],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}})],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}})],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}})],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("Dashboard")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("Send")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("Receive")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("History")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":""}},[_vm._v("Addresse")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RvBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            sessionCounter: ''
        };
    },
    beforeCreate: function beforeCreate() {
        var _this = this;
        _this.$cookie.set('FTN_SESSION_TIME', 0);

        if (_this.$cookie.get('FTN_SESSION_START')) {
            var auth = _this.$store.getters.checkAuth;

            if (auth) {
                var then = _this.$cookie.get('FTN_SESSION_START'),
                    now = __WEBPACK_IMPORTED_MODULE_0_moment___default()().unix(),
                    diff = now - then;

                // If difference between dates is greater than 900 sec (15 min)
                if (diff > 900) {
                    _this.$cookie.delete('FTN_SESSION_START');
                    _this.$router.push('/logout');
                } else {
                    // Update time of session
                    var sessionTime = parseInt(_this.$cookie.get('FTN_SESSION_TIME')) + diff * 1000;
                    _this.$cookie.set('FTN_SESSION_TIME', sessionTime);
                }
            } else {
                _this.$cookie.delete('FTN_SESSION_START');
            }
        } else {
            _this.$cookie.set('FTN_SESSION_START', __WEBPACK_IMPORTED_MODULE_0_moment___default()().unix());
        }

        _this.sessionCounter = setInterval(function () {
            var auth = _this.$store.getters.checkAuth;

            if (auth) {
                var time = parseInt(_this.$cookie.get('FTN_SESSION_TIME')) + 1000;

                _this.$cookie.set('FTN_SESSION_TIME', time);

                if (time >= 900000) {
                    _this.$store.commit('logoutUser');
                    window.location.reload();
                }
            }
        }, 1000);
    }
});

/***/ }),

/***/ "Ry6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    monthlyStatement: []
};

var getters = {
    monthlyStatement: function monthlyStatement(state) {
        return state.monthlyStatement;
    }
};

var mutations = {
    setMonthlyStatement: function setMonthlyStatement(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'monthlyStatement', data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "S+rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commissions-table-component",attrs:{"id":"commissions_table_component"}},[_c('b-row',{staticStyle:{"margin-bottom":"24px"}},[_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('router-link',{staticClass:"button--primary",attrs:{"to":{name: 'MonthlyStatement'}}},[_vm._v("Monthly Statement")])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-bottom":"24px"}},[_c('b-col',{attrs:{"lg":"3","cols":"12"}},[_c('p',[_vm._v("Search by user")]),_vm._v(" "),_c('dropdown-component',{attrs:{"autocomplete":true,"searchUrl":_vm.api.user.tree.search,"onElementClick":_vm.setUser}})],1)],1),_vm._v(" "),_c('div',{staticClass:"commissions-table-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_c('thead',[_c('tr',[_c('th',[_c('div',{staticClass:"calendar-icon"},[_c('p',[_vm._v("Date")]),_vm._v(" "),_c('i',{staticClass:"mdi mdi-calendar"}),_vm._v(" "),_c('datepicker',{attrs:{"placeholder":"range","options":{ mode: 'range', maxDate: 'today' }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)]),_vm._v(" "),_c('th',{on:{"click":function($event){return _vm.changeSort('amount')}}},[_c('p',[_vm._v("Income")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Bonus type")]),_vm._v(" "),_c('div',{staticClass:"filter-icon",on:{"click":function($event){return _vm.showFilter()}}},[_c('i',{staticClass:"mdi mdi-chevron-down"})]),_vm._v(" "),(_vm.filter)?_c('bonus-filter',{attrs:{"filters":_vm.filters}}):_vm._e()],1),_vm._v(" "),_c('th',{on:{"click":function($event){return _vm.changeSort('user')}}},[_c('p',[_vm._v("From user")]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.commissions),function(commission,commissionId){return _c('tr',{key:commissionId},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.datetime.utcToLocal(commission.date)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v("FND "+_vm._s(_vm.money.format(commission.amount.amount, 'fnd')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.filters[commission.type_name]))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(commission.from_user))])])])}),0)]),_vm._v(" "),(!_vm.commissions || _vm.commissions.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No results.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-icon"},[_c('i',{staticClass:"mdi mdi-chevron-up"}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-chevron-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-icon"},[_c('i',{staticClass:"mdi mdi-chevron-up"}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-chevron-down"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S/wW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'payout', 'popup'],
    data: function data() {
        return {
            code: '',
            validCode: true,
            showErrors: false,
            progress: false
        };
    },

    computed: {
        security: function security() {
            return this.$store.getters.settings.confirmations.payouts ? this.$store.getters.settings.confirmations.payouts.value : '';
        },
        modal: function modal() {
            return this.$store.getters.modals.payout.visible;
        }
    },
    methods: {
        hideModal: function hideModal() {
            this.code = '';
            this.validCode = true;
            this.showErrors = false;
            this.$store.commit('modals', {
                modal: 'payout',
                data: {
                    visible: false,
                    params: {}
                }
            });
        },
        validate: function validate() {
            var _this = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.submit();
                } else {
                    _this.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;
            this.payout.create(this.$store.getters.modals.payout.params);
            this.payout.setToken(this.code);
            this.payout.submit().then(function () {
                _this2.hideModal();
                _this2.progress = false;
            }, function () {
                _this2.hideModal();
                _this2.progress = false;
            });
        }
    },
    mounted: function mounted() {
        this.popup.show('In order to improve the process of payments and withdrawals, we established a cooperation with a new service provider. Currently work is underway on the implementation of the system - until then, the use of the bank transfer will only be possible in GBP currency. We encourage our users to use alternative methods. We apologize for the inconvenience.', 'I understand', false);
    }
});

/***/ }),

/***/ "S1AJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinsFromMining_vue__ = __webpack_require__("OL71");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe3fee1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinsFromMining_vue__ = __webpack_require__("gyX6");
function injectStyle (ssrContext) {
  __webpack_require__("ZHwb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinsFromMining_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe3fee1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinsFromMining_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S1TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"coming-soon-component",attrs:{"id":"coming_soon_component"}},[_c('b-col',{staticClass:"text-center",attrs:{"lg":"12","cols":"12"}},[_c('h1',{staticClass:"coming-soon-component--header"},[_vm._v("Coming soon...")]),_vm._v(" "),_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'Dashboard' }}},[_vm._v("Go to dashboard")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SD81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsUpdate_vue__ = __webpack_require__("iIA/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc94fbee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsUpdate_vue__ = __webpack_require__("Kyvz");
function injectStyle (ssrContext) {
  __webpack_require__("/TF9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc94fbee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc94fbee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SI3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__top_qualified_RankingTable__ = __webpack_require__("YcyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__top_qualified_TabsDesktop__ = __webpack_require__("so6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__top_qualified_TabsMobile__ = __webpack_require__("nzSH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__["a" /* default */], RankingTable: __WEBPACK_IMPORTED_MODULE_1__top_qualified_RankingTable__["a" /* default */], TabsDesktop: __WEBPACK_IMPORTED_MODULE_2__top_qualified_TabsDesktop__["a" /* default */], TabsMobile: __WEBPACK_IMPORTED_MODULE_3__top_qualified_TabsMobile__["a" /* default */] },
    data: function data() {
        return {
            ranking: {
                vip: {
                    code: 'vip',
                    name: 'VIP'
                },
                diamond_2: {
                    code: 'diamond_2',
                    name: '2** DIAMOND'
                },
                diamond_1: {
                    code: 'diamond_1',
                    name: '1* DIAMOND'
                },
                diamond: {
                    code: 'diamond',
                    name: 'DIAMOND'
                },
                gold: {
                    code: 'gold',
                    name: 'GOLD'
                },
                silver: {
                    code: 'silver',
                    name: 'SILVER'
                },
                bronze: {
                    code: 'bronze',
                    name: 'BRONZE'
                }
            },
            selected: 'vip'
        };
    },

    methods: {
        setRanking: function setRanking(rankingCode) {
            if (this.ranking[rankingCode]) {
                this.selected = this.ranking[rankingCode].code;
            }
        }
    }
});

/***/ }),

/***/ "SM57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7f68fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingSoon_vue__ = __webpack_require__("S1TP");
function injectStyle (ssrContext) {
  __webpack_require__("BkPh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e7f68fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7f68fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingSoon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SPsr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page__outer"},[_c('div',{staticClass:"home-page__element"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"12"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("APq4"),"alt":"FuturoNetwork"}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"home-page__element"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"12"}},[_c('h1',{staticClass:"title"},[_vm._v("\n                    Welcome to FuturoNetwork "),_c('br',{staticClass:"desktop-only"}),_vm._v("online business\n                ")])])],1),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',{staticClass:"register-form"},[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"form-item form-input",class:{ 'form-item--error': (_vm.errors.has('username') && _vm.showErrors) || _vm.invalidData }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","placeholder":"login","name":"username","id":"field_username","data-vv-rules":"required","readonly":_vm.view == 1},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('username') && _vm.showErrors),expression:"errors.has('username') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('username')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-input",class:{ 'form-item--error': (_vm.errors.has('username') && _vm.showErrors) || _vm.invalidData }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"password","placeholder":"password","name":"password","id":"field_password","data-vv-rules":"required","readonly":_vm.view == 1},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password') && _vm.showErrors),expression:"errors.has('password') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.invalidData),expression:"invalidData"}],staticClass:"form-item--error--description form-item--error--description--white",staticStyle:{"color":"red"}},[_vm._v("Invalid data.")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.invalidCaptcha),expression:"invalidCaptcha"}],staticClass:"form-item--error--description form-item--error--description--white",staticStyle:{"color":"red"}},[_vm._v("Captcha field is required.")]),_vm._v(" "),_c('vue-recaptcha',{staticClass:"g-recaptcha",attrs:{"sitekey":_vm.recaptcha.sitekey},on:{"verify":_vm.onVerify,"render":_vm.onRender}}),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"button--primary login",class:{ 'button--progress': _vm.progress },style:({'width': '100%'}),attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Login")])]),_vm._v(" "),_c('p',{staticClass:"form-link",on:{"click":function($event){return _vm.changeView(3)}}},[_vm._v("Forgot your password?")]),_vm._v(" "),_c('div',{staticClass:"to-register"},[_vm._v("\n                        Don't you have an account?"),_c('br'),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.goToRegister()}}},[_vm._v("Register now!")])])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"home-page__element"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SUDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('info-modal'),_vm._v(" "),_c('main-menu',{attrs:{"active":'dashboard',"title":'Dashboard'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('dashboard-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SW55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_Checkbox_vue__ = __webpack_require__("8o3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_Textfield_vue__ = __webpack_require__("VURo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['account', 'api', 'recaptcha', 'terms'],
    components: { Checkbox: __WEBPACK_IMPORTED_MODULE_0__fields_Checkbox_vue__["a" /* default */], Textfield: __WEBPACK_IMPORTED_MODULE_1__fields_Textfield_vue__["a" /* default */], VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */] },
    data: function data() {
        return {
            canRegister: 'IN_PROGRESS',
            userData: {},
            progress: false,
            showErrors: false
        };
    },

    computed: {
        termsList: function termsList() {
            return this.$store.getters.terms;
        }
    },
    methods: {
        onVerify: function onVerify(response) {
            this.recaptcha.SetRecaptchaResponse(response);
            this.userData['g-recaptcha-response'] = response;
        },
        onRender: function onRender(recaptchaId) {
            this.recaptchaId = recaptchaId;
        },
        changeView: function changeView(view) {
            var _this = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this.$store.commit('loginFormView', view);
            }, 600);
        },
        goToLogin: function goToLogin() {
            var _this2 = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this2.$router.push({ name: 'Login' });
            }, 600);
        },
        updateValue: function updateValue(field, value) {
            this.userData[field] = value;
        },
        validate: function validate() {
            var _this3 = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this3.errors.any()) {
                    _this3.submit();
                } else {
                    _this3.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this4 = this;

            this.progress = true;
            this.account.save(this.userData).then(function () {
                _this4.progress = false;
                _this4.goToLogin();
            }, function () {
                _this4.progress = false;
                delete _this4.userData['g-recaptcha-response'];
                _this4.$children.find(function (component) {
                    return component.$widgetId === _this4.recaptchaId;
                }).reset();
            });
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store.commit('loginFormView', 2);
    },
    beforeMount: function beforeMount() {
        var _this5 = this;

        var location = this.$store.getters.location;

        if (location && location !== 'Poland') {
            this.userData = {
                login: '',
                first_name: '',
                last_name: '',
                email: '',
                email_confirmation: '',
                password: '',
                password_confirmation: '',
                gender: '',
                company_name: '',
                company_registration_number: '',
                sponsor: this.$route.params.sponsor ? this.$route.params.sponsor : 'futurenet'
            };

            this.terms.fetchData().then(function () {
                var terms = _this5.termsList;

                for (var term in terms) {
                    _this5.$set(_this5.userData, terms[term].key, false);
                }
            });

            this.canRegister = 'CAN_REGISTER';
        } else {
            this.canRegister = 'CAN_NOT_REGISTER';
        }
    },
    mounted: function mounted() {
        this.changeView(4);
    }
});

/***/ }),

/***/ "SYsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stp_vue__ = __webpack_require__("Yf+4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b57279_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stp_vue__ = __webpack_require__("nvDE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b57279_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Scyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['label', 'value']
});

/***/ }),

/***/ "Sd5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('business-qualifications-header'),_vm._v(" "),_c('business-qualifications-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Snw+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['label', 'value']
});

/***/ }),

/***/ "SrMI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SvCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualifications_vue__ = __webpack_require__("oRg7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0a6f2b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualifications_vue__ = __webpack_require__("zxUE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0a6f2b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sz5e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T/pq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T0B/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2l1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorLogo_vue__ = __webpack_require__("FlRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__404_Error404Content_vue__ = __webpack_require__("Ftvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__404_Error404Links_vue__ = __webpack_require__("rDhj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ErrorLogo: __WEBPACK_IMPORTED_MODULE_0__ErrorLogo_vue__["a" /* default */], Error404Content: __WEBPACK_IMPORTED_MODULE_1__404_Error404Content_vue__["a" /* default */], Error404Links: __WEBPACK_IMPORTED_MODULE_2__404_Error404Links_vue__["a" /* default */] },
    beforeCreate: function beforeCreate() {
        this.$store.commit('setError', {
            status: true,
            code: 404,
            redirect: false
        });
    },
    beforeMount: function beforeMount() {
        this.$store.commit('loginFormView', 2);
    }
});

/***/ }),

/***/ "T3HA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('monthly-statement-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TAYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicesContent_vue__ = __webpack_require__("99wC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f468ce44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesContent_vue__ = __webpack_require__("E/nY");
function injectStyle (ssrContext) {
  __webpack_require__("r60O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f468ce44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicesContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f468ce44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TAjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'sponsorSystem',"title":'Sponsor System'}}),_vm._v(" "),_c('sponsor-system-content')],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TF+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-component",attrs:{"id":"modal_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.hideModal()}}}),_vm._v(" "),_c('div',{staticClass:"modal-inner"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[(_vm.confirmationType === 'GOOGLE_AUTHENTICATOR')?_c('div',[_c('p',{staticClass:"p1"},[_vm._v("Put here code from google authenticator:")])]):_vm._e(),_vm._v(" "),(_vm.confirmationType === 'EMAIL')?_c('div',[_c('p',{staticClass:"p1"},[_vm._v("Check your email address.")]),_vm._v(" "),_c('p',{staticClass:"p1"},[_vm._v("Put here code from message:")])]):_vm._e(),_vm._v(" "),(_vm.confirmationType === 'NOT_CONFIGURED')?_c('div',[_c('p',{staticClass:"p1",staticStyle:{"margin-bottom":"24px"}},[_vm._v(_vm._s(_vm.message))])]):_vm._e(),_vm._v(" "),(_vm.confirmationType === 'GOOGLE_AUTHENTICATOR' || _vm.confirmationType === 'EMAIL')?_c('div',{staticClass:"modal-form-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","name":"code","data-vv-rules":"required"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code') && _vm.showErrors),expression:"errors.has('code') && showErrors"}],staticClass:"field-error--description"},[_vm._v("This field is required.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"button--cancel",on:{"click":function($event){_vm.progress ? '' : _vm.hideModal()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"button--action button--confirm",class:{ 'button--progress': _vm.progress }},[_vm._v("\n                                    Save")])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "THyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);





__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');
var status = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('status');

var state = {
    lastLogin: null,
    mobileMenu: false,
    otp: 0,
    verificationFiles: [],
    settings: {},
    temporarySettings: false
};

var getters = {

    mobileMenu: function mobileMenu(state) {
        return state.mobileMenu;
    },

    otp: function otp(state) {
        return state.otp;
    },

    verificationFiles: function verificationFiles(state) {
        return state.verificationFiles;
    },

    /**
     * Get user's settings
     * @param state
     * @returns {state.settings|{confirmations, notifications}}
     */
    settings: function settings(state) {
        return state.settings;
    },

    /**
     * Get user's temporary settings
     * @param state
     * @returns {state.temporarySettings|{confirmations, notifications}}
     */
    temporarySettings: function temporarySettings(state) {
        return state.temporarySettings;
    }
};

var mutations = {
    /**
     * Set settings in store
     * @param state
     * @param response
     */
    setSettings: function setSettings(state, response) {
        var data = response.data.settings,
            settingsData = {
            confirmations: {
                twoStepLogin: data.filter(function (obj) {
                    return obj.name === 'TWO_STEP_LOGIN_VERIFICATION';
                })[0],
                payouts: data.filter(function (obj) {
                    return obj.name === 'TWO_STEP_PAYOUT_VERIFICATION';
                })[0]
            }
        };
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'settings', settingsData);
    },


    /**
     * Set new setting - temporary settings before save
     */
    setTemporarySetting: function setTemporarySetting(state, params) {
        if (!state.temporarySettings) {
            state.temporarySettings = {};
        }
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.temporarySettings, params.id, params);
    },


    /**
     * Reset temporary settings list
     * @param state
     */
    resetTemporarySettings: function resetTemporarySettings(state) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'temporarySetting', false);
    },


    /**
     * Set security config in store
     * @param state
     * @param data
     */
    setOtp: function setOtp(state, data) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'otp', data);
    },


    /**
     * Set verification images in store
     * @param state
     * @param data
     */
    setVerificationFiles: function setVerificationFiles(state, data) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'verificationFiles', data);
    },


    /**
     * Toggle mobile menu
     * @param state
     */
    toggleMobileMenu: function toggleMobileMenu(state) {
        var toggle = !this.getters.mobileMenu;
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'mobileMenu', toggle);
    },


    /**
     * Off mobile menu
     * @param state
     */
    offMobileMenu: function offMobileMenu(state) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'mobileMenu', false);
    }
};

var actions = {
    loadLoginHistory: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.history(1, 8)).then(function (response) {
                                commit('setLoginHistory', response.data.data.results);
                            }, function (error) {
                                status['status' + error.status]();
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadLoginHistory(_x) {
            return _ref2.apply(this, arguments);
        }

        return loadLoginHistory;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "TOiN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TgYI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tgd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-outer"},[_c('h3',[_vm._v("FutureNet Products Packs")]),_vm._v(" "),_c('h3',[_vm._v("Total amount to FutureNet: "+_vm._s(_vm.amount))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TsIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payout_vue__ = __webpack_require__("IT6p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1975f7b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payout_vue__ = __webpack_require__("KY3A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1975f7b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TwYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_FNProductPacksContent_vue__ = __webpack_require__("FUxq");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], PacksContent: __WEBPACK_IMPORTED_MODULE_1__content_FNProductPacksContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "U/Yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U0YE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2Rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verification_EditData_vue__ = __webpack_require__("EaRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verification_UploadFiles_vue__ = __webpack_require__("vRgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__verification_UploadedFiles_vue__ = __webpack_require__("yx7B");
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { EditData: __WEBPACK_IMPORTED_MODULE_0__verification_EditData_vue__["a" /* default */], UploadFiles: __WEBPACK_IMPORTED_MODULE_1__verification_UploadFiles_vue__["a" /* default */], UploadedFiles: __WEBPACK_IMPORTED_MODULE_2__verification_UploadedFiles_vue__["a" /* default */] },
    computed: {
        checkUserData: function checkUserData() {
            var filled = true;
            for (var index in this.userData) {
                if (this.userData[index] == '' || !this.userData[index]) {
                    filled = false;
                    break;
                }
                if (!filled) break;
            }
            return filled;
        },
        isVerified: function isVerified() {
            var verified = this.$store.getters.user.isVerified,
                inProgress = this.$store.getters.verificationFiles.filter(function (obj) {
                return obj.status === 'accepted' || obj.status === 'new';
            });

            return verified || inProgress.length > 0;
        },
        userData: function userData() {
            return {
                email: this.$store.getters.user.email,
                firstname: this.$store.getters.user.firstName,
                lastname: this.$store.getters.user.lastName,
                street: this.$store.getters.user.street,
                city: this.$store.getters.user.city,
                zip: this.$store.getters.user.postalCode,
                birthdate: this.$store.getters.user.birthDate,
                phone: this.$store.getters.user.phoneNumber
            };
        }
    }
});

/***/ }),

/***/ "UTr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'',"title":'Profile'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('profile-edit-data-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UdFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('account_number') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":'payout_' + 'account_number'}},[_vm._v("\n            "+_vm._s(_vm.methodName)+" account number\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":'payout_' + 'account_number',"name":'account_number',"type":"text","data-vv-rules":"required|max:255","data-vv-as":_vm.methodName + ' account number',"disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('account_number') && _vm.showErrors),expression:"errors.has('account_number') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('account_number')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uf2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['addClass', 'checked', 'label', 'message', 'name', 'progress', 'rules', 'showErrors', 'updateValue'],
    data: function data() {
        return {
            value: false
        };
    },

    methods: {
        setValue: function setValue() {
            this.value = !(this.checked || this.value);
            this.updateValue(this.name, this.value);
        }
    },
    watch: {
        value: function value() {
            this.updateValue(this.name, this.value);
        }
    }
});

/***/ }),

/***/ "Ur2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'business',"title":'Vouchers'}}),_vm._v(" "),_c('codes-content')],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uur/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsHeader_vue__ = __webpack_require__("5a7z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f2288d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsHeader_vue__ = __webpack_require__("F9hf");
function injectStyle (ssrContext) {
  __webpack_require__("t6+I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f2288d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UzRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_advcash_component"}},[_c('p',[_vm._v("AdvCash")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('advcash-login',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V8a5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatementContent_vue__ = __webpack_require__("tNZw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef932be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatementContent_vue__ = __webpack_require__("T3HA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatementContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef932be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatementContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VECj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('div',{staticClass:"modal-component",attrs:{"id":"modal_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){_vm.progress ? '' : _vm.hideModal()}}}),_vm._v(" "),_c('div',{staticClass:"modal-inner"},[_c('form',[_c('b-row',[_c('b-col',{attrs:{"lg":"12","cols":"12"}},[_c('p',{staticClass:"p2 text-left"},[_vm._v("Are you sure you want to buy this package?"),_c('br'),_vm._v("Pay with:")])])],1),_vm._v(" "),(_vm.select)?_c('b-row',[_c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-select",class:{ 'field-error': _vm.errors.has('country') }},[_c('div',{staticClass:"select-outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"text","readonly":true},domProps:{"value":(_vm.selected)},on:{"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList),expression:"openList"}],staticStyle:{"text-align":"left"}},_vm._l((_vm.packets),function(single){return (single >= _vm.select)?_c('li',{class:{ 'active': '$' + single === _vm.selected },on:{"click":function($event){_vm.setItem(single), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v("FND "+_vm._s(single))]):_vm._e()}),0)])])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12","cols":"12"}},[_c('div',{staticClass:"form-item form-item-radio"},[_c('label',{staticClass:"form-label text-left",attrs:{"for":"transfer_money"}},[_vm._v("\n                                            Transfer money or use money from FutureAdPro account\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],attrs:{"id":"transfer_money","name":"payment_method","data-vv-rules":"required","data-vv-as":"payment method","type":"radio","value":"transferMoney"},domProps:{"checked":_vm._q(_vm.paymentType,"transferMoney")},on:{"click":function($event){return _vm.hideErrors()},"change":function($event){_vm.paymentType="transferMoney"}}}),_vm._v(" "),_c('div',{staticClass:"check"})])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12","cols":"12"}},[_c('div',{staticClass:"form-item form-item-radio"},[_c('label',{staticClass:"form-label text-left",attrs:{"for":"futuro_account"}},[_vm._v("\n                                            FuturoNetwork account\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],attrs:{"id":"futuro_account","name":"payment_method","data-vv-rules":"required","data-vv-as":"payment method","type":"radio","value":"futurenetAccount"},domProps:{"checked":_vm._q(_vm.paymentType,"futurenetAccount")},on:{"click":function($event){return _vm.hideErrors()},"change":function($event){_vm.paymentType="futurenetAccount"}}}),_vm._v(" "),_c('div',{staticClass:"check"})])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12","cols":"12"}},[_c('div',{staticClass:"form-item form-item-radio"},[_c('label',{staticClass:"form-label text-left",attrs:{"for":"code"}},[_vm._v("\n                                            FuturoNetwork voucher\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],attrs:{"id":"code","name":"payment_method","data-vv-rules":"required","data-vv-as":"payment method","type":"radio","value":"code"},domProps:{"checked":_vm._q(_vm.paymentType,"code")},on:{"click":function($event){return _vm.hideErrors()},"change":function($event){_vm.paymentType="code"}}}),_vm._v(" "),_c('div',{staticClass:"check"})])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"1","cols":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","cols":"6"}},[(_vm.paymentType === 'code')?_c('div',{staticClass:"modal-form-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","name":"code","data-vv-rules":"required"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})]):_vm._e()])],1),_vm._v(" "),_c('b-row',{staticStyle:{"display":"none"}},[_c('b-col',{attrs:{"lg":"12","cols":"12"}},[_c('div',{staticClass:"form-item form-item-radio"},[_c('label',{staticClass:"form-label text-left",attrs:{"for":"futuro_account"}},[_vm._v("\n                                            Bitcoin\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],attrs:{"id":"bitcoin","name":"payment_method","data-vv-rules":"required","data-vv-as":"payment method","type":"radio","value":"bitcoin"},domProps:{"checked":_vm._q(_vm.paymentType,"bitcoin")},on:{"click":function($event){return _vm.hideErrors()},"change":function($event){_vm.paymentType="bitcoin"}}}),_vm._v(" "),_c('div',{staticClass:"check"})])])],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.codeNotFound),expression:"codeNotFound"}],staticClass:"field-error--description"},[_vm._v("Incorrect code")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.notEnoughMoney),expression:"notEnoughMoney"}],staticClass:"field-error--description"},[_vm._v("Not enough money to buy a package")]),_vm._v(" "),(_vm.paymentType === 'futurenetAccount')?_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('p',{staticClass:"p1 text-right"},[_vm._v("FuturoNetwork account balance:"),_c('br'),_vm._v("FND "+_vm._s(_vm.available))])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-actions text-right"},[_c('a',{staticClass:"button--cancel",on:{"click":function($event){_vm.progress ? '' : _vm.hideModal()}}},[_vm._v("cancel")]),_vm._v(" "),_c('a',{staticClass:"button--primary",class:{ 'disabled' : _vm.progress || !_vm.paymentType || (_vm.paymentType === 'code' && !_vm.code) || _vm.notEnoughMoney },on:{"click":function($event){_vm.progress ? '' : _vm.confirm(_vm.paymentType)}}},[_vm._v("Pay")])])],1),_vm._v(" "),(_vm.progress)?_c('div',{staticClass:"data-loader__modal"}):_vm._e()])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VEGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Street_vue__ = __webpack_require__("wiZE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d2158e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Street_vue__ = __webpack_require__("YqjQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Street_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d2158e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Street_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VURo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Textfield_vue__ = __webpack_require__("P4mI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac0e63f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textfield_vue__ = __webpack_require__("5iRO");
function injectStyle (ssrContext) {
  __webpack_require__("uDti")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ac0e63f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Textfield_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac0e63f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Textfield_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VaUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commissions_stats_StatsItem_vue__ = __webpack_require__("lV2G");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    components: { StatsItem: __WEBPACK_IMPORTED_MODULE_0__commissions_stats_StatsItem_vue__["a" /* default */] },
    computed: {
        businessBonusAmount: function businessBonusAmount() {
            return this.$store.getters.totalIncomes.business_bonus_income.amount;
        },
        carBonusAmount: function carBonusAmount() {
            return this.$store.getters.totalIncomes.car_bonus_income.amount;
        },
        directBonusCareerLevelAmount: function directBonusCareerLevelAmount() {
            return this.$store.getters.totalIncomes.direct_bonus_career_level_income.amount;
        },
        directBonusPositionAmount: function directBonusPositionAmount() {
            return this.$store.getters.totalIncomes.direct_bonus_position_income.amount;
        },
        matchingBonusAmount: function matchingBonusAmount() {
            return this.$store.getters.totalIncomes.matching_bonus_income.amount;
        },
        unilevelBonusCareerLevelAmount: function unilevelBonusCareerLevelAmount() {
            return this.$store.getters.totalIncomes.unilevel_bonus_career_level_income.amount;
        },
        unilevelBonusPositionAmount: function unilevelBonusPositionAmount() {
            return this.$store.getters.totalIncomes.unilevel_bonus_position_income.amount;
        },
        stats: function stats() {
            return {
                1: {
                    label: 'Income from<br>Direct Bonus:',
                    value: 'FND ' + this.money.format(this.directBonusPositionAmount, 'fnd')
                },
                2: {
                    label: 'Income from<br>Unilevel Bonus:',
                    value: 'FND ' + this.money.format(this.unilevelBonusPositionAmount, 'fnd')
                },
                3: {
                    label: 'Income from<br>Career Sponsor Bonus:',
                    value: 'FND ' + this.money.format(this.directBonusCareerLevelAmount, 'fnd')
                },
                4: {
                    label: 'Income from<br>Career Unilevel Bonus:',
                    value: 'FND ' + this.money.format(this.unilevelBonusCareerLevelAmount, 'fnd')
                },
                5: {
                    label: 'Income from<br>Matching Bonus:',
                    value: 'FND ' + this.money.format(this.matchingBonusAmount, 'fnd')
                },
                6: {
                    label: 'Income from<br>Car Bonus:',
                    value: 'FND ' + this.money.format(this.carBonusAmount, 'fnd')
                },
                7: {
                    label: 'Income from<br>Business Bonus:',
                    value: 'FND ' + this.money.format(this.businessBonusAmount, 'fnd')
                }
            };
        }
    }
});

/***/ }),

/***/ "VdUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("My account balance: ")]),_vm._v(" "),_c('p',{staticClass:"my_money"},[_vm._v("FND "+_vm._s(_vm.money.format(_vm.accountBalance, 'fnd')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('payout-history-table')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vg51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a);

var Datetime = function () {
    function Datetime() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Datetime);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Datetime, [{
        key: 'localToUtc',

        /**
         * Convert date (string) from local to UTC
         * @param datetime
         * @returns {string}
         */
        value: function localToUtc(datetime) {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(__WEBPACK_IMPORTED_MODULE_4_moment___default()(datetime)).format('YYYY-MM-DD');
        }

        /**
         * Convert date (string) from UTC to local
         * @param datetime
         * @returns {string}
         */

    }, {
        key: 'utcToLocal',
        value: function utcToLocal(datetime) {
            return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(datetime).local().format('YYYY-MM-DD');
        }
    }]);

    return Datetime;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('datetime', Datetime);

/***/ }),

/***/ "Voz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    packages: [],
    generatingQueue: []
};

var getters = {
    packages: function packages(state) {
        return state.packages;
    },
    getGeneratingQueue: function getGeneratingQueue(state) {
        return state.generatingQueue;
    }
};

var mutations = {
    setPackagesList: function setPackagesList(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'packages', data);
    },
    addPackageToQueue: function addPackageToQueue(state, data) {
        state.generatingQueue.push(data);
    },
    removePackageFromQueue: function removePackageFromQueue(state, data) {
        var i = state.generatingQueue.indexOf(data);
        if (i !== -1) {
            state.generatingQueue.splice(i, 1);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "Vsm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"user-data tr",attrs:{"cols":"12","lg":"6","id":"user_data"}},[_c('div',{staticClass:"data-outer"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6","lg":"5"}},[_c('div',{staticClass:"form-label"},[_vm._v("\n                    User name\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","lg":"7"}},[_c('div',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.username))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6","lg":"5"}},[_c('div',{staticClass:"form-label"},[_vm._v("\n                    Email\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","lg":"7"}},[_c('div',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.email))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6","lg":"5"}},[_c('div',{staticClass:"form-label"},[_vm._v("\n                    Address\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","lg":"7"}},[_c('div',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.street)),_c('br'),_vm._v(_vm._s(_vm.zip)+" "+_vm._s(_vm.city))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6","lg":"5"}},[_c('div',{staticClass:"form-label"},[_vm._v("\n                    Phone number\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","lg":"7"}},[_c('div',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.phoneNumber))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6","lg":"5"}},[_c('div',{staticClass:"form-label"},[_vm._v("\n                    Reflink\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","lg":"7"}},[_c('div',{directives:[{name:"clipboard",rawName:"v-clipboard",value:('//' + _vm.reflink),expression:"'//' + reflink"},{name:"tippy",rawName:"v-tippy",value:({ placement : 'top',  arrow: true }),expression:"{ placement : 'top',  arrow: true }"}],staticClass:"form-label reflink",attrs:{"title":'Click to copy your reflink'}},[_vm._v(_vm._s(_vm.reflink))])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"7"}},[_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'ProfileEditData' }},domProps:{"innerHTML":_vm._s(_vm.isVerified ? 'Show data' : 'Edit data')}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VteA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VxMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start-packet-header",attrs:{"id":"start_packet_header"}},[_c('b-row',_vm._l((_vm.informations),function(item,index){return (item.position == 'block-1')?_c('b-col',{key:index,staticClass:"start-packet-header-info",attrs:{"cols":"6","lg":"3","id":"start_packet_header_info"}},[_c('div',{staticClass:"start-packet-header-info-element"},[_c('p',{staticClass:"start-packet-header-info-label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('p',{staticClass:"start-packet-header-info-value",domProps:{"innerHTML":_vm._s(item.value)}})])]):_vm._e()}),1),_vm._v(" "),_c('b-row',_vm._l((_vm.informations),function(item,index){return (item.position == 'block-2')?_c('b-col',{key:index,staticClass:"start-packet-header-info",attrs:{"cols":"6","lg":"3","id":"start_packet_header_info"}},[_c('div',{staticClass:"start-packet-header-info-element"},[_c('p',{staticClass:"start-packet-header-info-label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('p',{staticClass:"start-packet-header-info-value",domProps:{"innerHTML":_vm._s(item.value)}})])]):_vm._e()}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W+gU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__codes_CreateCode_vue__ = __webpack_require__("fd+i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__codes_CodesList_vue__ = __webpack_require__("ffds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['code', 'popup'],
    components: { CreateCode: __WEBPACK_IMPORTED_MODULE_0__codes_CreateCode_vue__["a" /* default */], CodesList: __WEBPACK_IMPORTED_MODULE_1__codes_CodesList_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__["a" /* default */] },
    mounted: function mounted() {
        if (this.$route.params.code) {
            this.code.confirmCode(this.$route.params.code);
            this.$router.push({ path: '/business/codes' });
        }
    }
});

/***/ }),

/***/ "W9ib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('api');

var Countries = function () {
    function Countries() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Countries);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Countries, [{
        key: 'fetchList',
        value: function fetchList() {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.countries.list).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setCountries', response.body);
            }, function () {});
        }
    }]);

    return Countries;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('countries', Countries);

/***/ }),

/***/ "WCWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__coindeal_AccountNumber__ = __webpack_require__("Dco8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'method', 'methodName', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], AccountNumber: __WEBPACK_IMPORTED_MODULE_1__coindeal_AccountNumber__["a" /* default */] }
});

/***/ }),

/***/ "WDcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-desktop desktop-only"},[_c('h3',[_vm._v("Top Qualified")]),_vm._v(" "),_c('div',{staticClass:"ranking-desktop--tabs"},_vm._l((_vm.ranking),function(value,index){return _c('div',{key:index,staticClass:"ranking-desktop--tab",class:{ 'active' : value.code === _vm.selected },on:{"click":function($event){return _vm.setRanking(value.code)}}},[_c('p',[_vm._v(_vm._s(value.name))])])}),0),_vm._v(" "),_c('div',{staticClass:"ranking-desktop--header"},[_c('img',{staticClass:"coin-bg",attrs:{"src":"/static/img/coins/bronze-big.png"}}),_vm._v(" "),_c('img',{staticClass:"coin-icon",attrs:{"src":_vm.getCoinPath(_vm.selected)}}),_vm._v(" "),_c('p',[_vm._v("See below people qualified as "+_vm._s(_vm.ranking[_vm.selected].name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WMJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('div',{staticClass:"modal-component",attrs:{"id":"modal_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.hideModal()}}}),_vm._v(" "),_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.source}})]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"button--cancel",on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("Close")])])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WRaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        withdraw: function withdraw() {
            return this.$store.getters.futurocoinWithdraw[0] ? this.$store.getters.futurocoinWithdraw[0] : '';
        }
    }
});

/***/ }),

/***/ "X/bZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"futurocoin-table-component",attrs:{"id":"futurocoin_table_component"}},[_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("FuturoCoins from mining")]),_vm._v(" "),_c('div',{staticClass:"futurocoin-table-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_c('thead',[_c('tr',[_c('th',[_c('div',{staticClass:"calendar-icon"},[_c('p',[_vm._v("Date")]),_vm._v(" "),_c('i',{staticClass:"mdi mdi-calendar"}),_vm._v(" "),_c('datepicker',{attrs:{"placeholder":"range","options":{ mode: 'range', maxDate: 'today' }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dailyMining),function(day,index){return _c('tr',{key:index},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.datetime.utcToLocal(day.date)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.money.format(day.amount, 'fto'))+" FTO")])])])}),0)]),_vm._v(" "),(_vm.dailyMining.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No results.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Income")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X131":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X1Vh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("FigV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b3c232_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("crci");
function injectStyle (ssrContext) {
  __webpack_require__("DriP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b3c232_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X8Za":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bottombar_Calculating_vue__ = __webpack_require__("mdqp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bottombar_HeaderStats_vue__ = __webpack_require__("DCDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bottombar_HeaderPayout_vue__ = __webpack_require__("ukEU");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Calculating: __WEBPACK_IMPORTED_MODULE_0__bottombar_Calculating_vue__["a" /* default */], HeaderStats: __WEBPACK_IMPORTED_MODULE_1__bottombar_HeaderStats_vue__["a" /* default */], HeaderPayout: __WEBPACK_IMPORTED_MODULE_2__bottombar_HeaderPayout_vue__["a" /* default */] }
});

/***/ }),

/***/ "XD1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_MonthlyStatementContent_vue__ = __webpack_require__("V8a5");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], MonthlyStatementContent: __WEBPACK_IMPORTED_MODULE_1__content_MonthlyStatementContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "XDUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-outer select-outer--search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"text"},domProps:{"value":(_vm.selected)},on:{"keyup":function($event){return _vm.debounce(_vm.selected, $event)},"keydown":function($event){return _vm.keydownEvent($event)},"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpened()),expression:"isOpened()"}],on:{"mouseleave":function($event){return _vm.closeDropdown()}}},_vm._l((_vm.getList()),function(user,index){return _c('li',{class:{ 'active' : _vm.userHovered === index },on:{"mouseover":function($event){return _vm.userHover(index)},"click":function($event){_vm.onElementClick(user), _vm.selectUser(user.login), _vm.closeDropdown()}}},[_vm._v("\n            "+_vm._s(user.login)+"\n        ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XEc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'money', 'popup'],
    data: function data() {
        return {
            progress: true,
            openList: false,
            hoverList: false,
            packages: {
                100: 1,
                250: 3,
                500: 7,
                1000: 15,
                5000: 80,
                10000: 180,
                25000: 500
            },
            selected: 'FND 100 - 1 FORCE FACTOR',
            ftoValue: '-'
        };
    },

    methods: {
        setItem: function setItem(selected, value) {
            this.selected = selected;
            this.loadData(value);
        },
        loadData: function loadData(value) {
            var _this = this;

            this.progress = true;

            this.$http.get(this.api.mining.ftoPerPowerPoint()).then(function (response) {
                _this.ftoValue = _this.money.format(response.data.data.value * value, 'fto');
                _this.progress = false;
            }, function (error) {
                _this.progress = false;
                _this.popup.show('An error occurred.');
            });
        }
    },
    created: function created() {
        this.loadData(1);
    }
});

/***/ }),

/***/ "XGuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('stp_login') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_stp_login"}},[_vm._v("\n            STP login\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_stp_login","name":"stp_login","type":"text","data-vv-rules":"required|max:255","data-vv-as":"STP login","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('stp_login') && _vm.showErrors),expression:"errors.has('stp_login') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('stp_login')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XOin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['currentPage', 'items', 'loader', 'numberOfPages', 'setItems', 'setPage'],
    data: function data() {
        return {
            openList: false,
            paginationOptions: {
                25: 25,
                50: 50,
                100: 100
            }
        };
    },

    methods: {
        goToTop: function goToTop() {
            window.scrollTo(0, 0);
        }
    }
});

/***/ }),

/***/ "XaBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawCoinsModal_vue__ = __webpack_require__("glna");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f611c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawCoinsModal_vue__ = __webpack_require__("F5my");
function injectStyle (ssrContext) {
  __webpack_require__("U0YE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawCoinsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f611c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawCoinsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XlrM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsTable_vue__ = __webpack_require__("LN/0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6498976_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsTable_vue__ = __webpack_require__("MQXs");
function injectStyle (ssrContext) {
  __webpack_require__("TgYI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6498976"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6498976_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XsKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('div',{staticClass:"form-item form-item-amount"},[_c('p',[_vm._v("Enter payout amount:")]),_vm._v(" "),_c('div',{staticClass:"transfer-value",class:{ 'field-error': (_vm.errors.has('payout_amount') && _vm.showErrors) || (_vm.amountError && _vm.showErrors) || (_vm.maxAmountError && _vm.showErrors) }},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],attrs:{"type":"text","name":"payout_amount","id":"payout_amount","data-vv-rules":"required|currency|money|greaterThanZero","data-vv-as":"amount"},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"currency"},[_vm._v("FND")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('payout_amount') && _vm.showErrors),expression:"errors.has('payout_amount') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('payout_amount')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XvX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsContent_vue__ = __webpack_require__("jVbI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312d50e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsContent_vue__ = __webpack_require__("9Nmr");
function injectStyle (ssrContext) {
  __webpack_require__("Rfz/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-312d50e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312d50e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y0zW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['updateValue', 'sending', 'showErrors', 'isVerified'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    computed: {
        defaultValue: function defaultValue() {
            return this.$store.getters.user.birthDate;
        }
    },
    watch: {
        defaultValue: function defaultValue() {
            this.fieldValue = this.defaultValue;
        },
        fieldValue: function fieldValue() {
            this.updateValue('birthDate', this.fieldValue);
        }
    },
    mounted: function mounted() {
        this.fieldValue = this.defaultValue;
        this.updateValue('birthDate', this.fieldValue);
    }
});

/***/ }),

/***/ "Y5/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"futurocoin-table-component",attrs:{"id":"futurocoin_table_component"}},[_c('h3',{staticStyle:{"margin-top":"25px"}},[_vm._v("Transfer history")]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"24px"}},[_c('b-col',{attrs:{"lg":"4"}},[_c('type')],1)],1),_vm._v(" "),_c('div',{staticClass:"futurocoin-table-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_c('thead',[_c('tr',[_c('th',[_c('div',{staticClass:"calendar-icon"},[_c('p',[_vm._v("Date")]),_vm._v(" "),_c('i',{staticClass:"mdi mdi-calendar"}),_vm._v(" "),_c('datepicker',{attrs:{"placeholder":"range","options":{ mode: 'range', maxDate: 'today' }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('div',{staticClass:"sort-icon",on:{"click":function($event){return _vm.changeSort('date')}}},[_c('i',{staticClass:"mdi mdi-chevron-up"}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-chevron-down"})])]),_vm._v(" "),_c('th',{on:{"click":function($event){return _vm.changeSort('amount')}}},[_c('p',[_vm._v("Amount")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('th',{on:{"click":function($event){return _vm.changeSort('type')}}},[_c('p',[_vm._v("Type")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('tbody',_vm._l((_vm.transferHistory),function(transfer,index){return _c('tr',{key:index},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.datetime.utcToLocal(transfer.date)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.money.format(transfer.amount.amount, 'fto'))+" FTO")])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.getTypeName(transfer.type_name)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(transfer.status.status))])])])}),0)]),_vm._v(" "),(_vm.transferHistory.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No results.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-icon"},[_c('i',{staticClass:"mdi mdi-chevron-up"}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-chevron-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-icon"},[_c('i',{staticClass:"mdi mdi-chevron-up"}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-chevron-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y8HF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_CheckFnwallet_vue__ = __webpack_require__("EjMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calculator_Calculator_vue__ = __webpack_require__("IgLk");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CheckFnwallet: __WEBPACK_IMPORTED_MODULE_0__dashboard_CheckFnwallet_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */], Calculator: __WEBPACK_IMPORTED_MODULE_2__calculator_Calculator_vue__["a" /* default */] },
    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        }
    }
});

/***/ }),

/***/ "Y996":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('iban') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_iban"}},[_vm._v("\n            IBAN\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_iban","name":"iban","type":"text","data-vv-rules":"required|max:255","data-vv-as":"IBAN","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('iban') && _vm.showErrors ),expression:"errors.has('iban') && showErrors "}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('iban')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YPtq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ya4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'popup', 'recaptcha', 'status', 'user'],
    components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */] },
    data: function data() {
        return {
            progress: false,
            showErrors: false,
            email: ''
        };
    },

    methods: {
        onVerify: function onVerify(response) {
            this['g-recaptcha-response'] = response;
        },
        onRender: function onRender(recaptchaId) {
            this.recaptchaId = recaptchaId;
        },
        changeView: function changeView(view) {
            var _this = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this.$store.commit('loginFormView', view);
            }, 600);
        },
        validate: function validate(e) {
            this.showErrors = false;
            this.$validator.validateAll();

            if (!this.errors.any()) {
                this.submit();
            } else {
                this.showErrors = true;
            }
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;
            var email = document.querySelector('#forgot_password_email').value;

            this.$http.post(this.api.user.password.remind, {
                email: email,
                'g-recaptcha-response': this['g-recaptcha-response']
            }).then(function () {
                _this2.progress = false;
                _this2.popup.show('Please check your email and follow the instructions provided.', 'OK', true);
            }, function (error) {
                _this2.progress = false;
                _this2.$children.find(function (component) {
                    return component.$widgetId === _this2.recaptchaId;
                }).reset();
                switch (error.status) {
                    default:
                        if (_this2.status['status' + error.status]) {
                            _this2.status['status' + error.status]();
                        } else {
                            _this2.popup.show(error.data.errors[0].message);
                        }
                }
            });
        }
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_partials_section_pages_BusinessQualifications__ = __webpack_require__("SvCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_partials_section_pages_Calculator__ = __webpack_require__("AsgG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_partials_section_pages_Codes__ = __webpack_require__("eyzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_partials_section_pages_Commissions__ = __webpack_require__("PBSs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_partials_section_pages_Dashboard__ = __webpack_require__("lfVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layout_partials_section_pages_DashboardFirstTime__ = __webpack_require__("vYXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layout_partials_section_pages_FNProductPacks__ = __webpack_require__("gsB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_layout_partials_section_pages_Futurocoin__ = __webpack_require__("v00P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_layout_partials_section_pages_FuturocoinHistory__ = __webpack_require__("ODA6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_login_Login__ = __webpack_require__("NaOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_logout_Logout__ = __webpack_require__("ti53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_layout_partials_section_pages_MarketingPlan__ = __webpack_require__("P9Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_layout_partials_section_pages_MonthlyStatement__ = __webpack_require__("ngdj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_layout_partials_section_pages_MyTeam__ = __webpack_require__("/Kr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_layout_partials_section_pages_News__ = __webpack_require__("9Hxm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_layout_partials_section_pages_Otp__ = __webpack_require__("cdSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_layout_partials_section_pages_Profile__ = __webpack_require__("ZfBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_layout_partials_section_pages_ProfileEditData__ = __webpack_require__("Kwgm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_layout_partials_section_pages_Payout__ = __webpack_require__("TsIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_layout_partials_section_pages_PayoutHistory__ = __webpack_require__("5EBs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_register_Register__ = __webpack_require__("vsCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_remind_password_RemindPassword__ = __webpack_require__("DgVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_layout_partials_section_pages_StartPacket__ = __webpack_require__("kw3P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_layout_partials_section_pages_Invoices__ = __webpack_require__("zU53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_layout_partials_section_pages_SponsorSystem__ = __webpack_require__("Gaby");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_terms_and_conditions_TermsAndConditions__ = __webpack_require__("B+h8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_terms_TermsUpdate__ = __webpack_require__("SD81");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_layout_partials_section_pages_TopQualified__ = __webpack_require__("APta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_layout_partials_section_pages_Withdraw__ = __webpack_require__("d5/w");



































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a);

/**
 * Inject services into components
 */
var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api'),
    popup = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('popup'),
    user = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('user');

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [
    /**
     * Main menu
     */
    {
        path: '/how-many-fto',
        name: 'Calculator',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_5__components_layout_partials_section_pages_Calculator__["a" /* default */]
    }, {
        path: '/business/commissions',
        name: 'BusinessCommissions',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_7__components_layout_partials_section_pages_Commissions__["a" /* default */]
    }, {
        path: '/futurocoin',
        name: 'Futurocoin',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_11__components_layout_partials_section_pages_Futurocoin__["a" /* default */]
    }, {
        path: '/futurocoin/history',
        name: 'FuturocoinHistory',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_12__components_layout_partials_section_pages_FuturocoinHistory__["a" /* default */]
    }, {
        path: '/business/qualifications',
        name: 'BusinessQualifications',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_4__components_layout_partials_section_pages_BusinessQualifications__["a" /* default */]
    }, {
        path: '/business/codes',
        name: 'Codes',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_6__components_layout_partials_section_pages_Codes__["a" /* default */]
    }, {
        path: '/',
        name: 'Dashboard',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_8__components_layout_partials_section_pages_Dashboard__["a" /* default */]
    }, {
        path: '/fnproductpacks',
        name: 'FNProductPacks',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_10__components_layout_partials_section_pages_FNProductPacks__["a" /* default */]
    }, {
        path: '/login',
        name: 'Login',
        meta: {
            Auth: false,
            hideHeader: true
        },
        component: __WEBPACK_IMPORTED_MODULE_13__components_login_Login__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.checkAuth) {
                next('/');
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(api.auth.user).then(function (response) {
                    user.fetchData(response.data, next);
                    next('/');
                }).catch(function () {
                    next();
                });
            }
            next();
        }
    }, {
        path: '/logout',
        name: 'Logout',
        meta: {
            Auth: true,
            hideHeader: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_14__components_logout_Logout__["a" /* default */]
    }, {
        path: '/marketing-plan',
        name: 'MarketingPlan',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_15__components_layout_partials_section_pages_MarketingPlan__["a" /* default */]
    }, {
        path: '/my-start-package',
        name: 'MyStartPacket',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_26__components_layout_partials_section_pages_StartPacket__["a" /* default */]
    }, {
        path: '/business/commissions/monthly-statement',
        name: 'MonthlyStatement',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_16__components_layout_partials_section_pages_MonthlyStatement__["a" /* default */]
    }, {
        path: '/my-start-package/invoices',
        name: 'Invoices',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_27__components_layout_partials_section_pages_Invoices__["a" /* default */]
    }, {
        path: '/my-team',
        name: 'MyTeam',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_17__components_layout_partials_section_pages_MyTeam__["a" /* default */]
    }, {
        path: '/news',
        name: 'News',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_18__components_layout_partials_section_pages_News__["a" /* default */]
    }, {
        path: '/otp',
        name: 'Otp',
        meta: {
            Auth: true,
            OtpPage: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_19__components_layout_partials_section_pages_Otp__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user.showOtpPage) {
                next();
            } else {
                next({ name: 'Profile' });
            }
        }
    }, {
        path: '/payout',
        name: 'Payout',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_22__components_layout_partials_section_pages_Payout__["a" /* default */]
    }, {
        path: '/payout/history',
        name: 'PayoutHistory',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_23__components_layout_partials_section_pages_PayoutHistory__["a" /* default */]
    }, {
        path: '/payout-confirmation/:token/:id',
        name: 'PayoutConfirmation',
        beforeEnter: function beforeEnter(to, from, next) {
            if (to.params && to.params.token && to.params.id) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(api.payout.confirmByUser, {
                    'token': to.params.token,
                    'id': to.params.id
                }).then(function () {
                    next({ 'name': 'PayoutHistory' });
                    popup.show('Payout was confirmed.');
                }, function (error) {
                    popup.show(error.body.errors[0].message);
                    next({ 'name': 'PayoutHistory' });
                });
            }
            next({ 'name': 'PayoutHistory' });
        }
    }, {
        path: '/profile',
        name: 'Profile',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_20__components_layout_partials_section_pages_Profile__["a" /* default */]
    }, {
        path: '/profile/edit-data',
        name: 'ProfileEditData',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_21__components_layout_partials_section_pages_ProfileEditData__["a" /* default */]
    }, {
        path: '/register/:sponsor?',
        name: 'Register',
        meta: {
            Auth: false,
            hideHeader: true
        },
        component: __WEBPACK_IMPORTED_MODULE_24__components_register_Register__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.checkAuth) {
                next('/');
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(api.auth.user).then(function (response) {
                    user.fetchData(response.data, next);
                    next('/');
                }).catch(function () {
                    next();
                });
            }
            next();
        }
    }, {
        path: '/user/remind-password/:token',
        name: 'RemindPassword',
        meta: {
            Auth: false,
            hideHeader: true
        },
        component: __WEBPACK_IMPORTED_MODULE_25__components_remind_password_RemindPassword__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.checkAuth) {
                next('/');
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(api.auth.user).then(function (response) {
                    user.fetchData(response.data, next);
                    next('/');
                }).catch(function () {
                    next();
                });
            }
            next();
        }
    }, {
        path: '/start-package',
        name: 'StartPacket',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_9__components_layout_partials_section_pages_DashboardFirstTime__["a" /* default */]
    }, {
        path: '/sponsor-system',
        name: 'SponsorSystem',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_28__components_layout_partials_section_pages_SponsorSystem__["a" /* default */]
    }, {
        path: '/code/confirm/:code',
        name: 'CodeConfirmation',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_6__components_layout_partials_section_pages_Codes__["a" /* default */]
    }, {
        path: '/terms',
        name: 'Terms',
        meta: {
            Auth: false,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_29__components_terms_and_conditions_TermsAndConditions__["a" /* default */]
    }, {
        path: '/terms-update',
        name: 'TermsUpdate',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_30__components_terms_TermsUpdate__["a" /* default */]
    }, {
        path: '/top-qualified',
        name: 'TopQualified',
        meta: { Auth: true },
        component: __WEBPACK_IMPORTED_MODULE_31__components_layout_partials_section_pages_TopQualified__["a" /* default */]
    }, {
        path: '/withdraw',
        name: 'Withdraw',
        meta: {
            Auth: true,
            noPacket: true
        },
        component: __WEBPACK_IMPORTED_MODULE_32__components_layout_partials_section_pages_Withdraw__["a" /* default */]
    },
    /**
     * Errors
     */
    {
        path: "*",
        meta: {
            Auth: false,
            hideHeader: true,
            hideFooter: true
        },
        beforeEnter: function beforeEnter(to, from, next) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('setError', {
                status: true,
                code: 404,
                redirect: true
            });
            next({ name: 'Dashboard' });
        }
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YcyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingTable_vue__ = __webpack_require__("PuPz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439e61ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingTable_vue__ = __webpack_require__("rBGk");
function injectStyle (ssrContext) {
  __webpack_require__("sKk/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-439e61ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RankingTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439e61ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RankingTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yf+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stp_StpLogin_vue__ = __webpack_require__("qo7n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], StpLogin: __WEBPACK_IMPORTED_MODULE_1__stp_StpLogin_vue__["a" /* default */] }
});

/***/ }),

/***/ "Yft9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YfyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "YqjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('street') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_street"}},[_vm._v("\n            Street\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_street","name":"street","type":"text","data-vv-rules":"required|max:255","data-vv-as":"street","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('street') && _vm.showErrors),expression:"errors.has('street') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('street')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z+f4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z2CB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('dashboard-panel')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZFAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);








__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('api'),
    status = __WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.get('status');

var state = {
    commissions: {},

    commissionsLoader: true,

    commissionsFilter: false,

    commissionsSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        user: '',
        sort: [],
        filter: []
    }
};

var getters = {
    commissions: function commissions(state) {
        return state.commissions;
    },

    commissionsFilter: function commissionsFilter(state) {
        return state.commissionsFilter;
    },

    commissionsLoader: function commissionsLoader(state) {
        return state.commissionsLoader;
    },

    commissionsSettings: function commissionsSettings(state) {
        return state.commissionsSettings;
    }
};

var mutations = {
    /**
     * Set commissions in store
     * @param state
     * @param data
     */
    setCommissions: function setCommissions(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'commissions', data);
        } else {
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'commissions', []);
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'numberOfPages', data.number_of_pages);
    },


    /**
     * Show filter
     * @param state
     */
    commissionsFilterOn: function commissionsFilterOn(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'commissionsFilter', true);
    },


    /**
     * Hide filter
     * @param state
     */
    commissionsFilterOff: function commissionsFilterOff(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'commissionsFilter', false);
    },


    /**
     * Show loader
     * @param state
     */
    commissionsLoaderOn: function commissionsLoaderOn(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'commissionsLoader', true);
    },


    /**
     * Hide loader
     * @param state
     */
    commissionsLoaderOff: function commissionsLoaderOff(state) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state, 'commissionsLoader', false);
    },


    /**
     * Add filter
     * @param state
     * @param value
     */
    commissionsAddFilter: function commissionsAddFilter(state, value) {
        var filter = state.commissionsSettings.filter;
        if (!filter[value]) {
            filter.push(value);
            __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'filter', filter);
        }
    },


    /**
     * Set filter
     * @param state
     * @param value
     */
    commissionsRemoveFilter: function commissionsRemoveFilter(state, value) {
        var filter = state.commissionsSettings.filter;

        var index = filter.indexOf(value);

        filter.splice(index, 1);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'filter', filter);
    }
};

var actions = {

    /**
     * Get commissions data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadCommissions: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                commit('commissionsLoaderOn');
                                var settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(data);
                                if (settings.params.sort) {
                                    var sort = [];
                                    for (var field in data.params.sort) {
                                        sort.push(data.params.sort[field]);
                                    }
                                    settings.params.sort = sort;
                                }

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(api.bonus.history(settings.params)).then(function (response) {
                                    commit('setCommissions', response.data);
                                    commit('commissionsLoaderOff');
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    commit('commissionsLoaderOff');
                                    reject();
                                });
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadCommissions(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return loadCommissions;
    }(),


    /**
     * Set sorting in commissions
     * @param field
     * @returns {Promise}
     */
    commissionsSetSort: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, field) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                var sort = state.commissionsSettings.sort,
                                    isSet = false;

                                for (var sortId in sort) {
                                    if (!isSet && sort[sortId].field === field) {
                                        isSet = sortId;
                                    }
                                }

                                if (!isSet) {
                                    sort.push({
                                        field: field,
                                        order: 'asc'
                                    });
                                } else {
                                    sort[isSet].order = sort[isSet].order === 'desc' ? 'asc' : 'desc';
                                }

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'sort', sort);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function commissionsSetSort(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return commissionsSetSort;
    }(),


    /**
     * Set max number of items in commissions
     * @param getters
     * @param data
     * @returns {Promise}
     */
    commissionsSetItems: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function commissionsSetItems(_x5, _x6) {
            return _ref6.apply(this, arguments);
        }

        return commissionsSetItems;
    }(),


    /**
     * Set user
     * @param user
     * @returns {Promise}
     */
    commissionsSetUser: function () {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, user) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

                            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'user', user);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function commissionsSetUser(_x7, _x8) {
            return _ref8.apply(this, arguments);
        }

        return commissionsSetUser;
    }(),


    /**
     * Set page in commissions
     * @param getters
     * @param data
     * @returns {Promise}
     */
    commissionsSetPage: function () {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

                            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'currentPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function commissionsSetPage(_x9, _x10) {
            return _ref10.apply(this, arguments);
        }

        return commissionsSetPage;
    }(),


    /**
     * Set date in commissions
     * @param date
     * @returns {Promise}
     */
    commissionsSetDate: function () {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref11, date) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref11);

                            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

                                var dates = date.split(' to ');

                                if (dates[1]) {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'fromDate', dates[0]);
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'toDate', dates[1]);
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'fromDate', dates[0]);
                                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(state.commissionsSettings, 'toDate', false);
                                }

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function commissionsSetDate(_x11, _x12) {
            return _ref12.apply(this, arguments);
        }

        return commissionsSetDate;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "ZHLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error503_vue__ = __webpack_require__("logO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c3017e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error503_vue__ = __webpack_require__("ZiuT");
function injectStyle (ssrContext) {
  __webpack_require__("T/pq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38c3017e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error503_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c3017e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error503_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZHwb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoPayFourYou_vue__ = __webpack_require__("79ri");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0b45b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TwoPayFourYou_vue__ = __webpack_require__("fKhP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoPayFourYou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0b45b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TwoPayFourYou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZVS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('tabs-desktop',{attrs:{"ranking":_vm.ranking,"selected":_vm.selected,"set-ranking":_vm.setRanking}}),_vm._v(" "),_c('tabs-mobile',{attrs:{"ranking":_vm.ranking,"selected":_vm.selected,"set-ranking":_vm.setRanking}}),_vm._v(" "),_c('ranking-table',{attrs:{"ranking":_vm.ranking,"selected":_vm.selected}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zbdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutHistoryContent_vue__ = __webpack_require__("a7RX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a2ae2e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutHistoryContent_vue__ = __webpack_require__("VdUJ");
function injectStyle (ssrContext) {
  __webpack_require__("Sz5e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a2ae2e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutHistoryContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a2ae2e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutHistoryContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZfBu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("ckGE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26710d54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("Zlr+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26710d54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZiuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer"},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"fullscreen-box--content"},[_c('b-container',{staticClass:"register-center"},[_c('error-logo'),_vm._v(" "),_c('error-503-content'),_vm._v(" "),_c('error-503-redirect')],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zlr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'',"title":'Profile'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('profile-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a7RX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payout_history_PayoutHistoryTable_vue__ = __webpack_require__("kRJ4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__["a" /* default */], PayoutHistoryTable: __WEBPACK_IMPORTED_MODULE_1__payout_history_PayoutHistoryTable_vue__["a" /* default */] },
    dependencies: ['money'],
    computed: {
        accountBalance: function accountBalance() {
            return this.$store.getters.user.moneyBalance;
        }
    }
});

/***/ }),

/***/ "aF0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('wallet') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_wallet_name"}},[_vm._v("\n            Wallet name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_wallet_name","name":"wallet","type":"text","data-vv-rules":"required|max:255","data-vv-as":"wallet name","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('wallet') && _vm.showErrors),expression:"errors.has('wallet') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('wallet')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_bitcoin_component"}},[_c('p',[_vm._v(_vm._s(_vm.methodName))]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('account-number',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue,"method":_vm.method,"method-name":_vm.methodName}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aMkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['method', 'methodName', 'sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "aOSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('neteller_email') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_neteller_email"}},[_vm._v("\n            Neteller email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_neteller_email","name":"neteller_email","type":"text","data-vv-rules":"required|max:255|email","data-vv-as":"Neteller email","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('neteller_email') && _vm.showErrors),expression:"errors.has('neteller_email') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('neteller_email')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "ahAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'',"title":'FutureNet Products Packs'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('packs-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "auol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commissions_table_BonusFilter_vue__ = __webpack_require__("xcMF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BonusFilter: __WEBPACK_IMPORTED_MODULE_0__commissions_table_BonusFilter_vue__["a" /* default */] },
    dependencies: ['api', 'datetime', 'money'],
    data: function data() {
        return {
            date: '',
            filters: {
                'direct-bonus-position': 'Direct Bonus',
                'unilevel-bonus-position': 'Unilevel Bonus',
                'direct-bonus-career-level': 'Career Sponsor Bonus',
                'unilevel-bonus-career-level': 'Career Unilevel Bonus',
                'matching-bonus': 'Matching Bonus',
                'car-bonus': 'Car Bonus',
                'business-bonus': 'Business Bonus'
            },
            items: 25
        };
    },

    computed: {
        commissions: function commissions() {
            return this.$store.getters.commissions ? this.$store.getters.commissions.results : [];
        },
        currentPage: function currentPage() {
            return this.$store.getters.commissionsSettings.currentPage;
        },
        filter: function filter() {
            return this.$store.getters.commissionsFilter;
        },
        loader: function loader() {
            return this.$store.getters.commissionsLoader;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.commissionsSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.commissionsSettings.numberOfPages;
        }
    },
    methods: {
        /**
         * Change sort
         */
        changeSort: function changeSort(field) {
            var _this = this;

            this.$store.dispatch('commissionsSetSort', field).then(function () {
                _this.getData();
            });
        },

        /**
         * Set default settings
         */
        clearSettings: function clearSettings() {
            var _this2 = this;

            this.$store.dispatch('commissionsSettingsClear').then(function () {
                _this2.getData();
                _this2.items = 25;
            });
        },


        /**
         * Get data with transactions
         */
        getData: function getData() {
            var settings = this.$store.getters.commissionsSettings;

            this.$store.dispatch('loadCommissions', {
                params: settings
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this3 = this;

            this.items = items;
            this.$store.dispatch('commissionsSetItems', items).then(function () {
                _this3.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this4 = this;

            this.$store.dispatch('commissionsSetPage', page).then(function () {
                _this4.getData();
                window.scrollTo(0, 0);
            });
        },


        /**
         * Set user in filter
         */
        setUser: function setUser(user) {
            var _this5 = this;

            this.$store.dispatch('commissionsSetUser', user).then(function () {
                _this5.getData();
            });
        },


        /**
         * Show filter
         */
        showFilter: function showFilter() {
            this.$store.commit('commissionsFilterOn');
        }
    },
    watch: {
        /**
         * Get data with transactions if date in calendar was changed
         */
        date: function date() {
            var _this6 = this;

            this.$store.dispatch('commissionsSetDate', this.date).then(function () {
                _this6.getData();
            });
        }
    },
    beforeMount: function beforeMount() {
        var _this7 = this;

        var settings = this.$store.getters.commissionsSettings;

        this.$store.dispatch('loadCommissions', {
            params: settings
        }).then(function () {
            _this7.items = settings.maxPerPage;
        });
    }
});

/***/ }),

/***/ "b5yM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'futurocoin',"title":'Futurocoin'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('futurocoin-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bFM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__security_Param__ = __webpack_require__("jlXv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['settings'],
    components: { ParamComponent: __WEBPACK_IMPORTED_MODULE_0__security_Param__["a" /* default */] },
    data: function data() {
        return {
            loginOptions: {
                NOT_CONFIGURED: '-',
                EMAIL: 'e-mail',
                GOOGLE_AUTHENTICATOR: 'google authenticator'
            },
            payoutsOptions: {
                EMAIL: 'e-mail',
                GOOGLE_AUTHENTICATOR: 'google authenticator'
            }
        };
    },
    mounted: function mounted() {
        this.$store.commit('resetTemporarySettings');
    }
});

/***/ }),

/***/ "bICo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('password', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    user: {
        uid: null,
        login: null,
        isVerified: false,
        email: null,
        phoneNumber: null,
        firstName: null,
        lastName: null,
        otp: false,
        showOtpPage: false,
        previousCareerLevel: null,
        currentMonthCareerLevel: null,
        careerLevel: null,
        directBonusCareerLevel: null,
        directBonusPosition: null,
        frontliners: '-',
        lastBusinessBonus: '-',
        lastCarBonus: '-',
        matchingBonus: '-',
        position: '-',
        unilevelTeam: '-',
        startPacket: '-',
        sponsorBonus: '-',
        moneyBalance: '-',
        street: null,
        city: null,
        postalCode: null,
        country: null,
        birthDate: null,
        gender: null,
        companyName: null,
        companyRegistrationNumber: null,
        isCompany: null,
        isFromUe: false,
        has_unilevel_bonus_from_frontliners: false,
        frontliners_unilevel_group: null,
        terms_of_use_accepted: null
    }
};

var getters = {

    user: function user(state) {
        return state.user;
    },

    userFullName: function userFullName(state) {
        return state.user.firstName + ' ' + state.user.lastName;
    }
};

var mutations = {
    /**
     * Set user data
     * @param state
     */
    setUser: function setUser(state, response) {
        var data = response.data,
            userData = {
            uid: data.user_id,
            login: data.login,
            isVerified: data.is_verified,
            email: data.email,
            phoneNumber: data.phone_number,
            firstName: data.first_name,
            lastName: data.last_name,
            otp: false,
            showOtpPage: false,
            previousCareerLevel: data.previous_career_level,
            currentMonthCareerLevel: data.current_month_career_level,
            careerLevel: data.career_level,
            directBonusCareerLevel: data.direct_bonus_career_level,
            directBonusPosition: data.direct_bonus_position,
            frontliners: data.frontliners,
            lastBusinessBonus: data.last_business_bonus,
            lastCarBonus: data.last_car_bonus,
            matchingBonus: data.matching_bonus,
            position: data.position,
            unilevelTeam: data.unilevel_team,
            startPacket: data.direct_bonus_position,
            sponsorBonus: 0,
            moneyBalance: data.money_balance,
            street: data.street,
            city: data.city,
            postalCode: data.postal_code,
            country: data.country,
            birthDate: data.birth_date,
            future_net_upgrade_account_balance: data.future_net_upgrade_account_balance,
            gender: data.gender,
            companyName: data.company_name,
            companyRegistrationNumber: data.company_registration_number,
            isCompany: data.is_company,
            isFromUe: data.is_gdpr_required,
            has_unilevel_bonus_from_frontliners: data.has_unilevel_bonus_from_frontliners,
            frontliners_unilevel_group: data.frontliners_unilevel_group,
            terms_of_use_accepted: data.terms_of_use_accepted
        };
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', userData);
    },
    setOtp: function setOtp(state) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.user, 'otp', true);
    },
    showOtpPage: function showOtpPage(state) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.user, 'showOtpPage', true);
    },
    hideOtpPage: function hideOtpPage(state) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.user, 'showOtpPage', false);
    }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "ba/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bdUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error500Redirect_vue__ = __webpack_require__("2m+7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72898110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error500Redirect_vue__ = __webpack_require__("MyOm");
function injectStyle (ssrContext) {
  __webpack_require__("yfYV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72898110"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error500Redirect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72898110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error500Redirect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bh5i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bla+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining',{attrs:{"hide-payout":true,"button-label":'Transfer history',"button-link":'FuturocoinHistory'}}),_vm._v(" "),_c('futurocoin-stats'),_vm._v(" "),_c('royal-bonuses-table'),_vm._v(" "),_c('futurocoin-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "blku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinStats_vue__ = __webpack_require__("vOOy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d17a72b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinStats_vue__ = __webpack_require__("xTF3");
function injectStyle (ssrContext) {
  __webpack_require__("mjpC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d17a72b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bnKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('div',{staticClass:"modal-component",attrs:{"id":"modal_component"}},[_c('div',{staticClass:"modal-area"},[_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-overlay-inside"},[_c('div',{staticClass:"modal-outer"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){_vm.reload ? _vm.reloadPage() : _vm.hideModal()}}}),_vm._v(" "),_c('div',{staticClass:"modal-inner"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('p',{staticClass:"p2"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button--action button--confirm",attrs:{"type":"button"},on:{"click":function($event){_vm.reload ? _vm.reloadPage() : _vm.hideModal()}}},[_vm._v("\n                                    "+_vm._s(_vm.button || 'OK'))])])])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bsDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "bzZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['updateValue', 'sending', 'showErrors', 'label', 'fieldKey', 'property', 'isVerified'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    computed: {
        defaultValue: function defaultValue() {
            return this.$store.getters.user[this.property];
        }
    },
    watch: {
        defaultValue: function defaultValue() {
            this.fieldValue = this.defaultValue;
        },
        fieldValue: function fieldValue() {
            this.updateValue(this.property, this.fieldValue);
        }
    },
    mounted: function mounted() {
        this.fieldValue = this.defaultValue;
        this.updateValue(this.property, this.fieldValue);
    }
});

/***/ }),

/***/ "c+CG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c08f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("JTuK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c2b128_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("Tgd4");
function injectStyle (ssrContext) {
  __webpack_require__("rJao")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43c2b128"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43c2b128_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cGzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calculator_CheckFTO_vue__ = __webpack_require__("l7GL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__start_packet_StartPacketHeader_vue__ = __webpack_require__("AJVb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__start_packet_StartPacketTable_vue__ = __webpack_require__("yvye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__start_packet_StartPacketFooter_vue__ = __webpack_require__("AMCO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__start_packet_StartPacketList__ = __webpack_require__("E9CY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__start_packet_StartPacketUpdate_vue__ = __webpack_require__("0AIT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        CheckFto: __WEBPACK_IMPORTED_MODULE_0__calculator_CheckFTO_vue__["a" /* default */],
        FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */],
        StartPacketHeader: __WEBPACK_IMPORTED_MODULE_2__start_packet_StartPacketHeader_vue__["a" /* default */],
        StartPacketTable: __WEBPACK_IMPORTED_MODULE_3__start_packet_StartPacketTable_vue__["a" /* default */],
        StartPacketFooter: __WEBPACK_IMPORTED_MODULE_4__start_packet_StartPacketFooter_vue__["a" /* default */],
        StartPacketList: __WEBPACK_IMPORTED_MODULE_5__start_packet_StartPacketList__["a" /* default */],
        StartPacketUpdate: __WEBPACK_IMPORTED_MODULE_6__start_packet_StartPacketUpdate_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "cImD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('commissions-total'),_vm._v(" "),_c('commissions-stats'),_vm._v(" "),_c('commissions-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cNCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountOwner_vue__ = __webpack_require__("ekDu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0653478e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountOwner_vue__ = __webpack_require__("f0Ys");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountOwner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0653478e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountOwner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cOqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEditDataContent_vue__ = __webpack_require__("o/Iy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d64e6f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEditDataContent_vue__ = __webpack_require__("3cPK");
function injectStyle (ssrContext) {
  __webpack_require__("T0B/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11d64e6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileEditDataContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d64e6f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileEditDataContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cXYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cXYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_SaveSettings__ = __webpack_require__("uOM7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'popup', 'settings'],
    components: { SaveSettings: __WEBPACK_IMPORTED_MODULE_1__modals_SaveSettings__["a" /* default */] },
    props: ['inputLabel', 'list', 'paramKey', 'paramLabel', 'paramName', 'paramSettingsName'],
    data: function data() {
        return {
            label: '',
            selected: '',
            token: '',
            openList: false,
            hoverList: false,
            confirmation: {
                params: {},
                type: '',
                visibility: false
            }

        };
    },

    computed: {
        settingId: function settingId() {
            return this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].id : false;
        },
        settingName: function settingName() {
            return this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].name : '';
        },
        settingValue: function settingValue() {
            return this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].value : '';
        },
        settingWatcher: function settingWatcher() {
            return this.$store.getters.settings;
        }
    },
    methods: {
        /**
         * Fail action during save settings
         */
        fail: function fail(error, params) {
            if (!error) {
                this.confirmation.visibility = false;
                this.$forceUpdate();
            } else {
                switch (error) {
                    case 404:
                        this.confirmation.visibility = false;
                        this.onChange(params.value, params.index);
                        break;
                }
            }
        },


        /**
         * Action on change option in select
         */
        onChange: function onChange(value, index) {
            var _this = this;

            var currentChoice = this.settingValue,
                newChoice = index;

            if (currentChoice === newChoice) return;

            if (currentChoice !== 'NOT_CONFIGURED') {
                this.$http.get(this.api.token.generate(this.paramSettingsName)).then(function () {
                    _this.showModal(value, index, currentChoice);
                }, function () {
                    _this.popup.show('An error occurred.');
                });
            } else {
                this.showModal(value, index, false);
            }
        },


        /**
         * Show modal with token
         * @param value
         * @param index
         * @param type
         */
        showModal: function showModal(value, index, type) {
            this.confirmation = {
                params: {
                    value: value,
                    index: index
                },
                settings: this.paramSettingsName,
                type: type,
                visibility: true
            };
        },


        /**
         * Set selected option and save
         */
        setSelected: function setSelected(params, token) {
            var _this2 = this;

            var oldLabel = this.label,
                oldSelected = this.selected;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.label = params.value;
                _this2.selected = params.index;
                _this2.token = token;

                _this2.setTemporarySetting();
                _this2.settings.create();
                _this2.settings.save().then(function () {
                    _this2.token = '';
                    resolve();
                }, function () {
                    _this2.label = oldLabel;
                    _this2.selected = oldSelected;
                    _this2.token = '';
                    reject();
                });
            });
        },


        /**
         * Set temporary settings
         */
        setTemporarySetting: function setTemporarySetting() {
            this.$store.commit('setTemporarySetting', {
                id: this.settingId,
                name: this.settingName,
                value: this.selected,
                token: this.token
            });
        }
    },
    mounted: function mounted() {
        if (this.$store.getters.settings.confirmations) {
            this.label = this.list[this.$store.getters.settings.confirmations[this.paramName].value];
            this.selected = this.$store.getters.settings.confirmations[this.paramName].value;
        }
    },

    watch: {
        settingWatcher: function settingWatcher() {
            this.label = this.$store.getters.settings.confirmations ? this.list[this.$store.getters.settings.confirmations[this.paramName].value] : '';
            this.selected = this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].value : '';
        }
    }
});

/***/ }),

/***/ "cbyq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cdSu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Otp_vue__ = __webpack_require__("Gah6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4ab6218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Otp_vue__ = __webpack_require__("yKTR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Otp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4ab6218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Otp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cdbE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chAp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-header",attrs:{"id":"dashboard_header"}},[_c('h2',[_vm._v("Welcome to FuturoNetwork! "),_c('br'),_vm._v("\n        Buy Start Package and start your Futuro Business\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ckGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_ProfileContent_vue__ = __webpack_require__("Kh+z");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], ProfileContent: __WEBPACK_IMPORTED_MODULE_1__content_ProfileContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "crci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"settings-header",attrs:{"cols":"12","lg":"12"}},[_c('h3',[_vm._v("Profile settings")])]),_vm._v(" "),_c('user-data'),_vm._v(" "),_c('user-password')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cscL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_TopQualifiedContent_vue__ = __webpack_require__("RjHC");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], TopQualifiedContent: __WEBPACK_IMPORTED_MODULE_1__content_TopQualifiedContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "d5/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Withdraw_vue__ = __webpack_require__("EQRH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910b23e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Withdraw_vue__ = __webpack_require__("J6yw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Withdraw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_910b23e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Withdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d8+G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8iA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Middlebar_vue__ = __webpack_require__("1rPU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69544d8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Middlebar_vue__ = __webpack_require__("myad");
function injectStyle (ssrContext) {
  __webpack_require__("nTAC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Middlebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69544d8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Middlebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dAuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bitcoin_vue__ = __webpack_require__("0xrw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7246e887_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bitcoin_vue__ = __webpack_require__("65uj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bitcoin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7246e887_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bitcoin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dCOn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dDZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsContent_vue__ = __webpack_require__("1yF1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfb83e20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsContent_vue__ = __webpack_require__("cImD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommissionsContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfb83e20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommissionsContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dSK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_payza_component"}},[_c('p',[_vm._v("Payza")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('payza-email',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dSZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_inject__);


var _gRecaptchaResponse = null;

__WEBPACK_IMPORTED_MODULE_0_vue_inject___default.a.constant('recaptcha', {
    sitekey: "6Ld3krMUAAAAAA5A7EAVE284xxtkx7Q2Fb7cyoLq",
    SetRecaptchaResponse: function SetRecaptchaResponse(key) {
        _gRecaptchaResponse = key;
    },
    GetRecaptchaResponse: function GetRecaptchaResponse() {
        return _gRecaptchaResponse;
    }
});

/***/ }),

/***/ "dZ8A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"check_fto_component"}},[_c('h3',[_c('router-link',{attrs:{"to":{ name: 'Calculator' }}},[_vm._v("Check how many FTOs you would get in each mining package"),_c('br',{staticClass:"desktop-only"}),_vm._v(" if you had it now.")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "disk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7JJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eeog":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_CommissionsContent_vue__ = __webpack_require__("dDZh");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], CommissionsContent: __WEBPACK_IMPORTED_MODULE_1__content_CommissionsContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "ekDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('owner', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "eyzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Codes_vue__ = __webpack_require__("uhZd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2a0d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Codes_vue__ = __webpack_require__("Ur2S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Codes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2a0d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Codes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ezXG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f+9K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f0Ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('account_owner') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_account_owner"}},[_vm._v("\n            Account owner\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_account_owner","name":"account_owner","type":"text","data-vv-rules":"required|max:255","data-vv-as":"account owner","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('account_owner') && _vm.showErrors ),expression:"errors.has('account_owner') && showErrors "}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('account_owner')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f11k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    },
    methods: {
        toggleMenu: function toggleMenu() {
            this.$store.commit('toggleMobileMenu');
        }
    }
});

/***/ }),

/***/ "f1H9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f1MP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['invoice', 'money'],
    data: function data() {
        return {
            tableHeaders: {
                date: 'Date',
                value: 'Value',
                invoice: 'Invoice'
            },
            generatingQueue: []
        };
    },

    computed: {
        tableRows: function tableRows() {
            return this.$store.getters.packages;
        }
    },
    methods: {
        isVerified: function isVerified() {
            return this.$store.getters.user.isVerified;
        },
        IsGenerateButtonVisible: function IsGenerateButtonVisible(invoiceId) {
            return !invoiceId;
        },
        GenerateInvoice: function GenerateInvoice(packageId) {
            this.$store.commit('addPackageToQueue', packageId);
            this.invoice.generateInvoice(packageId);
        },
        IsInvoiceGenerating: function IsInvoiceGenerating(packageId) {
            return this.$store.getters.getGeneratingQueue.indexOf(packageId) > -1;
        },
        GetDownloadLink: function GetDownloadLink(invoiceId) {
            return this.invoice.getDownloadLink(invoiceId);
        }
    }
});

/***/ }),

/***/ "fKhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_stp_component"}},[_c('p',[_vm._v("2Pay4You")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('country',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('wallet-name',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('description',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fNFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_CheckFnwallet_vue__ = __webpack_require__("EjMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marketing_plan_MarketingPlanItem_vue__ = __webpack_require__("ySsK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CheckFnwallet: __WEBPACK_IMPORTED_MODULE_1__dashboard_CheckFnwallet_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__["a" /* default */], MarketingPlanItem: __WEBPACK_IMPORTED_MODULE_3__marketing_plan_MarketingPlanItem_vue__["a" /* default */] },
    data: function data() {
        return {
            items: {
                1: {
                    label: 'FuturoNetwork marketing plan EN',
                    link: 'https://download.futurenet.club/futuro/FuturoNetwork_MarketingPlan_(EN).pdf'
                },
                2: {
                    label: 'FuturoNetwork marketing plan PL',
                    link: 'https://download.futurenet.club/futuro/FuturoNetwork_MarketingPlan_(PL).pdf'
                },
                3: {
                    label: 'FuturoNetwork marketing plan CN',
                    link: 'https://download.futurenet.club/futuro/FuturoNetwork_MarketingPlan_(CN).pdf'
                }
            }
        };
    },

    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        },
        isBanned: function isBanned() {
            var isBanned = this.$store.getters.isBanned;

            return !isBanned && (typeof isBanned === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(isBanned)) !== 'object';
        }
    }
});

/***/ }),

/***/ "fRpT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fW/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "fd+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCode_vue__ = __webpack_require__("J8c5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f59086_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCode_vue__ = __webpack_require__("wd+b");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f59086_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ffds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodesList_vue__ = __webpack_require__("93WT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c4efb9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodesList_vue__ = __webpack_require__("kZ4d");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c4efb9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fhvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"col":"","lg":"1","cols":"1"}},[(_vm.levelIndex > 0)?_c('div',{staticClass:"my-team-tree__level"},[_c('p',[_vm._v("Level "+_vm._s(_vm.levelIndex))])]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"col":"","lg":"11","cols":"10"}},[_c('div',{staticClass:"my-team-tree__carousel"},[(_vm.controlsVisible)?_c('div',{staticClass:"my-team-tree__carousel__controls"},[_c('div',{staticClass:"my-team-tree__carousel__controls__prev",on:{"click":function($event){return _vm.CarouselScrollPrev()}}},[_vm._v("<")]),_vm._v(" "),_c('div',{staticClass:"my-team-tree__carousel__controls__next",on:{"click":function($event){return _vm.CarouselScrollNext()}}},[_vm._v(">")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"touch",rawName:"v-touch:swipe.left",value:(_vm.CarouselScrollNext),expression:"CarouselScrollNext",arg:"swipe",modifiers:{"left":true}},{name:"touch",rawName:"v-touch:swipe.right",value:(_vm.CarouselScrollPrev),expression:"CarouselScrollPrev",arg:"swipe",modifiers:{"right":true}}],staticClass:"my-team-tree__carousel__wrapper"},[(!_vm.items.length)?_c('div',{staticClass:"my-team-tree__carousel__wrapper__no-results"},[_vm._v("\n                    No results\n                ")]):_vm._e(),_vm._v(" "),(_vm.items.length)?_c('div',{staticClass:"my-team-tree__carousel__wrapper__container",class:{ 'animation-available': _vm.isLoaded },style:([_vm.getCarouselWidth, _vm.setPosition])},_vm._l((_vm.items),function(item,index){return _c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element",class:{
                            'active' : _vm.isElementActive === item.login || _vm.levelIndex === 0,
                            'inactive' : (_vm.isElementActive !== item.login && _vm.isElementSelected && _vm.levelIndex > 0),
                            'detailed': _vm.isDetailed === item.login },style:([_vm.getElementWidth])},[_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__data",on:{"click":function($event){return _vm.LoadNextLevel(item, index, _vm.levelIndex, $event)}}},[_c('span',[_vm._v(_vm._s(item.login))]),_vm._v(" "),(_vm.isDetailed === item.login)?_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : 'bottom',  arrow: true }),expression:"{ placement : 'bottom',  arrow: true }"}],staticClass:"my-team-tree__carousel__wrapper__container__element__data__email mdi mdi-email",attrs:{"title":item.email,"href":'mailto:' + item.email}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__connector"},[_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__connector__horizontal"})]),_vm._v(" "),_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__circle"}),_vm._v(" "),_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__handler"},[_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__handler__holder",on:{"click":function($event){return _vm.LoadNextLevel(item, index, _vm.levelIndex, $event)}}}),_vm._v(" "),(_vm.levelIndex > 0)?_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__handler__coin"},[_c('img',{attrs:{"src":_vm.GetCoinPath(item.career_level)}})]):_vm._e(),_vm._v(" "),(_vm.levelIndex > 0)?_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__handler__counts"},[_vm._v(_vm._s(item.children_count))]):_vm._e(),_vm._v(" "),(_vm.levelIndex === 1)?_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__handler__button",on:{"click":function($event){return _vm.ShowDetails(item)}}},[(_vm.isDetailed === item.login)?_c('div',{staticClass:"my-team-tree__carousel__wrapper__container__element__handler__button--close"},[_vm._v("x")]):_vm._e(),_vm._v(" "),(_vm.isDetailed !== item.login)?_c('div',[_vm._v("show details")]):_vm._e()]):_vm._e()])])}),0):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fimc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bottombar_vue__ = __webpack_require__("X8Za");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701ad224_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bottombar_vue__ = __webpack_require__("5kAD");
function injectStyle (ssrContext) {
  __webpack_require__("f+9K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-701ad224"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bottombar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701ad224_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bottombar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fncw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc27f80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error500Content_vue__ = __webpack_require__("QP14");
function injectStyle (ssrContext) {
  __webpack_require__("MHzj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fc27f80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc27f80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error500Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fqG+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'',"title":'Transfer history'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('futurocoin-history-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fyYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"commissions_total_component",attrs:{"id":"commissions_total_component"}},[_c('b-col',{attrs:{"lg":"3","cols":"6"}},[_c('div',{staticClass:"commissions-total-label"},[_c('p',[_vm._v("My frontliners:")])]),_vm._v(" "),_c('div',{staticClass:"commissions-total-value"},[_c('p',[_vm._v(_vm._s(_vm.frontliners))])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","cols":"6"}},[_c('div',{staticClass:"commissions-total-label"},[_c('p',[_vm._v("My unilevel team:")])]),_vm._v(" "),_c('div',{staticClass:"commissions-total-value"},[_c('p',[_vm._v(_vm._s(_vm.tenLevelTeam))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g0Pl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g5xZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutForm_vue__ = __webpack_require__("qzqf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288d31ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutForm_vue__ = __webpack_require__("/6pU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288d31ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g81O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('bitcoin_account_number') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_bitcoin_account_number"}},[_vm._v("\n            Bitcoin account number\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_bitcoin_account_number","name":"bitcoin_account_number","type":"text","data-vv-rules":"required|max:255","data-vv-as":"Bitcoin account number","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bitcoin_account_number') && _vm.showErrors),expression:"errors.has('bitcoin_account_number') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('bitcoin_account_number')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gIBB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/futuronetwork-logo.be61d74.png";

/***/ }),

/***/ "gRVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('packs-header'),_vm._v(" "),_c('packs-table')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gVFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"header-stats-component",attrs:{"id":"header_stats_component"}},[_c('b-col',{staticClass:"mobile-only stats-element--header",attrs:{"cols":"12","order":"0"}},[_vm._v("My last income")]),_vm._v(" "),_c('b-col',{staticClass:"mobile-only stats-element--header",attrs:{"cols":"12","order":"4"}},[_vm._v("My last turnover")]),_vm._v(" "),_vm._l((_vm.stats),function(stat,index){return _c('b-col',{key:index,staticClass:"stats-element",attrs:{"lg":"4","cols":"4","order":index}},[_c('div',{staticClass:"stats-element--inside"},[_c('div',{staticClass:"stats-element--label"},[_c('span',{staticClass:"mobile-only"},[_vm._v(_vm._s(stat.label_mobile))]),_vm._v(" "),_c('span',{staticClass:"desktop-only"},[_vm._v(_vm._s(stat.label))])]),_vm._v(" "),_c('div',{staticClass:"stats-element--amount"},[_vm._v("\n                FND "+_vm._s(stat.value)+"\n            ")])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "giZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorContent_vue__ = __webpack_require__("Y8HF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27acca25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorContent_vue__ = __webpack_require__("+8Je");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27acca25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "glna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['transfer'],
    computed: {
        coins: function coins() {
            return this.$store.getters.modals.withdrawCoins.coins;
        },
        modal: function modal() {
            return this.$store.getters.modals.withdrawCoins.visible;
        }
    },
    methods: {
        accept: function accept() {
            var _this = this;

            this.transfer.process(this.$store.getters.modals.withdrawCoins.type, this.$store.getters.modals.withdrawCoins.coins).then(function () {
                var params = {
                    modal: 'withdrawCoins',
                    data: {
                        visible: false,
                        coins: _this.$store.getters.modals.withdrawCoins.coins,
                        type: _this.$store.getters.modals.withdrawCoins.type,
                        accept: true
                    }
                };
                _this.$store.commit('modals', params);
            });
        },
        hideModal: function hideModal() {
            var params = {
                modal: 'withdrawCoins',
                data: {
                    visible: false,
                    coins: 0,
                    type: 'mining',
                    accept: false
                }
            };
            this.$store.commit('modals', params);
        }
    }
});

/***/ }),

/***/ "gp3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_SponsorSystemContent_vue__ = __webpack_require__("iHt5");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], SponsorSystemContent: __WEBPACK_IMPORTED_MODULE_1__content_SponsorSystemContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "gsB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FNProductPacks_vue__ = __webpack_require__("TwYr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b4a759_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FNProductPacks_vue__ = __webpack_require__("ahAk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FNProductPacks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b4a759_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FNProductPacks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gw2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("wNWf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed1ed7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("SPsr");
function injectStyle (ssrContext) {
  __webpack_require__("nn+r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ed1ed7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed1ed7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gyX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"futurocoin-from-mining-component",attrs:{"no-gutters":"","id":"futurocoin_from_mining_component"}},[_c('b-col',{staticClass:"futurocoin-from-mining-inner",attrs:{"lg":"8"}},[_c('div',{staticClass:"futurocoin-from-mining-banner"},[(_vm.amount !== '-')?_c('span',[_vm._v("\n                Your FuturoCoins from mining: "+_vm._s(_vm.amount)+" FTO\n            ")]):_c('span',[_vm._v("\n                FTO are being counted\n                 "),_c('div',{staticClass:"data-loader__inline"})])])]),_vm._v(" "),(_vm.hidePayout)?_c('header-button',{attrs:{"button-label":_vm.buttonLabel,"button-link":_vm.buttonLink}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8yr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('city') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_city"}},[_vm._v("\n            City\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_city","name":"city","type":"text","data-vv-rules":"required|max:255","data-vv-as":"city","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('city') && _vm.showErrors),expression:"errors.has('city') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('city')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hB2s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'business',"title":'Commissions'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('commissions-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hGOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserData_vue__ = __webpack_require__("DmGi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a82e4d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserData_vue__ = __webpack_require__("Vsm8");
function injectStyle (ssrContext) {
  __webpack_require__("KzCJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a82e4d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a82e4d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hJ60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "haes":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');

var CareerLevel = function () {
    function CareerLevel() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CareerLevel);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CareerLevel, [{
        key: 'fetchData',
        value: function fetchData() {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(api.careerLevel.next).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setQualifications', response.data);
            });
        }
    }]);

    return CareerLevel;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('careerLevel', CareerLevel);

/***/ }),

/***/ "hbbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "hhj0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hv3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-component",attrs:{"id":"box_component"}},[_c('div',{staticClass:"box-component-inner"},[_c('h2',[_vm._v("Two-step verification")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('div',{staticClass:"mw--360"},[_c('p',[_vm._v("Enter your token below:")]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': (_vm.errors.has('token') && _vm.showErrors) || _vm.incorrect }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"login_token","name":"token","data-vv-rules":"required","data-vv-as":"token","disabled":_vm.progress,"type":"text"},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('token') && _vm.showErrors),expression:"errors.has('token') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('token')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.incorrect),expression:"incorrect"}],staticClass:"field-error--description"},[_vm._v("Incorrect token. Try again.")])])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button--primary login",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Confirm")]),_vm._v(" "),_c('p',{staticClass:"button--text",on:{"click":function($event){return _vm.changeView(0)}}},[_vm._v("Back to login")])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v("\n\n                If You have problem in two-step verification,"),_c('br'),_vm._v("\n                please contact with our support team by e-mail\n                "),_c('a',{attrs:{"href":"mailto: futuronetwork.help@gmail.com "}},[_vm._v("futuronetwork.help@gmail.com ")]),_vm._v(".\n                "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hzzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('payza_email') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_payza_email"}},[_vm._v("\n            Payza email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_payza_email","name":"payza_email","type":"text","data-vv-rules":"required|max:255|email","data-vv-as":"Payza email","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('payza_email') && _vm.showErrors),expression:"errors.has('payza_email') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('payza_email')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("MEVT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1756f02c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("2rtx");
function injectStyle (ssrContext) {
  __webpack_require__("X131")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1756f02c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i2Wu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iGZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['packet'],
    data: function data() {
        return {
            tableData: {
                0: {
                    tableHeaders: {
                        0: 'My start package',
                        100: 'FND 100',
                        250: 'FND 250',
                        500: 'FND 500',
                        1000: 'FND 1000',
                        5000: 'FND 5000',
                        10000: 'FND 10000',
                        25000: 'FND 25000'
                    },
                    tableRows: {
                        1: {
                            0: 'Level 1',
                            100: '1%',
                            250: '2%',
                            500: '2%',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        2: {
                            0: 'Level 2',
                            100: '1%',
                            250: '2%',
                            500: '2%',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        3: {
                            0: 'Level 3',
                            100: '1%',
                            250: '2%',
                            500: '2%',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        4: {
                            0: 'Level 4',
                            100: '1%',
                            250: '2%',
                            500: '2%',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        5: {
                            0: 'Level 5',
                            100: '',
                            250: '2%',
                            500: '2%',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        6: {
                            0: 'Level 6',
                            100: '',
                            250: '',
                            500: '2%',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        7: {
                            0: 'Level 7',
                            100: '',
                            250: '',
                            500: '',
                            1000: '3%',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        8: {
                            0: 'Level 8',
                            100: '',
                            250: '',
                            500: '',
                            1000: '',
                            5000: '3%',
                            10000: '3%',
                            25000: '3%'
                        },
                        9: {
                            0: 'Level 9',
                            100: '',
                            250: '',
                            500: '',
                            1000: '',
                            5000: '',
                            10000: '3%',
                            25000: '3%'
                        },
                        10: {
                            0: 'Level 10',
                            100: '',
                            250: '',
                            500: '',
                            1000: '',
                            5000: '',
                            10000: '',
                            25000: '3%'
                        }
                    }
                },
                1: {
                    tableHeaders: {
                        0: 'level / no. of frontliners',
                        1: '100 FND own pack',
                        2: '5<br>frontliners',
                        3: '8<br>frontliners',
                        4: '10 frontliners',
                        5: '15 frontliners',
                        6: '20 frontliners',
                        7: '30 frontliners'
                    },
                    tableRows: {
                        1: {
                            0: 'Level 1',
                            1: '1%',
                            2: '2%',
                            3: '2%',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        2: {
                            0: 'Level 2',
                            1: '1%',
                            2: '2%',
                            3: '2%',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        3: {
                            0: 'Level 3',
                            1: '1%',
                            2: '2%',
                            3: '2%',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        4: {
                            0: 'Level 4',
                            1: '1%',
                            2: '2%',
                            3: '2%',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        5: {
                            0: 'Level 5',
                            1: '',
                            2: '2%',
                            3: '2%',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        6: {
                            0: 'Level 6',
                            1: '',
                            2: '',
                            3: '2%',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        7: {
                            0: 'Level 7',
                            1: '',
                            2: '',
                            3: '',
                            4: '3%',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        8: {
                            0: 'Level 8',
                            1: '',
                            2: '',
                            3: '',
                            4: '',
                            5: '3%',
                            6: '3%',
                            7: '3%'
                        },
                        9: {
                            0: 'Level 9',
                            1: '',
                            2: '',
                            3: '',
                            4: '',
                            5: '',
                            6: '3%',
                            7: '3%'
                        },
                        10: {
                            0: 'Level 10',
                            1: '',
                            2: '',
                            3: '',
                            4: '',
                            5: '',
                            6: '',
                            7: '3%'
                        }
                    }
                }
            },
            packets: {
                0: '0',
                100: 'FND 100',
                250: 'FND 250',
                500: 'FND 500',
                1000: 'FND 1000',
                5000: 'FND 5000',
                10000: 'FND 10000',
                25000: 'FND 25000'
            },
            loader: false
        };
    },

    computed: {
        startPacket: function startPacket() {
            // Need to be increased by 1 for second table
            return this.HasUnilevelBonusFromFrontliners() ? (this.$store.getters.user.frontliners_unilevel_group + 1).toString() : this.$store.getters.user.position;
        }
    },
    methods: {
        GetTableHeader: function GetTableHeader() {
            return this.tableData[this.HasUnilevelBonusFromFrontliners()].tableHeaders;
        },
        GetTableRows: function GetTableRows() {
            return this.tableData[this.HasUnilevelBonusFromFrontliners()].tableRows;
        },
        HasUnilevelBonusFromFrontliners: function HasUnilevelBonusFromFrontliners() {
            return this.$store.getters.user.has_unilevel_bonus_from_frontliners ? 1 : 0;
        },
        buyPacket: function buyPacket(index) {
            this.packet.create(index);
            this.$store.commit('modals', {
                modal: 'buyPacket',
                data: {
                    visible: true,
                    message: 'Are you sure you want to buy this package?',
                    packet: this.packet
                }
            });
        }
    }
});

/***/ }),

/***/ "iHt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SponsorSystemContent_vue__ = __webpack_require__("/5OG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fd7ade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SponsorSystemContent_vue__ = __webpack_require__("HtOP");
function injectStyle (ssrContext) {
  __webpack_require__("tXs5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68fd7ade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SponsorSystemContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fd7ade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SponsorSystemContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iIA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_Checkbox__ = __webpack_require__("7o89");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Checkbox: __WEBPACK_IMPORTED_MODULE_0__fields_Checkbox__["a" /* default */] },
    dependencies: ['popup', 'terms', 'user'],
    data: function data() {
        return {
            areChanges: false,
            progress: false,
            showErrors: false,
            signatures: []
        };
    },

    computed: {
        termsAccepted: function termsAccepted() {
            return this.$store.getters.user.terms_of_use_accepted;
        },
        termsList: function termsList() {
            return this.$store.getters.terms;
        },
        userFromUe: function userFromUe() {
            return this.$store.getters.user.isFromUe;
        }
    },
    methods: {
        getValue: function getValue(name) {
            return this.signatures.filter(function (obj) {
                if (obj.regulation === name) {
                    return !!obj.accepted;
                }
            })[0];
        },
        updateValue: function updateValue(name, value) {

            var messages = {
                'consent-to-data-processing-for-marketing-purposes': 'Withdrawal of consent means no access to marketing information.',
                'consent-to-sending-commercial-information-by-email': 'Withdrawal of consent means no access to our newsletter.',
                'declaration-of-familiarization-with-the-information-clause': 'Withdrawal of consent means blocking your accounts and therefore you will lose access to them.',
                'declaration-of-familiarization-with-the-regulations': 'Withdrawal of consent means blocking your accounts and therefore you will lose access to them.'
            };

            this.signatures.filter(function (obj) {
                if (obj.regulation === name) {
                    obj.accepted = value ? 1 : 0;
                }
            });

            this.areChanges = true;

            if (!value) this.popup.show(messages[name]);
        },
        validate: function validate() {
            var _this = this;

            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    if (_this.areChanges) {
                        _this.showErrors = false;
                        _this.submit();
                    }
                } else {
                    _this.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;
            this.terms.sign(this.signatures).then(function () {
                _this2.progress = false;
                _this2.user.reloadData().then(function () {
                    _this2.$router.push('/');
                    _this2.popup.show('Thank you for submmiting and thank you for being part of FutureNet.', 'OK', false);
                });
            });
        }
    },
    created: function created() {
        var _this3 = this;

        this.terms.fetchData().then(function () {
            for (var term in _this3.termsList) {
                _this3.signatures.push({
                    regulation: _this3.termsList[term].key,
                    accepted: 0
                });
            }
        });
    },
    mounted: function mounted() {
        var _this4 = this;

        this.terms.setAccepted().then(function () {
            var acceptedList = _this4.$store.getters.acceptedTerms;

            for (var term in acceptedList) {
                if (acceptedList[term].accepted) {
                    _this4.updateValue(acceptedList[term].key, true);
                }
            }
        });
    }
});

/***/ }),

/***/ "iN9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






__webpack_require__("C/dE");

var api = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('api');
var popup = __WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.get('popup');

var Code = function () {
    function Code() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Code);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Code, [{
        key: 'fetchList',
        value: function fetchList(params) {
            var url = params ? api.codes.list(params) : api.codes.list(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.listSettings);
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('startListLoading');
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(url).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setList', response.body);
            });
        }
    }, {
        key: 'confirmCode',
        value: function confirmCode(hash) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('startListLoading');
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(api.codes.confirm, { hash: hash }).then(function () {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('listSetPage', 1).then(function () {
                    _this.fetchList();
                    popup.show('Congratulations! You have confirmed your voucher.');
                });
            }).catch(function (error) {
                popup.show(error.body.errors[0].message);
            });
        }
    }, {
        key: 'cancelCode',
        value: function cancelCode(code) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('startListLoading');
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(api.codes.cancel, { codeId: code.codeId }).then(function () {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('listSetPage', 1).then(function () {
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('cancelCode', code);
                    _this2.fetchList();
                });
            }).catch(function (error) {
                popup.show(error.body.message);
            });
        }
    }, {
        key: 'createCode',
        value: function createCode(amount) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('startCreateLoading');
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(api.codes.create, { amount: amount }).then(function () {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('listSetPage', 1).then(function () {
                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('stopCreateLoading');
                    _this3.fetchList();
                });
            }).catch(function (error) {
                popup.show(error.body.errors[0].message);
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('stopCreateLoading');
            });
        }
    }]);

    return Code;
}();

__WEBPACK_IMPORTED_MODULE_3_vue_inject___default.a.service('code', Code);

/***/ }),

/***/ "iQo2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iR4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"form-item form-item-select",class:{ 'field-error': _vm.errors.has('currency') && _vm.showErrors }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedId),expression:"selectedId"}],attrs:{"type":"hidden","id":"payout_currency"},domProps:{"value":(_vm.selectedId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedId=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"form-label",attrs:{"for":"payout_currency_label"}},[_vm._v("Account currency")]),_vm._v(" "),_c('div',{staticClass:"select-outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedValue),expression:"selectedValue"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","id":"payout_currency_label","name":"currency","data-vv-rules":"required","data-vv-as":"account currency","readonly":true,"disabled":_vm.sending},domProps:{"value":(_vm.selectedValue)},on:{"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.selectedValue=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList && !_vm.sending),expression:"openList && !sending"}]},_vm._l((_vm.options),function(option,index){return _c('li',{key:index,on:{"click":function($event){_vm.setItem(index, option), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v(_vm._s(option))])}),0),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('currency') && _vm.showErrors),expression:"errors.has('currency') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('currency')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iiO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('p',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("Commission statements for each month are ready after 14 days.")]),_vm._v(" "),(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style2"},[_c('thead',[_c('tr',{staticClass:"business-qualifications-header-table"},_vm._l((_vm.tableHeaders),function(header,headerId){return _c('th',{key:headerId},[_c('p',[_vm._v(_vm._s(header))])])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableRows),function(statement,index){return (_vm.tableRows.length > 0)?_c('tr',{staticClass:"row-items"},[_c('td',[_vm._v("\n                        "+_vm._s(statement.date_from)+" - "+_vm._s(statement.date_to)+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v("\n                        FND "+_vm._s(_vm.money.format(statement.total_amount, 'fnd'))+"\n                    ")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button--primary",attrs:{"href":_vm.downloadLink(statement.month_period),"target":"_blank"}},[_vm._v("Download PDF")])])]):_vm._e()}),0)]),_vm._v(" "),(_vm.tableRows.length <= 0 && !_vm.loader)?_c('p',{staticStyle:{"margin":"24px 0"}},[_vm._v("No results.")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "inPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__ = __webpack_require__("3Zlc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ada4d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__ = __webpack_require__("OAkg");
function injectStyle (ssrContext) {
  __webpack_require__("disk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24ada4d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ada4d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iuKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"marketing-plan-item"},[_c('b-col',{staticClass:"marketing-plan-item--label",attrs:{"lg":"4","cols":"9"}},[_c('p',[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('b-col',{staticClass:"marketing-plan-item--button",attrs:{"lg":"4","cols":"3"}},[_c('a',{staticClass:"button--primary",attrs:{"href":_vm.link,"target":"_blank"}},[_c('span',{staticClass:"desktop-only"},[_vm._v("Download")]),_c('i',{staticClass:"fa fa-download mobile-only",attrs:{"aria-hidden":"true"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iwU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iz9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-menu",class:{'active' : _vm.mobileMenu},attrs:{"col":"","lg":"3","id":"section_menu"}},[_c('div',{staticClass:"section-menu-title desktop-only"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{staticClass:"section-menu-inner"},[_c('ul',{staticClass:"section-menu-list"},_vm._l((_vm.menu),function(item,index){return _c('section-menu-item',{key:index,attrs:{"item":item,"index":index,"active":_vm.active,"no-packet":item.noPacket ? true : false,"no-packet-path":item.noPacketPath,"mobile-only":item.mobileOnly,"lv2":item.lv2 ? item.lv2 : false}})}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j9I8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jG/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'popup', 'recaptcha', 'status', 'user'],
    props: ['captchaValue'],
    data: function data() {
        return {
            incorrect: false,
            progress: false,
            showErrors: false,
            token: ''
        };
    },

    computed: {
        verificationType: function verificationType() {
            return this.$store.getters.settings.confirmations.twoStepLogin;
        }
    },
    methods: {
        changeView: function changeView(view) {
            var _this = this;

            this.$store.commit('loginFormView', 2);
            setTimeout(function () {
                _this.$store.commit('loginFormView', view);
            }, 600);
        },
        loginSuccess: function loginSuccess(data) {
            this.progress = false;
            this.user.fetchData(data);
            this.$router.push({ name: 'Dashboard' });
        },
        validate: function validate(e) {
            this.showErrors = false;
            this.$validator.validateAll();

            if (!this.errors.any()) {
                this.submit();
            } else {
                this.showErrors = true;
            }
        },
        submit: function submit() {
            var _this2 = this;

            this.incorrect = false;
            this.progress = true;
            var username = document.querySelector('#field_username').value,
                password = document.querySelector('#field_password').value;

            this.$http.post(this.api.auth.login, {
                _username: username,
                _password: password,
                token: this.token,
                'g-recaptcha-response': this.captchaValue
            }).then(function (response) {
                _this2.loginSuccess(response.data);
                _this2.recaptcha.SetRecaptchaResponse(null);
            }, function (error) {
                setTimeout(function () {
                    _this2.progress = false;
                    switch (error.status) {
                        case 423:
                            _this2.incorrect = true;
                            break;
                        default:
                            if (_this2.status['status' + error.status]) {
                                _this2.status['status' + error.status]();
                            } else {
                                _this2.popup.show(error.data.errors[0].message);
                            }
                    }
                }, 1000);
            });
        }
    }
});

/***/ }),

/***/ "jSJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("GVad");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4850a8b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("O7iR");
function injectStyle (ssrContext) {
  __webpack_require__("ABJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4850a8b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4850a8b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jVbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ComingSoon_vue__ = __webpack_require__("SM57");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ComingSoon: __WEBPACK_IMPORTED_MODULE_0__common_ComingSoon_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */] }
});

/***/ }),

/***/ "jW2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_CalculatorContent_vue__ = __webpack_require__("giZg");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], CalculatorContent: __WEBPACK_IMPORTED_MODULE_1__content_CalculatorContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "jdrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        exchangeRate: function exchangeRate() {
            return this.$store.getters.exchangeRate;
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('loadExchangeRate');
    }
});

/***/ }),

/***/ "jgsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.addClass},[_c('div',{staticClass:"form-item form-checkbox",class:{ 'form-item--error': _vm.errors.has(_vm.name) && _vm.showErrors }},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"checkbox","name":_vm.name,"id":'register_form_' + _vm.name,"data-vv-rules":_vm.rules,"data-vv-as":_vm.label,"disabled":_vm.progress},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":'register_form_' + _vm.name},domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"check"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.name) && _vm.showErrors),expression:"errors.has(name) && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first(_vm.name)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jlXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Param_vue__ = __webpack_require__("cXYc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b8ae90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Param_vue__ = __webpack_require__("CZa5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Param_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b8ae90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Param_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "joDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'user'],
    props: ['items', 'levelIndex', 'index'],
    data: function data() {
        return {
            config: {
                elementWidth: 150,
                elementsVisible: {
                    desktop: 5,
                    mobile: 1
                }
            },
            carousel: {
                container: 0,
                wrapper: 0,
                offset: 0,
                active: -1,
                loaded: false,
                detailed: [-1, -1]
            }
        };
    },

    mounted: function mounted() {
        // Get first row after 'me'
        if (this.levelIndex === 0) {
            this.LoadNextLevel();
        }

        // Set initial row center
        var _container = this.$el.querySelector('.my-team-tree__carousel__wrapper__container');
        var _wrapper = this.$el.querySelector('.my-team-tree__carousel__wrapper');

        this.carousel.container = _container ? _container.offsetWidth : null;
        this.carousel.wrapper = _wrapper ? _wrapper.offsetWidth : null;
        var _this = this;

        // Add information in next digest to prevent problem with animation at the first stage
        // 333ms was set into CSS animations
        setTimeout(function () {
            _this.carousel.loaded = true;
        }, 333);

        // Simulate a set item as active when loading whole tree
        var _index = this.$store.getters.getTreePath[this.levelIndex + 1];
        var _tree = this.$store.getters.getTree[this.levelIndex];
        if (_index) {
            var _numberOfItems = _tree.length;
            var _median = parseInt(_numberOfItems / 2);
            this.carousel.active = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_index)).index;

            if (this.carousel.active > -1) {
                this.carousel.offset = this.carousel.active - _median;
                this.setPosition;
            }
        }
    },
    computed: {
        getElementWidth: function getElementWidth() {
            return {
                width: this.config.elementWidth + 'px'
            };
        },

        getCarouselWidth: function getCarouselWidth() {
            return {
                width: this.items.length * this.config.elementWidth + 'px'
            };
        },

        getCurrentUserLevel: function getCurrentUserLevel() {
            return this.$store.getters.getTree[0][0];
        },

        getActiveUser: function getActiveUser() {
            return this.$store.getters.getTreePath[this.levelIndex + 1];
        },

        controlsVisible: function controlsVisible() {
            return this.items.length > this.config.elementsVisible.desktop;
        },

        isElementActive: function isElementActive() {
            return this.$store.getters.getTreePath[this.levelIndex + 1] ? this.getActiveUser.login : false;
        },

        isElementSelected: function isElementSelected() {
            return this.$store.getters.getTreePath[this.levelIndex + 1];
        },

        isLoaded: function isLoaded() {
            return this.carousel.loaded;
        },

        setPosition: function setPosition() {

            // Different placement for even and odd circles
            var _isOdd = this.items.length % 2 === 1;
            var _valueToMove = _isOdd ? 0 : 0.5 * this.config.elementWidth;

            return {
                transform: 'translate(' + ((this.carousel.wrapper - this.carousel.container) / 2 - this.carousel.offset * this.config.elementWidth - _valueToMove) + 'px, 0)'
            };
        },

        isDetailed: function isDetailed() {
            return this.carousel.detailed;
        }
    },
    methods: {

        CarouselScrollPrev: function CarouselScrollPrev() {
            if (Math.abs(this.carousel.offset) < parseInt(this.items.length / 2) || this.carousel.offset === Math.abs(parseInt(this.items.length / 2))) {
                this.carousel.offset--;
                this.setPosition;
            }
        },

        CarouselScrollNext: function CarouselScrollNext() {
            if (Math.abs(this.carousel.offset) < parseInt(this.items.length / 2) || this.carousel.offset === -Math.abs(parseInt(this.items.length / 2))) {
                this.carousel.offset++;
                this.setPosition;
            }
        },

        LoadNextLevel: function LoadNextLevel(item, index, levelIndex, event) {
            var _this2 = this;

            // Do not load if level 0 clicked
            if (levelIndex === 0) {
                return;
            }

            // Do not load if user click on email icon
            if (event) {
                // There is different object for MouseEvent in different browsers
                // Chrome implementation
                if (event.srcElement && event.srcElement.href) {
                    return;
                } else

                    // Firefox implementation
                    if (event.originalTarget && event.originalTarget.href) {
                        return;
                    }
            }

            // Show spinner
            this.$store.commit('ShowTreeLoader', { loading: true });

            if (this.$store.getters.getTree[this.levelIndex + 1] && this.levelIndex > 0) {
                this.$store.commit('BackToLevel', { levelIndex: this.levelIndex + 1 });
            }

            // Set offset to move carousel to valid position only if there is no 0 level
            if (this.levelIndex !== 0) {
                this.carousel.offset = index - parseInt(this.items.length / 2);
            }

            // If item is not defined
            // Get it from stored array
            if (!item) {
                // if no item provided, load logged user first level
                item = this.getCurrentUserLevel;
            }

            // Get data
            this.$http.get(this.api.user.tree.frontliners(item.login)).then(function (frontliners) {

                // In edge cases check if item exist before increase path array
                if (frontliners) {
                    _this2.$store.commit('SetPath', { login: item.login, index: index, levelIndex: _this2.levelIndex });

                    // Set clicked element to active
                    _this2.carousel.active = _this2.getActiveUser.index;
                }

                // Insert level at the bottom of array
                _this2.$store.commit('InsertLevel', { level: frontliners.data.data, levelIndex: _this2.levelIndex });

                // Hide spinner
                _this2.$store.commit('ShowTreeLoader', { loading: false });
            });
        },

        ShowDetails: function ShowDetails(item) {
            this.carousel.detailed = this.carousel.detailed === item.login ? null : item.login;
        },

        GetCoinPath: function GetCoinPath(carrerLevel) {
            return 'static/img/coins/' + carrerLevel + '.png';
        }

    }
});

/***/ }),

/***/ "k0Yb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k5sS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_neteller_component"}},[_c('p',[_vm._v("Neteller")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('neteller-email',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kD/R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kEAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__advcash_AdvcashLogin_vue__ = __webpack_require__("BmrB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], AdvcashLogin: __WEBPACK_IMPORTED_MODULE_1__advcash_AdvcashLogin_vue__["a" /* default */] }
});

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "kOKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "kOpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bankTransfer_Iban_vue__ = __webpack_require__("A8e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bankTransfer_BicSwift_vue__ = __webpack_require__("wXgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Street_vue__ = __webpack_require__("VEGs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Zip_vue__ = __webpack_require__("lHOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_City_vue__ = __webpack_require__("FYx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bankTransfer_AccountOwner_vue__ = __webpack_require__("cNCN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bankTransfer_AccountCurrency_vue__ = __webpack_require__("FbZ5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], Iban: __WEBPACK_IMPORTED_MODULE_1__bankTransfer_Iban_vue__["a" /* default */], BicSwift: __WEBPACK_IMPORTED_MODULE_2__bankTransfer_BicSwift_vue__["a" /* default */], Street: __WEBPACK_IMPORTED_MODULE_3__common_Street_vue__["a" /* default */], Zip: __WEBPACK_IMPORTED_MODULE_4__common_Zip_vue__["a" /* default */], City: __WEBPACK_IMPORTED_MODULE_5__common_City_vue__["a" /* default */], AccountOwner: __WEBPACK_IMPORTED_MODULE_6__bankTransfer_AccountOwner_vue__["a" /* default */], AccountCurrency: __WEBPACK_IMPORTED_MODULE_7__bankTransfer_AccountCurrency_vue__["a" /* default */] }
});

/***/ }),

/***/ "kQNS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__my_team_tree_level_MyTeamTreeLevel_vue__ = __webpack_require__("49/T");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api'],
    mounted: function mounted() {
        if (!this.tree.length) {
            this.$store.commit('SetPath', { login: this.getUser.login, index: 0 });
            this.$store.commit('InsertLevel', {
                level: [{
                    email: this.getUser.email,
                    login: this.getUser.login
                }],
                levelIndex: -1
            });
        }
    },
    components: { MyTeamTreeLevel: __WEBPACK_IMPORTED_MODULE_2__my_team_tree_level_MyTeamTreeLevel_vue__["a" /* default */] },
    computed: {
        tree: function tree() {
            return this.$store.getters.getTree;
        },
        isLoading: function isLoading() {
            return this.$store.getters.getTreeLoading;
        },
        getUser: function getUser() {
            return this.$store.getters.user;
        },
        areButtonsAvailable: function areButtonsAvailable() {
            return this.tree.length > 2;
        }
    },
    methods: {
        loadTree: function loadTree(user) {
            var _this = this;

            // Clear current tree
            this.$store.commit('BackToLevel', { levelIndex: 1 });

            // Update view value
            this.selected = user.login;

            // Get path
            this.$http.get(this.api.user.tree.pathFor(user)).then(function (path) {
                var _promisesArray = [];
                path.data.data.forEach(function (login, key) {
                    _promisesArray.push(_this.$http.get(_this.api.user.tree.frontliners(login)));
                });

                // Resolve all promises
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(_promisesArray).then(function (tree) {
                    tree.forEach(function (level, key) {
                        // Remove vue observer, not necessary
                        var parsedLevel = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(level.data.data));
                        _this.$store.commit('InsertLevel', {
                            level: level.data.data,
                            levelIndex: key
                        });

                        // Do not set path for last child
                        if (tree.length > key + 1) {
                            _this.$store.commit('SetPath', {
                                login: path.data.data[key + 1],
                                levelIndex: key + 1,
                                index: parsedLevel.findIndex(function (frontliner) {
                                    return frontliner.login === path.data.data[key + 1];
                                }) });
                        }
                    });
                });
            });
        },
        backToPreviousLevel: function backToPreviousLevel() {
            if (this.tree.length - 1 > 1) {
                this.$store.commit('BackToLevelWithoutPath', { levelIndex: this.tree.length - 1 });
            }
        },
        treeReset: function treeReset() {
            this.$store.commit('BackToLevelWithoutPath', { levelIndex: 2 });
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.$store.commit('ClearTree');
    }
});

/***/ }),

/***/ "kRJ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutHistoryTable_vue__ = __webpack_require__("37qr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d51d15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutHistoryTable_vue__ = __webpack_require__("u5Eo");
function injectStyle (ssrContext) {
  __webpack_require__("lf4m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d51d15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutHistoryTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d51d15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutHistoryTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kSTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_FuturocoinContent_vue__ = __webpack_require__("xiIz");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], FuturocoinContent: __WEBPACK_IMPORTED_MODULE_1__content_FuturocoinContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "kZ4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codes-list-component",attrs:{"id":"codes_list_component"}},[_c('p',{staticStyle:{"margin-bottom":"11px"}},[_vm._v("Your vouchers")]),_vm._v(" "),_c('div',{staticClass:"codes-list-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.codes.length == 0)?_c('tr',[_c('th',{attrs:{"colspan":"7"}},[_vm._v("You don't have any vouchers yet")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.codes),function(code,index){return _c('tr',{key:code.codeId},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.rowNumber(index)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(code.code))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v("FND "+_vm._s(_vm.money.format(code.value, 'fnd')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.codeStatus(code)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(code.createdAt))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(code.reason ? code.reason : '-'))])]),_vm._v(" "),_c('td',[(code.status == 'new')?_c('button',{staticClass:"button--primary",on:{"click":function($event){return _vm.cancelCode(code)}}},[_vm._v("Cancel")]):_vm._e()])])})],2)])])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('p',[_vm._v("No:")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Voucher:")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Value:")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Status:")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Create Date:")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Reason reject:")])]),_vm._v(" "),_c('th',[_c('p',[_vm._v("Actions:")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kZlc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api'],
    props: ['actionError', 'actionSuccess', 'actionSuccessParams', 'confirmationType', 'message'],
    data: function data() {
        return {
            code: '',
            showErrors: false,
            progress: false
        };
    },

    methods: {
        hideModal: function hideModal() {
            this.actionError();
        },
        validate: function validate() {
            var _this = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.submit();
                } else {
                    _this.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;
            this.actionSuccess(this.actionSuccessParams, this.code).then(function () {
                _this2.progress = false;
                _this2.hideModal();
            }, function () {
                _this2.hideModal();
            });
        }
    }
});

/***/ }),

/***/ "kdA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"title":'Calculator'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('calculator-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "km1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderButton_vue__ = __webpack_require__("lqVk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eebbed0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderButton_vue__ = __webpack_require__("soIc");
function injectStyle (ssrContext) {
  __webpack_require__("F4E9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eebbed0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eebbed0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kmNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-select",class:{ 'field-error': _vm.errors.has('gender') }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genderCode),expression:"genderCode"}],attrs:{"type":"hidden","id":"user_data_gender"},domProps:{"value":(_vm.genderCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.genderCode=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"form-label",attrs:{"for":"user_data_gender"}},[_vm._v("Account type")]),_vm._v(" "),_c('div',{staticClass:"select-outer",class:{ 'disabled': _vm.isVerified }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"},{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","id":"user_data_gender_select","name":"gender","data-vv-rules":"required","readonly":true,"disabled":_vm.sending || _vm.isVerified},domProps:{"value":(_vm.selected)},on:{"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList && !_vm.sending && !_vm.isVerified),expression:"openList && !sending && !isVerified"}]},_vm._l((_vm.genders),function(gender,index){return _c('li',{key:index,on:{"click":function($event){_vm.setItem(index, gender), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v(_vm._s(gender))])}),0),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('gender')),expression:"errors.has('gender')"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('gender')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "koqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Birthdate_vue__ = __webpack_require__("Y0zW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7775cde7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Birthdate_vue__ = __webpack_require__("9L9O");
function injectStyle (ssrContext) {
  __webpack_require__("x1pm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Birthdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7775cde7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Birthdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ks8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__perfectMoney_PerfectMoneyAccountNumber_vue__ = __webpack_require__("m1TP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], PerfectMoneyAccountNumber: __WEBPACK_IMPORTED_MODULE_1__perfectMoney_PerfectMoneyAccountNumber_vue__["a" /* default */] }
});

/***/ }),

/***/ "kvAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_DashboardContent_vue__ = __webpack_require__("wZ9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_InfoModal__ = __webpack_require__("17Xg");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { InfoModal: __WEBPACK_IMPORTED_MODULE_2__modals_InfoModal__["a" /* default */], MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], DashboardContent: __WEBPACK_IMPORTED_MODULE_1__content_DashboardContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "kw3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacket_vue__ = __webpack_require__("/96R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6733a2b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacket_vue__ = __webpack_require__("2jf0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6733a2b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l2xT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l7GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0710690_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckFTO_vue__ = __webpack_require__("dZ8A");
function injectStyle (ssrContext) {
  __webpack_require__("Z+f4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0710690"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0710690_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckFTO_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lEZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_component_vue__ = __webpack_require__("tvzD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cef7fac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_component_vue__ = __webpack_require__("rvNf");
function injectStyle (ssrContext) {
  __webpack_require__("qihF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cef7fac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cef7fac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lHOv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zip_vue__ = __webpack_require__("7Q6j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5039b97c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zip_vue__ = __webpack_require__("AIAa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5039b97c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lIKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_Payout_vue__ = __webpack_require__("+AmT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payout_PayoutForm_vue__ = __webpack_require__("g5xZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'money', 'popup'],
    components: { FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_0__dashboard_FuturocoinsFromMining_vue__["a" /* default */], Payout: __WEBPACK_IMPORTED_MODULE_1__modals_Payout_vue__["a" /* default */], PayoutForm: __WEBPACK_IMPORTED_MODULE_2__payout_PayoutForm_vue__["a" /* default */] },
    data: function data() {
        return {
            amount: 0,
            method: 'bitcoin',
            methods: {
                0: {
                    banktransfer: {
                        name: 'Bank transfer',
                        enabled: false
                    },
                    bitcoin: {
                        name: 'Bitcoin',
                        enabled: true
                    },
                    advcash: {
                        name: 'AdvCash',
                        enabled: false
                    }
                },
                1: {
                    neteller: {
                        name: 'Neteller',
                        enabled: false
                    },
                    payza: {
                        name: 'Payza',
                        enabled: false
                    },
                    perfectmoney: {
                        name: 'Perfect Money',
                        enabled: false
                    },
                    stp: {
                        name: 'Stp',
                        enabled: false
                    }
                    // 'Payment via CoinDeal' : {
                    //     coindeal_futurocoin: {
                    //         name: 'FuturoCoin',
                    //         enabled: true
                    //     },
                    //     coindeal_bitcoin: {
                    //         name: 'Bitcoin',
                    //         enabled: true
                    //     },
                    //     coindeal_litecoin: {
                    //         name: 'Litecoin',
                    //         enabled: true
                    //     },
                    //     coindeal_bitcoin_cash: {
                    //         name: 'Bitcoin Cash',
                    //         enabled: true
                    //     },
                    //     coindeal_dash: {
                    //         name: 'Dash',
                    //         enabled: true
                    //     },
                    //     coindeal_ethereum: {
                    //         name: 'Ethereum',
                    //         enabled: true
                    //     }
                    // }
                } },
            pendingPayouts: 'LOADING',
            progress: false
        };
    },

    computed: {
        accountBalance: function accountBalance() {
            return this.$store.getters.user.moneyBalance;
        },
        isVerified: function isVerified() {
            return this.$store.getters.user.isVerified;
        }
    },
    methods: {
        GetOptionTitle: function GetOptionTitle(option) {
            return option.enabled ? '' : 'Comming soon';
        }
    },
    created: function created() {
        var _this = this;

        this.$http.get(this.api.payout.list({})).then(function (response) {
            var results = response.data.results.filter(function (obj) {
                return obj.status === 'new';
            });
            if (results.length >= 1) {
                _this.pendingPayouts = 'FOUND';
            } else {
                _this.pendingPayouts = 'NOT_FOUND';
            }
        }, function (error) {
            _this.popup.show(error.data.errors[0].message);
        });
    }
});

/***/ }),

/***/ "lV2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsItem_vue__ = __webpack_require__("Scyq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ebe0b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsItem_vue__ = __webpack_require__("PLPJ");
function injectStyle (ssrContext) {
  __webpack_require__("vNdn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45ebe0b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ebe0b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lf4m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("kvAV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd921e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("SUDA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd921e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "logO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorLogo_vue__ = __webpack_require__("FlRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__503_Error503Content_vue__ = __webpack_require__("zSg7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ErrorLogo: __WEBPACK_IMPORTED_MODULE_0__ErrorLogo_vue__["a" /* default */], Error503Content: __WEBPACK_IMPORTED_MODULE_1__503_Error503Content_vue__["a" /* default */] },
    beforeCreate: function beforeCreate() {
        this.$store.commit('setError', {
            status: true,
            code: 503,
            redirect: false
        });
    },
    beforeMount: function beforeMount() {
        this.$store.commit('loginFormView', 2);
    }
});

/***/ }),

/***/ "lqVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['buttonLabel', 'buttonLink']
});

/***/ }),

/***/ "m+H1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('start-packet-header'),_vm._v(" "),_c('start-packet-table'),_vm._v(" "),_c('start-packet-footer'),_vm._v(" "),_c('check-fto'),_vm._v(" "),_c('start-packet-list'),_vm._v(" "),_c('start-packet-update')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m1TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerfectMoneyAccountNumber_vue__ = __webpack_require__("OET/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b393fa8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerfectMoneyAccountNumber_vue__ = __webpack_require__("qUAR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerfectMoneyAccountNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b393fa8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerfectMoneyAccountNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mOA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetellerEmail_vue__ = __webpack_require__("hbbx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193b193a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetellerEmail_vue__ = __webpack_require__("aOSy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetellerEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193b193a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetellerEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mVWM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mZoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['royalBonuses', 'money'],
    computed: {
        royalBonusesList: function royalBonusesList() {
            return this.$store.getters.royalBonuses;
        }
    },
    methods: {
        /**
         * Get data
         */
        getData: function getData() {
            this.royalBonuses.fetchData();
        }
    },
    beforeMount: function beforeMount() {
        this.getData();
    }
});

/***/ }),

/***/ "mdqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036bce02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculating_vue__ = __webpack_require__("oNSE");
function injectStyle (ssrContext) {
  __webpack_require__("cbyq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-036bce02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036bce02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mivH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsContent_vue__ = __webpack_require__("x1A4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af60735e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsContent_vue__ = __webpack_require__("Sd5+");
function injectStyle (ssrContext) {
  __webpack_require__("uPG5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af60735e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessQualificationsContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af60735e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessQualificationsContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjpC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mqfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Type_vue__ = __webpack_require__("QZCM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51226114_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Type_vue__ = __webpack_require__("qCRQ");
function injectStyle (ssrContext) {
  __webpack_require__("uAID")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51226114"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Type_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51226114_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Type_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "myad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"middlebar-component",attrs:{"id":"middlebar_component","no-gutters":""}},[_c('b-col',{staticClass:"header-logo",attrs:{"id":"header_logo","lg":"3","cols":"6"}},[_c('header-logo')],1),_vm._v(" "),_c('b-col',{staticClass:"header-user",attrs:{"id":"header_user","lg":"9","cols":"6"}},[_c('header-user',{staticClass:"desktop-only"}),_vm._v(" "),_c('main-menu-hamburger'),_vm._v(" "),_c('header-options',{staticClass:"desktop-only"})],1),_vm._v(" "),_c('b-col',{staticClass:"header-alert",attrs:{"id":"header_alert","cols":"12"}},[_c('header-cookie-message',{attrs:{"cookie":"message_1","message":"<p class='color--white'>We would like to hereby inform you that distribution of the FuturoNetwork service within the MLM system, which was suspended in the territory of the European Union, Switzerland and the United States, will be ultimately unavailable in the aforementioned destinations.</p>\n        <p class='color--white'>The aforementioned decision is made following the legal regulations effective in these countries.</p>"}})],1),_vm._v(" "),(!_vm.termsAccepted)?_c('b-col',{staticClass:"header-alert",attrs:{"id":"header_alert","cols":"12"}},[_c('header-alert-bottom')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nO8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_inject__);




__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_2_vue_inject___default.a.get('api');

var state = {
    auth: false,
    confirmations: {
        google: false
    },
    isBanned: null,
    location: null,
    loginForm: {
        view: 2
    },
    twoStepVerification: false
};

var getters = {
    /**
     * Check is logged in
     * @param state
     * @returns {boolean|*}
     */
    checkAuth: function checkAuth(state) {
        return state.auth;
    },

    isBanned: function isBanned(state) {
        return state.isBanned;
    },

    location: function location(state) {
        return state.location;
    },

    loginForm: function loginForm(state) {
        return state.loginForm;
    },

    checkTwoStepVerification: function checkTwoStepVerification(state) {
        return state.twoStepVerification;
    }
};

var mutations = {
    banned: function banned(state, isBanned) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'isBanned', isBanned);
    },
    location: function location(state, _location) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'location', _location);
    },
    loginUser: function loginUser(state) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'auth', true);
    },
    logoutUser: function logoutUser(state) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'auth', false);
    },
    confirmTwoStepVerification: function confirmTwoStepVerification(state) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'twoStepVerification', true);
    },
    loginFormData: function loginFormData(state, params) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.loginForm, params.name, params.value);
    },
    loginFormView: function loginFormView(state, view) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.loginForm, 'view', view);
    }
};

var actions = {
    loginUser: function loginUser(_ref) {
        var commit = _ref.commit;

        commit('loginUser');
    },


    /**
     * Logout user
     * @param commit
     */
    logoutUser: function logoutUser(_ref2) {
        var commit = _ref2.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(api.auth.logout).then(function () {
                commit('logoutUser');
                resolve();
            }, function () {
                reject();
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "nP4U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nTAC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "naA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_CheckFnwallet_vue__ = __webpack_require__("EjMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_Security_vue__ = __webpack_require__("r2yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_Settings_vue__ = __webpack_require__("X1Vh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_Verification_vue__ = __webpack_require__("7alQ");
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CheckFnwallet: __WEBPACK_IMPORTED_MODULE_0__dashboard_CheckFnwallet_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */], Security: __WEBPACK_IMPORTED_MODULE_2__profile_Security_vue__["a" /* default */], Settings: __WEBPACK_IMPORTED_MODULE_3__profile_Settings_vue__["a" /* default */], Verification: __WEBPACK_IMPORTED_MODULE_4__profile_Verification_vue__["a" /* default */] },
    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        }
    }
});

/***/ }),

/***/ "nfiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"start-packet-footer-component",attrs:{"no-gutters":"","id":"start_packet_footer_component"}},[_c('b-col',{staticClass:"start-packet-footer-element",attrs:{"lg":"12"}},[_c('ul',{staticClass:"start-packet-footer-list"},[_c('li',{staticClass:"start-packet-footer-item"},[_c('router-link',{attrs:{"to":{ name: 'MarketingPlan' }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ngdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatement_vue__ = __webpack_require__("XD1i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd315c9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatement_vue__ = __webpack_require__("CRx1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyStatement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd315c9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyStatement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nn+r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nvDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_stp_component"}},[_c('p',[_vm._v("STP")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('b-col',{attrs:{"lg":"6"}},[_c('autocomplete-component',{attrs:{"default-value":'',"field-key":'country',"label":'Country',"list":_vm.countries,"rules":{ required: true, isOnList: [_vm.countries] },"show-errors":_vm.showErrors,"update-value":_vm.setValue}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('stp-login',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nyEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_RegisterForm_vue__ = __webpack_require__("+Qm2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { RegisterForm: __WEBPACK_IMPORTED_MODULE_0__partials_RegisterForm_vue__["a" /* default */] },
    computed: {
        view: function view() {
            return this.$store.getters.loginForm.view;
        }
    }
});

/***/ }),

/***/ "nylp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        frontliners: function frontliners() {
            return this.$store.getters.user.frontliners;
        },
        tenLevelTeam: function tenLevelTeam() {
            return this.$store.getters.user.unilevelTeam;
        }
    }
});

/***/ }),

/***/ "nzSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsMobile_vue__ = __webpack_require__("8hLG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab75d538_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsMobile_vue__ = __webpack_require__("IJRl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab75d538_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o/Iy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_CheckFnwallet_vue__ = __webpack_require__("EjMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_edit_data_Birthdate_vue__ = __webpack_require__("koqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_edit_data_Email_vue__ = __webpack_require__("inPW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_edit_data_Gender__ = __webpack_require__("Qk7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__profile_edit_data_Phone_vue__ = __webpack_require__("1cql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profile_edit_data_Textfield_vue__ = __webpack_require__("8VDq");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'popup', 'status', 'user'],
    components: { CheckFnwallet: __WEBPACK_IMPORTED_MODULE_1__dashboard_CheckFnwallet_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__["a" /* default */], Birthdate: __WEBPACK_IMPORTED_MODULE_3__profile_edit_data_Birthdate_vue__["a" /* default */], Email: __WEBPACK_IMPORTED_MODULE_4__profile_edit_data_Email_vue__["a" /* default */], Gender: __WEBPACK_IMPORTED_MODULE_5__profile_edit_data_Gender__["a" /* default */], Phone: __WEBPACK_IMPORTED_MODULE_6__profile_edit_data_Phone_vue__["a" /* default */], Textfield: __WEBPACK_IMPORTED_MODULE_7__profile_edit_data_Textfield_vue__["a" /* default */] },
    data: function data() {
        return {
            progress: false,
            showErrors: false,
            showCompanyFields: false,
            userData: {
                firstName: '',
                lastName: '',
                street: '',
                city: '',
                postalCode: '',
                country: '',
                phoneNumber: '',
                birthDate: '',
                gender: '',
                companyName: '',
                companyRegistrationNumber: ''
            }
        };
    },

    computed: {
        countries: function countries() {
            return this.$store.getters.countries;
        },
        defaultValues: function defaultValues() {
            return this.$store.getters.user;
        },
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position !== 0;
        },
        isVerified: function isVerified() {
            return this.$store.getters.user.isVerified;
        }
    },
    methods: {
        toggleCompanyFields: function toggleCompanyFields(gender) {
            this.showCompanyFields = gender === 'company';
        },
        updateValue: function updateValue(field, value) {
            this.userData[field] = value;
        },
        validate: function validate(e) {
            var _this = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.submit();
                } else {
                    _this.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;

            // Clear company data if gender is not company
            if (this.userData.gender !== 'company') {
                this.userData.companyName = '';
                this.userData.companyRegistrationNumber = '';
            }

            this.$http.post(this.api.user.update, this.userData).then(function (response) {
                _this2.user.reloadData(response.data).then(function () {
                    _this2.popup.show('Data was changed successfully!');
                    _this2.progress = false;
                    _this2.$router.push({ name: 'Profile' });
                });
            }, function (error) {
                var message = error.data.message[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.data.message)[0]];
                switch (error.status) {
                    case 422:
                        _this2.popup.show(message);
                        break;
                    default:
                        if (_this2.status['status' + error.status]) {
                            _this2.status['status' + error.status]();
                        } else {
                            _this2.popup.show(message);
                        }
                }
                _this2.progress = false;
            });
        }
    },
    beforeMount: function beforeMount() {
        var gender = this.$store.getters.user.gender;

        if (gender === 'company') {
            this.showCompanyFields = true;
        }
    }
});

/***/ }),

/***/ "o84U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['autocomplete', 'searchUrl', 'onElementClick'],
    data: function data() {
        return {
            selected: '',
            index: 0,
            sending: false,
            list: [],
            opened: false,
            searchDebounce: null,
            userHovered: null
        };
    },

    methods: {
        debounce: function debounce(value, event) {
            var _this = this;

            // Do not nothing if Tab key pressed
            if (event && event.key === 'Tab' || event.key === 'Enter') {
                return;
            }

            // Own debounce implementations because debounce VUE is deprecated
            // See https://github.com/vuejs/vue/issues/2873
            if (this.searchDebounce) {
                clearTimeout(this.searchDebounce);
            }
            this.searchDebounce = setTimeout(function () {
                return _this.search(value);
            }, 400);
        },
        search: function search(value) {
            var _this2 = this;

            // Do not call API when empty
            if (!value) {
                return;
            }

            this.$http.get(this.searchUrl(value)).then(function (results) {
                _this2.list = results.data.data;
                _this2.openDropdown();
                _this2.selectFirst();
            });
        },
        keydownEvent: function keydownEvent(event) {
            // Do not lost focus when tab key used
            if (event.key === 'Tab') {
                this.selectNext();
                event.preventDefault();
            }

            // Autocomplete when press enter
            if (event.key === 'Enter') {
                var newSelection = this.selected = this.list[this.userHovered].login;
                this.onElementClick(newSelection);
                this.closeDropdown();
            }
        },
        userHover: function userHover(index) {
            this.userHovered = index;
        },
        selectNext: function selectNext() {
            var len = this.list.length;

            if (len <= this.userHovered + 1) {
                this.userHovered = 0;
                this.userHover(0);
            } else {
                this.userHovered++;
            }
        },
        selectFirst: function selectFirst() {
            this.userHovered = 0;
        },
        selectUser: function selectUser(user) {
            this.selected = user;
        },
        isOpened: function isOpened() {
            return this.opened;
        },
        openDropdown: function openDropdown() {
            this.opened = true;
        },
        closeDropdown: function closeDropdown() {
            this.opened = false;
        },
        getList: function getList() {
            return this.list;
        }
    }
});

/***/ }),

/***/ "oNSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counting-component",attrs:{"id":"counting_component"}},[_c('p',[_vm._v("We are calculating your commissions."),_c('br'),_vm._v("It will be visible soon.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oO/w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oRg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_BusinessQualificationsContent_vue__ = __webpack_require__("mivH");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], BusinessQualificationsContent: __WEBPACK_IMPORTED_MODULE_1__content_BusinessQualificationsContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "oVgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advcash_vue__ = __webpack_require__("kEAd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02a5889e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advcash_vue__ = __webpack_require__("UzRq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advcash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02a5889e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advcash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "og54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("Ya4G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2137ec2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("wj9D");
function injectStyle (ssrContext) {
  __webpack_require__("l2xT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2137ec2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2137ec2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ohqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    beforeCreate: function beforeCreate() {
        var _this = this;

        this.$store.commit('loginFormView', 2);
        localStorage.removeItem('infoModal');
        this.$store.dispatch('logoutUser').then(function () {
            _this.$router.push({ name: 'Login' });
        }, function () {
            window.location.reload();
        });
    }
});

/***/ }),

/***/ "ojr2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('password') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_futuro_network_password"}},[_vm._v("\n            FuturoNetwork password\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_futuro_network_password","name":"password","type":"password","data-vv-rules":"required|max:255","data-vv-as":"FuturoNetwork password","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password') && _vm.showErrors),expression:"errors.has('password') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('password')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pXg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionMenuItem_vue__ = __webpack_require__("qdrT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6159458d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionMenuItem_vue__ = __webpack_require__("PQrG");
function injectStyle (ssrContext) {
  __webpack_require__("8fwS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6159458d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6159458d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfAh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "poai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['source'],
    computed: {
        modal: function modal() {
            return this.$store.getters.modals.image.visible;
        }
    },
    methods: {
        hideModal: function hideModal() {
            this.$store.commit('modals', {
                modal: 'image',
                data: {
                    visible: false
                }
            });
        }
    }
});

/***/ }),

/***/ "pvNk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.addClass},[_c('div',{staticClass:"form-item form-checkbox",class:{ 'form-item--error': _vm.errors.has(_vm.name) && _vm.showErrors }},[_c('input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"checkbox","name":_vm.name,"id":'register_form_' + _vm.name,"data-vv-rules":_vm.rules,"data-vv-as":_vm.label,"disabled":_vm.progress},domProps:{"checked":_vm.checked},on:{"click":function($event){return _vm.setValue()}}}),_vm._v(" "),_c('label',{attrs:{"for":'register_form_' + _vm.name},domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"check"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.name) && _vm.showErrors),expression:"errors.has(name) && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v("\n            "+_vm._s(_vm.errors.first(_vm.name))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q8c7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-component",class:{'active' : _vm.mobileMenu},attrs:{"id":"hamburger_component"},on:{"click":function($event){return _vm.toggleMenu()}}},[_c('div',{staticClass:"hamburger-bar hamburger-bar--1"}),_vm._v(" "),_c('div',{staticClass:"hamburger-bar hamburger-bar--2"}),_vm._v(" "),_c('div',{staticClass:"hamburger-bar hamburger-bar--3"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qCRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item form-item-select"},[_c('label',{staticClass:"form-label"},[_vm._v("Filter by type")]),_vm._v(" "),_c('div',{staticClass:"select-outer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedValue),expression:"selectedValue"}],attrs:{"type":"text","name":"filter-type","readonly":true},domProps:{"value":(_vm.selectedValue)},on:{"focus":function($event){_vm.openList = true},"blur":function($event){_vm.openList = _vm.hoverList ? true : false},"input":function($event){if($event.target.composing){ return; }_vm.selectedValue=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.openList),expression:"openList"}]},_vm._l((_vm.types),function(type,index){return _c('li',{key:index,on:{"click":function($event){_vm.setItem(index, type), _vm.openList = false},"mouseover":function($event){_vm.hoverList = true},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v(_vm._s(type))])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qUAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('perfect_money_account_number') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"payout_perfect_money_account_number"}},[_vm._v("\n            Perfect Money account number\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"payout_perfect_money_account_number","name":"perfect_money_account_number","type":"text","data-vv-rules":"required|max:255","data-vv-as":"Perfect Money account number","disabled":_vm.sending},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('perfect_money_account_number') && _vm.showErrors),expression:"errors.has('perfect_money_account_number') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('perfect_money_account_number')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qdrT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['item', 'index', 'lv2', 'active', 'noPacket', 'mobileOnly', 'noPacketPath'],
    data: function data() {
        return {
            submenu: false
        };
    },

    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        },
        menu: function menu() {
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$parent.menu));
        }
    },
    methods: {
        toggleSubmenu: function toggleSubmenu(toggleAvailable) {
            if (toggleAvailable) {
                this.submenu = !this.submenu;
            }
        }
    },
    mounted: function mounted() {
        if (this.active === this.index) {
            this.submenu = true;
        }
    }
});

/***/ }),

/***/ "qihF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qkms":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qo7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StpLogin_vue__ = __webpack_require__("bsDS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc522ac0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StpLogin_vue__ = __webpack_require__("XGuN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StpLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc522ac0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StpLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qsOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['label', 'link']
});

/***/ }),

/***/ "qwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"lg":"4"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('phone') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"user_data_phone"}},[_vm._v("\n            Phone number\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"user_data_phone","name":"phone","type":"text","data-vv-rules":"required|phone|max:255","data-vv-as":"phone","disabled":_vm.sending || _vm.isVerified},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone') && _vm.showErrors),expression:"errors.has('phone') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('phone')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qzqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Amount_vue__ = __webpack_require__("xdf7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BankTransfer_vue__ = __webpack_require__("3Qsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Bitcoin_vue__ = __webpack_require__("dAuT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Coindeal_vue__ = __webpack_require__("DI36");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Neteller_vue__ = __webpack_require__("7w2l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Payza_vue__ = __webpack_require__("xKWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PerfectMoney_vue__ = __webpack_require__("t+0+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Stp_vue__ = __webpack_require__("SYsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Advcash__ = __webpack_require__("oVgz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TwoPayFourYou_vue__ = __webpack_require__("ZLrA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Amount: __WEBPACK_IMPORTED_MODULE_0__common_Amount_vue__["a" /* default */], BankTransfer: __WEBPACK_IMPORTED_MODULE_1__BankTransfer_vue__["a" /* default */], Bitcoin: __WEBPACK_IMPORTED_MODULE_2__Bitcoin_vue__["a" /* default */], Coindeal: __WEBPACK_IMPORTED_MODULE_3__Coindeal_vue__["a" /* default */], Neteller: __WEBPACK_IMPORTED_MODULE_4__Neteller_vue__["a" /* default */], Payza: __WEBPACK_IMPORTED_MODULE_5__Payza_vue__["a" /* default */], PerfectMoney: __WEBPACK_IMPORTED_MODULE_6__PerfectMoney_vue__["a" /* default */], Stp: __WEBPACK_IMPORTED_MODULE_7__Stp_vue__["a" /* default */], Advcash: __WEBPACK_IMPORTED_MODULE_8__Advcash__["a" /* default */], TwoPayFourYou: __WEBPACK_IMPORTED_MODULE_9__TwoPayFourYou_vue__["a" /* default */] },
    dependencies: ['money', 'payout'],
    props: ['method'],
    data: function data() {
        return {
            methodFields: {
                banktransfer: ['identifier', 'owner', 'bic', 'street', 'zip', 'city', 'currency'],
                bitcoin: ['identifier', 'country'],
                neteller: ['identifier', 'country'],
                payza: ['identifier', 'country'],
                perfectmoney: ['identifier', 'country'],
                stp: ['identifier', 'country'],
                advcash: ['identifier', 'country'],
                coindeal_futurocoin: ['identifier', 'country'],
                coindeal_bitcoin: ['identifier', 'country'],
                coindeal_litecoin: ['identifier', 'country'],
                coindeal_bitcoin_cash: ['identifier', 'country'],
                coindeal_dash: ['identifier', 'country'],
                coindeal_ethereum: ['identifier', 'country']
            },
            pendingPayouts: true,
            sending: false,
            amountError: false,
            maxAmountError: false,
            showErrors: false,
            account: {
                amount: '',
                identifier: '',
                owner: '',
                bic: '',
                street: '',
                zip: '',
                city: '',
                country: '',
                currency: '',
                description: '',
                password: ''
            },
            amountParams: {
                banktransfer: {
                    fee: 7,
                    percent: false,
                    minimum: 50
                },
                bitcoin: {
                    fee: 7,
                    percent: false,
                    minimum: 50
                },
                neteller: {
                    fee: 2.5,
                    percent: true,
                    minimum: 50
                },
                payza: {
                    fee: 3.9,
                    percent: true,
                    minimum: 50
                },
                perfectmoney: {
                    fee: 2.5,
                    percent: true,
                    minimum: 50
                },
                stp: {
                    fee: 2.5,
                    percent: false,
                    minimum: 50
                },
                advcash: {
                    fee: 2.5,
                    percent: false,
                    minimum: 50
                },
                coindeal_futurocoin: {
                    fee: 1,
                    percent: false,
                    minimum: 5
                },
                coindeal_bitcoin: {
                    fee: 2,
                    percent: false,
                    minimum: 5
                },
                coindeal_litecoin: {
                    fee: 2,
                    percent: false,
                    minimum: 5
                },
                coindeal_bitcoin_cash: {
                    fee: 2,
                    percent: false,
                    minimum: 5
                },
                coindeal_dash: {
                    fee: 2,
                    percent: false,
                    minimum: 5
                },
                coindeal_ethereum: {
                    fee: 2,
                    percent: false,
                    minimum: 5
                }
            },
            maxAmount: 10000
        };
    },

    computed: {
        available: function available() {
            return this.money.format(this.$store.getters.user.moneyBalance, 'fnd') - parseFloat(this.feeValue.toFixed(2));
        },
        countries: function countries() {
            return this.$store.getters.countries;
        },
        feeValue: function feeValue() {
            if (this.amountParams[this.method].percent) {
                return this.account.amount * this.amountParams[this.method].fee / 100;
            }
            return this.amountParams[this.method].fee;
        }
    },
    methods: {
        setValue: function setValue(key, value) {
            this.account[key] = value;
            if (key === 'amount') {
                this.amountError = !(parseFloat(this.account.amount) >= this.amountParams[this.method].minimum) && parseFloat(this.account.amount) <= this.available;
            }
        },
        validate: function validate() {
            var _this = this;

            this.showErrors = false;
            this.amountError = false;
            this.maxAmountError = false;
            this.$validator.validateAll().then(function () {
                if (!_this.errors.any() && parseFloat(_this.account.amount) >= _this.amountParams[_this.method].minimum && parseFloat(_this.account.amount) <= _this.available && parseFloat(_this.account.amount) <= _this.maxAmount) {
                    _this.submit();
                } else {
                    _this.showErrors = true;

                    if (_this.account.amount < _this.amountParams[_this.method].minimum || _this.account.amount > _this.available) {
                        _this.amountError = true;
                    }

                    if (parseFloat(_this.account.amount) > _this.maxAmount) {
                        _this.maxAmountError = true;
                    }
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            var method = this.method,
                account = {};

            for (var field in this.methodFields[method]) {
                switch (this.methodFields[method][field]) {
                    case 'street':
                    case 'country':
                        if (account.address) {
                            account.address.line1 += ' ' + this.account[this.methodFields[method][field]];
                        } else {
                            account.address = {
                                line1: this.account[this.methodFields[method][field]]
                            };
                        }
                        break;
                    case 'zip':
                    case 'city':
                        if (account.address.line2) {
                            account.address.line2 += ' ' + this.account[this.methodFields[method][field]];
                        } else {
                            account.address.line2 = this.account[this.methodFields[method][field]];
                        }
                        break;
                    default:
                        account[this.methodFields[method][field]] = this.account[this.methodFields[method][field]];
                }
            }

            var params = {
                method: this.method,
                amount: this.money.unformat(this.account.amount, 'fnd'),
                password: this.account.password,
                account: account
            };

            if (params.method === 'advcash') {
                account.country = account.address.line1;
            }

            this.payout.generateToken().then(function () {
                _this2.$store.commit('modals', {
                    modal: 'payout',
                    data: {
                        visible: true,
                        params: params
                    }
                });
            });
        }
    },
    watch: {
        method: function method() {
            this.errors.clear();
            this.$forceUpdate();
        }
    },
    mounted: function mounted() {
        this.$store.commit('modals', {
            modal: 'payout',
            data: {
                visible: false,
                params: {}
            }
        });
    }
});

/***/ }),

/***/ "r0SI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['addClass', 'checked', 'label', 'message', 'name', 'progress', 'rules', 'showErrors', 'updateValue'],
    data: function data() {
        return {
            value: ''
        };
    },

    watch: {
        value: function value() {
            this.updateValue(this.name, this.value);
        }
    }
});

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("u54A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r2yu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__ = __webpack_require__("bFM1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec97993e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__ = __webpack_require__("7vMS");
function injectStyle (ssrContext) {
  __webpack_require__("5YtG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec97993e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec97993e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r60O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rBGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranking-table-component",attrs:{"id":"ranking_table_component"}},[_c('div',{staticClass:"ranking-table-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style3"},[_c('tbody',_vm._l((_vm.list),function(name,index){return _c('tr',{key:index},[_c('td',[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.rowNumber(index))+". "+_vm._s(name.login))])])])}),0)]),_vm._v(" "),(_vm.list.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No qualified people.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rDhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311ce94c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404Links_vue__ = __webpack_require__("RoPZ");
function injectStyle (ssrContext) {
  __webpack_require__("Iozf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-311ce94c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311ce94c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404Links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rJao":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rbvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['cookie', 'message'],
    data: function data() {
        return {
            show: false
        };
    },
    methods: {
        confirm: function confirm() {
            this.$cookie.set(this.cookie, true);
            this.show = false;
        }
    },
    created: function created() {
        var cookie = this.$cookie.get(this.cookie);
        if (!cookie) {
            this.show = true;
        }
    }
});

/***/ }),

/***/ "rcsJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_vm._v("Terms and conditions\n    "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    TERMS ANS CONDITIONS "),_c('a',{attrs:{"href":"https://futuro.network/static/media/terms-and-conditions.pdf","target":"_blank"}},[_vm._v("HERE")]),_vm._v(".\n    "),_c('br'),_vm._v("\n    PRIVACY POLICY "),_c('a',{attrs:{"href":"https://futuro.network/static/media/privacy-policy.pdf","target":"_blank"}},[_vm._v("HERE")]),_vm._v(".\n")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rhxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer"},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"fullscreen-box--content"},[_c('b-container',{staticClass:"register-center"},[_c('error-logo'),_vm._v(" "),_c('error-500-content'),_vm._v(" "),_c('error-500-redirect')],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rt/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining',{attrs:{"hide-payout":true,"button-label":'Payout history',"button-link":'PayoutHistory'}}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("My account balance:")]),_vm._v(" "),_c('p',{staticClass:"my_money"},[_vm._v("FND "+_vm._s(_vm.money.format(_vm.accountBalance, 'fnd')))])])],1),_vm._v(" "),(_vm.isVerified && _vm.pendingPayouts === 'NOT_FOUND')?_c('div',[_vm._l((_vm.methods),function(row,rowIndex){return _c('b-row',{key:rowIndex},[(rowIndex.length > 1)?_c('b-col',{staticStyle:{"margin-bottom":"12px"},attrs:{"cols":"12"}},[_c('p',[_vm._v(_vm._s(rowIndex))])]):_vm._e(),_vm._v(" "),_vm._l((row),function(option,index){return _c('b-col',{key:index,attrs:{"lg":"3","cols":"6"}},[_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : 'bottom',  arrow: true }),expression:"{ placement : 'bottom',  arrow: true }"}],staticClass:"form-item form-item-radio",class:{ 'disabled' : !option.enabled },attrs:{"title":_vm.GetOptionTitle(option)}},[_c('label',{staticClass:"form-label",attrs:{"for":'method_' + index}},[_vm._v("\n                        "+_vm._s(option.name)+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.method),expression:"method"}],attrs:{"id":'method_' + index,"name":"payment_method","disabled":!option.enabled,"data-vv-rules":"required","data-vv-as":"payment method","type":"radio"},domProps:{"value":index,"checked":_vm._q(_vm.method,index)},on:{"change":function($event){_vm.method=index}}}),_vm._v(" "),_c('div',{staticClass:"check"})])])}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('payment_method')),expression:"errors.has('payment_method')"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('payment_method')))])],2)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('payout-form',{attrs:{"method":_vm.method}}),_vm._v(" "),_c('payout')],2):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"30px"}},[_c('a',{staticStyle:{"color":"red"},attrs:{"href":"https://futurenet.club/donate","target":"_blank"}},[_vm._v("Make the donation for FutureNet Foundation "),_c('i',{staticClass:"mdi mdi-chevron-right"})])]),_vm._v(" "),(_vm.pendingPayouts === 'FOUND')?_c('div',[_c('p',{staticClass:"text-alert"},[_vm._v("You have pending payout.")])]):_vm._e(),_vm._v(" "),(!_vm.isVerified)?_c('div',[_c('p',{staticClass:"text-alert"},[_vm._v("Your account is not verified yet.")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"28px"}},[_vm._v("Go to profile settings and start verification.")]),_vm._v(" "),_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: 'Profile' }}},[_vm._v("Profile settings")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rtCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-outer"},[_c('div',{staticClass:"filter-overlay"}),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideFilter),expression:"hideFilter"}],staticClass:"dropdown-filter"},[_c('ul',_vm._l((_vm.filters),function(filter,index){return _c('li',[_c('div',{staticClass:"form-item form-checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"agree","id":'filter_' + index},on:{"click":function($event){return _vm.setFilter($event, index)}}}),_vm._v(" "),_c('label',{attrs:{"for":'filter_' + filter}},[_vm._v(_vm._s(filter))]),_vm._v(" "),_c('div',{staticClass:"check"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('agree') && _vm.showErrors),expression:"errors.has('agree') && showErrors"}],staticClass:"field-error--description field-error--description--white"},[_vm._v(_vm._s(_vm.errors.first('agree')))])])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rvNf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item",attrs:{"id":"autocomplete_component"}},[_c('label',{staticClass:"form-label",attrs:{"for":'autocomplete_field_' + _vm.fieldKey},domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('div',{staticClass:"select-outer select-outer--autocomplete",class:{ 'field-error': _vm.errors.has(_vm.fieldKey) && _vm.showErrors, 'disabled': _vm.disabled }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"},{name:"validate",rawName:"v-validate",value:(_vm.rules),expression:"rules"}],attrs:{"type":"text","id":'autocomplete_field_' + _vm.fieldKey,"name":_vm.fieldKey,"disabled":_vm.disabled},domProps:{"value":(_vm.selected)},on:{"focus":function($event){return _vm.openDropdown()},"blur":function($event){_vm.openList = _vm.hoverList ? _vm.openDropdown() : _vm.closeDropdown()},"keydown":function($event){return _vm.keydownEvent($event)},"keyup":function($event){return _vm.openDropdown()},"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpened() && !_vm.disabled && _vm.selected && _vm.autocomplete.length > 0 && (_vm.autocomplete[0].name !== _vm.selected)),expression:"isOpened() && !disabled && selected && autocomplete.length > 0 && (autocomplete[0].name !== selected)"}]},_vm._l((_vm.autocomplete),function(value,index){return _c('li',{class:{ 'active' : _vm.itemHovered === index },on:{"click":function($event){_vm.select(value.name), _vm.closeDropdown()},"mouseover":function($event){_vm.hoverList = true, _vm.itemHover(index)},"mouseleave":function($event){_vm.hoverList = false}}},[_vm._v("\n                "+_vm._s(value.name)+"\n            ")])}),0),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.fieldKey) && _vm.showErrors),expression:"errors.has(fieldKey) && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first(_vm.fieldKey)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s/3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['packet'],
    data: function data() {
        return {
            loader: false,
            packets: {
                100: {
                    label: '100',
                    sign: '$',
                    stars: 1,
                    power: 1,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                250: {
                    label: '250',
                    sign: '$',
                    stars: 2,
                    power: 3,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                500: {
                    label: '500',
                    sign: '$',
                    stars: 3,
                    power: 7,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                1000: {
                    label: '1 000',
                    sign: '$',
                    stars: 4,
                    power: 15,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                5000: {
                    label: '5 000',
                    sign: '$',
                    stars: 5,
                    power: 80,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                10000: {
                    label: '10 000',
                    sign: '$',
                    stars: 6,
                    power: 180,
                    size: {
                        lg: 4,
                        sm: 6
                    },
                    disable: true
                },
                25000: {
                    label: '25 000',
                    sign: '$',
                    stars: 7,
                    power: 500,
                    size: {
                        lg: 12,
                        sm: 12
                    },
                    disable: true
                }
            }
        };
    },

    computed: {
        startPacket: function startPacket() {
            return this.$store.getters.user.position;
        }
    },
    methods: {
        buyPacket: function buyPacket(index) {
            this.packet.create(index);
            this.$store.commit('modals', {
                modal: 'buyPacket',
                data: {
                    visible: true,
                    packet: this.packet
                }
            });
        }
    }
});

/***/ }),

/***/ "s/y0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutContent_vue__ = __webpack_require__("lIKn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4d0ae8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutContent_vue__ = __webpack_require__("rt/S");
function injectStyle (ssrContext) {
  __webpack_require__("t3LG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a4d0ae8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayoutContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4d0ae8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayoutContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s0uy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-exchange-component",attrs:{"id":"header_exchange_component"}},[_c('div',{staticClass:"header-exchange--inner"},[_c('p',[_c('strong',[_vm._v("1 FTO = ")]),_vm._v(" "),_vm._l((_vm.exchangeRate),function(rate,index){return _c('span',{key:index,staticClass:"currency"},[_vm._v("\n                "+_vm._s(rate.value)+" "+_vm._s(rate.label)+" "),_c('span',{staticClass:"spacer"},[_vm._v("| ")])])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sKk/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sUmG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sXdc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['datetime', 'money', 'packet'],
    data: function data() {
        return {
            packets: [100, 250, 500, 1000, 5000, 10000, 25000],
            loader: false,
            items: 25
        };
    },

    computed: {
        packages: function packages() {
            return this.$store.getters.boughtPackets;
        },
        currentPage: function currentPage() {
            return this.$store.getters.boughtPacketsSettings.currentPage;
        },
        maxPerPage: function maxPerPage() {
            return this.$store.getters.boughtPacketsSettings.maxPerPage;
        },
        numberOfPages: function numberOfPages() {
            return this.$store.getters.boughtPacketsSettings.numberOfPages;
        }
    },
    methods: {
        countDays: function countDays(date) {
            var dateStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date),
                dateStop = __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
                diff = dateStop.diff(dateStart, 'days'),
                days = 50 - parseInt(diff),
                word = days > 1 ? 'days' : 'day';

            return {
                days: days,
                word: word
            };
        },
        getNextPacket: function getNextPacket(packetValue) {
            for (var value in this.packets) {
                if (this.packets[value] === packetValue) return parseInt(value) + 1;
            }
        },
        buyPacket: function buyPacket(index, packetId) {
            this.packet.create(index);
            this.$store.commit('modals', {
                modal: 'buyPacket',
                data: {
                    visible: true,
                    packet: this.packet,
                    select: this.packets[this.getNextPacket(parseInt(index))],
                    current: parseInt(index),
                    upgrade: packetId
                }
            });
        },

        /**
         * Get data with transactions
         */
        getData: function getData() {
            var _this = this;

            this.loader = true;

            var settings = this.$store.getters.boughtPacketsSettings;

            this.$store.dispatch('loadBoughtPackets', {
                params: settings
            }).then(function () {
                _this.loader = false;
            });
        },

        /**
         * Change sort
         */
        changeSort: function changeSort(field) {
            var _this2 = this;

            this.$store.dispatch('boughtPacketsSetSort', field).then(function () {
                _this2.getData();
            });
        },

        /**
         * Set default settings
         */
        clearSettings: function clearSettings() {
            var _this3 = this;

            this.$store.dispatch('boughtPacketsSettingsClear').then(function () {
                _this3.getData();
                _this3.items = 25;
            });
        },


        /**
         * Set number of items per page
         */
        setItems: function setItems(items) {
            var _this4 = this;

            this.items = items;
            this.$store.dispatch('boughtPacketsSetItems', items).then(function () {
                _this4.setPage(1);
            });
        },


        /**
         * Set current page
         * @param page
         */
        setPage: function setPage(page) {
            var _this5 = this;

            this.$store.dispatch('boughtPacketsSetPage', page).then(function () {
                _this5.getData();
            });
        }
    },
    beforeMount: function beforeMount() {
        var _this6 = this;

        var settings = this.$store.getters.boughtPacketsSettings;

        this.$store.dispatch('loadBoughtPackets', {
            params: settings
        }).then(function () {
            _this6.items = settings.maxPerPage;
        });
    }
});

/***/ }),

/***/ "sYzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-option-outer",attrs:{"id":"payout_bank_transfer_component"}},[_c('p',[_vm._v("Bank transfer")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Security check:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('futuro-network-password',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"15px"}},[_vm._v("Enter your bank account data:")]),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('iban',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('bic-swift',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('street',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('zip',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}),_vm._v(" "),_c('city',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1),_vm._v(" "),_c('b-row',{staticClass:"payout-option-inner"},[_c('account-currency',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}}),_vm._v(" "),_c('account-owner',{attrs:{"sending":_vm.sending,"show-errors":_vm.showErrors,"set-value":_vm.setValue}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sdOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    totalIncomes: {
        business_bonus_income: { amount: '-' },
        car_bonus_income: { amount: '-' },
        direct_bonus_career_level_income: { amount: '-' },
        direct_bonus_position_income: { amount: '-' },
        matching_bonus_income: { amount: '-' },
        total_income: { amount: '-' },
        unilevel_bonus_career_level_income: { amount: '-' },
        unilevel_bonus_position_income: { amount: '-' }
    }
};

var getters = {
    totalIncomes: function totalIncomes(state) {
        return state.totalIncomes;
    }
};

var mutations = {
    setTotalIncomes: function setTotalIncomes(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'totalIncomes', data);
    }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "seo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['popup'],
    data: function data() {
        return {
            displayModal: !localStorage.getItem('infoModal')
        };
    },

    methods: {
        hideModal: function hideModal() {
            localStorage.setItem('infoModal', '1');
            this.displayModal = false;
            this.popup.hide();
        }
    }
});

/***/ }),

/***/ "sfXl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsItem_vue__ = __webpack_require__("Snw+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552a2fe6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsItem_vue__ = __webpack_require__("6B5r");
function injectStyle (ssrContext) {
  __webpack_require__("vM6n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_552a2fe6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "so6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsDesktop_vue__ = __webpack_require__("Pgnr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787db561_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsDesktop_vue__ = __webpack_require__("WDcD");
function injectStyle (ssrContext) {
  __webpack_require__("fRpT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-787db561"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsDesktop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787db561_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabsDesktop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "soIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"header-payout",attrs:{"lg":"4"}},[_c('router-link',{staticClass:"button--primary",attrs:{"to":{ name: _vm.buttonLink }}},[_vm._v(_vm._s(_vm.buttonLabel))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sonc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_ForgotPassword_vue__ = __webpack_require__("og54");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_LoginForm_vue__ = __webpack_require__("gw2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_TokenForm_vue__ = __webpack_require__("EiG4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ForgotPassword: __WEBPACK_IMPORTED_MODULE_0__partials_ForgotPassword_vue__["a" /* default */], LoginForm: __WEBPACK_IMPORTED_MODULE_1__partials_LoginForm_vue__["a" /* default */], TokenForm: __WEBPACK_IMPORTED_MODULE_2__partials_TokenForm_vue__["a" /* default */] },
    data: function data() {
        return {
            captchaValue: ''
        };
    },

    computed: {
        view: function view() {
            return this.$store.getters.loginForm.view;
        }
    },
    methods: {
        saveCaptcha: function saveCaptcha(value) {
            this.captchaValue = value;
        }
    }
});

/***/ }),

/***/ "sx+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    qualifications: {
        option: '',
        amount: 0
    },

    totalIncome: 0,

    turnover: {
        today: 0,
        lastWeek: 0,
        monthly: 0
    }
};

var getters = {
    bonusIncome: function bonusIncome(state) {
        return state.bonusIncome;
    },

    income: function income(state) {
        return state.income;
    },

    qualifications: function qualifications(state) {
        return state.qualifications;
    },

    totalIncome: function totalIncome(state) {
        return state.totalIncome;
    },

    turnover: function turnover(state) {
        return state.turnover;
    }
};

var mutations = {
    /**
     * Set qualifications in store
     * @param state
     * @param data
     */
    setQualifications: function setQualifications(state, data) {
        var amount = data.turnover ? data.turnover.amount : '',
            currency = data.turnover ? data.turnover.currency.code : '';
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'qualifications', {
            option: data.option,
            amount: amount + ' ' + currency
        });
    },


    /**
     * Set total income in store
     * @param state
     * @param data
     */
    setTotalIncome: function setTotalIncome(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'totalIncome', data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "szSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorLogo_vue__ = __webpack_require__("FlRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__500_Error500Content_vue__ = __webpack_require__("fncw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__500_Error500Redirect_vue__ = __webpack_require__("bdUD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { ErrorLogo: __WEBPACK_IMPORTED_MODULE_0__ErrorLogo_vue__["a" /* default */], Error500Content: __WEBPACK_IMPORTED_MODULE_1__500_Error500Content_vue__["a" /* default */], Error500Redirect: __WEBPACK_IMPORTED_MODULE_2__500_Error500Redirect_vue__["a" /* default */] },
    beforeCreate: function beforeCreate() {
        this.$store.commit('setError', {
            status: true,
            code: 500,
            redirect: false
        });
    },
    beforeMount: function beforeMount() {
        this.$store.commit('loginFormView', 2);
    }
});

/***/ }),

/***/ "t+0+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerfectMoney_vue__ = __webpack_require__("ks8t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23bc20dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerfectMoney_vue__ = __webpack_require__("0Dow");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerfectMoney_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23bc20dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerfectMoney_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t1Ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__("1BnD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07906419_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__("iz9A");
function injectStyle (ssrContext) {
  __webpack_require__("9dc0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07906419"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07906419_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t3LG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t6+I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tED9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('create-code'),_vm._v(" "),_c('codes-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tNZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__monthly_statement_MonthlyStatementTable_vue__ = __webpack_require__("9Vq2");
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { MonthlyStatementTable: __WEBPACK_IMPORTED_MODULE_0__monthly_statement_MonthlyStatementTable_vue__["a" /* default */] }
});

/***/ }),

/***/ "tPa8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tXiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__ = __webpack_require__("K90U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payza_PayzaEmail_vue__ = __webpack_require__("GKAJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['countries', 'sending', 'showErrors', 'setValue'],
    components: { FuturoNetworkPassword: __WEBPACK_IMPORTED_MODULE_0__common_FuturoNetworkPassword_vue__["a" /* default */], PayzaEmail: __WEBPACK_IMPORTED_MODULE_1__payza_PayzaEmail_vue__["a" /* default */] }
});

/***/ }),

/***/ "tXs5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ti53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("ohqg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ef160d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("7/Py");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ef160d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "toql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_inject__);







__webpack_require__("8feS");

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a);

var api = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('api'),
    status = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('status');

var state = {
    ranking: [],

    rankingSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        careerLevel: 'vip'
    }
};

var getters = {
    ranking: function ranking(state) {
        return state.ranking;
    },

    rankingSettings: function rankingSettings(state) {
        return state.rankingSettings;
    }
};

var mutations = {
    /**
     * Set career level
     * @param getters
     * @param data
     * @returns {Promise}
     */
    rankingSetCareerLevel: function rankingSetCareerLevel(state, data) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.rankingSettings, 'careerLevel', data);
    },


    /**
     * Set ranking in store
     * @param state
     * @param data
     */
    setRanking: function setRanking(state, data) {
        if (data.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'ranking', data.results);
        } else {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'ranking', []);
        }
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.rankingSettings, 'currentPage', data.current_page);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.rankingSettings, 'maxPerPage', data.max_per_page);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.rankingSettings, 'numberOfPages', data.number_of_pages);
    }
};

var actions = {

    /**
     * Get ranking data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    loadRanking: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var commit = _ref.commit;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                var settings = state.rankingSettings;

                                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get(api.ranking.list(settings)).then(function (response) {
                                    commit('setRanking', response.data);
                                    resolve();
                                }, function (error) {
                                    status['status' + error.status]();
                                    reject();
                                });
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function loadRanking(_x) {
            return _ref2.apply(this, arguments);
        }

        return loadRanking;
    }(),


    /**
     * Set max number of items in ranking
     * @param getters
     * @param data
     * @returns {Promise}
     */
    rankingSetItems: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.rankingSettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function rankingSetItems(_x2, _x3) {
            return _ref4.apply(this, arguments);
        }

        return rankingSetItems;
    }(),


    /**
     * Set page in ranking
     * @param getters
     * @param data
     * @returns {Promise}
     */
    rankingSetPage: function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.rankingSettings, 'currentPage', data);
                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function rankingSetPage(_x4, _x5) {
            return _ref6.apply(this, arguments);
        }

        return rankingSetPage;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "tp95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinHistoryTable_vue__ = __webpack_require__("Ggpo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705518c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinHistoryTable_vue__ = __webpack_require__("Y5/p");
function injectStyle (ssrContext) {
  __webpack_require__("xrtl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-705518c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinHistoryTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705518c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinHistoryTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tvzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['defaultValue', 'disabled', 'fieldKey', 'label', 'list', 'rules', 'showErrors', 'updateValue'],
    data: function data() {
        return {
            selected: '',
            index: 0,
            sending: false,
            opened: false,
            hoverList: false,
            itemHovered: null
        };
    },

    computed: {
        autocomplete: function autocomplete() {
            var list = this.list,
                selected = this.selected.toLowerCase();
            if (!selected) {
                return list;
            } else {
                this.itemHover(0);
                return list.filter(function (obj) {
                    var name = obj.name.toLowerCase(),
                        len = selected.length;

                    return name.substring(0, len) === selected;
                }).slice(0, 6);
            }
        }
    },
    methods: {
        keydownEvent: function keydownEvent(event) {
            // Do not lost focus when tab key used
            if (event.key === 'Tab') {
                this.selectNext();
                event.preventDefault();
            }

            // Autocomplete when press enter
            if (event.key === 'Enter') {
                this.selected = this.autocomplete[this.itemHovered].name;
                this.closeDropdown();
            }
        },
        itemHover: function itemHover(index) {
            this.itemHovered = index;
        },
        selectNext: function selectNext() {
            var len = this.autocomplete.length;

            if (len <= this.itemHovered + 1) {
                this.itemHovered = 0;
                this.itemHover(0);
            } else {
                this.itemHovered++;
            }
        },
        selectFirst: function selectFirst() {
            this.itemHovered = 0;
        },
        select: function select(value) {
            this.selected = value;
        },
        isOpened: function isOpened() {
            return this.opened;
        },
        openDropdown: function openDropdown() {
            this.opened = true;
        },
        closeDropdown: function closeDropdown() {
            this.opened = false;
        }
    },
    watch: {
        selected: function selected() {
            this.updateValue(this.fieldKey, this.selected);
        }
    },
    mounted: function mounted() {
        this.selected = this.defaultValue;
    }
});

/***/ }),

/***/ "u54A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u5Eo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payout-history-table-component",attrs:{"id":"payout_history_table_component"}},[_c('p',[_vm._v("Payout history")]),_vm._v(" "),_c('div',{staticClass:"payout-history-table-outer table-responsive"},[(_vm.loader)?_c('div',{staticClass:"data-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_c('thead',[_c('tr',[_c('th',[_c('div',{staticClass:"calendar-icon"},[_c('p',[_vm._v("Date")]),_vm._v(" "),_c('i',{staticClass:"mdi mdi-calendar"}),_vm._v(" "),_c('datepicker',{attrs:{"placeholder":"range","options":{ mode: 'range', maxDate: 'today' }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('tbody',_vm._l((_vm.payouts),function(payout,index){return _c('tr',{key:index},[_c('td',[_c('p',[_vm._v(_vm._s(payout.date))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.money.format(payout.amount, 'fnd')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.money.format(payout.fee, 'fnd')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm.money.format(Number(payout.amount) + Number(payout.fee), 'fnd')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(payout.method.replace('_', ' ')))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(payout.status === 'new' ? 'no' : 'yes'))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(payout.status))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(payout.reject_reason ? payout.reject_reason : '-'))])]),_vm._v(" "),(payout.status === 'new')?_c('td',{staticClass:"operations"},[_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : 'top',  arrow: true }),expression:"{ placement : 'top',  arrow: true }"}],staticClass:"button--primary",attrs:{"title":"Send email with confirmation link"},on:{"click":function($event){return _vm.sendConfirmationEmail(payout.id)}}},[_c('i',{staticClass:"mdi mdi-email"})]),_vm._v(" "),_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : 'top',  arrow: true }),expression:"{ placement : 'top',  arrow: true }"}],staticClass:"button--primary",attrs:{"title":"Cancel payout"},on:{"click":function($event){return _vm.cancelPayout(payout.id)}}},[_c('i',{staticClass:"mdi mdi-close"})])]):_c('td')])}),0)]),_vm._v(" "),(_vm.payouts.length == 0)?_c('p',{staticStyle:{"margin-top":"25px"}},[_vm._v("No results.")]):_vm._e()])]),_vm._v(" "),_c('pagination-component',{attrs:{"current-page":_vm.currentPage,"items":_vm.items,"loader":_vm.loader,"number-of-pages":_vm.numberOfPages,"set-items":_vm.setItems,"set-page":_vm.setPage}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Amount [FND]")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Fee [FND]")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Final amount to payout [FND]")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Method")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Confirmed by you")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p',[_vm._v("Reason of rejection")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uAHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
    royalBonuses: {
        birthday: 0,
        each_day: 0,
        macau: 0,
        macau2018: 0,
        royal: 0
    }
};

var getters = {
    royalBonuses: function royalBonuses(state) {
        return state.royalBonuses;
    }
};

var mutations = {
    setRoyalBonuses: function setRoyalBonuses(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'royalBonuses', {
            birthday: data.birthday,
            each_day: data.each_day,
            macau: data.macau,
            macau2018: data.macau2018,
            royal: data.royal
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "uAID":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDti":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uHuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c7888a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardHeader_vue__ = __webpack_require__("chAp");
function injectStyle (ssrContext) {
  __webpack_require__("TOiN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c7888a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uN9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['popup', 'verification'],
    data: function data() {
        return {
            filesList: [],
            progress: false
        };
    },

    methods: {
        uploadFiles: function uploadFiles(e) {
            var files = e.target.files || e.dataTransfer.files;

            if (!files.length) return;
            for (var file in files) {
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(files[file]) === 'object') {
                    var extensions = ['image/png', 'image/jpg', 'image/jpeg'];
                    if (extensions.indexOf(files[file].type) === -1) {
                        this.popup.show('Only JPG and PNG accepted.');
                    } else if (files[file].size / 1024 / 1024 > 1) {
                        this.popup.show('Max file size is 1 MB.');
                    } else {
                        this.createImage(files[file], file);
                    }
                }
            }
        },
        createImage: function createImage(file, index) {
            var reader = new FileReader(),
                vm = this;

            reader.onload = function (e) {
                vm.$set(vm.filesList, index, {
                    url: e.target.result,
                    name: file.name,
                    progress: false
                });
            };

            reader.readAsDataURL(file);
        },
        removeFiles: function removeFiles() {
            this.filesList = [];
        },
        confirmFiles: function confirmFiles() {
            var _this = this;

            this.progress = true;

            var filesToUpload = [];

            for (var fileId in this.filesList) {
                filesToUpload.push(this.filesList[fileId].url);
            }

            this.verification.sendFiles(filesToUpload).then(function () {
                _this.filesList = [];
                _this.progress = false;
                _this.verification.loadVerificationFiles();
            }, function () {
                _this.progress = false;
            });
        }
    }
});

/***/ }),

/***/ "uOM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveSettings_vue__ = __webpack_require__("kZlc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6965a85e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveSettings_vue__ = __webpack_require__("TF+z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6965a85e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uPG5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uQVa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uc3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"dashboard-panel-component",attrs:{"no-gutters":"","id":"dashboard_panel_component"}},_vm._l((_vm.panel),function(item,index){return _c('b-col',{key:index,staticClass:"dashboard-panel-element",class:{'small': item.small},attrs:{"lg":"4","cols":"6"}},[(item.path)?_c('router-link',{staticClass:"dashboard-panel-element-inner",attrs:{"to":{ name: item.path }}},[_c('div',{staticClass:"dashboard-panel-element-label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('div',{staticClass:"dashboard-panel-element-value",domProps:{"innerHTML":_vm._s(item.value)}}),_vm._v(" "),(item.info)?_c('i',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement : 'top',  arrow: true }),expression:"{ placement : 'top',  arrow: true }"}],staticClass:"dashboard-panel-element-value mdi mdi-help-circle",attrs:{"title":"The amount has been transferred to FutureNet. 10% of all your income from the Futuro Network is going to the FutureNet Product Packs. You get Media Points at your account for it.Here you can see the total amount since your start in the Futuro Network."}}):_vm._e()]):_c('div',{staticClass:"dashboard-panel-element-inner"},[_c('div',{staticClass:"dashboard-panel-element-label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('div',{staticClass:"dashboard-panel-element-value",domProps:{"innerHTML":_vm._s(item.value)}})])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "udQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uhZd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_CodesContent_vue__ = __webpack_require__("IK0A");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], CodesContent: __WEBPACK_IMPORTED_MODULE_1__content_CodesContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "ukEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderPayout_vue__ = __webpack_require__("KjWi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ef12f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderPayout_vue__ = __webpack_require__("ECUB");
function injectStyle (ssrContext) {
  __webpack_require__("SrMI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71ef12f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderPayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ef12f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderPayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v00P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Futurocoin_vue__ = __webpack_require__("kSTB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd22bb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Futurocoin_vue__ = __webpack_require__("b5yM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Futurocoin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd22bb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Futurocoin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v37A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('futurocoin-stats'),_vm._v(" "),_c('futurocoin-history-table'),_vm._v(" "),_c('router-link',{staticClass:"button--secondary",staticStyle:{"margin-top":"24px"},attrs:{"to":{ name: 'Futurocoin' }}},[_c('i',{staticClass:"mdi mdi-chevron-left"}),_vm._v(" Back to Futurocoin")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v78y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'myTeam',"title":'My team'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('my-team-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vCI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"col":"","lg":"9","cols":"12","id":"section_main"}},[_c('futurocoins-from-mining'),_vm._v(" "),_c('my-team-total'),_vm._v(" "),_c('my-team-tree')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vM6n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNdn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOJp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"autologout_component"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vOOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__futurocoin_stats_StatsItem_vue__ = __webpack_require__("sfXl");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    components: { StatsItem: __WEBPACK_IMPORTED_MODULE_0__futurocoin_stats_StatsItem_vue__["a" /* default */] },
    computed: {
        royalPosition: function royalPosition() {
            return this.$store.getters.ftoAccounts.royalBonusAccount;
        },
        stats: function stats() {
            return {
                1: {
                    label: 'All FuturoCoins<br class="desktop-only"> from mining',
                    value: this.money.format(this.$store.getters.ftoAccounts.miningOriginalAccount, 'fto'),
                    royal: false
                },
                2: {
                    label: 'Available FuturoCoins<br class="desktop-only"> from mining',
                    value: this.money.format(this.$store.getters.ftoAccounts.miningAccount, 'fto'),
                    royal: false
                },
                3: {},
                4: {
                    label: 'All FuturoCoins<br class="desktop-only"> from Royal Position',
                    value: this.money.format(this.$store.getters.ftoAccounts.royalBonusOriginalAccount, 'fto'),
                    royal: true
                },
                5: {
                    label: 'Available FuturoCoins<br class="desktop-only"> from Royal Position',
                    value: this.money.format(this.$store.getters.ftoAccounts.royalBonusAccount, 'fto'),
                    royal: true
                },
                6: {
                    label: 'FuturoCoins<br class="desktop-only"> from Royal Position to withdraw',
                    value: this.money.format(this.$store.getters.ftoAccounts.allowToWithdrawFromRoyal, 'fto'),
                    royal: true
                }
            };
        }
    }
});

/***/ }),

/***/ "vRgV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFiles_vue__ = __webpack_require__("uN9z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d761031_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFiles_vue__ = __webpack_require__("KGCi");
function injectStyle (ssrContext) {
  __webpack_require__("zxC8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d761031_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vV8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");







var api = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('api');

var Invoice = function () {
    function Invoice() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Invoice);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Invoice, [{
        key: 'fetchPackageList',
        value: function fetchPackageList() {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.package.boughtList()).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setPackagesList', response.body.results);
            });
        }
    }, {
        key: 'generateInvoice',
        value: function generateInvoice(packageId) {
            var _this = this;

            var _packages = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.packages));
            _packages.find(function (element) {
                return element.id === packageId;
            });
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.invoice.generate(packageId)).then(function () {
                _this.fetchPackageList();
                __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('removePackageFromQueue', packageId);
            });
        }
    }, {
        key: 'getDownloadLink',
        value: function getDownloadLink(invoiceId) {
            return "https://api.futuro.network/api/v1/" + api.invoice.download(invoiceId);
        }
    }]);

    return Invoice;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('invoice', Invoice);

/***/ }),

/***/ "vYXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFirstTime_vue__ = __webpack_require__("4EqZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30c5ffa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFirstTime_vue__ = __webpack_require__("PgJu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFirstTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30c5ffa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFirstTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vkIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vrhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header_alert_component"}},[_c('router-link',{staticClass:"header-alert--inside",attrs:{"to":{ 'name': 'TermsUpdate' }}},[_c('p',[_vm._v("In connection with the introduction of the GDPR please make sure that you accept all required consents. Otherwise you will lose access to your account.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vsCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("nyEa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a97a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("wcGN");
function injectStyle (ssrContext) {
  __webpack_require__("e7JJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5a97a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a97a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vxE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__futurocoin_FuturocoinStats_vue__ = __webpack_require__("blku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__futurocoin_history_FuturocoinHistoryTable_vue__ = __webpack_require__("tp95");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['ftoAccounts'],
    components: { FuturocoinStats: __WEBPACK_IMPORTED_MODULE_0__futurocoin_FuturocoinStats_vue__["a" /* default */], FuturocoinHistoryTable: __WEBPACK_IMPORTED_MODULE_1__futurocoin_history_FuturocoinHistoryTable_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__["a" /* default */] },
    computed: {
        mining: function mining() {
            return this.$store.getters.ftoAccounts.miningAccount;
        },
        royalPosition: function royalPosition() {
            return this.$store.getters.ftoAccounts.royalBonusAccount;
        }
    },
    created: function created() {
        this.$store.dispatch('loadDailyMining');
        this.$store.dispatch('loadFuturocoinWithdraw');
    }
});

/***/ }),

/***/ "w2S+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_Topbar_vue__ = __webpack_require__("Lq+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_Middlebar_vue__ = __webpack_require__("d8iA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_Bottombar_vue__ = __webpack_require__("fimc");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Topbar: __WEBPACK_IMPORTED_MODULE_0__header_Topbar_vue__["a" /* default */], Middlebar: __WEBPACK_IMPORTED_MODULE_1__header_Middlebar_vue__["a" /* default */], Bottombar: __WEBPACK_IMPORTED_MODULE_2__header_Bottombar_vue__["a" /* default */] },
    computed: {
        menuOpen: function menuOpen() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "w780":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-component",attrs:{"id":"box_component"}},[_c('div',{staticClass:"box-component-inner"},[_c('h2',[_vm._v("Forgot password")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('div',{staticClass:"mw--360"},[_c('p',[_vm._v("Please enter new password:")]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('new_password') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"settings_new_password"}},[_vm._v("\n                        New password\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"},{name:"validate",rawName:"v-validate"}],ref:"new_password",staticClass:"settings-new-password",attrs:{"id":"settings_new_password","name":"new_password","data-vv-rules":"required","data-vv-as":"new password","disabled":_vm.progress,"type":"password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('new_password') && _vm.showErrors),expression:"errors.has('new_password') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('new_password')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('repeat_password') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"settings_repeat_password"}},[_vm._v("\n                        Repeat password\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repeatPassword),expression:"repeatPassword"},{name:"validate",rawName:"v-validate"}],staticClass:"settings-repeat-password",attrs:{"id":"settings_repeat_password","name":"repeat_password","data-vv-rules":"required|confirmed:new_password","data-vv-as":"password","disabled":_vm.progress,"type":"password"},domProps:{"value":(_vm.repeatPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repeatPassword=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('repeat_password') && _vm.showErrors),expression:"errors.has('repeat_password') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('repeat_password')))])])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button--primary password",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Change password")]),_vm._v(" "),_c('a',{staticClass:"prev-link",on:{"click":function($event){return _vm.goToLogin()}}},[_vm._v("Back to login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wNWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'status', 'user', 'recaptcha'],
    components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */] },
    props: ['saveCaptcha', 'view'],
    data: function data() {
        return {
            invalidData: false,
            invalidCaptcha: false,
            password: '',
            progress: false,
            showErrors: false,
            username: ''
        };
    },


    methods: {
        onVerify: function onVerify(response) {
            this.recaptcha.SetRecaptchaResponse(response);
        },
        onRender: function onRender(recaptchaId) {
            this.recaptchaId = recaptchaId;
        },
        changeView: function changeView(view) {
            var _this = this;

            this.$store.commit('loginFormView', 6);
            setTimeout(function () {
                _this.$store.commit('loginFormView', view);
            }, 600);
        },
        goToRegister: function goToRegister() {
            var _this2 = this;

            this.$store.commit('loginFormView', 6);
            setTimeout(function () {
                _this2.$router.push({ name: 'Register' });
            }, 600);
        },
        loginSuccess: function loginSuccess(data) {
            this.progress = false;
            this.user.fetchData(data);
            this.$router.push({ name: 'Dashboard' });
        },
        validate: function validate() {
            var _this3 = this;

            this.showErrors = false;
            this.$validator.validateAll().then(function () {
                if (!_this3.errors.any()) {
                    _this3.submit();
                } else {
                    _this3.showErrors = true;
                }
            });
        },
        submit: function submit() {
            var _this4 = this;

            var vm = this;
            vm.invalidData = false;
            vm.invalidCaptcha = false;
            vm.progress = true;
            vm.saveCaptcha(this.recaptcha.GetRecaptchaResponse());
            vm.$http.post(this.api.auth.login, {
                _username: vm.username,
                _password: vm.password,
                'g-recaptcha-response': this.recaptcha.GetRecaptchaResponse()
            }).then(function (response) {
                vm.loginSuccess(response.data);
                _this4.recaptcha.SetRecaptchaResponse(null);
            }, function (error) {
                _this4.$children.find(function (component) {
                    return component.$widgetId === _this4.recaptchaId;
                }).reset();
                setTimeout(function () {
                    vm.progress = false;
                    switch (error.status) {
                        case 400:
                            vm.invalidData = true;
                            _this4.recaptcha.SetRecaptchaResponse(null);
                            break;
                        case 422:
                            if (error.data && error.data.errors && error.data.errors[0].message === 'This value is not a valid captcha.') {
                                vm.invalidCaptcha = true;
                            } else {
                                vm.progress = true;
                                vm.$http.post(_this4.api.auth.login, {
                                    _username: vm.username,
                                    _password: vm.password,
                                    token: 'GENERATE'
                                }).then(function (response) {
                                    vm.loginSuccess(response.data);
                                    _this4.recaptcha.SetRecaptchaResponse(null);
                                }, function (error) {
                                    vm.progress = false;
                                    switch (error.status) {
                                        case 400:
                                            vm.invalidData = true;
                                            break;
                                        case 422:
                                            _this4.changeView(1);
                                            break;
                                        default:
                                            error.status ? _this4.status['status' + error.status]() : '';
                                    }
                                });
                            }
                            break;
                        default:
                            error.status ? _this4.status['status' + error.status]() : '';
                    }
                }, 1000);
            });
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store.commit('loginFormView', 2);
    },
    mounted: function mounted() {
        this.changeView(0);
    }
});

/***/ }),

/***/ "wUzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFirstTimeContent_vue__ = __webpack_require__("zh4L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233bac1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFirstTimeContent_vue__ = __webpack_require__("whtY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardFirstTimeContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233bac1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardFirstTimeContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wVkC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('identifier', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "wXgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BicSwift_vue__ = __webpack_require__("IJ0J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e25d682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BicSwift_vue__ = __webpack_require__("22Uw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BicSwift_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e25d682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BicSwift_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wZ9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardContent_vue__ = __webpack_require__("EtWD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218eca63_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardContent_vue__ = __webpack_require__("Z2CB");
function injectStyle (ssrContext) {
  __webpack_require__("GBzi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218eca63_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wa+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_inject__);







__webpack_require__("C/dE");

var api = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('api'),
    popup = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('popup'),
    status = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('status');

var Payout = function () {
    function Payout() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Payout);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Payout, [{
        key: 'create',
        value: function create(params) {
            this.data = params;
        }
    }, {
        key: 'generateToken',
        value: function generateToken() {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get(api.token.generate('TWO_STEP_PAYOUT_VERIFICATION')).then(function () {
                    resolve();
                }, function (error) {
                    popup.show(error.data.errors[0]);
                });
            });
        }
    }, {
        key: 'setToken',
        value: function setToken(token) {
            this.data['token'] = token;
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.post(api.payout.request, _this.data).then(function () {
                    popup.show('Payout success', 'OK', true);
                    resolve();
                }, function (error) {
                    if (status['status' + error.status]) {
                        status['status' + error.status]();
                    } else {
                        if (error.data && error.data.message) {
                            popup.show(error.data.message[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.data.message)[0]][0]);
                        } else if (error.data && error.data.errors) {
                            popup.show(error.data.errors[0].message);
                        }
                    }
                    reject();
                });
            });
        }
    }]);

    return Payout;
}();

__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.service('payout', Payout);

/***/ }),

/***/ "wakk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo-component",attrs:{"id":"header_logo_component"}},[(_vm.hasPacket)?_c('router-link',{staticClass:"header-logo--inner",attrs:{"to":'/'}},[_c('img',{attrs:{"src":__webpack_require__("gIBB"),"alt":"FuturoNetwork"}})]):_c('span',{staticClass:"header-logo--inner"},[_c('img',{attrs:{"src":__webpack_require__("gIBB"),"alt":"FuturoNetwork"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wcGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-box"},[_c('div',{staticClass:"fullscreen-box--outer",style:({ overflow: _vm.view == 2 ? 'hidden' : 'auto' })},[_c('div',{staticClass:"fullscreen-box--inner"},[_c('div',{staticClass:"fullscreen-box--container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"fullscreen-box--content"},[_c('transition',{attrs:{"name":"fadeInUp"}},[_c('register-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 4),expression:"view == 4"}],attrs:{"view":_vm.view}})],1)],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wd+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-code-component",staticStyle:{"margin-bottom":"11px"},attrs:{"id":"create_code_component"}},[_c('p',{staticStyle:{"margin-bottom":"11px"}},[_vm._v("Create unique voucher and give it to your friend")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',[_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('div',{staticClass:"form-item form-item-amount"},[_c('div',{staticClass:"transfer-value",class:{ 'field-error': _vm.errors.has('code_value') || _vm.available < 0 }},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.codeValue),expression:"codeValue"}],attrs:{"type":"text","name":"code_value","data-vv-rules":"required|money|greaterThanZero","data-vv-as":"code value","disabled":_vm.progress || true},domProps:{"value":(_vm.codeValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codeValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"currency"},[_vm._v("FND")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code_value') && _vm.showErrors),expression:"errors.has('code_value') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('code_value')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.available < _vm.codeValue && _vm.showErrors),expression:"available < codeValue && showErrors"}],staticClass:"field-error--description"},[_vm._v("Not enough founds")])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","cols":"12"}},[_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress },attrs:{"disabled":_vm.progress || true}},[_vm._v("Create")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "whtY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('dashboard-header'),_vm._v(" "),_c('check-fto'),_vm._v(" "),_c('dashboard-packets'),_vm._v(" "),_c('dashboard-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wiZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('street', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "wj9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-component",attrs:{"id":"box_component"}},[_c('div',{staticClass:"box-component-inner"},[_c('h2',[_vm._v("Forgot password")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('div',{staticClass:"mw--360"},[_c('p',[_vm._v("Please enter your email below:")]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('email') && _vm.showErrors }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate"}],attrs:{"id":"forgot_password_email","name":"email","data-vv-rules":"required|email","data-vv-as":"email","disabled":_vm.progress,"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email') && _vm.showErrors),expression:"errors.has('email') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('email')))])]),_vm._v(" "),_c('vue-recaptcha',{staticClass:"g-recaptcha",attrs:{"sitekey":_vm.recaptcha.sitekey},on:{"verify":_vm.onVerify,"render":_vm.onRender}})],1),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"button--primary password",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Submit")]),_vm._v(" "),_c('p',{staticClass:"button--text",on:{"click":function($event){return _vm.changeView(0)}}},[_vm._v("Back to login")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wpUA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            fieldValue: ''
        };
    },

    watch: {
        fieldValue: function fieldValue() {
            this.setValue('description', this.fieldValue);
        }
    }
});

/***/ }),

/***/ "wsjE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x1A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__business_qualifications_BusinessQualificationsHeader_vue__ = __webpack_require__("Uur/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__business_qualifications_BusinessQualificationsTable_vue__ = __webpack_require__("XlrM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['careerLevel', 'popup'],
    components: { BusinessQualificationsHeader: __WEBPACK_IMPORTED_MODULE_0__business_qualifications_BusinessQualificationsHeader_vue__["a" /* default */], BusinessQualificationsTable: __WEBPACK_IMPORTED_MODULE_1__business_qualifications_BusinessQualificationsTable_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_2__dashboard_FuturocoinsFromMining_vue__["a" /* default */] },
    beforeMount: function beforeMount() {
        this.careerLevel.fetchData();
    }
});

/***/ }),

/***/ "x1pm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIdz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");






var state = {
    isListLoading: false,
    isCreateLoading: false,
    list: [],
    listSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25
    }
};

var getters = {
    isListLoading: function isListLoading(state) {
        return state.isListLoading;
    },
    isCreateLoading: function isCreateLoading(state) {
        return state.isCreateLoading;
    },
    codes: function codes(state) {
        return state;
    },
    listSettings: function listSettings(state) {
        return state.listSettings;
    }
};

var mutations = {
    startListLoading: function startListLoading(state) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'isListLoading', true);
    },
    startCreateLoading: function startCreateLoading(state) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'isCreateLoading', true);
    },
    stopCreateLoading: function stopCreateLoading(state) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'isCreateLoading', false);
    },
    setList: function setList(state, list) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'list', list);
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'isListLoading', false);
        if (list.results.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'list', list.results);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.listSettings, 'currentPage', list.current_page);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.listSettings, 'maxPerPage', list.max_per_page);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.listSettings, 'numberOfPages', list.number_of_pages);
        } else {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'list', []);
        }
    },
    cancelCode: function cancelCode(state, code) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'list', state.list.filter(function (otherCode) {
            return code.codeId !== otherCode.codeId;
        }));
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'isListLoading', false);
    }
};

var actions = {
    /**
     * Set max number of items in list of vouchers
     * @param getters
     * @param data
     * @returns {Promise}
     */
    listSetItems: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref, data) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.listSettings, 'maxPerPage', data);

                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function listSetItems(_x, _x2) {
            return _ref2.apply(this, arguments);
        }

        return listSetItems;
    }(),


    /**
     * Set page in list of vouchers
     * @param getters
     * @param data
     * @returns {Promise}
     */
    listSetPage: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, data) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

                            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.listSettings, 'currentPage', data);
                                resolve();
                            }));

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function listSetPage(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return listSetPage;
    }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__ = __webpack_require__("xvGj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_errors_Error404_vue__ = __webpack_require__("Eyos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_errors_Error500_vue__ = __webpack_require__("xMtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_errors_Error503_vue__ = __webpack_require__("ZHLF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Layout_vue__ = __webpack_require__("i/0a");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: { CookieLaw: __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default.a, Error404: __WEBPACK_IMPORTED_MODULE_1__components_errors_Error404_vue__["a" /* default */], Error500: __WEBPACK_IMPORTED_MODULE_2__components_errors_Error500_vue__["a" /* default */], Error503: __WEBPACK_IMPORTED_MODULE_3__components_errors_Error503_vue__["a" /* default */], Layout: __WEBPACK_IMPORTED_MODULE_4__components_layout_Layout_vue__["a" /* default */] },
    computed: {
        code: function code() {
            return this.$store.getters.error.code;
        },
        showErrorPage: function showErrorPage() {
            return this.$store.getters.error.status;
        }
    },
    beforeCreate: function beforeCreate() {
        if (!this.$store.getters.error.redirect) {
            this.$store.commit('setError', {
                status: false,
                code: 0,
                redirect: false
            });
        }
    }
});

/***/ }),

/***/ "xKWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payza_vue__ = __webpack_require__("tXiL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d12d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payza_vue__ = __webpack_require__("dSK+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payza_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d12d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payza_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "xMtN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error500_vue__ = __webpack_require__("szSH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a73618_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error500_vue__ = __webpack_require__("rhxs");
function injectStyle (ssrContext) {
  __webpack_require__("dCOn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14a73618"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a73618_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xTF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"futurocoin-stats-component",attrs:{"id":"futurocoin_stats_component"}},_vm._l((_vm.stats),function(stat,index){return _c('b-col',{key:index,attrs:{"lg":"4","md":"4","cols":"12"}},[(!stat.royal || stat.royal && _vm.royalPosition > 0)?_c('stats-item',{attrs:{"label":stat.label,"value":stat.value}}):_vm._e()],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xcMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusFilter_vue__ = __webpack_require__("0d1H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab64aede_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusFilter_vue__ = __webpack_require__("rtCj");
function injectStyle (ssrContext) {
  __webpack_require__("REuH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab64aede"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab64aede_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xdf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amount_vue__ = __webpack_require__("CjjZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119b25a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amount_vue__ = __webpack_require__("XsKC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Amount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119b25a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Amount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xiIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinContent_vue__ = __webpack_require__("Ln/W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a1f285_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinContent_vue__ = __webpack_require__("bla+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FuturocoinContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a1f285_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FuturocoinContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xjTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPackets_vue__ = __webpack_require__("IIjg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a619fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPackets_vue__ = __webpack_require__("zVsA");
function injectStyle (ssrContext) {
  __webpack_require__("HTni")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2a619fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPackets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a619fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPackets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xk9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[(!_vm.hasPacket)?_c('check-fnwallet'):_vm._e(),_vm._v(" "),(_vm.hasPacket)?_c('futurocoins-from-mining'):_vm._e(),_vm._v(" "),(_vm.isBanned)?_c('div',{staticClass:"marketing-plan-outer"},_vm._l((_vm.items),function(item,index){return _c('marketing-plan-item',{key:index,attrs:{"label":item.label,"link":item.link}})}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xnSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['$validator'],
    props: ['sending', 'showErrors', 'setValue'],
    data: function data() {
        return {
            options: {
                // EUR: 'EUR',
                // USD: 'USD',
                GBP: 'GBP'
            },
            openList: false,
            hoverList: false,
            selectedId: 'GBP',
            selectedValue: 'GBP'
        };
    },

    methods: {
        setItem: function setItem(id, value) {
            this.selectedValue = value;
            this.selectedId = id;
        }
    },
    mounted: function mounted() {
        this.setValue('currency', this.selectedId);
    },

    watch: {
        selectedId: function selectedId() {
            this.setValue('currency', this.selectedId);
        }
    }
});

/***/ }),

/***/ "xrtl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xwmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_MarketingPlanContent_vue__ = __webpack_require__("9TqV");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], MarketingPlanContent: __WEBPACK_IMPORTED_MODULE_1__content_MarketingPlanContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "xxgd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");







__webpack_require__("H/Zg");
__webpack_require__("C/dE");

var api = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('api'),
    popup = __WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.get('popup');

var MonthlyStatement = function () {
    function MonthlyStatement() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MonthlyStatement);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MonthlyStatement, [{
        key: 'fetchData',
        value: function fetchData() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.commissions.list).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setMonthlyStatement', response.body.results);
                    resolve();
                }, function (error) {
                    if (error.data && error.data.errors) {
                        popup.show(error.data.errors[0].message);
                    }
                    reject();
                });
            });
        }
    }, {
        key: 'getDownloadLink',
        value: function getDownloadLink(period) {
            return "https://api.futuro.network/api/v1/" + api.commissions.download(period);
        }
    }]);

    return MonthlyStatement;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('monthlyStatement', MonthlyStatement);

/***/ }),

/***/ "y3zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtpContent_vue__ = __webpack_require__("zETE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e4b8b92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtpContent_vue__ = __webpack_require__("+wPV");
function injectStyle (ssrContext) {
  __webpack_require__("wsjE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e4b8b92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtpContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e4b8b92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtpContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y76o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['popup'],
    computed: {
        message: function message() {
            return Array.isArray(this.$store.getters.modals.alert.message) ? this.$store.getters.modals.alert.message.join(' ') : this.$store.getters.modals.alert.message;
        },
        button: function button() {
            return this.$store.getters.modals.alert.button;
        },
        modal: function modal() {
            return this.$store.getters.modals.alert.visible;
        },
        reload: function reload() {
            return this.$store.getters.modals.alert.reload;
        }
    },
    methods: {
        hideModal: function hideModal() {
            this.popup.hide();
        },
        reloadPage: function reloadPage() {
            window.location.reload();
        }
    }
});

/***/ }),

/***/ "yAWa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yKTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'',"title":'Set OTP'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('otp-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"commissions_total_component",attrs:{"id":"commissions_total_component"}},[_c('b-col',{attrs:{"lg":"6","cols":"12"}},[_c('div',{staticClass:"commissions-total-label"},[_c('p',[_vm._v("Total income:")])]),_vm._v(" "),_c('div',{staticClass:"commissions-total-value"},[_c('p',[_vm._v(_vm._s(_vm.totalIncome))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingPlanItem_vue__ = __webpack_require__("qsOg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130f5e56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingPlanItem_vue__ = __webpack_require__("iuKS");
function injectStyle (ssrContext) {
  __webpack_require__("kQNS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-130f5e56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingPlanItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130f5e56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingPlanItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yW/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutHeader_vue__ = __webpack_require__("w2S+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bbfc3ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutHeader_vue__ = __webpack_require__("QRUy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bbfc3ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ye8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_inject__);






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a);

__webpack_require__("H/Zg");
__webpack_require__("zD7H");

var api = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('api'),
    countries = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('countries'),
    status = __WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.get('status');

var User = function () {
    function User() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, User);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(User, [{
        key: 'fetchData',
        value: function fetchData(userData) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setUser', userData);
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setSettings', userData);
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('loginUser');
                countries.fetchList();
                _this.isBanned();
                resolve();
            });
        }
    }, {
        key: 'isBanned',
        value: function isBanned() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.auth.location.banned).then(function (response) {
                    if (response.data && response.data.data) {
                        return resolve({
                            banned: response.data.data.banned,
                            location: response.data.data.location
                        });
                    }
                    return resolve(null);
                }, function (error) {
                    status['status' + error.status]();
                    return resolve(null);
                });
            });
        }
    }, {
        key: 'reloadData',
        value: function reloadData() {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(api.auth.user).then(function (response) {
                    _this2.fetchData(response.data).then(function () {
                        resolve();
                    });
                }, function (error) {
                    status['status' + error.status]();
                    reject();
                });
            });
        }
    }]);

    return User;
}();

__WEBPACK_IMPORTED_MODULE_5_vue_inject___default.a.service('user', User);

/***/ }),

/***/ "yeQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"error-404-content-component"},[_c('b-col',{attrs:{"lg":"6"}},[_c('p',{staticClass:"error-number"},[_vm._v("404")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('h1',{staticClass:"error-title"},[_vm._v("Page not found")]),_vm._v(" "),_c('p',[_vm._v("Sorry, we can't seem to find the page you're looking for. Go to "),_c('a',{attrs:{"href":"/"}},[_vm._v("Dashboard")]),_vm._v(".")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yeq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['money'],
    data: function data() {
        return {
            progress: false,
            paymentType: false,
            code: null,
            packetId: null,
            codeNotFound: false,
            notEnoughMoney: false,
            packets: [100, 250, 500, 1000, 5000, 10000, 25000],
            selected: false,
            openList: false,
            hoverList: false
        };
    },

    computed: {
        available: function available() {
            return this.money.format(this.$store.getters.user.moneyBalance, 'fnd');
        },
        message: function message() {
            return this.$store.getters.modals.buyPacket.message;
        },
        modal: function modal() {
            return this.$store.getters.modals.buyPacket.visible;
        },
        packet: function packet() {
            return this.$store.getters.modals.buyPacket.packet;
        },
        select: function select() {
            return this.$store.getters.modals.buyPacket.select;
        },
        current: function current() {
            return this.$store.getters.modals.buyPacket.current;
        },
        upgrade: function upgrade() {
            return this.$store.getters.modals.buyPacket.upgrade;
        }
    },
    methods: {
        hideErrors: function hideErrors() {
            this.codeNotFound = false;
            this.notEnoughMoney = false;
        },
        hideModal: function hideModal() {
            this.paymentType = false;
            this.code = null;
            this.hideErrors();
            var params = {
                modal: 'buyPacket',
                data: {
                    visible: false,
                    message: '',
                    packet: 0
                }
            };
            this.$store.commit('modals', params);
        },
        setItem: function setItem(item) {
            this.packet.create(item);
            this.selected = 'FND ' + item;
        },
        confirm: function confirm(method) {
            var _this = this;

            if (!method) {
                return;
            }

            if (method === 'code' && !this.code) {
                return;
            }

            if (this.upgrade) {
                if (parseFloat(this.packet.value) - parseInt(this.current) > parseFloat(this.available) && this.paymentType === 'futurenetAccount') {
                    this.notEnoughMoney = true;
                    return;
                }
            } else {
                if (parseFloat(this.packet.value) > parseFloat(this.available) && this.paymentType === 'futurenetAccount') {
                    this.notEnoughMoney = true;
                    return;
                }
            }

            this.progress = true;
            this.codeNotFound = false;
            this.notEnoughMoney = false;

            this.packet.buy(method, this.code, this.upgrade).then(function () {
                _this.progress = false;
                _this.hideModal();
            }, function (error) {
                _this.codeNotFound = error.status === 404;
                _this.notEnoughMoney = error.status === 422;
                _this.progress = false;
                _this.loader = false;
            });
        }
    },
    watch: {
        packet: function packet() {
            if (this.select) {
                this.selected = 'FND ' + this.$store.getters.modals.buyPacket.select;
                this.packet.create(this.$store.getters.modals.buyPacket.select);
            }

            if (this.upgrade) {
                this.packetId = this.$store.getters.modals.buyPacket.upgrade;
            }
        }
    }
});

/***/ }),

/***/ "yfYV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yvye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketTable_vue__ = __webpack_require__("iGZb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7662d72c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketTable_vue__ = __webpack_require__("JfmZ");
function injectStyle (ssrContext) {
  __webpack_require__("A7YB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7662d72c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartPacketTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7662d72c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartPacketTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ywea":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yx7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadedFiles_vue__ = __webpack_require__("OJ/h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290beefe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadedFiles_vue__ = __webpack_require__("+unR");
function injectStyle (ssrContext) {
  __webpack_require__("hJ60")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290beefe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadedFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290beefe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadedFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yzjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderExchange_vue__ = __webpack_require__("jdrC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b77d5ff8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderExchange_vue__ = __webpack_require__("s0uy");
function injectStyle (ssrContext) {
  __webpack_require__("0QUt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b77d5ff8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderExchange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b77d5ff8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderExchange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zD7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject__ = __webpack_require__("GeUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_inject__);






var Status = function () {
    function Status() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Status);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Status, [{
        key: 'status0',

        /**
         * Status 0
         */
        value: function status0() {}
        // No additional action needed


        /**
         * Error 401 - redirect to login
         * @param next
         * @returns {void|*}
         */

    }, {
        key: 'status401',
        value: function status401(next) {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('logoutUser');
            return next ? next({ name: 'Login' }) : __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Login' });
        }

        /**
         * Error 403
         */

    }, {
        key: 'status403',
        value: function status403() {
            return __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'TermsUpdate' });
        }

        /**
         * Error 404 - redirect to 404 page
         * @param next
         * @returns {void|*}
         */

    }, {
        key: 'status404',
        value: function status404() {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setError', {
                status: true,
                code: 404,
                redirect: false
            });
        }

        /**
         * Error 500 - redirect to 500 page
         * @param next
         * @returns {void|*}
         */

    }, {
        key: 'status500',
        value: function status500() {
            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setError', {
                status: true,
                code: 500,
                redirect: false
            });
        }
    }]);

    return Status;
}();

__WEBPACK_IMPORTED_MODULE_4_vue_inject___default.a.service('status', Status);

/***/ }),

/***/ "zETE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_CheckFnwallet_vue__ = __webpack_require__("EjMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__ = __webpack_require__("S1AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_vue__ = __webpack_require__("Z1I5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'popup', 'status', 'settings'],
    components: { CheckFnwallet: __WEBPACK_IMPORTED_MODULE_0__dashboard_CheckFnwallet_vue__["a" /* default */], FuturocoinsFromMining: __WEBPACK_IMPORTED_MODULE_1__dashboard_FuturocoinsFromMining_vue__["a" /* default */], QrcodeVue: __WEBPACK_IMPORTED_MODULE_2_qrcode_vue__["a" /* default */] },
    data: function data() {
        return {
            accountName: 'FuturoNetwork',
            accountKey: '',
            code: '',
            instructions: {
                EN: 'https://futurenet.club/download/SettingupGoogleAuthenticatoronFutureNet.club.pdf',
                PL: 'https://futurenet.club/download/SettingupGoogleAuthenticatorpl.pdf'
            },
            token: '',
            progress: false
        };
    },

    computed: {
        hasPacket: function hasPacket() {
            return this.$store.getters.user.position != 0;
        },
        qrcode: function qrcode() {
            return 'otpauth://totp/' + this.accountName + '?secret=' + this.accountKey;
        },
        username: function username() {
            return this.$store.getters.user.login;
        }
    },
    methods: {
        validate: function validate() {
            var _this = this;

            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.submit();
                }
            });
        },
        submit: function submit() {
            var _this2 = this;

            this.progress = true;

            this.$http.post(this.api.token.confirm, {
                token: this.token
            }).then(function (response) {
                _this2.$store.commit('setOtp');
                _this2.settings.create();
                _this2.settings.save();
                _this2.progress = false;
            }, function (error) {
                _this2.popup.show(error.data.errors[0].message);
                _this2.progress = false;
            });
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        this.$store.commit('hideOtpPage');
        this.$http.get(this.api.user.settings.google).then(function (response) {
            _this3.accountKey = response.data.data.filter(function (obj) {
                return obj.name === "GOOGLE_AUTHENTICATOR_SECRET";
            })[0]['value'];
        }, function (error) {
            _this3.popup.show(error.data.message);
        });
    }
});

/***/ }),

/***/ "zNih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"section-main",attrs:{"cols":"12","lg":"9","id":"section_main"}},[_c('h3',[_vm._v("Withdraw request")]),_vm._v(" "),(_vm.isFetched)?_c('div',[(_vm.requestWasSent)?_c('div',[_c('p'),_vm._v(" "),_c('p',[_vm._v("\n                Your withdraw request already sent. Check 'Requests history' for withdraw status. "),_c('br'),_vm._v("\n                You can send new request after verification of current request will be finished.\n            ")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('p',[_vm._v("Available Mined FuturoCoins: "+_vm._s(_vm.minedBalance)+" FTO")]),_vm._v(" "),_c('p',[_vm._v("Available Bonus FuturoCoins: "+_vm._s(_vm.bonusBalance)+" FTO")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(" CoinDeal is about to close the FTO/BTC market on 30.06.2020.")]),_vm._v("\n\n        Please use any other FTO wallet of any exchange platform."),_c('br'),_vm._v("\n        In order to change the wallet number for your previous withdrawal request."),_c('br'),_vm._v("\n        Please, contact our support team by e-mail\n        "),_c('a',{attrs:{"href":"mailto: futuronetwork.help@gmail.com "}},[_vm._v("futuronetwork.help@gmail.com ")]),_vm._v(".\n        "),_c('br'),_vm._v(" "),(_vm.showForm)?_c('div',[_c('p'),_vm._v(" "),_c('p',[_vm._v("\n                In order to make withdrawal request please fill in next data:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("1. Your e-mail address")]),_vm._v(" "),_c('li',[_vm._v("2. Your external FTO wallet (please make sure that you are filling in valid wallet)")]),_vm._v(" "),_c('li',[_vm._v("3. Amount of FTO you want to withdraw")]),_vm._v(" "),_c('li',[_vm._v("4. Click the button “Send”")])]),_vm._v(" "),_c('p',[_vm._v("The withdrawal request will be automatically received and processed by the financial department.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Please fill-up the form:")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('b-row',[_c('b-col',{attrs:{"cols":"","lg":"12"}},[_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('email') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"withdraw_request_email"}},[_vm._v("\n                                Email\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate"}],staticClass:"hf-bg-col",attrs:{"id":"withdraw_request_email","name":"email","data-vv-rules":"required","data-vv-as":"withdraw email","disabled":_vm.progress,"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email') && _vm.showErrors),expression:"errors.has('email') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('email')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('address') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"withdraw_request_address"}},[_vm._v("\n                                FTO Address\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"},{name:"validate",rawName:"v-validate"}],staticClass:"hf-bg-col",attrs:{"id":"withdraw_request_address","name":"address","data-vv-rules":"required","data-vv-as":"withdraw address","disabled":_vm.progress,"type":"text"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('address') && _vm.showErrors),expression:"errors.has('address') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('address')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('balance') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"withdraw_request_balance"}},[_vm._v("\n                                FTO Balance\n                            ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.balance),expression:"balance"},{name:"validate",rawName:"v-validate"}],staticClass:"select-s hf-bg-col",attrs:{"id":"withdraw_request_balance","name":"balance","data-vv-rules":"required","data-vv-as":"withdraw balance","disabled":_vm.progress},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.balance=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.onBalanceChange($event)}]}},[_c('option',{attrs:{"value":"MINED"}},[_vm._v("Mined FTO")]),_vm._v(" "),_c('option',{attrs:{"value":"BONUS"}},[_vm._v("Bonus FTO")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('balance') && _vm.showErrors),expression:"errors.has('balance') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('balance')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text",class:{ 'field-error': _vm.errors.has('amount') && _vm.showErrors }},[_c('label',{staticClass:"form-label",attrs:{"for":"withdraw_request_amount"}},[_vm._v("\n                                FTO Amount (receive: "+_vm._s(_vm.amount > 0 ?(_vm.amount - _vm.ftoFee).toFixed(8) : 0)+" FTO,\n                                blockchain commission: "+_vm._s(_vm.ftoFee)+" FTO)\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"},{name:"validate",rawName:"v-validate"}],staticClass:"hf-bg-col",attrs:{"id":"withdraw_request_amount","name":"amount","data-vv-rules":"required","data-vv-as":"withdraw amount","disabled":_vm.progress,"type":"text"},domProps:{"value":(_vm.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value},_vm.checkAmount]}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('amount') && _vm.showErrors),expression:"errors.has('amount') && showErrors"}],staticClass:"field-error--description"},[_vm._v(_vm._s(_vm.errors.first('amount')))])]),_vm._v(" "),_c('div',{staticClass:"form-item form-item-text"},[_c('label',{staticClass:"form-label",attrs:{"for":"withdraw_request_text"}},[_vm._v("\n                                Text note\n                            ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],attrs:{"id":"withdraw_request_text"},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"7"}},[_c('button',{staticClass:"button--primary",class:{ 'button--progress': _vm.progress },attrs:{"type":_vm.progress ? 'button' : 'submit'}},[_vm._v("Send\n                        ")])])],1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.showHistory)?_c('div',{staticClass:"table-responsive"},[_c('h4',[_vm._v("Requests history")]),_vm._v(" "),_c('div',{staticClass:"table-outer"},[_c('table',{staticClass:"table-style1"},[_c('thead',[_c('tr',{staticClass:"business-qualifications-header-table"},[_c('th',{staticStyle:{"width":"10%","text-align":"center"}},[_c('p',[_vm._v("Date")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"20%","text-align":"center"}},[_c('p',[_vm._v("Email")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"25%","text-align":"center"}},[_c('p',[_vm._v("FTO Address")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"3%","text-align":"center"}},[_c('p',[_vm._v("Balance")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"20%","text-align":"right"}},[_c('p',[_vm._v("FTO amount")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"12%","text-align":"center"}},[_c('p',[_vm._v("Status")])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.requestHistory),function(w){return _c('tr',{key:w.id,staticClass:"row-items"},[_c('td',[_c('p',[_vm._v(_vm._s(w.created_at))])]),_vm._v(" "),_c('td',{staticClass:"cut-email",staticStyle:{"text-align":"left"}},[_c('p',[_vm._v(_vm._s(w.email))])]),_vm._v(" "),_c('td',{staticClass:"cut-address",staticStyle:{"text-align":"left"}},[_c('p',[_vm._v(_vm._s(w.address))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('p',[_vm._v(_vm._s(w.balance_name))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('p',[_vm._v(_vm._s((w.amount / 100000000).toFixed(8))+" FTO")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},style:(w.status === 'CANCELED' ? 'cursor: pointer;' : 'cursor: auto;'),on:{"click":function($event){return _vm.clickItem(w)}}},[_c('p',[(w.status === 'CANCELED')?_c('i',{staticClass:"mdi mdi-18px mdi-information-outline",staticStyle:{"color":"red"}}):_vm._e(),_vm._v("\n                                "+_vm._s(w.status === 'IN_PROGRESS' ? 'IN PROGRESS' : w.status)+"\n                            ")])])])}),0)])])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zSg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f6ddbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error503Content_vue__ = __webpack_require__("DRWM");
function injectStyle (ssrContext) {
  __webpack_require__("g0Pl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00f6ddbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f6ddbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error503Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zU53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__ = __webpack_require__("6PyL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3453b7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__ = __webpack_require__("Bdim");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3453b7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zVsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"dashboard-panel-component",attrs:{"id":"dashboard_panel_component"}},_vm._l((_vm.packets),function(packet,index){return (index > 0)?_c('b-col',{key:index,attrs:{"lg":packet.size.lg,"cols":packet.size.sm}},[_c('div',{staticClass:"dashboard-panel-element",class:{ 'content-center' : packet.size.lg === 12 },on:{"click":function($event){!_vm.loader && !packet.disable ? _vm.buyPacket(index) : ''}}},[_c('div',{staticClass:"dashboard-panel-element--gradient"}),_vm._v(" "),_c('div',{staticClass:"dashboard-panel-element-value"},[_c('span',{staticClass:"dashboard-panel-element-value--sign"},[_vm._v(_vm._s(packet.sign))]),_vm._v(_vm._s(packet.label)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"dashboard-panel-element-buy",class:{ 'disabled': packet.disable}},[_vm._v("Buy")]),_vm._v(" "),_c('div',{staticClass:"dashboard-panel-element-stars"},_vm._l((7),function(star,starId){return _c('i',{key:starId,staticClass:"mdi mdi-star",class:{ 'active' : packet.stars >= star }})}),0),_vm._v(" "),_c('div',{staticClass:"dashboard-panel-element-power"},[_vm._v("\n                Power: "+_vm._s(packet.power)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"dashboard-panel-element-digger",class:'dashboard-panel-element-digger-background-' + index})])]):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zdo5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification",attrs:{"id":"verification"}},[_c('h3',[_vm._v("Verification")]),_vm._v(" "),_c('uploaded-files'),_vm._v(" "),(!_vm.checkUserData)?_c('edit-data'):_vm._e(),_vm._v(" "),(_vm.checkUserData && !_vm.isVerified)?_c('upload-files'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zevV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zh4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calculator_CheckFTO_vue__ = __webpack_require__("l7GL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_first_time_DashboardHeader_vue__ = __webpack_require__("uHuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_first_time_DashboardPackets_vue__ = __webpack_require__("xjTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__start_packet_StartPacketFooter_vue__ = __webpack_require__("AMCO");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CheckFto: __WEBPACK_IMPORTED_MODULE_0__calculator_CheckFTO_vue__["a" /* default */], DashboardHeader: __WEBPACK_IMPORTED_MODULE_1__dashboard_first_time_DashboardHeader_vue__["a" /* default */], DashboardPackets: __WEBPACK_IMPORTED_MODULE_2__dashboard_first_time_DashboardPackets_vue__["a" /* default */], DashboardFooter: __WEBPACK_IMPORTED_MODULE_3__start_packet_StartPacketFooter_vue__["a" /* default */] }
});

/***/ }),

/***/ "zhJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__ = __webpack_require__("t1Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_FuturocoinHistoryContent_vue__ = __webpack_require__("2G/l");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['auth', 'mobile, user'],
    components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__menu_MainMenu_vue__["a" /* default */], FuturocoinHistoryContent: __WEBPACK_IMPORTED_MODULE_1__content_FuturocoinHistoryContent_vue__["a" /* default */] },
    computed: {
        mobileMenu: function mobileMenu() {
            return this.$store.getters.mobileMenu;
        }
    }
});

/***/ }),

/***/ "znVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenuHamburger_vue__ = __webpack_require__("f11k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf092676_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenuHamburger_vue__ = __webpack_require__("q8c7");
function injectStyle (ssrContext) {
  __webpack_require__("FJh3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenuHamburger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf092676_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenuHamburger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zpNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    dependencies: ['api', 'status', 'ftoAccounts', 'money', 'popup'],
    data: function data() {
        return {
            progress: false,
            showErrors: false,

            email: '',
            address: '',
            text: '',
            balance: '', // BONUS, BALANCE
            amount: '',

            showForm: true,
            isFetched: true,
            requestWasSent: false,
            showHistory: false,

            ftoFee: 0.0006,
            minedBalance: 0,
            bonusBalance: 0,

            requestHistory: [{
                id: '',
                email: '',
                address: '',
                amount: '',
                status: '',
                created_at: '',
                reject_reason: ''
            }]
        };
    },

    methods: {
        clearData: function clearData() {
            this.email = '';
            this.address = '';
            this.text = '';
            this.amount = '';
            this.balance = '';
        },
        validate: function validate() {
            var _this = this;

            this.showErrors = false;

            this.$validator.validateAll().then(function () {
                if (!_this.errors.any()) {
                    _this.submit();
                } else {
                    _this.showErrors = true;
                }
            });
        },
        onBalanceChange: function onBalanceChange(event) {
            this.amount = '';
        },
        checkAmount: function checkAmount() {
            if (this.balance.length === 0) {
                this.popup.show('Please choose FTO balance to withdraw');
                this.amount = '';
                return;
            }

            this.amount = this.amount.replace(/,/g, '.');
            if (isNaN(this.amount)) {
                this.popup.show('Not a number');
                this.amount = '';
                return;
            }

            if (this.amount.indexOf('.') > 0) {
                var dig1 = this.amount.split('.')[0];
                var dig2 = this.amount.split('.')[1];
                if (dig2.length > 8) {
                    dig2 = dig2.substr(0, 8);
                    this.amount = dig1 + '.' + dig2;
                }
            }

            var a = parseFloat(this.amount);
            if (this.balance === 'BONUS') {
                if (a > parseFloat(this.bonusBalance)) {
                    this.amount = this.bonusBalance;
                }
            }

            if (this.balance === 'MINED') {
                if (a > parseFloat(this.minedBalance)) {
                    this.amount = this.minedBalance;
                }
            }
        },
        clickItem: function clickItem(w) {
            var reject_reason = w.reject_reason;
            if (reject_reason === null) {
                reject_reason = 'No reject reason present';
            }
            this.popup.show('Reject reason: ' + reject_reason);
        },
        checkActiveRequest: function checkActiveRequest() {
            var _this2 = this;

            this.isFetched = false;

            this.$http.get(this.api.withdraw.getLast).then(function (response) {
                var reqData = response.data.data;

                _this2.minedBalance = (reqData.minedBalance / 100000000).toFixed(8);
                _this2.bonusBalance = (reqData.bonusBalance / 100000000).toFixed(8);

                if (reqData.active === null) {
                    _this2.isFetched = true;
                    return;
                }

                if (reqData.active.status === 'OPEN' || reqData.active.status === 'IN_PROGRESS') {
                    _this2.requestWasSent = true;
                    _this2.showForm = false;
                }

                _this2.isFetched = true;
            }, function (error) {
                _this2.popup.show('Error happened');
            });
        },
        getAllRequests: function getAllRequests() {
            var _this3 = this;

            this.isFetched = false;

            this.$http.get(this.api.withdraw.getAll).then(function (response) {
                if (response.data.data.length === 0) {
                    _this3.showHistory = false;
                    return;
                }

                _this3.requestHistory = response.data.data;
                _this3.showHistory = true;
            }, function (error) {
                _this3.popup.show('Could not load history table');
            });
        },
        submit: function submit() {
            var _this4 = this;

            this.progress = true;

            this.amount = this.amount.replace(/,/g, '.');

            if (this.amount <= this.ftoFee) {
                this.popup.show("Minimum withdraw amount: " + this.ftoFee + "1 FTO", 'OK', false);
                this.progress = false;
                return;
            }

            if (this.balance === 'MINED' && this.amount > parseFloat(this.minedBalance)) {
                this.popup.show("Typed " + this.amount + " FTO is biggest than available " + this.balance + " amount " + this.minedBalance + " FTO", 'OK', false);
                this.progress = false;
                return;
            }

            if (this.balance === 'BONUS' && this.amount > parseFloat(this.bonusBalance)) {
                this.popup.show("Typed " + this.amount + " FTO is biggest than available " + this.balance + " amount " + this.bonusBalance + " FTO", 'OK', false);
                this.progress = false;
                return;
            }

            this.$http.post(this.api.withdraw.send, {
                email: this.email,
                address: this.address,
                amount: this.amount,
                balance: this.balance,
                text: this.text
            }).then(function () {
                console.log('Then');

                _this4.popup.show('Withdraw request sent!', 'OK', false);
                _this4.clearData();
                _this4.progress = false;
                location.reload();
            }, function (error) {
                switch (error.status) {
                    case 422:
                        _this4.popup.show(error.data.errors[0].message, 'OK', false);
                        break;
                    default:
                        if (_this4.status['status' + error.status]) {
                            _this4.status['status' + error.status]();
                        } else {
                            _this4.popup.show(error.data.errors[0].message, 'OK', false);
                        }
                }
                _this4.progress = false;
            });
        }
    },
    beforeMount: function beforeMount() {
        this.clearData();
        this.checkActiveRequest();
        this.getAllRequests();
    }
});

/***/ }),

/***/ "zqx8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zsLI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zxC8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zxUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'business',"title":'Qualification'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('business-qualifications-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.631c0ba4bde4f2df9533.js